import ksaFlag from "./assets/images/icons/ksa-flag.svg";
export const config = {
	apiUrl: process.env.REACT_APP_API_URL,
	redirectDomainUrl: process.env.REACT_APP_REDIRECT_URL,

	phoneKeysList: [{ label: "+966", flag: ksaFlag, value: "+966" }],

	idTypeList: [
		{ label: "National ID", value: "id" },
		{ label: "IQAMA ID", value: "iqama" },
	],

	idIssueList: [{ label: "Saudi Arabia", value: "SaudiArabia" }],

	martialStatusList: [
		{
			code: "1",
			eName: "Single",
			aName: "أعزب",
		},
		{
			code: "2",
			eName: "Married",
			aName: "متزوج",
		},
		{
			code: "3",
			eName: "Divorced",
			aName: "مطلق",
		},
		{
			code: "4",
			eName: "Widow",
			aName: "أرمل",
		},
		{
			code: "5",
			eName: "Other",
			aName: "أخرى",
		},
	],
	plateCharchtersMapper: {
		ا: "A",
		ب: "B",
		ح: "J",
		د: "D",
		ر: "R",
		س: "S",
		ص: "X",
		ط: "T",
		ع: "E",
		ق: "G",
		ك: "K",
		ل: "L",
		م: "Z",
		ن: "N",
		ه: "H",
		و: "U",
		ى: "V",
	},
	productCode: {
		tp: "MotorImtiazeTP",
		sp: "PRMotorImtiazeSP",
		co: "PRMotorImtiazeCO",
	},

	mileExpectedPerYear: [
		{ label: "0-5000", value: "0-5000" },
		{ label: "5001-15000", value: "5001-10000" },
		{ label: "10001-15000", value: "5001-15000" },
		{ label: "15001-20000", value: "15001-20000" },
		{ label: "20001-30000", value: "20001-30000" },
		{ label: "30001-40000", value: "30001-40000" },
		{ label: "40001-50000", value: "40001-50000" },
		{ label: "50000+", value: "50000+" },
	],
	regionDetails: [
		{
			regionCode: "1",
			descriptionEn: "Riyadh",
			descriptionAr: "منطقة الرياض",
		},
		{
			regionCode: "2",
			descriptionEn: "Makkah Al Mukuramah",
			descriptionAr: "منطقه مكة المكرمة",
		},
		{
			regionCode: "3",
			descriptionEn: "Eastern Region",
			descriptionAr: "المنطقة الشرقية",
		},
		{
			regionCode: "4",
			descriptionEn: "Al Madina Al Munawara / Tabuk",
			descriptionAr: "منطقة المدينة المنورة / منطقة تبوك",
		},
		{
			regionCode: "5",
			descriptionEn: "Qassim / Hail",
			descriptionAr: "منطقة القصيم / منطقة حائل",
		},
		{
			regionCode: "6",
			descriptionEn: "Asseer / Najran / Baha",
			descriptionAr: "منطقة عسير / منطقة نجران / منطقة الباحة",
		},
		{
			regionCode: "7",
			descriptionEn: "Northern Boarders Region / Jouf",
			descriptionAr: "منطقة الحدود الشمالية / منطقة الجوف",
		},
		{
			regionCode: "8",
			descriptionEn: "Jazan",
			descriptionAr: "منطقة جازان",
		},
	],
	educationList: [
		{ label: "SSLC", value: "SSLC" },
		{ label: "PUC", value: "PUC" },
		{ label: "Bachelor", value: "PGD" },
		{ label: "Master", value: "Master" },
	],

	RoadConvictions: [
		{
			roadConvictionDescription: "Parking Violation  ",
			roadConvictionCode: "MORE THAN 20",
		},
		{
			roadConvictionDescription: "NIL",
			roadConvictionCode: "NIL",
		},
		{
			roadConvictionDescription: "Speed Ticket",
			roadConvictionCode: "1-5",
		},
		{
			roadConvictionDescription: "Override Traffic Light",
			roadConvictionCode: "6-10",
		},
		{
			roadConvictionDescription: "Driving Opposite direction",
			roadConvictionCode: "11-15",
		},
		{
			roadConvictionDescription: "Drifting",
			roadConvictionCode: "16-20",
		},
	],

	RoadConvictionsAr: [
		{
			roadConvictionDescription: "مخالفة الوقوف الخاطى",
			roadConvictionCode: "MORE THAN 20",
		},
		{
			roadConvictionDescription: "لايوجد",
			roadConvictionCode: "NIL",
		},
		{
			roadConvictionDescription: "تجاوز السرعة المحددة",
			roadConvictionCode: "1-5",
		},
		{
			roadConvictionDescription: "تجاوز الاشارة الحمراء",
			roadConvictionCode: "6-10",
		},
		{
			roadConvictionDescription: "القيادة عكس الاتجاة",
			roadConvictionCode: "11-15",
		},
		{
			roadConvictionDescription: "التفحيط",
			roadConvictionCode: "16-20",
		},
	],
	MedicalConditions: [
		{
			medicalConditionsCode: "6",
			medicalConditionsDescription: "Lenses for Eyesight",
		},
		{
			medicalConditionsCode: "4",
			medicalConditionsDescription: "Automatic Vehicle",
		},
		{
			medicalConditionsCode: "7",
			medicalConditionsDescription: "Daytime Only",
		},
		{
			medicalConditionsCode: "5",
			medicalConditionsDescription: "Prostheses Part",
		},
		{
			medicalConditionsCode: "9",
			medicalConditionsDescription: "Vehicle for disabled",
		},
		{
			medicalConditionsCode: "1",
			medicalConditionsDescription: "Without restrictions",
		},
		{
			medicalConditionsCode: "2",
			medicalConditionsDescription: "Wearing glasses",
		},
		{
			medicalConditionsCode: "3",
			medicalConditionsDescription: "Have a disability",
		},
		{
			medicalConditionsCode: "8",
			medicalConditionsDescription: "Earpiece",
		},
	],
	MedicalConditionsAr: [
		{
			medicalConditionsCode: "6",
			medicalConditionsDescription: "عدسات مقوية للنظر",
		},
		{
			medicalConditionsCode: "4",
			medicalConditionsDescription: "سيارة أوتوماتيك",
		},
		{
			medicalConditionsCode: "7",
			medicalConditionsDescription: "لساعات النهار فقط",
		},
		{
			medicalConditionsCode: "5",
			medicalConditionsDescription: "طرف صناعي",
		},
		{
			medicalConditionsCode: "9",
			medicalConditionsDescription: "سيارة خاصة للمعوقين",
		},
		{
			medicalConditionsCode: "1",
			medicalConditionsDescription: "بدون قيود",
		},
		{
			medicalConditionsCode: "2",
			medicalConditionsDescription: "عدسات مقوية للنظر",
		},
		{
			medicalConditionsCode: "3",
			medicalConditionsDescription: "سيارة خاصة للمعوقين",
		},
		{
			medicalConditionsCode: "8",
			medicalConditionsDescription: "سماعة الأذن",
		},
	],
	LicenseExperienceYears: [
		{
			licenseExperienceYearsCode: "0",
			licenseExperienceYearsDescription: "0 Year",
		},
		{
			licenseExperienceYearsCode: "1",
			licenseExperienceYearsDescription: "1 Year",
		},
		{
			licenseExperienceYearsCode: "2",
			licenseExperienceYearsDescription: "2 Years",
		},
		{
			licenseExperienceYearsCode: "3",
			licenseExperienceYearsDescription: "3 Years",
		},
		{
			licenseExperienceYearsCode: "4",
			licenseExperienceYearsDescription: "4 Years",
		},
		{
			licenseExperienceYearsCode: "5",
			licenseExperienceYearsDescription: "5 Years",
		},
		{
			licenseExperienceYearsCode: "6",
			licenseExperienceYearsDescription: "6 Years",
		},
		{
			licenseExperienceYearsCode: "7",
			licenseExperienceYearsDescription: "7 Years",
		},
		{
			licenseExperienceYearsCode: "8",
			licenseExperienceYearsDescription: "8 Years",
		},
		{
			licenseExperienceYearsCode: "9",
			licenseExperienceYearsDescription: "9 Years",
		},
		{
			licenseExperienceYearsCode: "10",
			licenseExperienceYearsDescription: "10 Years",
		},
		{
			licenseExperienceYearsCode: "91",
			licenseExperienceYearsDescription: "Above Ten Years",
		},
	],
	LicenseExperienceYearsAr: [
		{
			licenseExperienceYearsCode: "0",
			licenseExperienceYearsDescription: "اقل من سنه",
		},
		{
			licenseExperienceYearsCode: "1",
			licenseExperienceYearsDescription: "سنة واحدة",
		},
		{
			licenseExperienceYearsCode: "3",
			licenseExperienceYearsDescription: "ثلاث سنوات",
		},
		{
			licenseExperienceYearsCode: "4",
			licenseExperienceYearsDescription: "أربع سنوات",
		},
		{
			licenseExperienceYearsCode: "5",
			licenseExperienceYearsDescription: "خمس سنوات",
		},
		{
			licenseExperienceYearsCode: "6",
			licenseExperienceYearsDescription: "6 سنوات",
		},
		{
			licenseExperienceYearsCode: "7",
			licenseExperienceYearsDescription: "7 سنوات",
		},
		{
			licenseExperienceYearsCode: "8",
			licenseExperienceYearsDescription: "8 سنوات",
		},
		{
			licenseExperienceYearsCode: "9",
			licenseExperienceYearsDescription: "9 سنوات",
		},
		{
			licenseExperienceYearsCode: "10",
			licenseExperienceYearsDescription: "10 سنوات",
		},
		{
			licenseExperienceYearsCode: "91",
			licenseExperienceYearsDescription: "أكثر من عشر سنوات",
		},
		{
			licenseExperienceYearsCode: "2",
			licenseExperienceYearsDescription: "سنتان",
		},
	],
	occupationListAr: [
		{
			occupationCode: "712501",
			occupationDescription: null,
		},
		{
			occupationCode: "235906",
			occupationDescription: null,
		},
		{
			occupationCode: "121102",
			occupationDescription: null,
		},
		{
			occupationCode: "431101",
			occupationDescription: null,
		},
		{
			occupationCode: "331301",
			occupationDescription: null,
		},
		{
			occupationCode: "712402",
			occupationDescription: null,
		},
		{
			occupationCode: "235502",
			occupationDescription: null,
		},
		{
			occupationCode: "331402",
			occupationDescription: null,
		},
		{
			occupationCode: "121118",
			occupationDescription: null,
		},
		{
			occupationCode: "212002",
			occupationDescription: null,
		},
		{
			occupationCode: "223002",
			occupationDescription: null,
		},
		{
			occupationCode: "323003",
			occupationDescription: null,
		},
		{
			occupationCode: "242105",
			occupationDescription: null,
		},
		{
			occupationCode: "121215",
			occupationDescription: null,
		},
		{
			occupationCode: "412001",
			occupationDescription: null,
		},
		{
			occupationCode: "121315",
			occupationDescription: null,
		},
		{
			occupationCode: "242203",
			occupationDescription: null,
		},
		{
			occupationCode: "242204",
			occupationDescription: null,
		},
		{
			occupationCode: "121902",
			occupationDescription: null,
		},
		{
			occupationCode: "121214",
			occupationDescription: null,
		},
		{
			occupationCode: "242103",
			occupationDescription: null,
		},
		{
			occupationCode: "252910",
			occupationDescription: null,
		},
		{
			occupationCode: "242121",
			occupationDescription: null,
		},
		{
			occupationCode: "134516",
			occupationDescription: null,
		},
		{
			occupationCode: "235904",
			occupationDescription: null,
		},
		{
			occupationCode: "216604",
			occupationDescription: null,
		},
		{
			occupationCode: "122201",
			occupationDescription: null,
		},
		{
			occupationCode: "243101",
			occupationDescription: null,
		},
		{
			occupationCode: "134916",
			occupationDescription: null,
		},
		{
			occupationCode: "343102",
			occupationDescription: null,
		},
		{
			occupationCode: "753104",
			occupationDescription: null,
		},
		{
			occupationCode: "921301",
			occupationDescription: null,
		},
		{
			occupationCode: "131101",
			occupationDescription: null,
		},
		{
			occupationCode: "834102",
			occupationDescription: null,
		},
		{
			occupationCode: "723301",
			occupationDescription: null,
		},
		{
			occupationCode: "311509",
			occupationDescription: null,
		},
		{
			occupationCode: "213203",
			occupationDescription: null,
		},
		{
			occupationCode: "314208",
			occupationDescription: null,
		},
		{
			occupationCode: "231019",
			occupationDescription: null,
		},
		{
			occupationCode: "213202",
			occupationDescription: null,
		},
		{
			occupationCode: "522317",
			occupationDescription: null,
		},
		{
			occupationCode: "834101",
			occupationDescription: null,
		},
		{
			occupationCode: "315401",
			occupationDescription: null,
		},
		{
			occupationCode: "213302",
			occupationDescription: null,
		},
		{
			occupationCode: "216501",
			occupationDescription: null,
		},
		{
			occupationCode: "132410",
			occupationDescription: null,
		},
		{
			occupationCode: "132405",
			occupationDescription: null,
		},
		{
			occupationCode: "821105",
			occupationDescription: null,
		},
		{
			occupationCode: "912202",
			occupationDescription: null,
		},
		{
			occupationCode: "742101",
			occupationDescription: null,
		},
		{
			occupationCode: "723203",
			occupationDescription: null,
		},
		{
			occupationCode: "723201",
			occupationDescription: null,
		},
		{
			occupationCode: "723202",
			occupationDescription: null,
		},
		{
			occupationCode: "315301",
			occupationDescription: null,
		},
		{
			occupationCode: "132402",
			occupationDescription: null,
		},
		{
			occupationCode: "315502",
			occupationDescription: null,
		},
		{
			occupationCode: "622103",
			occupationDescription: null,
		},
		{
			occupationCode: "221212",
			occupationDescription: null,
		},
		{
			occupationCode: "111207",
			occupationDescription: null,
		},
		{
			occupationCode: "832204",
			occupationDescription: null,
		},
		{
			occupationCode: "611202",
			occupationDescription: null,
		},
		{
			occupationCode: "222105",
			occupationDescription: null,
		},
		{
			occupationCode: "325901",
			occupationDescription: null,
		},
		{
			occupationCode: "221209",
			occupationDescription: null,
		},
		{
			occupationCode: "933201",
			occupationDescription: null,
		},
		{
			occupationCode: "131105",
			occupationDescription: null,
		},
		{
			occupationCode: "921201",
			occupationDescription: null,
		},
		{
			occupationCode: "213205",
			occupationDescription: null,
		},
		{
			occupationCode: "612101",
			occupationDescription: null,
		},
		{
			occupationCode: "314105",
			occupationDescription: null,
		},
		{
			occupationCode: "516402",
			occupationDescription: null,
		},
		{
			occupationCode: "216602",
			occupationDescription: null,
		},
		{
			occupationCode: "265601",
			occupationDescription: null,
		},
		{
			occupationCode: "263205",
			occupationDescription: null,
		},
		{
			occupationCode: "134929",
			occupationDescription: null,
		},
		{
			occupationCode: "263203",
			occupationDescription: null,
		},
		{
			occupationCode: "265107",
			occupationDescription: null,
		},
		{
			occupationCode: "263201",
			occupationDescription: null,
		},
		{
			occupationCode: "131107",
			occupationDescription: null,
		},
		{
			occupationCode: "251205",
			occupationDescription: null,
		},
		{
			occupationCode: "251401",
			occupationDescription: null,
		},
		{
			occupationCode: "232005",
			occupationDescription: null,
		},
		{
			occupationCode: "231021",
			occupationDescription: null,
		},
		{
			occupationCode: "314202",
			occupationDescription: null,
		},
		{
			occupationCode: "622201",
			occupationDescription: null,
		},
		{
			occupationCode: "234102",
			occupationDescription: null,
		},
		{
			occupationCode: "233002",
			occupationDescription: null,
		},
		{
			occupationCode: "261105",
			occupationDescription: null,
		},
		{
			occupationCode: "263206",
			occupationDescription: null,
		},
		{
			occupationCode: "263209",
			occupationDescription: null,
		},
		{
			occupationCode: "231007",
			occupationDescription: null,
		},
		{
			occupationCode: "311805",
			occupationDescription: null,
		},
		{
			occupationCode: "311804",
			occupationDescription: null,
		},
		{
			occupationCode: "232006",
			occupationDescription: null,
		},
		{
			occupationCode: "441501",
			occupationDescription: null,
		},
		{
			occupationCode: "134932",
			occupationDescription: null,
		},
		{
			occupationCode: "265408",
			occupationDescription: null,
		},
		{
			occupationCode: "233037",
			occupationDescription: null,
		},
		{
			occupationCode: "134931",
			occupationDescription: null,
		},
		{
			occupationCode: "226904",
			occupationDescription: null,
		},
		{
			occupationCode: "226405",
			occupationDescription: null,
		},
		{
			occupationCode: "252902",
			occupationDescription: null,
		},
		{
			occupationCode: "333908",
			occupationDescription: null,
		},
		{
			occupationCode: "231003",
			occupationDescription: null,
		},
		{
			occupationCode: "232007",
			occupationDescription: null,
		},
		{
			occupationCode: "712101",
			occupationDescription: null,
		},
		{
			occupationCode: "834205",
			occupationDescription: null,
		},
		{
			occupationCode: "931203",
			occupationDescription: null,
		},
		{
			occupationCode: "134507",
			occupationDescription: null,
		},
		{
			occupationCode: "211102",
			occupationDescription: null,
		},
		{
			occupationCode: "311101",
			occupationDescription: null,
		},
		{
			occupationCode: "211103",
			occupationDescription: null,
		},
		{
			occupationCode: "134923",
			occupationDescription: null,
		},
		{
			occupationCode: "333902",
			occupationDescription: null,
		},
		{
			occupationCode: "352101",
			occupationDescription: null,
		},
		{
			occupationCode: "226601",
			occupationDescription: null,
		},
		{
			occupationCode: "226603",
			occupationDescription: null,
		},
		{
			occupationCode: "321106",
			occupationDescription: null,
		},
		{
			occupationCode: "121106",
			occupationDescription: null,
		},
		{
			occupationCode: "741201",
			occupationDescription: null,
		},
		{
			occupationCode: "723105",
			occupationDescription: null,
		},
		{
			occupationCode: "723101",
			occupationDescription: null,
		},
		{
			occupationCode: "721304",
			occupationDescription: null,
		},
		{
			occupationCode: "313901",
			occupationDescription: null,
		},
		{
			occupationCode: "815202",
			occupationDescription: null,
		},
		{
			occupationCode: "215105",
			occupationDescription: null,
		},
		{
			occupationCode: "214410",
			occupationDescription: null,
		},
		{
			occupationCode: "311407",
			occupationDescription: null,
		},
		{
			occupationCode: "242113",
			occupationDescription: null,
		},
		{
			occupationCode: "315306",
			occupationDescription: null,
		},
		{
			occupationCode: "132409",
			occupationDescription: null,
		},
		{
			occupationCode: "315501",
			occupationDescription: null,
		},
		{
			occupationCode: "134917",
			occupationDescription: null,
		},
		{
			occupationCode: "531102",
			occupationDescription: null,
		},
		{
			occupationCode: "815604",
			occupationDescription: null,
		},
		{
			occupationCode: "815603",
			occupationDescription: null,
		},
		{
			occupationCode: "341101",
			occupationDescription: null,
		},
		{
			occupationCode: "816001",
			occupationDescription: null,
		},
		{
			occupationCode: "815904",
			occupationDescription: null,
		},
		{
			occupationCode: "265207",
			occupationDescription: null,
		},
		{
			occupationCode: "134601",
			occupationDescription: null,
		},
		{
			occupationCode: "121111",
			occupationDescription: null,
		},
		{
			occupationCode: "241307",
			occupationDescription: null,
		},
		{
			occupationCode: "513201",
			occupationDescription: null,
		},
		{
			occupationCode: "233016",
			occupationDescription: null,
		},
		{
			occupationCode: "821907",
			occupationDescription: null,
		},
		{
			occupationCode: "723403",
			occupationDescription: null,
		},
		{
			occupationCode: "252908",
			occupationDescription: null,
		},
		{
			occupationCode: "962303",
			occupationDescription: null,
		},
		{
			occupationCode: "213102",
			occupationDescription: null,
		},
		{
			occupationCode: "231014",
			occupationDescription: null,
		},
		{
			occupationCode: "213101",
			occupationDescription: null,
		},
		{
			occupationCode: "314101",
			occupationDescription: null,
		},
		{
			occupationCode: "214901",
			occupationDescription: null,
		},
		{
			occupationCode: "213104",
			occupationDescription: null,
		},
		{
			occupationCode: "612202",
			occupationDescription: null,
		},
		{
			occupationCode: "516405",
			occupationDescription: null,
		},
		{
			occupationCode: "722104",
			occupationDescription: null,
		},
		{
			occupationCode: "311212",
			occupationDescription: null,
		},
		{
			occupationCode: "314207",
			occupationDescription: null,
		},
		{
			occupationCode: "721301",
			occupationDescription: null,
		},
		{
			occupationCode: "732302",
			occupationDescription: null,
		},
		{
			occupationCode: "314103",
			occupationDescription: null,
		},
		{
			occupationCode: "235201",
			occupationDescription: null,
		},
		{
			occupationCode: "112008",
			occupationDescription: null,
		},
		{
			occupationCode: "251111",
			occupationDescription: null,
		},
		{
			occupationCode: "711201",
			occupationDescription: null,
		},
		{
			occupationCode: "214207",
			occupationDescription: null,
		},
		{
			occupationCode: "215303",
			occupationDescription: null,
		},
		{
			occupationCode: "121105",
			occupationDescription: null,
		},
		{
			occupationCode: "241107",
			occupationDescription: null,
		},
		{
			occupationCode: "312301",
			occupationDescription: null,
		},
		{
			occupationCode: "713301",
			occupationDescription: null,
		},
		{
			occupationCode: "311206",
			occupationDescription: null,
		},
		{
			occupationCode: "311207",
			occupationDescription: null,
		},
		{
			occupationCode: "834203",
			occupationDescription: null,
		},
		{
			occupationCode: "833101",
			occupationDescription: null,
		},
		{
			occupationCode: "723102",
			occupationDescription: null,
		},
		{
			occupationCode: "622401",
			occupationDescription: null,
		},
		{
			occupationCode: "634003",
			occupationDescription: null,
		},
		{
			occupationCode: "232002",
			occupationDescription: null,
		},
		{
			occupationCode: "233007",
			occupationDescription: null,
		},
		{
			occupationCode: "231004",
			occupationDescription: null,
		},
		{
			occupationCode: "242106",
			occupationDescription: null,
		},
		{
			occupationCode: "241309",
			occupationDescription: null,
		},
		{
			occupationCode: "242117",
			occupationDescription: null,
		},
		{
			occupationCode: "122101",
			occupationDescription: null,
		},
		{
			occupationCode: "251108",
			occupationDescription: null,
		},
		{
			occupationCode: "515202",
			occupationDescription: null,
		},
		{
			occupationCode: "815303",
			occupationDescription: null,
		},
		{
			occupationCode: "815304",
			occupationDescription: null,
		},
		{
			occupationCode: "141204",
			occupationDescription: null,
		},
		{
			occupationCode: "422201",
			occupationDescription: null,
		},
		{
			occupationCode: "133010",
			occupationDescription: null,
		},
		{
			occupationCode: "422301",
			occupationDescription: null,
		},
		{
			occupationCode: "516404",
			occupationDescription: null,
		},
		{
			occupationCode: "143903",
			occupationDescription: null,
		},
		{
			occupationCode: "832201",
			occupationDescription: null,
		},
		{
			occupationCode: "962901",
			occupationDescription: null,
		},
		{
			occupationCode: "818304",
			occupationDescription: null,
		},
		{
			occupationCode: "821903",
			occupationDescription: null,
		},
		{
			occupationCode: "814304",
			occupationDescription: null,
		},
		{
			occupationCode: "325904",
			occupationDescription: null,
		},
		{
			occupationCode: "321103",
			occupationDescription: null,
		},
		{
			occupationCode: "325905",
			occupationDescription: null,
		},
		{
			occupationCode: "221231",
			occupationDescription: null,
		},
		{
			occupationCode: "221205",
			occupationDescription: null,
		},
		{
			occupationCode: "325903",
			occupationDescription: null,
		},
		{
			occupationCode: "242404",
			occupationDescription: null,
		},
		{
			occupationCode: "912103",
			occupationDescription: null,
		},
		{
			occupationCode: "731803",
			occupationDescription: null,
		},
		{
			occupationCode: "815702",
			occupationDescription: null,
		},
		{
			occupationCode: "712201",
			occupationDescription: null,
		},
		{
			occupationCode: "962102",
			occupationDescription: null,
		},
		{
			occupationCode: "315205",
			occupationDescription: null,
		},
		{
			occupationCode: "265101",
			occupationDescription: null,
		},
		{
			occupationCode: "752201",
			occupationDescription: null,
		},
		{
			occupationCode: "261104",
			occupationDescription: null,
		},
		{
			occupationCode: "121104",
			occupationDescription: null,
		},
		{
			occupationCode: "523001",
			occupationDescription: null,
		},
		{
			occupationCode: "335906",
			occupationDescription: null,
		},
		{
			occupationCode: "333201",
			occupationDescription: null,
		},
		{
			occupationCode: "314204",
			occupationDescription: null,
		},
		{
			occupationCode: "612103",
			occupationDescription: null,
		},
		{
			occupationCode: "817101",
			occupationDescription: null,
		},
		{
			occupationCode: "811404",
			occupationDescription: null,
		},
		{
			occupationCode: "811401",
			occupationDescription: null,
		},
		{
			occupationCode: "818101",
			occupationDescription: null,
		},
		{
			occupationCode: "331501",
			occupationDescription: null,
		},
		{
			occupationCode: "241105",
			occupationDescription: null,
		},
		{
			occupationCode: "112002",
			occupationDescription: null,
		},
		{
			occupationCode: "111402",
			occupationDescription: null,
		},
		{
			occupationCode: "242104",
			occupationDescription: null,
		},
		{
			occupationCode: "512003",
			occupationDescription: null,
		},
		{
			occupationCode: "313303",
			occupationDescription: null,
		},
		{
			occupationCode: "132113",
			occupationDescription: null,
		},
		{
			occupationCode: "214501",
			occupationDescription: null,
		},
		{
			occupationCode: "214503",
			occupationDescription: null,
		},
		{
			occupationCode: "311601",
			occupationDescription: null,
		},
		{
			occupationCode: "813108",
			occupationDescription: null,
		},
		{
			occupationCode: "813101",
			occupationDescription: null,
		},
		{
			occupationCode: "813106",
			occupationDescription: null,
		},
		{
			occupationCode: "311602",
			occupationDescription: null,
		},
		{
			occupationCode: "813107",
			occupationDescription: null,
		},
		{
			occupationCode: "313301",
			occupationDescription: null,
		},
		{
			occupationCode: "313302",
			occupationDescription: null,
		},
		{
			occupationCode: "231016",
			occupationDescription: null,
		},
		{
			occupationCode: "112001",
			occupationDescription: null,
		},
		{
			occupationCode: "132114",
			occupationDescription: null,
		},
		{
			occupationCode: "134208",
			occupationDescription: null,
		},
		{
			occupationCode: "134101",
			occupationDescription: null,
		},
		{
			occupationCode: "531101",
			occupationDescription: null,
		},
		{
			occupationCode: "531103",
			occupationDescription: null,
		},
		{
			occupationCode: "713304",
			occupationDescription: null,
		},
		{
			occupationCode: "731602",
			occupationDescription: null,
		},
		{
			occupationCode: "265302",
			occupationDescription: null,
		},
		{
			occupationCode: "143126",
			occupationDescription: null,
		},
		{
			occupationCode: "265903",
			occupationDescription: null,
		},
		{
			occupationCode: "216401",
			occupationDescription: null,
		},
		{
			occupationCode: "134930",
			occupationDescription: null,
		},
		{
			occupationCode: "335403",
			occupationDescription: null,
		},
		{
			occupationCode: "134946",
			occupationDescription: null,
		},
		{
			occupationCode: "541102",
			occupationDescription: null,
		},
		{
			occupationCode: "132301",
			occupationDescription: null,
		},
		{
			occupationCode: "214203",
			occupationDescription: null,
		},
		{
			occupationCode: "121212",
			occupationDescription: null,
		},
		{
			occupationCode: "711102",
			occupationDescription: null,
		},
		{
			occupationCode: "515101",
			occupationDescription: null,
		},
		{
			occupationCode: "211202",
			occupationDescription: null,
		},
		{
			occupationCode: "226202",
			occupationDescription: null,
		},
		{
			occupationCode: "213116",
			occupationDescription: null,
		},
		{
			occupationCode: "222106",
			occupationDescription: null,
		},
		{
			occupationCode: "226502",
			occupationDescription: null,
		},
		{
			occupationCode: "815306",
			occupationDescription: null,
		},
		{
			occupationCode: "522304",
			occupationDescription: null,
		},
		{
			occupationCode: "251109",
			occupationDescription: null,
		},
		{
			occupationCode: "265902",
			occupationDescription: null,
		},
		{
			occupationCode: "622202",
			occupationDescription: null,
		},
		{
			occupationCode: "622204",
			occupationDescription: null,
		},
		{
			occupationCode: "541902",
			occupationDescription: null,
		},
		{
			occupationCode: "343512",
			occupationDescription: null,
		},
		{
			occupationCode: "513202",
			occupationDescription: null,
		},
		{
			occupationCode: "121113",
			occupationDescription: null,
		},
		{
			occupationCode: "621004",
			occupationDescription: null,
		},
		{
			occupationCode: "332202",
			occupationDescription: null,
		},
		{
			occupationCode: "335905",
			occupationDescription: null,
		},
		{
			occupationCode: "243106",
			occupationDescription: null,
		},
		{
			occupationCode: "242101",
			occupationDescription: null,
		},
		{
			occupationCode: "334103",
			occupationDescription: null,
		},
		{
			occupationCode: "334102",
			occupationDescription: null,
		},
		{
			occupationCode: "332402",
			occupationDescription: null,
		},
		{
			occupationCode: "121904",
			occupationDescription: null,
		},
		{
			occupationCode: "133005",
			occupationDescription: null,
		},
		{
			occupationCode: "351303",
			occupationDescription: null,
		},
		{
			occupationCode: "133004",
			occupationDescription: null,
		},
		{
			occupationCode: "351302",
			occupationDescription: null,
		},
		{
			occupationCode: "351102",
			occupationDescription: null,
		},
		{
			occupationCode: "351202",
			occupationDescription: null,
		},
		{
			occupationCode: "222103",
			occupationDescription: null,
		},
		{
			occupationCode: "121205",
			occupationDescription: null,
		},
		{
			occupationCode: "242305",
			occupationDescription: null,
		},
		{
			occupationCode: "121303",
			occupationDescription: null,
		},
		{
			occupationCode: "712701",
			occupationDescription: null,
		},
		{
			occupationCode: "241106",
			occupationDescription: null,
		},
		{
			occupationCode: "215204",
			occupationDescription: null,
		},
		{
			occupationCode: "233030",
			occupationDescription: null,
		},
		{
			occupationCode: "234107",
			occupationDescription: null,
		},
		{
			occupationCode: "251101",
			occupationDescription: null,
		},
		{
			occupationCode: "351304",
			occupationDescription: null,
		},
		{
			occupationCode: "754302",
			occupationDescription: null,
		},
		{
			occupationCode: "215205",
			occupationDescription: null,
		},
		{
			occupationCode: "711401",
			occupationDescription: null,
		},
		{
			occupationCode: "931302",
			occupationDescription: null,
		},
		{
			occupationCode: "833204",
			occupationDescription: null,
		},
		{
			occupationCode: "811402",
			occupationDescription: null,
		},
		{
			occupationCode: "265206",
			occupationDescription: null,
		},
		{
			occupationCode: "333203",
			occupationDescription: null,
		},
		{
			occupationCode: "243206",
			occupationDescription: null,
		},
		{
			occupationCode: "711502",
			occupationDescription: null,
		},
		{
			occupationCode: "931301",
			occupationDescription: null,
		},
		{
			occupationCode: "214205",
			occupationDescription: null,
		},
		{
			occupationCode: "312304",
			occupationDescription: null,
		},
		{
			occupationCode: "311205",
			occupationDescription: null,
		},
		{
			occupationCode: "311203",
			occupationDescription: null,
		},
		{
			occupationCode: "132303",
			occupationDescription: null,
		},
		{
			occupationCode: "312303",
			occupationDescription: null,
		},
		{
			occupationCode: "311204",
			occupationDescription: null,
		},
		{
			occupationCode: "931201",
			occupationDescription: null,
		},
		{
			occupationCode: "335903",
			occupationDescription: null,
		},
		{
			occupationCode: "122105",
			occupationDescription: null,
		},
		{
			occupationCode: "821101",
			occupationDescription: null,
		},
		{
			occupationCode: "315305",
			occupationDescription: null,
		},
		{
			occupationCode: "721302",
			occupationDescription: null,
		},
		{
			occupationCode: "241301",
			occupationDescription: null,
		},
		{
			occupationCode: "112006",
			occupationDescription: null,
		},
		{
			occupationCode: "633001",
			occupationDescription: null,
		},
		{
			occupationCode: "441901",
			occupationDescription: null,
		},
		{
			occupationCode: "514203",
			occupationDescription: null,
		},
		{
			occupationCode: "522308",
			occupationDescription: null,
		},
		{
			occupationCode: "813103",
			occupationDescription: null,
		},
		{
			occupationCode: "241102",
			occupationDescription: null,
		},
		{
			occupationCode: "214902",
			occupationDescription: null,
		},
		{
			occupationCode: "751303",
			occupationDescription: null,
		},
		{
			occupationCode: "815104",
			occupationDescription: null,
		},
		{
			occupationCode: "143102",
			occupationDescription: null,
		},
		{
			occupationCode: "341102",
			occupationDescription: null,
		},
		{
			occupationCode: "834301",
			occupationDescription: null,
		},
		{
			occupationCode: "834303",
			occupationDescription: null,
		},
		{
			occupationCode: "721502",
			occupationDescription: null,
		},
		{
			occupationCode: "241302",
			occupationDescription: null,
		},
		{
			occupationCode: "242118",
			occupationDescription: null,
		},
		{
			occupationCode: "222113",
			occupationDescription: null,
		},
		{
			occupationCode: "131108",
			occupationDescription: null,
		},
		{
			occupationCode: "611101",
			occupationDescription: null,
		},
		{
			occupationCode: "134935",
			occupationDescription: null,
		},
		{
			occupationCode: "811201",
			occupationDescription: null,
		},
		{
			occupationCode: "131203",
			occupationDescription: null,
		},
		{
			occupationCode: "622102",
			occupationDescription: null,
		},
		{
			occupationCode: "622203",
			occupationDescription: null,
		},
		{
			occupationCode: "634002",
			occupationDescription: null,
		},
		{
			occupationCode: "263214",
			occupationDescription: null,
		},
		{
			occupationCode: "134926",
			occupationDescription: null,
		},
		{
			occupationCode: "143101",
			occupationDescription: null,
		},
		{
			occupationCode: "323002",
			occupationDescription: null,
		},
		{
			occupationCode: "262103",
			occupationDescription: null,
		},
		{
			occupationCode: "421103",
			occupationDescription: null,
		},
		{
			occupationCode: "235102",
			occupationDescription: null,
		},
		{
			occupationCode: "912104",
			occupationDescription: null,
		},
		{
			occupationCode: "422202",
			occupationDescription: null,
		},
		{
			occupationCode: "122204",
			occupationDescription: null,
		},
		{
			occupationCode: "422501",
			occupationDescription: null,
		},
		{
			occupationCode: "422902",
			occupationDescription: null,
		},
		{
			occupationCode: "121306",
			occupationDescription: null,
		},
		{
			occupationCode: "122102",
			occupationDescription: null,
		},
		{
			occupationCode: "243105",
			occupationDescription: null,
		},
		{
			occupationCode: "333102",
			occupationDescription: null,
		},
		{
			occupationCode: "333103",
			occupationDescription: null,
		},
		{
			occupationCode: "441304",
			occupationDescription: null,
		},
		{
			occupationCode: "335201",
			occupationDescription: null,
		},
		{
			occupationCode: "335102",
			occupationDescription: null,
		},
		{
			occupationCode: "134936",
			occupationDescription: null,
		},
		{
			occupationCode: "134937",
			occupationDescription: null,
		},
		{
			occupationCode: "242114",
			occupationDescription: null,
		},
		{
			occupationCode: "252904",
			occupationDescription: null,
		},
		{
			occupationCode: "252921",
			occupationDescription: null,
		},
		{
			occupationCode: "252903",
			occupationDescription: null,
		},
		{
			occupationCode: "252916",
			occupationDescription: null,
		},
		{
			occupationCode: "252922",
			occupationDescription: null,
		},
		{
			occupationCode: "252918",
			occupationDescription: null,
		},
		{
			occupationCode: "252917",
			occupationDescription: null,
		},
		{
			occupationCode: "252915",
			occupationDescription: null,
		},
		{
			occupationCode: "252906",
			occupationDescription: null,
		},
		{
			occupationCode: "251104",
			occupationDescription: null,
		},
		{
			occupationCode: "252905",
			occupationDescription: null,
		},
		{
			occupationCode: "252204",
			occupationDescription: null,
		},
		{
			occupationCode: "242130",
			occupationDescription: null,
		},
		{
			occupationCode: "112010",
			occupationDescription: null,
		},
		{
			occupationCode: "242128",
			occupationDescription: null,
		},
		{
			occupationCode: "242126",
			occupationDescription: null,
		},
		{
			occupationCode: "242129",
			occupationDescription: null,
		},
		{
			occupationCode: "235603",
			occupationDescription: null,
		},
		{
			occupationCode: "252919",
			occupationDescription: null,
		},
		{
			occupationCode: "251206",
			occupationDescription: null,
		},
		{
			occupationCode: "121216",
			occupationDescription: null,
		},
		{
			occupationCode: "261107",
			occupationDescription: null,
		},
		{
			occupationCode: "133012",
			occupationDescription: null,
		},
		{
			occupationCode: "242207",
			occupationDescription: null,
		},
		{
			occupationCode: "251904",
			occupationDescription: null,
		},
		{
			occupationCode: "242127",
			occupationDescription: null,
		},
		{
			occupationCode: "252920",
			occupationDescription: null,
		},
		{
			occupationCode: "251106",
			occupationDescription: null,
		},
		{
			occupationCode: "235604",
			occupationDescription: null,
		},
		{
			occupationCode: "816002",
			occupationDescription: null,
		},
		{
			occupationCode: "751301",
			occupationDescription: null,
		},
		{
			occupationCode: "331505",
			occupationDescription: null,
		},
		{
			occupationCode: "212004",
			occupationDescription: null,
		},
		{
			occupationCode: "441302",
			occupationDescription: null,
		},
		{
			occupationCode: "252206",
			occupationDescription: null,
		},
		{
			occupationCode: "422702",
			occupationDescription: null,
		},
		{
			occupationCode: "441301",
			occupationDescription: null,
		},
		{
			occupationCode: "441303",
			occupationDescription: null,
		},
		{
			occupationCode: "413201",
			occupationDescription: null,
		},
		{
			occupationCode: "334101",
			occupationDescription: null,
		},
		{
			occupationCode: "252907",
			occupationDescription: null,
		},
		{
			occupationCode: "252909",
			occupationDescription: null,
		},
		{
			occupationCode: "133008",
			occupationDescription: null,
		},
		{
			occupationCode: "252105",
			occupationDescription: null,
		},
		{
			occupationCode: "252103",
			occupationDescription: null,
		},
		{
			occupationCode: "252101",
			occupationDescription: null,
		},
		{
			occupationCode: "252102",
			occupationDescription: null,
		},
		{
			occupationCode: "133011",
			occupationDescription: null,
		},
		{
			occupationCode: "252104",
			occupationDescription: null,
		},
		{
			occupationCode: "351204",
			occupationDescription: null,
		},
		{
			occupationCode: "816013",
			occupationDescription: null,
		},
		{
			occupationCode: "816014",
			occupationDescription: null,
		},
		{
			occupationCode: "816015",
			occupationDescription: null,
		},
		{
			occupationCode: "134503",
			occupationDescription: null,
		},
		{
			occupationCode: "731601",
			occupationDescription: null,
		},
		{
			occupationCode: "11001",
			occupationDescription: null,
		},
		{
			occupationCode: "31001",
			occupationDescription: null,
		},
		{
			occupationCode: "21001",
			occupationDescription: null,
		},
		{
			occupationCode: "212006",
			occupationDescription: null,
		},
		{
			occupationCode: "931303",
			occupationDescription: null,
		},
		{
			occupationCode: "321402",
			occupationDescription: null,
		},
		{
			occupationCode: "321401",
			occupationDescription: null,
		},
		{
			occupationCode: "226109",
			occupationDescription: null,
		},
		{
			occupationCode: "111203",
			occupationDescription: null,
		},
		{
			occupationCode: "134502",
			occupationDescription: null,
		},
		{
			occupationCode: "313201",
			occupationDescription: null,
		},
		{
			occupationCode: "516901",
			occupationDescription: null,
		},
		{
			occupationCode: "215207",
			occupationDescription: null,
		},
		{
			occupationCode: "221214",
			occupationDescription: null,
		},
		{
			occupationCode: "325906",
			occupationDescription: null,
		},
		{
			occupationCode: "226504",
			occupationDescription: null,
		},
		{
			occupationCode: "252901",
			occupationDescription: null,
		},
		{
			occupationCode: "522103",
			occupationDescription: null,
		},
		{
			occupationCode: "311406",
			occupationDescription: null,
		},
		{
			occupationCode: "216605",
			occupationDescription: null,
		},
		{
			occupationCode: "251302",
			occupationDescription: null,
		},
		{
			occupationCode: "143116",
			occupationDescription: null,
		},
		{
			occupationCode: "351103",
			occupationDescription: null,
		},
		{
			occupationCode: "252911",
			occupationDescription: null,
		},
		{
			occupationCode: "263306",
			occupationDescription: null,
		},
		{
			occupationCode: "111209",
			occupationDescription: null,
		},
		{
			occupationCode: "524301",
			occupationDescription: null,
		},
		{
			occupationCode: "532103",
			occupationDescription: null,
		},
		{
			occupationCode: "951002",
			occupationDescription: null,
		},
		{
			occupationCode: "265105",
			occupationDescription: null,
		},
		{
			occupationCode: "343507",
			occupationDescription: null,
		},
		{
			occupationCode: "835004",
			occupationDescription: null,
		},
		{
			occupationCode: "731901",
			occupationDescription: null,
		},
		{
			occupationCode: "262102",
			occupationDescription: null,
		},
		{
			occupationCode: "134518",
			occupationDescription: null,
		},
		{
			occupationCode: "811303",
			occupationDescription: null,
		},
		{
			occupationCode: "741206",
			occupationDescription: null,
		},
		{
			occupationCode: "723306",
			occupationDescription: null,
		},
		{
			occupationCode: "931206",
			occupationDescription: null,
		},
		{
			occupationCode: "516501",
			occupationDescription: null,
		},
		{
			occupationCode: "352110",
			occupationDescription: null,
		},
		{
			occupationCode: "321104",
			occupationDescription: null,
		},
		{
			occupationCode: "142004",
			occupationDescription: null,
		},
		{
			occupationCode: "243107",
			occupationDescription: null,
		},
		{
			occupationCode: "263102",
			occupationDescription: null,
		},
		{
			occupationCode: "121301",
			occupationDescription: null,
		},
		{
			occupationCode: "263101",
			occupationDescription: null,
		},
		{
			occupationCode: "816007",
			occupationDescription: null,
		},
		{
			occupationCode: "143118",
			occupationDescription: null,
		},
		{
			occupationCode: "264207",
			occupationDescription: null,
		},
		{
			occupationCode: "264205",
			occupationDescription: null,
		},
		{
			occupationCode: "134514",
			occupationDescription: null,
		},
		{
			occupationCode: "134512",
			occupationDescription: null,
		},
		{
			occupationCode: "235103",
			occupationDescription: null,
		},
		{
			occupationCode: "231002",
			occupationDescription: null,
		},
		{
			occupationCode: "134511",
			occupationDescription: null,
		},
		{
			occupationCode: "235104",
			occupationDescription: null,
		},
		{
			occupationCode: "265412",
			occupationDescription: null,
		},
		{
			occupationCode: "134301",
			occupationDescription: null,
		},
		{
			occupationCode: "222111",
			occupationDescription: null,
		},
		{
			occupationCode: "532102",
			occupationDescription: null,
		},
		{
			occupationCode: "821202",
			occupationDescription: null,
		},
		{
			occupationCode: "311307",
			occupationDescription: null,
		},
		{
			occupationCode: "313104",
			occupationDescription: null,
		},
		{
			occupationCode: "821203",
			occupationDescription: null,
		},
		{
			occupationCode: "311306",
			occupationDescription: null,
		},
		{
			occupationCode: "821205",
			occupationDescription: null,
		},
		{
			occupationCode: "741207",
			occupationDescription: null,
		},
		{
			occupationCode: "215101",
			occupationDescription: null,
		},
		{
			occupationCode: "215103",
			occupationDescription: null,
		},
		{
			occupationCode: "311301",
			occupationDescription: null,
		},
		{
			occupationCode: "821201",
			occupationDescription: null,
		},
		{
			occupationCode: "311305",
			occupationDescription: null,
		},
		{
			occupationCode: "741202",
			occupationDescription: null,
		},
		{
			occupationCode: "313103",
			occupationDescription: null,
		},
		{
			occupationCode: "311304",
			occupationDescription: null,
		},
		{
			occupationCode: "215104",
			occupationDescription: null,
		},
		{
			occupationCode: "311308",
			occupationDescription: null,
		},
		{
			occupationCode: "821207",
			occupationDescription: null,
		},
		{
			occupationCode: "311404",
			occupationDescription: null,
		},
		{
			occupationCode: "311403",
			occupationDescription: null,
		},
		{
			occupationCode: "132112",
			occupationDescription: null,
		},
		{
			occupationCode: "215203",
			occupationDescription: null,
		},
		{
			occupationCode: "311409",
			occupationDescription: null,
		},
		{
			occupationCode: "742102",
			occupationDescription: null,
		},
		{
			occupationCode: "821208",
			occupationDescription: null,
		},
		{
			occupationCode: "215201",
			occupationDescription: null,
		},
		{
			occupationCode: "215202",
			occupationDescription: null,
		},
		{
			occupationCode: "234109",
			occupationDescription: null,
		},
		{
			occupationCode: "741203",
			occupationDescription: null,
		},
		{
			occupationCode: "753302",
			occupationDescription: null,
		},
		{
			occupationCode: "213111",
			occupationDescription: null,
		},
		{
			occupationCode: "242110",
			occupationDescription: null,
		},
		{
			occupationCode: "224001",
			occupationDescription: null,
		},
		{
			occupationCode: "325801",
			occupationDescription: null,
		},
		{
			occupationCode: "222114",
			occupationDescription: null,
		},
		{
			occupationCode: "325802",
			occupationDescription: null,
		},
		{
			occupationCode: "134901",
			occupationDescription: null,
		},
		{
			occupationCode: "242304",
			occupationDescription: null,
		},
		{
			occupationCode: "252913",
			occupationDescription: null,
		},
		{
			occupationCode: "821102",
			occupationDescription: null,
		},
		{
			occupationCode: "311801",
			occupationDescription: null,
		},
		{
			occupationCode: "231006",
			occupationDescription: null,
		},
		{
			occupationCode: "233022",
			occupationDescription: null,
		},
		{
			occupationCode: "232003",
			occupationDescription: null,
		},
		{
			occupationCode: "143103",
			occupationDescription: null,
		},
		{
			occupationCode: "325702",
			occupationDescription: null,
		},
		{
			occupationCode: "134908",
			occupationDescription: null,
		},
		{
			occupationCode: "231018",
			occupationDescription: null,
		},
		{
			occupationCode: "214301",
			occupationDescription: null,
		},
		{
			occupationCode: "226301",
			occupationDescription: null,
		},
		{
			occupationCode: "213301",
			occupationDescription: null,
		},
		{
			occupationCode: "325301",
			occupationDescription: null,
		},
		{
			occupationCode: "213113",
			occupationDescription: null,
		},
		{
			occupationCode: "516201",
			occupationDescription: null,
		},
		{
			occupationCode: "134515",
			occupationDescription: null,
		},
		{
			occupationCode: "333204",
			occupationDescription: null,
		},
		{
			occupationCode: "333202",
			occupationDescription: null,
		},
		{
			occupationCode: "311208",
			occupationDescription: null,
		},
		{
			occupationCode: "261904",
			occupationDescription: null,
		},
		{
			occupationCode: "334301",
			occupationDescription: null,
		},
		{
			occupationCode: "262106",
			occupationDescription: null,
		},
		{
			occupationCode: "343201",
			occupationDescription: null,
		},
		{
			occupationCode: "343302",
			occupationDescription: null,
		},
		{
			occupationCode: "524102",
			occupationDescription: null,
		},
		{
			occupationCode: "214903",
			occupationDescription: null,
		},
		{
			occupationCode: "754201",
			occupationDescription: null,
		},
		{
			occupationCode: "813109",
			occupationDescription: null,
		},
		{
			occupationCode: "343509",
			occupationDescription: null,
		},
		{
			occupationCode: "541101",
			occupationDescription: null,
		},
		{
			occupationCode: "815408",
			occupationDescription: null,
		},
		{
			occupationCode: "815406",
			occupationDescription: null,
		},
		{
			occupationCode: "815407",
			occupationDescription: null,
		},
		{
			occupationCode: "132115",
			occupationDescription: null,
		},
		{
			occupationCode: "754901",
			occupationDescription: null,
		},
		{
			occupationCode: "612903",
			occupationDescription: null,
		},
		{
			occupationCode: "516406",
			occupationDescription: null,
		},
		{
			occupationCode: "263502",
			occupationDescription: null,
		},
		{
			occupationCode: "226107",
			occupationDescription: null,
		},
		{
			occupationCode: "234104",
			occupationDescription: null,
		},
		{
			occupationCode: "221102",
			occupationDescription: null,
		},
		{
			occupationCode: "921101",
			occupationDescription: null,
		},
		{
			occupationCode: "921102",
			occupationDescription: null,
		},
		{
			occupationCode: "216301",
			occupationDescription: null,
		},
		{
			occupationCode: "516902",
			occupationDescription: null,
		},
		{
			occupationCode: "941101",
			occupationDescription: null,
		},
		{
			occupationCode: "263602",
			occupationDescription: null,
		},
		{
			occupationCode: "263607",
			occupationDescription: null,
		},
		{
			occupationCode: "111403",
			occupationDescription: null,
		},
		{
			occupationCode: "315206",
			occupationDescription: null,
		},
		{
			occupationCode: "813105",
			occupationDescription: null,
		},
		{
			occupationCode: "821905",
			occupationDescription: null,
		},
		{
			occupationCode: "815105",
			occupationDescription: null,
		},
		{
			occupationCode: "422701",
			occupationDescription: null,
		},
		{
			occupationCode: "818302",
			occupationDescription: null,
		},
		{
			occupationCode: "143109",
			occupationDescription: null,
		},
		{
			occupationCode: "343503",
			occupationDescription: null,
		},
		{
			occupationCode: "134604",
			occupationDescription: null,
		},
		{
			occupationCode: "241303",
			occupationDescription: null,
		},
		{
			occupationCode: "134603",
			occupationDescription: null,
		},
		{
			occupationCode: "121115",
			occupationDescription: null,
		},
		{
			occupationCode: "241201",
			occupationDescription: null,
		},
		{
			occupationCode: "241311",
			occupationDescription: null,
		},
		{
			occupationCode: "241304",
			occupationDescription: null,
		},
		{
			occupationCode: "121101",
			occupationDescription: null,
		},
		{
			occupationCode: "241203",
			occupationDescription: null,
		},
		{
			occupationCode: "241305",
			occupationDescription: null,
		},
		{
			occupationCode: "121308",
			occupationDescription: null,
		},
		{
			occupationCode: "134939",
			occupationDescription: null,
		},
		{
			occupationCode: "311202",
			occupationDescription: null,
		},
		{
			occupationCode: "311213",
			occupationDescription: null,
		},
		{
			occupationCode: "962401",
			occupationDescription: null,
		},
		{
			occupationCode: "532902",
			occupationDescription: null,
		},
		{
			occupationCode: "816009",
			occupationDescription: null,
		},
		{
			occupationCode: "131202",
			occupationDescription: null,
		},
		{
			occupationCode: "921602",
			occupationDescription: null,
		},
		{
			occupationCode: "921601",
			occupationDescription: null,
		},
		{
			occupationCode: "622101",
			occupationDescription: null,
		},
		{
			occupationCode: "213206",
			occupationDescription: null,
		},
		{
			occupationCode: "131201",
			occupationDescription: null,
		},
		{
			occupationCode: "731805",
			occupationDescription: null,
		},
		{
			occupationCode: "622302",
			occupationDescription: null,
		},
		{
			occupationCode: "622104",
			occupationDescription: null,
		},
		{
			occupationCode: "751102",
			occupationDescription: null,
		},
		{
			occupationCode: "342301",
			occupationDescription: null,
		},
		{
			occupationCode: "315304",
			occupationDescription: null,
		},
		{
			occupationCode: "721203",
			occupationDescription: null,
		},
		{
			occupationCode: "132414",
			occupationDescription: null,
		},
		{
			occupationCode: "511101",
			occupationDescription: null,
		},
		{
			occupationCode: "315302",
			occupationDescription: null,
		},
		{
			occupationCode: "754902",
			occupationDescription: null,
		},
		{
			occupationCode: "223001",
			occupationDescription: null,
		},
		{
			occupationCode: "524601",
			occupationDescription: null,
		},
		{
			occupationCode: "751502",
			occupationDescription: null,
		},
		{
			occupationCode: "751501",
			occupationDescription: null,
		},
		{
			occupationCode: "522302",
			occupationDescription: null,
		},
		{
			occupationCode: "141205",
			occupationDescription: null,
		},
		{
			occupationCode: "816003",
			occupationDescription: null,
		},
		{
			occupationCode: "521201",
			occupationDescription: null,
		},
		{
			occupationCode: "314106",
			occupationDescription: null,
		},
		{
			occupationCode: "816012",
			occupationDescription: null,
		},
		{
			occupationCode: "331101",
			occupationDescription: null,
		},
		{
			occupationCode: "234103",
			occupationDescription: null,
		},
		{
			occupationCode: "233003",
			occupationDescription: null,
		},
		{
			occupationCode: "235301",
			occupationDescription: null,
		},
		{
			occupationCode: "134914",
			occupationDescription: null,
		},
		{
			occupationCode: "343103",
			occupationDescription: null,
		},
		{
			occupationCode: "261901",
			occupationDescription: null,
		},
		{
			occupationCode: "311901",
			occupationDescription: null,
		},
		{
			occupationCode: "921503",
			occupationDescription: null,
		},
		{
			occupationCode: "231020",
			occupationDescription: null,
		},
		{
			occupationCode: "921501",
			occupationDescription: null,
		},
		{
			occupationCode: "213204",
			occupationDescription: null,
		},
		{
			occupationCode: "314301",
			occupationDescription: null,
		},
		{
			occupationCode: "621001",
			occupationDescription: null,
		},
		{
			occupationCode: "335902",
			occupationDescription: null,
		},
		{
			occupationCode: "333101",
			occupationDescription: null,
		},
		{
			occupationCode: "263604",
			occupationDescription: null,
		},
		{
			occupationCode: "816004",
			occupationDescription: null,
		},
		{
			occupationCode: "751401",
			occupationDescription: null,
		},
		{
			occupationCode: "226403",
			occupationDescription: null,
		},
		{
			occupationCode: "421401",
			occupationDescription: null,
		},
		{
			occupationCode: "122205",
			occupationDescription: null,
		},
		{
			occupationCode: "516302",
			occupationDescription: null,
		},
		{
			occupationCode: "753103",
			occupationDescription: null,
		},
		{
			occupationCode: "821901",
			occupationDescription: null,
		},
		{
			occupationCode: "752202",
			occupationDescription: null,
		},
		{
			occupationCode: "216304",
			occupationDescription: null,
		},
		{
			occupationCode: "522310",
			occupationDescription: null,
		},
		{
			occupationCode: "332401",
			occupationDescription: null,
		},
		{
			occupationCode: "251107",
			occupationDescription: null,
		},
		{
			occupationCode: "833205",
			occupationDescription: null,
		},
		{
			occupationCode: "961302",
			occupationDescription: null,
		},
		{
			occupationCode: "753201",
			occupationDescription: null,
		},
		{
			occupationCode: "313401",
			occupationDescription: null,
		},
		{
			occupationCode: "524501",
			occupationDescription: null,
		},
		{
			occupationCode: "731302",
			occupationDescription: null,
		},
		{
			occupationCode: "263301",
			occupationDescription: null,
		},
		{
			occupationCode: "226105",
			occupationDescription: null,
		},
		{
			occupationCode: "112004",
			occupationDescription: null,
		},
		{
			occupationCode: "134940",
			occupationDescription: null,
		},
		{
			occupationCode: "335907",
			occupationDescription: null,
		},
		{
			occupationCode: "221217",
			occupationDescription: null,
		},
		{
			occupationCode: "213110",
			occupationDescription: null,
		},
		{
			occupationCode: "753502",
			occupationDescription: null,
		},
		{
			occupationCode: "216503",
			occupationDescription: null,
		},
		{
			occupationCode: "132209",
			occupationDescription: null,
		},
		{
			occupationCode: "311105",
			occupationDescription: null,
		},
		{
			occupationCode: "211402",
			occupationDescription: null,
		},
		{
			occupationCode: "214204",
			occupationDescription: null,
		},
		{
			occupationCode: "751302",
			occupationDescription: null,
		},
		{
			occupationCode: "818105",
			occupationDescription: null,
		},
		{
			occupationCode: "731501",
			occupationDescription: null,
		},
		{
			occupationCode: "818106",
			occupationDescription: null,
		},
		{
			occupationCode: "818102",
			occupationDescription: null,
		},
		{
			occupationCode: "818103",
			occupationDescription: null,
		},
		{
			occupationCode: "818104",
			occupationDescription: null,
		},
		{
			occupationCode: "731502",
			occupationDescription: null,
		},
		{
			occupationCode: "411001",
			occupationDescription: null,
		},
		{
			occupationCode: "241312",
			occupationDescription: null,
		},
		{
			occupationCode: "111107",
			occupationDescription: null,
		},
		{
			occupationCode: "111205",
			occupationDescription: null,
		},
		{
			occupationCode: "834206",
			occupationDescription: null,
		},
		{
			occupationCode: "611103",
			occupationDescription: null,
		},
		{
			occupationCode: "816010",
			occupationDescription: null,
		},
		{
			occupationCode: "816006",
			occupationDescription: null,
		},
		{
			occupationCode: "134918",
			occupationDescription: null,
		},
		{
			occupationCode: "216601",
			occupationDescription: null,
		},
		{
			occupationCode: "931207",
			occupationDescription: null,
		},
		{
			occupationCode: "611303",
			occupationDescription: null,
		},
		{
			occupationCode: "611102",
			occupationDescription: null,
		},
		{
			occupationCode: "134913",
			occupationDescription: null,
		},
		{
			occupationCode: "311303",
			occupationDescription: null,
		},
		{
			occupationCode: "516401",
			occupationDescription: null,
		},
		{
			occupationCode: "315402",
			occupationDescription: null,
		},
		{
			occupationCode: "541903",
			occupationDescription: null,
		},
		{
			occupationCode: "541904",
			occupationDescription: null,
		},
		{
			occupationCode: "515203",
			occupationDescription: null,
		},
		{
			occupationCode: "235901",
			occupationDescription: null,
		},
		{
			occupationCode: "221222",
			occupationDescription: null,
		},
		{
			occupationCode: "222107",
			occupationDescription: null,
		},
		{
			occupationCode: "263606",
			occupationDescription: null,
		},
		{
			occupationCode: "341306",
			occupationDescription: null,
		},
		{
			occupationCode: "134919",
			occupationDescription: null,
		},
		{
			occupationCode: "263605",
			occupationDescription: null,
		},
		{
			occupationCode: "134404",
			occupationDescription: null,
		},
		{
			occupationCode: "712203",
			occupationDescription: null,
		},
		{
			occupationCode: "921204",
			occupationDescription: null,
		},
		{
			occupationCode: "343401",
			occupationDescription: null,
		},
		{
			occupationCode: "134903",
			occupationDescription: null,
		},
		{
			occupationCode: "111401",
			occupationDescription: null,
		},
		{
			occupationCode: "134912",
			occupationDescription: null,
		},
		{
			occupationCode: "112005",
			occupationDescription: null,
		},
		{
			occupationCode: "134938",
			occupationDescription: null,
		},
		{
			occupationCode: "134506",
			occupationDescription: null,
		},
		{
			occupationCode: "134201",
			occupationDescription: null,
		},
		{
			occupationCode: "325601",
			occupationDescription: null,
		},
		{
			occupationCode: "134206",
			occupationDescription: null,
		},
		{
			occupationCode: "514204",
			occupationDescription: null,
		},
		{
			occupationCode: "143104",
			occupationDescription: null,
		},
		{
			occupationCode: "325704",
			occupationDescription: null,
		},
		{
			occupationCode: "134202",
			occupationDescription: null,
		},
		{
			occupationCode: "262107",
			occupationDescription: null,
		},
		{
			occupationCode: "325201",
			occupationDescription: null,
		},
		{
			occupationCode: "231008",
			occupationDescription: null,
		},
		{
			occupationCode: "233024",
			occupationDescription: null,
		},
		{
			occupationCode: "325203",
			occupationDescription: null,
		},
		{
			occupationCode: "212005",
			occupationDescription: null,
		},
		{
			occupationCode: "234105",
			occupationDescription: null,
		},
		{
			occupationCode: "311508",
			occupationDescription: null,
		},
		{
			occupationCode: "723302",
			occupationDescription: null,
		},
		{
			occupationCode: "214409",
			occupationDescription: null,
		},
		{
			occupationCode: "834207",
			occupationDescription: null,
		},
		{
			occupationCode: "516502",
			occupationDescription: null,
		},
		{
			occupationCode: "315303",
			occupationDescription: null,
		},
		{
			occupationCode: "311513",
			occupationDescription: null,
		},
		{
			occupationCode: "835001",
			occupationDescription: null,
		},
		{
			occupationCode: "221211",
			occupationDescription: null,
		},
		{
			occupationCode: "343501",
			occupationDescription: null,
		},
		{
			occupationCode: "522312",
			occupationDescription: null,
		},
		{
			occupationCode: "815504",
			occupationDescription: null,
		},
		{
			occupationCode: "815501",
			occupationDescription: null,
		},
		{
			occupationCode: "622301",
			occupationDescription: null,
		},
		{
			occupationCode: "231001",
			occupationDescription: null,
		},
		{
			occupationCode: "263305",
			occupationDescription: null,
		},
		{
			occupationCode: "341305",
			occupationDescription: null,
		},
		{
			occupationCode: "341304",
			occupationDescription: null,
		},
		{
			occupationCode: "233028",
			occupationDescription: null,
		},
		{
			occupationCode: "612107",
			occupationDescription: null,
		},
		{
			occupationCode: "611301",
			occupationDescription: null,
		},
		{
			occupationCode: "422901",
			occupationDescription: null,
		},
		{
			occupationCode: "134205",
			occupationDescription: null,
		},
		{
			occupationCode: "141202",
			occupationDescription: null,
		},
		{
			occupationCode: "231023",
			occupationDescription: null,
		},
		{
			occupationCode: "141104",
			occupationDescription: null,
		},
		{
			occupationCode: "335904",
			occupationDescription: null,
		},
		{
			occupationCode: "911202",
			occupationDescription: null,
		},
		{
			occupationCode: "141101",
			occupationDescription: null,
		},
		{
			occupationCode: "263212",
			occupationDescription: null,
		},
		{
			occupationCode: "141102",
			occupationDescription: null,
		},
		{
			occupationCode: "422401",
			occupationDescription: null,
		},
		{
			occupationCode: "263210",
			occupationDescription: null,
		},
		{
			occupationCode: "141103",
			occupationDescription: null,
		},
		{
			occupationCode: "512004",
			occupationDescription: null,
		},
		{
			occupationCode: "532201",
			occupationDescription: null,
		},
		{
			occupationCode: "515201",
			occupationDescription: null,
		},
		{
			occupationCode: "134401",
			occupationDescription: null,
		},
		{
			occupationCode: "121207",
			occupationDescription: null,
		},
		{
			occupationCode: "121201",
			occupationDescription: null,
		},
		{
			occupationCode: "242302",
			occupationDescription: null,
		},
		{
			occupationCode: "242401",
			occupationDescription: null,
		},
		{
			occupationCode: "214907",
			occupationDescription: null,
		},
		{
			occupationCode: "441601",
			occupationDescription: null,
		},
		{
			occupationCode: "242310",
			occupationDescription: null,
		},
		{
			occupationCode: "214406",
			occupationDescription: null,
		},
		{
			occupationCode: "712702",
			occupationDescription: null,
		},
		{
			occupationCode: "311502",
			occupationDescription: null,
		},
		{
			occupationCode: "216504",
			occupationDescription: null,
		},
		{
			occupationCode: "311107",
			occupationDescription: null,
		},
		{
			occupationCode: "132210",
			occupationDescription: null,
		},
		{
			occupationCode: "211404",
			occupationDescription: null,
		},
		{
			occupationCode: "742202",
			occupationDescription: null,
		},
		{
			occupationCode: "742201",
			occupationDescription: null,
		},
		{
			occupationCode: "232004",
			occupationDescription: null,
		},
		{
			occupationCode: "335901",
			occupationDescription: null,
		},
		{
			occupationCode: "252914",
			occupationDescription: null,
		},
		{
			occupationCode: "754903",
			occupationDescription: null,
		},
		{
			occupationCode: "313206",
			occupationDescription: null,
		},
		{
			occupationCode: "262202",
			occupationDescription: null,
		},
		{
			occupationCode: "121208",
			occupationDescription: null,
		},
		{
			occupationCode: "211302",
			occupationDescription: null,
		},
		{
			occupationCode: "216303",
			occupationDescription: null,
		},
		{
			occupationCode: "132109",
			occupationDescription: null,
		},
		{
			occupationCode: "214101",
			occupationDescription: null,
		},
		{
			occupationCode: "243303",
			occupationDescription: null,
		},
		{
			occupationCode: "132102",
			occupationDescription: null,
		},
		{
			occupationCode: "731202",
			occupationDescription: null,
		},
		{
			occupationCode: "231005",
			occupationDescription: null,
		},
		{
			occupationCode: "251102",
			occupationDescription: null,
		},
		{
			occupationCode: "252207",
			occupationDescription: null,
		},
		{
			occupationCode: "252203",
			occupationDescription: null,
		},
		{
			occupationCode: "422502",
			occupationDescription: null,
		},
		{
			occupationCode: "314104",
			occupationDescription: null,
		},
		{
			occupationCode: "811103",
			occupationDescription: null,
		},
		{
			occupationCode: "134504",
			occupationDescription: null,
		},
		{
			occupationCode: "134505",
			occupationDescription: null,
		},
		{
			occupationCode: "121213",
			occupationDescription: null,
		},
		{
			occupationCode: "242119",
			occupationDescription: null,
		},
		{
			occupationCode: "121312",
			occupationDescription: null,
		},
		{
			occupationCode: "343510",
			occupationDescription: null,
		},
		{
			occupationCode: "332101",
			occupationDescription: null,
		},
		{
			occupationCode: "331502",
			occupationDescription: null,
		},
		{
			occupationCode: "134602",
			occupationDescription: null,
		},
		{
			occupationCode: "332103",
			occupationDescription: null,
		},
		{
			occupationCode: "121109",
			occupationDescription: null,
		},
		{
			occupationCode: "11002",
			occupationDescription: null,
		},
		{
			occupationCode: "31002",
			occupationDescription: null,
		},
		{
			occupationCode: "21002",
			occupationDescription: null,
		},
		{
			occupationCode: "221210",
			occupationDescription: null,
		},
		{
			occupationCode: "216102",
			occupationDescription: null,
		},
		{
			occupationCode: "343202",
			occupationDescription: null,
		},
		{
			occupationCode: "233026",
			occupationDescription: null,
		},
		{
			occupationCode: "233027",
			occupationDescription: null,
		},
		{
			occupationCode: "233033",
			occupationDescription: null,
		},
		{
			occupationCode: "233036",
			occupationDescription: null,
		},
		{
			occupationCode: "233035",
			occupationDescription: null,
		},
		{
			occupationCode: "233034",
			occupationDescription: null,
		},
		{
			occupationCode: "233032",
			occupationDescription: null,
		},
		{
			occupationCode: "233025",
			occupationDescription: null,
		},
		{
			occupationCode: "233029",
			occupationDescription: null,
		},
		{
			occupationCode: "121107",
			occupationDescription: null,
		},
		{
			occupationCode: "243204",
			occupationDescription: null,
		},
		{
			occupationCode: "21005",
			occupationDescription: null,
		},
		{
			occupationCode: "11005",
			occupationDescription: null,
		},
		{
			occupationCode: "31005",
			occupationDescription: null,
		},
		{
			occupationCode: "243203",
			occupationDescription: null,
		},
		{
			occupationCode: "122202",
			occupationDescription: null,
		},
		{
			occupationCode: "432103",
			occupationDescription: null,
		},
		{
			occupationCode: "241109",
			occupationDescription: null,
		},
		{
			occupationCode: "331302",
			occupationDescription: null,
		},
		{
			occupationCode: "134925",
			occupationDescription: null,
		},
		{
			occupationCode: "134924",
			occupationDescription: null,
		},
		{
			occupationCode: "121110",
			occupationDescription: null,
		},
		{
			occupationCode: "241202",
			occupationDescription: null,
		},
		{
			occupationCode: "121307",
			occupationDescription: null,
		},
		{
			occupationCode: "243201",
			occupationDescription: null,
		},
		{
			occupationCode: "815305",
			occupationDescription: null,
		},
		{
			occupationCode: "912102",
			occupationDescription: null,
		},
		{
			occupationCode: "815703",
			occupationDescription: null,
		},
		{
			occupationCode: "131102",
			occupationDescription: null,
		},
		{
			occupationCode: "314203",
			occupationDescription: null,
		},
		{
			occupationCode: "263601",
			occupationDescription: null,
		},
		{
			occupationCode: "214910",
			occupationDescription: null,
		},
		{
			occupationCode: "133002",
			occupationDescription: null,
		},
		{
			occupationCode: "133001",
			occupationDescription: null,
		},
		{
			occupationCode: "351301",
			occupationDescription: null,
		},
		{
			occupationCode: "351101",
			occupationDescription: null,
		},
		{
			occupationCode: "235601",
			occupationDescription: null,
		},
		{
			occupationCode: "351201",
			occupationDescription: null,
		},
		{
			occupationCode: "214911",
			occupationDescription: null,
		},
		{
			occupationCode: "133007",
			occupationDescription: null,
		},
		{
			occupationCode: "215206",
			occupationDescription: null,
		},
		{
			occupationCode: "133009",
			occupationDescription: null,
		},
		{
			occupationCode: "235602",
			occupationDescription: null,
		},
		{
			occupationCode: "243402",
			occupationDescription: null,
		},
		{
			occupationCode: "243401",
			occupationDescription: null,
		},
		{
			occupationCode: "515301",
			occupationDescription: null,
		},
		{
			occupationCode: "311514",
			occupationDescription: null,
		},
		{
			occupationCode: "335908",
			occupationDescription: null,
		},
		{
			occupationCode: "216305",
			occupationDescription: null,
		},
		{
			occupationCode: "522313",
			occupationDescription: null,
		},
		{
			occupationCode: "242303",
			occupationDescription: null,
		},
		{
			occupationCode: "242301",
			occupationDescription: null,
		},
		{
			occupationCode: "242403",
			occupationDescription: null,
		},
		{
			occupationCode: "264201",
			occupationDescription: null,
		},
		{
			occupationCode: "264203",
			occupationDescription: null,
		},
		{
			occupationCode: "264202",
			occupationDescription: null,
		},
		{
			occupationCode: "334202",
			occupationDescription: null,
		},
		{
			occupationCode: "341202",
			occupationDescription: null,
		},
		{
			occupationCode: "134403",
			occupationDescription: null,
		},
		{
			occupationCode: "263504",
			occupationDescription: null,
		},
		{
			occupationCode: "134102",
			occupationDescription: null,
		},
		{
			occupationCode: "722203",
			occupationDescription: null,
		},
		{
			occupationCode: "941201",
			occupationDescription: null,
		},
		{
			occupationCode: "731801",
			occupationDescription: null,
		},
		{
			occupationCode: "815204",
			occupationDescription: null,
		},
		{
			occupationCode: "818301",
			occupationDescription: null,
		},
		{
			occupationCode: "932102",
			occupationDescription: null,
		},
		{
			occupationCode: "121211",
			occupationDescription: null,
		},
		{
			occupationCode: "333302",
			occupationDescription: null,
		},
		{
			occupationCode: "121202",
			occupationDescription: null,
		},
		{
			occupationCode: "242309",
			occupationDescription: null,
		},
		{
			occupationCode: "242307",
			occupationDescription: null,
		},
		{
			occupationCode: "242202",
			occupationDescription: null,
		},
		{
			occupationCode: "121210",
			occupationDescription: null,
		},
		{
			occupationCode: "242308",
			occupationDescription: null,
		},
		{
			occupationCode: "221216",
			occupationDescription: null,
		},
		{
			occupationCode: "422101",
			occupationDescription: null,
		},
		{
			occupationCode: "216505",
			occupationDescription: null,
		},
		{
			occupationCode: "132404",
			occupationDescription: null,
		},
		{
			occupationCode: "132412",
			occupationDescription: null,
		},
		{
			occupationCode: "132110",
			occupationDescription: null,
		},
		{
			occupationCode: "132406",
			occupationDescription: null,
		},
		{
			occupationCode: "216201",
			occupationDescription: null,
		},
		{
			occupationCode: "921401",
			occupationDescription: null,
		},
		{
			occupationCode: "722301",
			occupationDescription: null,
		},
		{
			occupationCode: "815701",
			occupationDescription: null,
		},
		{
			occupationCode: "231010",
			occupationDescription: null,
		},
		{
			occupationCode: "263603",
			occupationDescription: null,
		},
		{
			occupationCode: "235203",
			occupationDescription: null,
		},
		{
			occupationCode: "331203",
			occupationDescription: null,
		},
		{
			occupationCode: "134605",
			occupationDescription: null,
		},
		{
			occupationCode: "815502",
			occupationDescription: null,
		},
		{
			occupationCode: "731804",
			occupationDescription: null,
		},
		{
			occupationCode: "815507",
			occupationDescription: null,
		},
		{
			occupationCode: "815508",
			occupationDescription: null,
		},
		{
			occupationCode: "753602",
			occupationDescription: null,
		},
		{
			occupationCode: "815509",
			occupationDescription: null,
		},
		{
			occupationCode: "815505",
			occupationDescription: null,
		},
		{
			occupationCode: "815503",
			occupationDescription: null,
		},
		{
			occupationCode: "815506",
			occupationDescription: null,
		},
		{
			occupationCode: "134911",
			occupationDescription: null,
		},
		{
			occupationCode: "334201",
			occupationDescription: null,
		},
		{
			occupationCode: "261106",
			occupationDescription: null,
		},
		{
			occupationCode: "262201",
			occupationDescription: null,
		},
		{
			occupationCode: "233019",
			occupationDescription: null,
		},
		{
			occupationCode: "441101",
			occupationDescription: null,
		},
		{
			occupationCode: "134927",
			occupationDescription: null,
		},
		{
			occupationCode: "262203",
			occupationDescription: null,
		},
		{
			occupationCode: "343303",
			occupationDescription: null,
		},
		{
			occupationCode: "121309",
			occupationDescription: null,
		},
		{
			occupationCode: "335401",
			occupationDescription: null,
		},
		{
			occupationCode: "541901",
			occupationDescription: null,
		},
		{
			occupationCode: "723303",
			occupationDescription: null,
		},
		{
			occupationCode: "265403",
			occupationDescription: null,
		},
		{
			occupationCode: "352106",
			occupationDescription: null,
		},
		{
			occupationCode: "522305",
			occupationDescription: null,
		},
		{
			occupationCode: "264305",
			occupationDescription: null,
		},
		{
			occupationCode: "264106",
			occupationDescription: null,
		},
		{
			occupationCode: "264105",
			occupationDescription: null,
		},
		{
			occupationCode: "333907",
			occupationDescription: null,
		},
		{
			occupationCode: "325907",
			occupationDescription: null,
		},
		{
			occupationCode: "341103",
			occupationDescription: null,
		},
		{
			occupationCode: "131104",
			occupationDescription: null,
		},
		{
			occupationCode: "933301",
			occupationDescription: null,
		},
		{
			occupationCode: "834201",
			occupationDescription: null,
		},
		{
			occupationCode: "331201",
			occupationDescription: null,
		},
		{
			occupationCode: "722202",
			occupationDescription: null,
		},
		{
			occupationCode: "231025",
			occupationDescription: null,
		},
		{
			occupationCode: "132415",
			occupationDescription: null,
		},
		{
			occupationCode: "621003",
			occupationDescription: null,
		},
		{
			occupationCode: "962302",
			occupationDescription: null,
		},
		{
			occupationCode: "331506",
			occupationDescription: null,
		},
		{
			occupationCode: "441201",
			occupationDescription: null,
		},
		{
			occupationCode: "242107",
			occupationDescription: null,
		},
		{
			occupationCode: "441203",
			occupationDescription: null,
		},
		{
			occupationCode: "441202",
			occupationDescription: null,
		},
		{
			occupationCode: "132104",
			occupationDescription: null,
		},
		{
			occupationCode: "343502",
			occupationDescription: null,
		},
		{
			occupationCode: "251905",
			occupationDescription: null,
		},
		{
			occupationCode: "132101",
			occupationDescription: null,
		},
		{
			occupationCode: "932901",
			occupationDescription: null,
		},
		{
			occupationCode: "312201",
			occupationDescription: null,
		},
		{
			occupationCode: "611306",
			occupationDescription: null,
		},
		{
			occupationCode: "818108",
			occupationDescription: null,
		},
		{
			occupationCode: "213107",
			occupationDescription: null,
		},
		{
			occupationCode: "754103",
			occupationDescription: null,
		},
		{
			occupationCode: "315202",
			occupationDescription: null,
		},
		{
			occupationCode: "315208",
			occupationDescription: null,
		},
		{
			occupationCode: "511102",
			occupationDescription: null,
		},
		{
			occupationCode: "311503",
			occupationDescription: null,
		},
		{
			occupationCode: "311504",
			occupationDescription: null,
		},
		{
			occupationCode: "132407",
			occupationDescription: null,
		},
		{
			occupationCode: "243108",
			occupationDescription: null,
		},
		{
			occupationCode: "524905",
			occupationDescription: null,
		},
		{
			occupationCode: "341301",
			occupationDescription: null,
		},
		{
			occupationCode: "214904",
			occupationDescription: null,
		},
		{
			occupationCode: "222104",
			occupationDescription: null,
		},
		{
			occupationCode: "231017",
			occupationDescription: null,
		},
		{
			occupationCode: "331403",
			occupationDescription: null,
		},
		{
			occupationCode: "212001",
			occupationDescription: null,
		},
		{
			occupationCode: "753402",
			occupationDescription: null,
		},
		{
			occupationCode: "341105",
			occupationDescription: null,
		},
		{
			occupationCode: "134207",
			occupationDescription: null,
		},
		{
			occupationCode: "941102",
			occupationDescription: null,
		},
		{
			occupationCode: "235105",
			occupationDescription: null,
		},
		{
			occupationCode: "731101",
			occupationDescription: null,
		},
		{
			occupationCode: "816008",
			occupationDescription: null,
		},
		{
			occupationCode: "132111",
			occupationDescription: null,
		},
		{
			occupationCode: "214401",
			occupationDescription: null,
		},
		{
			occupationCode: "214403",
			occupationDescription: null,
		},
		{
			occupationCode: "311501",
			occupationDescription: null,
		},
		{
			occupationCode: "821106",
			occupationDescription: null,
		},
		{
			occupationCode: "311511",
			occupationDescription: null,
		},
		{
			occupationCode: "311506",
			occupationDescription: null,
		},
		{
			occupationCode: "311505",
			occupationDescription: null,
		},
		{
			occupationCode: "311507",
			occupationDescription: null,
		},
		{
			occupationCode: "214412",
			occupationDescription: null,
		},
		{
			occupationCode: "311902",
			occupationDescription: null,
		},
		{
			occupationCode: "226902",
			occupationDescription: null,
		},
		{
			occupationCode: "143113",
			occupationDescription: null,
		},
		{
			occupationCode: "231013",
			occupationDescription: null,
		},
		{
			occupationCode: "264209",
			occupationDescription: null,
		},
		{
			occupationCode: "264206",
			occupationDescription: null,
		},
		{
			occupationCode: "143111",
			occupationDescription: null,
		},
		{
			occupationCode: "143112",
			occupationDescription: null,
		},
		{
			occupationCode: "264204",
			occupationDescription: null,
		},
		{
			occupationCode: "215210",
			occupationDescription: null,
		},
		{
			occupationCode: "821206",
			occupationDescription: null,
		},
		{
			occupationCode: "215208",
			occupationDescription: null,
		},
		{
			occupationCode: "215209",
			occupationDescription: null,
		},
		{
			occupationCode: "311408",
			occupationDescription: null,
		},
		{
			occupationCode: "532903",
			occupationDescription: null,
		},
		{
			occupationCode: "331503",
			occupationDescription: null,
		},
		{
			occupationCode: "213115",
			occupationDescription: null,
		},
		{
			occupationCode: "321201",
			occupationDescription: null,
		},
		{
			occupationCode: "325401",
			occupationDescription: null,
		},
		{
			occupationCode: "211104",
			occupationDescription: null,
		},
		{
			occupationCode: "321203",
			occupationDescription: null,
		},
		{
			occupationCode: "226903",
			occupationDescription: null,
		},
		{
			occupationCode: "331406",
			occupationDescription: null,
		},
		{
			occupationCode: "243301",
			occupationDescription: null,
		},
		{
			occupationCode: "111102",
			occupationDescription: null,
		},
		{
			occupationCode: "753102",
			occupationDescription: null,
		},
		{
			occupationCode: "222116",
			occupationDescription: null,
		},
		{
			occupationCode: "962101",
			occupationDescription: null,
		},
		{
			occupationCode: "812205",
			occupationDescription: null,
		},
		{
			occupationCode: "812102",
			occupationDescription: null,
		},
		{
			occupationCode: "313504",
			occupationDescription: null,
		},
		{
			occupationCode: "812202",
			occupationDescription: null,
		},
		{
			occupationCode: "721402",
			occupationDescription: null,
		},
		{
			occupationCode: "214602",
			occupationDescription: null,
		},
		{
			occupationCode: "812104",
			occupationDescription: null,
		},
		{
			occupationCode: "722401",
			occupationDescription: null,
		},
		{
			occupationCode: "812201",
			occupationDescription: null,
		},
		{
			occupationCode: "812106",
			occupationDescription: null,
		},
		{
			occupationCode: "812203",
			occupationDescription: null,
		},
		{
			occupationCode: "812105",
			occupationDescription: null,
		},
		{
			occupationCode: "313502",
			occupationDescription: null,
		},
		{
			occupationCode: "721102",
			occupationDescription: null,
		},
		{
			occupationCode: "812204",
			occupationDescription: null,
		},
		{
			occupationCode: "313501",
			occupationDescription: null,
		},
		{
			occupationCode: "313503",
			occupationDescription: null,
		},
		{
			occupationCode: "812103",
			occupationDescription: null,
		},
		{
			occupationCode: "311701",
			occupationDescription: null,
		},
		{
			occupationCode: "722402",
			occupationDescription: null,
		},
		{
			occupationCode: "311103",
			occupationDescription: null,
		},
		{
			occupationCode: "311102",
			occupationDescription: null,
		},
		{
			occupationCode: "134907",
			occupationDescription: null,
		},
		{
			occupationCode: "962301",
			occupationDescription: null,
		},
		{
			occupationCode: "831103",
			occupationDescription: null,
		},
		{
			occupationCode: "213114",
			occupationDescription: null,
		},
		{
			occupationCode: "441502",
			occupationDescription: null,
		},
		{
			occupationCode: "222201",
			occupationDescription: null,
		},
		{
			occupationCode: "322201",
			occupationDescription: null,
		},
		{
			occupationCode: "753105",
			occupationDescription: null,
		},
		{
			occupationCode: "612104",
			occupationDescription: null,
		},
		{
			occupationCode: "811104",
			occupationDescription: null,
		},
		{
			occupationCode: "931101",
			occupationDescription: null,
		},
		{
			occupationCode: "311705",
			occupationDescription: null,
		},
		{
			occupationCode: "214601",
			occupationDescription: null,
		},
		{
			occupationCode: "311703",
			occupationDescription: null,
		},
		{
			occupationCode: "723305",
			occupationDescription: null,
		},
		{
			occupationCode: "311702",
			occupationDescription: null,
		},
		{
			occupationCode: "132201",
			occupationDescription: null,
		},
		{
			occupationCode: "312101",
			occupationDescription: null,
		},
		{
			occupationCode: "216506",
			occupationDescription: null,
		},
		{
			occupationCode: "811101",
			occupationDescription: null,
		},
		{
			occupationCode: "111201",
			occupationDescription: null,
		},
		{
			occupationCode: "832205",
			occupationDescription: null,
		},
		{
			occupationCode: "611401",
			occupationDescription: null,
		},
		{
			occupationCode: "834104",
			occupationDescription: null,
		},
		{
			occupationCode: "834103",
			occupationDescription: null,
		},
		{
			occupationCode: "951003",
			occupationDescription: null,
		},
		{
			occupationCode: "524101",
			occupationDescription: null,
		},
		{
			occupationCode: "321204",
			occupationDescription: null,
		},
		{
			occupationCode: "265411",
			occupationDescription: null,
		},
		{
			occupationCode: "352109",
			occupationDescription: null,
		},
		{
			occupationCode: "343508",
			occupationDescription: null,
		},
		{
			occupationCode: "516301",
			occupationDescription: null,
		},
		{
			occupationCode: "711404",
			occupationDescription: null,
		},
		{
			occupationCode: "712204",
			occupationDescription: null,
		},
		{
			occupationCode: "341303",
			occupationDescription: null,
		},
		{
			occupationCode: "911201",
			occupationDescription: null,
		},
		{
			occupationCode: "832101",
			occupationDescription: null,
		},
		{
			occupationCode: "723103",
			occupationDescription: null,
		},
		{
			occupationCode: "265502",
			occupationDescription: null,
		},
		{
			occupationCode: "265401",
			occupationDescription: null,
		},
		{
			occupationCode: "265402",
			occupationDescription: null,
		},
		{
			occupationCode: "216603",
			occupationDescription: null,
		},
		{
			occupationCode: "134902",
			occupationDescription: null,
		},
		{
			occupationCode: "262104",
			occupationDescription: null,
		},
		{
			occupationCode: "134928",
			occupationDescription: null,
		},
		{
			occupationCode: "262105",
			occupationDescription: null,
		},
		{
			occupationCode: "343301",
			occupationDescription: null,
		},
		{
			occupationCode: "611305",
			occupationDescription: null,
		},
		{
			occupationCode: "265204",
			occupationDescription: null,
		},
		{
			occupationCode: "265205",
			occupationDescription: null,
		},
		{
			occupationCode: "235402",
			occupationDescription: null,
		},
		{
			occupationCode: "265203",
			occupationDescription: null,
		},
		{
			occupationCode: "514202",
			occupationDescription: null,
		},
		{
			occupationCode: "11003",
			occupationDescription: null,
		},
		{
			occupationCode: "31003",
			occupationDescription: null,
		},
		{
			occupationCode: "134944",
			occupationDescription: null,
		},
		{
			occupationCode: "211405",
			occupationDescription: null,
		},
		{
			occupationCode: "213305",
			occupationDescription: null,
		},
		{
			occupationCode: "223003",
			occupationDescription: null,
		},
		{
			occupationCode: "214405",
			occupationDescription: null,
		},
		{
			occupationCode: "321105",
			occupationDescription: null,
		},
		{
			occupationCode: "222110",
			occupationDescription: null,
		},
		{
			occupationCode: "221206",
			occupationDescription: null,
		},
		{
			occupationCode: "252301",
			occupationDescription: null,
		},
		{
			occupationCode: "214913",
			occupationDescription: null,
		},
		{
			occupationCode: "214912",
			occupationDescription: null,
		},
		{
			occupationCode: "252202",
			occupationDescription: null,
		},
		{
			occupationCode: "325911",
			occupationDescription: null,
		},
		{
			occupationCode: "221220",
			occupationDescription: null,
		},
		{
			occupationCode: "143119",
			occupationDescription: null,
		},
		{
			occupationCode: "952002",
			occupationDescription: null,
		},
		{
			occupationCode: "723401",
			occupationDescription: null,
		},
		{
			occupationCode: "325909",
			occupationDescription: null,
		},
		{
			occupationCode: "261902",
			occupationDescription: null,
		},
		{
			occupationCode: "214915",
			occupationDescription: null,
		},
		{
			occupationCode: "211105",
			occupationDescription: null,
		},
		{
			occupationCode: "222101",
			occupationDescription: null,
		},
		{
			occupationCode: "322101",
			occupationDescription: null,
		},
		{
			occupationCode: "611302",
			occupationDescription: null,
		},
		{
			occupationCode: "131109",
			occupationDescription: null,
		},
		{
			occupationCode: "234203",
			occupationDescription: null,
		},
		{
			occupationCode: "921402",
			occupationDescription: null,
		},
		{
			occupationCode: "242111",
			occupationDescription: null,
		},
		{
			occupationCode: "325908",
			occupationDescription: null,
		},
		{
			occupationCode: "226501",
			occupationDescription: null,
		},
		{
			occupationCode: "325701",
			occupationDescription: null,
		},
		{
			occupationCode: "226302",
			occupationDescription: null,
		},
		{
			occupationCode: "226901",
			occupationDescription: null,
		},
		{
			occupationCode: "325502",
			occupationDescription: null,
		},
		{
			occupationCode: "211407",
			occupationDescription: null,
		},
		{
			occupationCode: "121901",
			occupationDescription: null,
		},
		{
			occupationCode: "334104",
			occupationDescription: null,
		},
		{
			occupationCode: "732103",
			occupationDescription: null,
		},
		{
			occupationCode: "811301",
			occupationDescription: null,
		},
		{
			occupationCode: "311302",
			occupationDescription: null,
		},
		{
			occupationCode: "811302",
			occupationDescription: null,
		},
		{
			occupationCode: "132206",
			occupationDescription: null,
		},
		{
			occupationCode: "132207",
			occupationDescription: null,
		},
		{
			occupationCode: "132203",
			occupationDescription: null,
		},
		{
			occupationCode: "811306",
			occupationDescription: null,
		},
		{
			occupationCode: "311704",
			occupationDescription: null,
		},
		{
			occupationCode: "214603",
			occupationDescription: null,
		},
		{
			occupationCode: "313403",
			occupationDescription: null,
		},
		{
			occupationCode: "132211",
			occupationDescription: null,
		},
		{
			occupationCode: "313404",
			occupationDescription: null,
		},
		{
			occupationCode: "132105",
			occupationDescription: null,
		},
		{
			occupationCode: "313402",
			occupationDescription: null,
		},
		{
			occupationCode: "811304",
			occupationDescription: null,
		},
		{
			occupationCode: "325902",
			occupationDescription: null,
		},
		{
			occupationCode: "812101",
			occupationDescription: null,
		},
		{
			occupationCode: "831203",
			occupationDescription: null,
		},
		{
			occupationCode: "811308",
			occupationDescription: null,
		},
		{
			occupationCode: "815106",
			occupationDescription: null,
		},
		{
			occupationCode: "325402",
			occupationDescription: null,
		},
		{
			occupationCode: "731104",
			occupationDescription: null,
		},
		{
			occupationCode: "325403",
			occupationDescription: null,
		},
		{
			occupationCode: "325101",
			occupationDescription: null,
		},
		{
			occupationCode: "226102",
			occupationDescription: null,
		},
		{
			occupationCode: "226103",
			occupationDescription: null,
		},
		{
			occupationCode: "226108",
			occupationDescription: null,
		},
		{
			occupationCode: "811202",
			occupationDescription: null,
		},
		{
			occupationCode: "134402",
			occupationDescription: null,
		},
		{
			occupationCode: "221224",
			occupationDescription: null,
		},
		{
			occupationCode: "323001",
			occupationDescription: null,
		},
		{
			occupationCode: "214105",
			occupationDescription: null,
		},
		{
			occupationCode: "612901",
			occupationDescription: null,
		},
		{
			occupationCode: "754101",
			occupationDescription: null,
		},
		{
			occupationCode: "932101",
			occupationDescription: null,
		},
		{
			occupationCode: "818303",
			occupationDescription: null,
		},
		{
			occupationCode: "933401",
			occupationDescription: null,
		},
		{
			occupationCode: "265106",
			occupationDescription: null,
		},
		{
			occupationCode: "813104",
			occupationDescription: null,
		},
		{
			occupationCode: "611204",
			occupationDescription: null,
		},
		{
			occupationCode: "265904",
			occupationDescription: null,
		},
		{
			occupationCode: "512002",
			occupationDescription: null,
		},
		{
			occupationCode: "814306",
			occupationDescription: null,
		},
		{
			occupationCode: "814303",
			occupationDescription: null,
		},
		{
			occupationCode: "817104",
			occupationDescription: null,
		},
		{
			occupationCode: "814307",
			occupationDescription: null,
		},
		{
			occupationCode: "814305",
			occupationDescription: null,
		},
		{
			occupationCode: "814301",
			occupationDescription: null,
		},
		{
			occupationCode: "817103",
			occupationDescription: null,
		},
		{
			occupationCode: "814302",
			occupationDescription: null,
		},
		{
			occupationCode: "432302",
			occupationDescription: null,
		},
		{
			occupationCode: "112007",
			occupationDescription: null,
		},
		{
			occupationCode: "335402",
			occupationDescription: null,
		},
		{
			occupationCode: "134943",
			occupationDescription: null,
		},
		{
			occupationCode: "134942",
			occupationDescription: null,
		},
		{
			occupationCode: "621002",
			occupationDescription: null,
		},
		{
			occupationCode: "314302",
			occupationDescription: null,
		},
		{
			occupationCode: "131103",
			occupationDescription: null,
		},
		{
			occupationCode: "921502",
			occupationDescription: null,
		},
		{
			occupationCode: "422602",
			occupationDescription: null,
		},
		{
			occupationCode: "532101",
			occupationDescription: null,
		},
		{
			occupationCode: "335504",
			occupationDescription: null,
		},
		{
			occupationCode: "235108",
			occupationDescription: null,
		},
		{
			occupationCode: "952001",
			occupationDescription: null,
		},
		{
			occupationCode: "524904",
			occupationDescription: null,
		},
		{
			occupationCode: "222109",
			occupationDescription: null,
		},
		{
			occupationCode: "226106",
			occupationDescription: null,
		},
		{
			occupationCode: "221227",
			occupationDescription: null,
		},
		{
			occupationCode: "222108",
			occupationDescription: null,
		},
		{
			occupationCode: "221226",
			occupationDescription: null,
		},
		{
			occupationCode: "731204",
			occupationDescription: null,
		},
		{
			occupationCode: "121313",
			occupationDescription: null,
		},
		{
			occupationCode: "242402",
			occupationDescription: null,
		},
		{
			occupationCode: "522307",
			occupationDescription: null,
		},
		{
			occupationCode: "541403",
			occupationDescription: null,
		},
		{
			occupationCode: "754401",
			occupationDescription: null,
		},
		{
			occupationCode: "612902",
			occupationDescription: null,
		},
		{
			occupationCode: "211304",
			occupationDescription: null,
		},
		{
			occupationCode: "813102",
			occupationDescription: null,
		},
		{
			occupationCode: "243302",
			occupationDescription: null,
		},
		{
			occupationCode: "134212",
			occupationDescription: null,
		},
		{
			occupationCode: "242112",
			occupationDescription: null,
		},
		{
			occupationCode: "314102",
			occupationDescription: null,
		},
		{
			occupationCode: "211303",
			occupationDescription: null,
		},
		{
			occupationCode: "213109",
			occupationDescription: null,
		},
		{
			occupationCode: "134211",
			occupationDescription: null,
		},
		{
			occupationCode: "321301",
			occupationDescription: null,
		},
		{
			occupationCode: "263304",
			occupationDescription: null,
		},
		{
			occupationCode: "532901",
			occupationDescription: null,
		},
		{
			occupationCode: "321202",
			occupationDescription: null,
		},
		{
			occupationCode: "813201",
			occupationDescription: null,
		},
		{
			occupationCode: "343101",
			occupationDescription: null,
		},
		{
			occupationCode: "216507",
			occupationDescription: null,
		},
		{
			occupationCode: "265409",
			occupationDescription: null,
		},
		{
			occupationCode: "231015",
			occupationDescription: null,
		},
		{
			occupationCode: "311106",
			occupationDescription: null,
		},
		{
			occupationCode: "221230",
			occupationDescription: null,
		},
		{
			occupationCode: "226401",
			occupationDescription: null,
		},
		{
			occupationCode: "325501",
			occupationDescription: null,
		},
		{
			occupationCode: "731201",
			occupationDescription: null,
		},
		{
			occupationCode: "134920",
			occupationDescription: null,
		},
		{
			occupationCode: "712401",
			occupationDescription: null,
		},
		{
			occupationCode: "712602",
			occupationDescription: null,
		},
		{
			occupationCode: "132208",
			occupationDescription: null,
		},
		{
			occupationCode: "815902",
			occupationDescription: null,
		},
		{
			occupationCode: "816005",
			occupationDescription: null,
		},
		{
			occupationCode: "711403",
			occupationDescription: null,
		},
		{
			occupationCode: "235503",
			occupationDescription: null,
		},
		{
			occupationCode: "814205",
			occupationDescription: null,
		},
		{
			occupationCode: "814204",
			occupationDescription: null,
		},
		{
			occupationCode: "814201",
			occupationDescription: null,
		},
		{
			occupationCode: "814203",
			occupationDescription: null,
		},
		{
			occupationCode: "814202",
			occupationDescription: null,
		},
		{
			occupationCode: "221228",
			occupationDescription: null,
		},
		{
			occupationCode: "821902",
			occupationDescription: null,
		},
		{
			occupationCode: "226402",
			occupationDescription: null,
		},
		{
			occupationCode: "335501",
			occupationDescription: null,
		},
		{
			occupationCode: "541201",
			occupationDescription: null,
		},
		{
			occupationCode: "242206",
			occupationDescription: null,
		},
		{
			occupationCode: "134934",
			occupationDescription: null,
		},
		{
			occupationCode: "263303",
			occupationDescription: null,
		},
		{
			occupationCode: "132401",
			occupationDescription: null,
		},
		{
			occupationCode: "315207",
			occupationDescription: null,
		},
		{
			occupationCode: "524502",
			occupationDescription: null,
		},
		{
			occupationCode: "335101",
			occupationDescription: null,
		},
		{
			occupationCode: "132413",
			occupationDescription: null,
		},
		{
			occupationCode: "132419",
			occupationDescription: null,
		},
		{
			occupationCode: "132420",
			occupationDescription: null,
		},
		{
			occupationCode: "731401",
			occupationDescription: null,
		},
		{
			occupationCode: "731402",
			occupationDescription: null,
		},
		{
			occupationCode: "921202",
			occupationDescription: null,
		},
		{
			occupationCode: "612201",
			occupationDescription: null,
		},
		{
			occupationCode: "314205",
			occupationDescription: null,
		},
		{
			occupationCode: "741301",
			occupationDescription: null,
		},
		{
			occupationCode: "821204",
			occupationDescription: null,
		},
		{
			occupationCode: "215106",
			occupationDescription: null,
		},
		{
			occupationCode: "722103",
			occupationDescription: null,
		},
		{
			occupationCode: "741302",
			occupationDescription: null,
		},
		{
			occupationCode: "313102",
			occupationDescription: null,
		},
		{
			occupationCode: "132108",
			occupationDescription: null,
		},
		{
			occupationCode: "313101",
			occupationDescription: null,
		},
		{
			occupationCode: "311309",
			occupationDescription: null,
		},
		{
			occupationCode: "215107",
			occupationDescription: null,
		},
		{
			occupationCode: "341302",
			occupationDescription: null,
		},
		{
			occupationCode: "731303",
			occupationDescription: null,
		},
		{
			occupationCode: "731102",
			occupationDescription: null,
		},
		{
			occupationCode: "311405",
			occupationDescription: null,
		},
		{
			occupationCode: "234201",
			occupationDescription: null,
		},
		{
			occupationCode: "265603",
			occupationDescription: null,
		},
		{
			occupationCode: "343104",
			occupationDescription: null,
		},
		{
			occupationCode: "722102",
			occupationDescription: null,
		},
		{
			occupationCode: "222115",
			occupationDescription: null,
		},
		{
			occupationCode: "234106",
			occupationDescription: null,
		},
		{
			occupationCode: "234101",
			occupationDescription: null,
		},
		{
			occupationCode: "111206",
			occupationDescription: null,
		},
		{
			occupationCode: "732301",
			occupationDescription: null,
		},
		{
			occupationCode: "143115",
			occupationDescription: null,
		},
		{
			occupationCode: "732101",
			occupationDescription: null,
		},
		{
			occupationCode: "143114",
			occupationDescription: null,
		},
		{
			occupationCode: "732201",
			occupationDescription: null,
		},
		{
			occupationCode: "413102",
			occupationDescription: null,
		},
		{
			occupationCode: "134941",
			occupationDescription: null,
		},
		{
			occupationCode: "541301",
			occupationDescription: null,
		},
		{
			occupationCode: "242208",
			occupationDescription: null,
		},
		{
			occupationCode: "332301",
			occupationDescription: null,
		},
		{
			occupationCode: "832202",
			occupationDescription: null,
		},
		{
			occupationCode: "242201",
			occupationDescription: null,
		},
		{
			occupationCode: "524201",
			occupationDescription: null,
		},
		{
			occupationCode: "122302",
			occupationDescription: null,
		},
		{
			occupationCode: "932902",
			occupationDescription: null,
		},
		{
			occupationCode: "311905",
			occupationDescription: null,
		},
		{
			occupationCode: "214104",
			occupationDescription: null,
		},
		{
			occupationCode: "311906",
			occupationDescription: null,
		},
		{
			occupationCode: "713204",
			occupationDescription: null,
		},
		{
			occupationCode: "313905",
			occupationDescription: null,
		},
		{
			occupationCode: "231011",
			occupationDescription: null,
		},
		{
			occupationCode: "342103",
			occupationDescription: null,
		},
		{
			occupationCode: "342209",
			occupationDescription: null,
		},
		{
			occupationCode: "342210",
			occupationDescription: null,
		},
		{
			occupationCode: "342104",
			occupationDescription: null,
		},
		{
			occupationCode: "342218",
			occupationDescription: null,
		},
		{
			occupationCode: "342216",
			occupationDescription: null,
		},
		{
			occupationCode: "342208",
			occupationDescription: null,
		},
		{
			occupationCode: "342207",
			occupationDescription: null,
		},
		{
			occupationCode: "342105",
			occupationDescription: null,
		},
		{
			occupationCode: "342212",
			occupationDescription: null,
		},
		{
			occupationCode: "342219",
			occupationDescription: null,
		},
		{
			occupationCode: "342109",
			occupationDescription: null,
		},
		{
			occupationCode: "342220",
			occupationDescription: null,
		},
		{
			occupationCode: "342205",
			occupationDescription: null,
		},
		{
			occupationCode: "342102",
			occupationDescription: null,
		},
		{
			occupationCode: "342206",
			occupationDescription: null,
		},
		{
			occupationCode: "342217",
			occupationDescription: null,
		},
		{
			occupationCode: "342108",
			occupationDescription: null,
		},
		{
			occupationCode: "342203",
			occupationDescription: null,
		},
		{
			occupationCode: "342101",
			occupationDescription: null,
		},
		{
			occupationCode: "342204",
			occupationDescription: null,
		},
		{
			occupationCode: "342213",
			occupationDescription: null,
		},
		{
			occupationCode: "342106",
			occupationDescription: null,
		},
		{
			occupationCode: "342214",
			occupationDescription: null,
		},
		{
			occupationCode: "342215",
			occupationDescription: null,
		},
		{
			occupationCode: "342107",
			occupationDescription: null,
		},
		{
			occupationCode: "342110",
			occupationDescription: null,
		},
		{
			occupationCode: "232001",
			occupationDescription: null,
		},
		{
			occupationCode: "342211",
			occupationDescription: null,
		},
		{
			occupationCode: "121203",
			occupationDescription: null,
		},
		{
			occupationCode: "815203",
			occupationDescription: null,
		},
		{
			occupationCode: "251204",
			occupationDescription: null,
		},
		{
			occupationCode: "214909",
			occupationDescription: null,
		},
		{
			occupationCode: "121310",
			occupationDescription: null,
		},
		{
			occupationCode: "121314",
			occupationDescription: null,
		},
		{
			occupationCode: "242108",
			occupationDescription: null,
		},
		{
			occupationCode: "264303",
			occupationDescription: null,
		},
		{
			occupationCode: "121108",
			occupationDescription: null,
		},
		{
			occupationCode: "134922",
			occupationDescription: null,
		},
		{
			occupationCode: "261103",
			occupationDescription: null,
		},
		{
			occupationCode: "321403",
			occupationDescription: null,
		},
		{
			occupationCode: "243207",
			occupationDescription: null,
		},
		{
			occupationCode: "122206",
			occupationDescription: null,
		},
		{
			occupationCode: "263402",
			occupationDescription: null,
		},
		{
			occupationCode: "221233",
			occupationDescription: null,
		},
		{
			occupationCode: "263401",
			occupationDescription: null,
		},
		{
			occupationCode: "243205",
			occupationDescription: null,
		},
		{
			occupationCode: "134204",
			occupationDescription: null,
		},
		{
			occupationCode: "134203",
			occupationDescription: null,
		},
		{
			occupationCode: "221103",
			occupationDescription: null,
		},
		{
			occupationCode: "226303",
			occupationDescription: null,
		},
		{
			occupationCode: "325703",
			occupationDescription: null,
		},
		{
			occupationCode: "243202",
			occupationDescription: null,
		},
		{
			occupationCode: "134904",
			occupationDescription: null,
		},
		{
			occupationCode: "143117",
			occupationDescription: null,
		},
		{
			occupationCode: "333901",
			occupationDescription: null,
		},
		{
			occupationCode: "817102",
			occupationDescription: null,
		},
		{
			occupationCode: "243102",
			occupationDescription: null,
		},
		{
			occupationCode: "132417",
			occupationDescription: null,
		},
		{
			occupationCode: "332302",
			occupationDescription: null,
		},
		{
			occupationCode: "214906",
			occupationDescription: null,
		},
		{
			occupationCode: "754301",
			occupationDescription: null,
		},
		{
			occupationCode: "121304",
			occupationDescription: null,
		},
		{
			occupationCode: "242120",
			occupationDescription: null,
		},
		{
			occupationCode: "242122",
			occupationDescription: null,
		},
		{
			occupationCode: "311903",
			occupationDescription: null,
		},
		{
			occupationCode: "311904",
			occupationDescription: null,
		},
		{
			occupationCode: "214905",
			occupationDescription: null,
		},
		{
			occupationCode: "132205",
			occupationDescription: null,
		},
		{
			occupationCode: "132202",
			occupationDescription: null,
		},
		{
			occupationCode: "931102",
			occupationDescription: null,
		},
		{
			occupationCode: "215304",
			occupationDescription: null,
		},
		{
			occupationCode: "226304",
			occupationDescription: null,
		},
		{
			occupationCode: "265503",
			occupationDescription: null,
		},
		{
			occupationCode: "311401",
			occupationDescription: null,
		},
		{
			occupationCode: "215302",
			occupationDescription: null,
		},
		{
			occupationCode: "143124",
			occupationDescription: null,
		},
		{
			occupationCode: "143125",
			occupationDescription: null,
		},
		{
			occupationCode: "321102",
			occupationDescription: null,
		},
		{
			occupationCode: "224002",
			occupationDescription: null,
		},
		{
			occupationCode: "214408",
			occupationDescription: null,
		},
		{
			occupationCode: "132408",
			occupationDescription: null,
		},
		{
			occupationCode: "132403",
			occupationDescription: null,
		},
		{
			occupationCode: "132411",
			occupationDescription: null,
		},
		{
			occupationCode: "711402",
			occupationDescription: null,
		},
		{
			occupationCode: "333402",
			occupationDescription: null,
		},
		{
			occupationCode: "331504",
			occupationDescription: null,
		},
		{
			occupationCode: "333403",
			occupationDescription: null,
		},
		{
			occupationCode: "333401",
			occupationDescription: null,
		},
		{
			occupationCode: "331202",
			occupationDescription: null,
		},
		{
			occupationCode: "352102",
			occupationDescription: null,
		},
		{
			occupationCode: "333301",
			occupationDescription: null,
		},
		{
			occupationCode: "121204",
			occupationDescription: null,
		},
		{
			occupationCode: "121209",
			occupationDescription: null,
		},
		{
			occupationCode: "242311",
			occupationDescription: null,
		},
		{
			occupationCode: "134501",
			occupationDescription: null,
		},
		{
			occupationCode: "342202",
			occupationDescription: null,
		},
		{
			occupationCode: "712703",
			occupationDescription: null,
		},
		{
			occupationCode: "242124",
			occupationDescription: null,
		},
		{
			occupationCode: "111106",
			occupationDescription: null,
		},
		{
			occupationCode: "111204",
			occupationDescription: null,
		},
		{
			occupationCode: "111202",
			occupationDescription: null,
		},
		{
			occupationCode: "112003",
			occupationDescription: null,
		},
		{
			occupationCode: "341104",
			occupationDescription: null,
		},
		{
			occupationCode: "411002",
			occupationDescription: null,
		},
		{
			occupationCode: "261102",
			occupationDescription: null,
		},
		{
			occupationCode: "134921",
			occupationDescription: null,
		},
		{
			occupationCode: "134915",
			occupationDescription: null,
		},
		{
			occupationCode: "263609",
			occupationDescription: null,
		},
		{
			occupationCode: "263608",
			occupationDescription: null,
		},
		{
			occupationCode: "264208",
			occupationDescription: null,
		},
		{
			occupationCode: "311214",
			occupationDescription: null,
		},
		{
			occupationCode: "122301",
			occupationDescription: null,
		},
		{
			occupationCode: "214908",
			occupationDescription: null,
		},
		{
			occupationCode: "122303",
			occupationDescription: null,
		},
		{
			occupationCode: "516408",
			occupationDescription: null,
		},
		{
			occupationCode: "314303",
			occupationDescription: null,
		},
		{
			occupationCode: "134945",
			occupationDescription: null,
		},
		{
			occupationCode: "515102",
			occupationDescription: null,
		},
		{
			occupationCode: "226404",
			occupationDescription: null,
		},
		{
			occupationCode: "325503",
			occupationDescription: null,
		},
		{
			occupationCode: "141203",
			occupationDescription: null,
		},
		{
			occupationCode: "142001",
			occupationDescription: null,
		},
		{
			occupationCode: "221208",
			occupationDescription: null,
		},
		{
			occupationCode: "132204",
			occupationDescription: null,
		},
		{
			occupationCode: "121302",
			occupationDescription: null,
		},
		{
			occupationCode: "242102",
			occupationDescription: null,
		},
		{
			occupationCode: "721401",
			occupationDescription: null,
		},
		{
			occupationCode: "312302",
			occupationDescription: null,
		},
		{
			occupationCode: "311802",
			occupationDescription: null,
		},
		{
			occupationCode: "311210",
			occupationDescription: null,
		},
		{
			occupationCode: "931202",
			occupationDescription: null,
		},
		{
			occupationCode: "834202",
			occupationDescription: null,
		},
		{
			occupationCode: "132302",
			occupationDescription: null,
		},
		{
			occupationCode: "815302",
			occupationDescription: null,
		},
		{
			occupationCode: "712104",
			occupationDescription: null,
		},
		{
			occupationCode: "712102",
			occupationDescription: null,
		},
		{
			occupationCode: "713303",
			occupationDescription: null,
		},
		{
			occupationCode: "818902",
			occupationDescription: null,
		},
		{
			occupationCode: "11004",
			occupationDescription: null,
		},
		{
			occupationCode: "31004",
			occupationDescription: null,
		},
		{
			occupationCode: "814104",
			occupationDescription: null,
		},
		{
			occupationCode: "814103",
			occupationDescription: null,
		},
		{
			occupationCode: "814101",
			occupationDescription: null,
		},
		{
			occupationCode: "814102",
			occupationDescription: null,
		},
		{
			occupationCode: "814105",
			occupationDescription: null,
		},
		{
			occupationCode: "821906",
			occupationDescription: null,
		},
		{
			occupationCode: "134909",
			occupationDescription: null,
		},
		{
			occupationCode: "332201",
			occupationDescription: null,
		},
		{
			occupationCode: "243109",
			occupationDescription: null,
		},
		{
			occupationCode: "311510",
			occupationDescription: null,
		},
		{
			occupationCode: "912903",
			occupationDescription: null,
		},
		{
			occupationCode: "711901",
			occupationDescription: null,
		},
		{
			occupationCode: "233008",
			occupationDescription: null,
		},
		{
			occupationCode: "234108",
			occupationDescription: null,
		},
		{
			occupationCode: "311907",
			occupationDescription: null,
		},
		{
			occupationCode: "811203",
			occupationDescription: null,
		},
		{
			occupationCode: "264103",
			occupationDescription: null,
		},
		{
			occupationCode: "233015",
			occupationDescription: null,
		},
		{
			occupationCode: "233013",
			occupationDescription: null,
		},
		{
			occupationCode: "233005",
			occupationDescription: null,
		},
		{
			occupationCode: "233012",
			occupationDescription: null,
		},
		{
			occupationCode: "233021",
			occupationDescription: null,
		},
		{
			occupationCode: "233004",
			occupationDescription: null,
		},
		{
			occupationCode: "233017",
			occupationDescription: null,
		},
		{
			occupationCode: "233018",
			occupationDescription: null,
		},
		{
			occupationCode: "233023",
			occupationDescription: null,
		},
		{
			occupationCode: "233001",
			occupationDescription: null,
		},
		{
			occupationCode: "233009",
			occupationDescription: null,
		},
		{
			occupationCode: "233011",
			occupationDescription: null,
		},
		{
			occupationCode: "233014",
			occupationDescription: null,
		},
		{
			occupationCode: "233006",
			occupationDescription: null,
		},
		{
			occupationCode: "233010",
			occupationDescription: null,
		},
		{
			occupationCode: "121903",
			occupationDescription: null,
		},
		{
			occupationCode: "111404",
			occupationDescription: null,
		},
		{
			occupationCode: "251110",
			occupationDescription: null,
		},
		{
			occupationCode: "331102",
			occupationDescription: null,
		},
		{
			occupationCode: "241310",
			occupationDescription: null,
		},
		{
			occupationCode: "541401",
			occupationDescription: null,
		},
		{
			occupationCode: "216606",
			occupationDescription: null,
		},
		{
			occupationCode: "541402",
			occupationDescription: null,
		},
		{
			occupationCode: "11006",
			occupationDescription: null,
		},
		{
			occupationCode: "134910",
			occupationDescription: null,
		},
		{
			occupationCode: "231024",
			occupationDescription: null,
		},
		{
			occupationCode: "343506",
			occupationDescription: null,
		},
		{
			occupationCode: "31006",
			occupationDescription: null,
		},
		{
			occupationCode: "242116",
			occupationDescription: null,
		},
		{
			occupationCode: "21006",
			occupationDescription: null,
		},
		{
			occupationCode: "611304",
			occupationDescription: null,
		},
		{
			occupationCode: "211406",
			occupationDescription: null,
		},
		{
			occupationCode: "631001",
			occupationDescription: null,
		},
		{
			occupationCode: "634001",
			occupationDescription: null,
		},
		{
			occupationCode: "632001",
			occupationDescription: null,
		},
		{
			occupationCode: "522318",
			occupationDescription: null,
		},
		{
			occupationCode: "522316",
			occupationDescription: null,
		},
		{
			occupationCode: "524903",
			occupationDescription: null,
		},
		{
			occupationCode: "524902",
			occupationDescription: null,
		},
		{
			occupationCode: "522315",
			occupationDescription: null,
		},
		{
			occupationCode: "522320",
			occupationDescription: null,
		},
		{
			occupationCode: "522321",
			occupationDescription: null,
		},
		{
			occupationCode: "532202",
			occupationDescription: null,
		},
		{
			occupationCode: "252205",
			occupationDescription: null,
		},
		{
			occupationCode: "242109",
			occupationDescription: null,
		},
		{
			occupationCode: "522309",
			occupationDescription: null,
		},
		{
			occupationCode: "815301",
			occupationDescription: null,
		},
		{
			occupationCode: "541302",
			occupationDescription: null,
		},
		{
			occupationCode: "612105",
			occupationDescription: null,
		},
		{
			occupationCode: "912203",
			occupationDescription: null,
		},
		{
			occupationCode: "315101",
			occupationDescription: null,
		},
		{
			occupationCode: "835003",
			occupationDescription: null,
		},
		{
			occupationCode: "723307",
			occupationDescription: null,
		},
		{
			occupationCode: "315102",
			occupationDescription: null,
		},
		{
			occupationCode: "332403",
			occupationDescription: null,
		},
		{
			occupationCode: "432102",
			occupationDescription: null,
		},
		{
			occupationCode: "315203",
			occupationDescription: null,
		},
		{
			occupationCode: "951001",
			occupationDescription: null,
		},
		{
			occupationCode: "815601",
			occupationDescription: null,
		},
		{
			occupationCode: "753601",
			occupationDescription: null,
		},
		{
			occupationCode: "522306",
			occupationDescription: null,
		},
		{
			occupationCode: "815602",
			occupationDescription: null,
		},
		{
			occupationCode: "522201",
			occupationDescription: null,
		},
		{
			occupationCode: "143901",
			occupationDescription: null,
		},
		{
			occupationCode: "413101",
			occupationDescription: null,
		},
		{
			occupationCode: "265301",
			occupationDescription: null,
		},
		{
			occupationCode: "352111",
			occupationDescription: null,
		},
		{
			occupationCode: "235501",
			occupationDescription: null,
		},
		{
			occupationCode: "264304",
			occupationDescription: null,
		},
		{
			occupationCode: "235202",
			occupationDescription: null,
		},
		{
			occupationCode: "818901",
			occupationDescription: null,
		},
		{
			occupationCode: "732102",
			occupationDescription: null,
		},
		{
			occupationCode: "612302",
			occupationDescription: null,
		},
		{
			occupationCode: "511303",
			occupationDescription: null,
		},
		{
			occupationCode: "514201",
			occupationDescription: null,
		},
		{
			occupationCode: "751103",
			occupationDescription: null,
		},
		{
			occupationCode: "131106",
			occupationDescription: null,
		},
		{
			occupationCode: "231012",
			occupationDescription: null,
		},
		{
			occupationCode: "231009",
			occupationDescription: null,
		},
		{
			occupationCode: "134406",
			occupationDescription: null,
		},
		{
			occupationCode: "335301",
			occupationDescription: null,
		},
		{
			occupationCode: "134405",
			occupationDescription: null,
		},
		{
			occupationCode: "134407",
			occupationDescription: null,
		},
		{
			occupationCode: "134409",
			occupationDescription: null,
		},
		{
			occupationCode: "134408",
			occupationDescription: null,
		},
		{
			occupationCode: "263503",
			occupationDescription: null,
		},
		{
			occupationCode: "341201",
			occupationDescription: null,
		},
		{
			occupationCode: "263501",
			occupationDescription: null,
		},
		{
			occupationCode: "233031",
			occupationDescription: null,
		},
		{
			occupationCode: "263204",
			occupationDescription: null,
		},
		{
			occupationCode: "251203",
			occupationDescription: null,
		},
		{
			occupationCode: "251201",
			occupationDescription: null,
		},
		{
			occupationCode: "251202",
			occupationDescription: null,
		},
		{
			occupationCode: "214914",
			occupationDescription: null,
		},
		{
			occupationCode: "133006",
			occupationDescription: null,
		},
		{
			occupationCode: "251901",
			occupationDescription: null,
		},
		{
			occupationCode: "351203",
			occupationDescription: null,
		},
		{
			occupationCode: "251903",
			occupationDescription: null,
		},
		{
			occupationCode: "213304",
			occupationDescription: null,
		},
		{
			occupationCode: "931204",
			occupationDescription: null,
		},
		{
			occupationCode: "265410",
			occupationDescription: null,
		},
		{
			occupationCode: "343504",
			occupationDescription: null,
		},
		{
			occupationCode: "221201",
			occupationDescription: null,
		},
		{
			occupationCode: "221219",
			occupationDescription: null,
		},
		{
			occupationCode: "222102",
			occupationDescription: null,
		},
		{
			occupationCode: "226602",
			occupationDescription: null,
		},
		{
			occupationCode: "522303",
			occupationDescription: null,
		},
		{
			occupationCode: "143107",
			occupationDescription: null,
		},
		{
			occupationCode: "333903",
			occupationDescription: null,
		},
		{
			occupationCode: "342201",
			occupationDescription: null,
		},
		{
			occupationCode: "265602",
			occupationDescription: null,
		},
		{
			occupationCode: "143105",
			occupationDescription: null,
		},
		{
			occupationCode: "226503",
			occupationDescription: null,
		},
		{
			occupationCode: "342221",
			occupationDescription: null,
		},
		{
			occupationCode: "713201",
			occupationDescription: null,
		},
		{
			occupationCode: "335503",
			occupationDescription: null,
		},
		{
			occupationCode: "921203",
			occupationDescription: null,
		},
		{
			occupationCode: "516403",
			occupationDescription: null,
		},
		{
			occupationCode: "241103",
			occupationDescription: null,
		},
		{
			occupationCode: "521101",
			occupationDescription: null,
		},
		{
			occupationCode: "343505",
			occupationDescription: null,
		},
		{
			occupationCode: "313906",
			occupationDescription: null,
		},
		{
			occupationCode: "313902",
			occupationDescription: null,
		},
		{
			occupationCode: "331404",
			occupationDescription: null,
		},
		{
			occupationCode: "331401",
			occupationDescription: null,
		},
		{
			occupationCode: "331405",
			occupationDescription: null,
		},
		{
			occupationCode: "121117",
			occupationDescription: null,
		},
		{
			occupationCode: "818201",
			occupationDescription: null,
		},
		{
			occupationCode: "818204",
			occupationDescription: null,
		},
		{
			occupationCode: "612102",
			occupationDescription: null,
		},
		{
			occupationCode: "818107",
			occupationDescription: null,
		},
		{
			occupationCode: "711303",
			occupationDescription: null,
		},
		{
			occupationCode: "711302",
			occupationDescription: null,
		},
		{
			occupationCode: "711301",
			occupationDescription: null,
		},
		{
			occupationCode: "811204",
			occupationDescription: null,
		},
		{
			occupationCode: "811403",
			occupationDescription: null,
		},
		{
			occupationCode: "811102",
			occupationDescription: null,
		},
		{
			occupationCode: "432101",
			occupationDescription: null,
		},
		{
			occupationCode: "121311",
			occupationDescription: null,
		},
		{
			occupationCode: "242205",
			occupationDescription: null,
		},
		{
			occupationCode: "961301",
			occupationDescription: null,
		},
		{
			occupationCode: "731203",
			occupationDescription: null,
		},
		{
			occupationCode: "235905",
			occupationDescription: null,
		},
		{
			occupationCode: "134517",
			occupationDescription: null,
		},
		{
			occupationCode: "235903",
			occupationDescription: null,
		},
		{
			occupationCode: "235902",
			occupationDescription: null,
		},
		{
			occupationCode: "216302",
			occupationDescription: null,
		},
		{
			occupationCode: "816011",
			occupationDescription: null,
		},
		{
			occupationCode: "132416",
			occupationDescription: null,
		},
		{
			occupationCode: "141201",
			occupationDescription: null,
		},
		{
			occupationCode: "343511",
			occupationDescription: null,
		},
		{
			occupationCode: "111104",
			occupationDescription: null,
		},
		{
			occupationCode: "222112",
			occupationDescription: null,
		},
		{
			occupationCode: "311211",
			occupationDescription: null,
		},
		{
			occupationCode: "751203",
			occupationDescription: null,
		},
		{
			occupationCode: "912901",
			occupationDescription: null,
		},
		{
			occupationCode: "815103",
			occupationDescription: null,
		},
		{
			occupationCode: "252201",
			occupationDescription: null,
		},
		{
			occupationCode: "251103",
			occupationDescription: null,
		},
		{
			occupationCode: "251105",
			occupationDescription: null,
		},
		{
			occupationCode: "251902",
			occupationDescription: null,
		},
		{
			occupationCode: "753301",
			occupationDescription: null,
		},
		{
			occupationCode: "121206",
			occupationDescription: null,
		},
		{
			occupationCode: "833202",
			occupationDescription: null,
		},
		{
			occupationCode: "753501",
			occupationDescription: null,
		},
		{
			occupationCode: "121103",
			occupationDescription: null,
		},
		{
			occupationCode: "241108",
			occupationDescription: null,
		},
		{
			occupationCode: "335202",
			occupationDescription: null,
		},
		{
			occupationCode: "832203",
			occupationDescription: null,
		},
		{
			occupationCode: "516303",
			occupationDescription: null,
		},
		{
			occupationCode: "134519",
			occupationDescription: null,
		},
		{
			occupationCode: "531201",
			occupationDescription: null,
		},
		{
			occupationCode: "235204",
			occupationDescription: null,
		},
		{
			occupationCode: "235107",
			occupationDescription: null,
		},
		{
			occupationCode: "231027",
			occupationDescription: null,
		},
		{
			occupationCode: "235101",
			occupationDescription: null,
		},
		{
			occupationCode: "215102",
			occupationDescription: null,
		},
		{
			occupationCode: "264104",
			occupationDescription: null,
		},
		{
			occupationCode: "111210",
			occupationDescription: null,
		},
		{
			occupationCode: "214502",
			occupationDescription: null,
		},
		{
			occupationCode: "214202",
			occupationDescription: null,
		},
		{
			occupationCode: "311803",
			occupationDescription: null,
		},
		{
			occupationCode: "214402",
			occupationDescription: null,
		},
		{
			occupationCode: "214103",
			occupationDescription: null,
		},
		{
			occupationCode: "252912",
			occupationDescription: null,
		},
		{
			occupationCode: "134513",
			occupationDescription: null,
		},
		{
			occupationCode: "252302",
			occupationDescription: null,
		},
		{
			occupationCode: "422303",
			occupationDescription: null,
		},
		{
			occupationCode: "422302",
			occupationDescription: null,
		},
		{
			occupationCode: "524401",
			occupationDescription: null,
		},
		{
			occupationCode: "265407",
			occupationDescription: null,
		},
		{
			occupationCode: "243104",
			occupationDescription: null,
		},
		{
			occupationCode: "815903",
			occupationDescription: null,
		},
		{
			occupationCode: "815401",
			occupationDescription: null,
		},
		{
			occupationCode: "216306",
			occupationDescription: null,
		},
		{
			occupationCode: "815901",
			occupationDescription: null,
		},
		{
			occupationCode: "815409",
			occupationDescription: null,
		},
		{
			occupationCode: "815402",
			occupationDescription: null,
		},
		{
			occupationCode: "815410",
			occupationDescription: null,
		},
		{
			occupationCode: "713806",
			occupationDescription: null,
		},
		{
			occupationCode: "815201",
			occupationDescription: null,
		},
		{
			occupationCode: "821904",
			occupationDescription: null,
		},
		{
			occupationCode: "522311",
			occupationDescription: null,
		},
		{
			occupationCode: "111211",
			occupationDescription: null,
		},
		{
			occupationCode: "143120",
			occupationDescription: null,
		},
		{
			occupationCode: "265901",
			occupationDescription: null,
		},
		{
			occupationCode: "265404",
			occupationDescription: null,
		},
		{
			occupationCode: "265405",
			occupationDescription: null,
		},
		{
			occupationCode: "143121",
			occupationDescription: null,
		},
		{
			occupationCode: "321101",
			occupationDescription: null,
		},
		{
			occupationCode: "712403",
			occupationDescription: null,
		},
		{
			occupationCode: "265501",
			occupationDescription: null,
		},
		{
			occupationCode: "815405",
			occupationDescription: null,
		},
		{
			occupationCode: "815403",
			occupationDescription: null,
		},
		{
			occupationCode: "815404",
			occupationDescription: null,
		},
		{
			occupationCode: "815102",
			occupationDescription: null,
		},
		{
			occupationCode: "962902",
			occupationDescription: null,
		},
		{
			occupationCode: "422103",
			occupationDescription: null,
		},
		{
			occupationCode: "523002",
			occupationDescription: null,
		},
		{
			occupationCode: "818110",
			occupationDescription: null,
		},
		{
			occupationCode: "713302",
			occupationDescription: null,
		},
		{
			occupationCode: "818111",
			occupationDescription: null,
		},
		{
			occupationCode: "818109",
			occupationDescription: null,
		},
		{
			occupationCode: "712202",
			occupationDescription: null,
		},
		{
			occupationCode: "723104",
			occupationDescription: null,
		},
		{
			occupationCode: "751601",
			occupationDescription: null,
		},
		{
			occupationCode: "751602",
			occupationDescription: null,
		},
		{
			occupationCode: "931205",
			occupationDescription: null,
		},
		{
			occupationCode: "511301",
			occupationDescription: null,
		},
		{
			occupationCode: "333905",
			occupationDescription: null,
		},
		{
			occupationCode: "263207",
			occupationDescription: null,
		},
		{
			occupationCode: "263208",
			occupationDescription: null,
		},
		{
			occupationCode: "143110",
			occupationDescription: null,
		},
		{
			occupationCode: "263213",
			occupationDescription: null,
		},
		{
			occupationCode: "263211",
			occupationDescription: null,
		},
		{
			occupationCode: "831101",
			occupationDescription: null,
		},
		{
			occupationCode: "121114",
			occupationDescription: null,
		},
		{
			occupationCode: "121305",
			occupationDescription: null,
		},
		{
			occupationCode: "216402",
			occupationDescription: null,
		},
		{
			occupationCode: "833203",
			occupationDescription: null,
		},
		{
			occupationCode: "831204",
			occupationDescription: null,
		},
		{
			occupationCode: "831201",
			occupationDescription: null,
		},
		{
			occupationCode: "912204",
			occupationDescription: null,
		},
		{
			occupationCode: "831102",
			occupationDescription: null,
		},
		{
			occupationCode: "723304",
			occupationDescription: null,
		},
		{
			occupationCode: "311512",
			occupationDescription: null,
		},
		{
			occupationCode: "313903",
			occupationDescription: null,
		},
		{
			occupationCode: "134508",
			occupationDescription: null,
		},
		{
			occupationCode: "235106",
			occupationDescription: null,
		},
		{
			occupationCode: "134510",
			occupationDescription: null,
		},
		{
			occupationCode: "831202",
			occupationDescription: null,
		},
		{
			occupationCode: "833102",
			occupationDescription: null,
		},
		{
			occupationCode: "441401",
			occupationDescription: null,
		},
		{
			occupationCode: "134933",
			occupationDescription: null,
		},
		{
			occupationCode: "821103",
			occupationDescription: null,
		},
		{
			occupationCode: "933102",
			occupationDescription: null,
		},
		{
			occupationCode: "511201",
			occupationDescription: null,
		},
		{
			occupationCode: "143902",
			occupationDescription: null,
		},
		{
			occupationCode: "333904",
			occupationDescription: null,
		},
		{
			occupationCode: "422102",
			occupationDescription: null,
		},
		{
			occupationCode: "241104",
			occupationDescription: null,
		},
		{
			occupationCode: "121116",
			occupationDescription: null,
		},
		{
			occupationCode: "241308",
			occupationDescription: null,
		},
		{
			occupationCode: "611201",
			occupationDescription: null,
		},
		{
			occupationCode: "611203",
			occupationDescription: null,
		},
		{
			occupationCode: "432301",
			occupationDescription: null,
		},
		{
			occupationCode: "511202",
			occupationDescription: null,
		},
		{
			occupationCode: "315204",
			occupationDescription: null,
		},
		{
			occupationCode: "214411",
			occupationDescription: null,
		},
		{
			occupationCode: "818203",
			occupationDescription: null,
		},
		{
			occupationCode: "311402",
			occupationDescription: null,
		},
		{
			occupationCode: "143122",
			occupationDescription: null,
		},
		{
			occupationCode: "143123",
			occupationDescription: null,
		},
		{
			occupationCode: "721202",
			occupationDescription: null,
		},
		{
			occupationCode: "962201",
			occupationDescription: null,
		},
		{
			occupationCode: "753401",
			occupationDescription: null,
		},
		{
			occupationCode: "216403",
			occupationDescription: null,
		},
		{
			occupationCode: "132304",
			occupationDescription: null,
		},
		{
			occupationCode: "221232",
			occupationDescription: null,
		},
		{
			occupationCode: "814106",
			occupationDescription: null,
		},
		{
			occupationCode: "832206",
			occupationDescription: null,
		},
		{
			occupationCode: "242115",
			occupationDescription: null,
		},
		{
			occupationCode: "713202",
			occupationDescription: null,
		},
		{
			occupationCode: "611104",
			occupationDescription: null,
		},
		{
			occupationCode: "613001",
			occupationDescription: null,
		},
		{
			occupationCode: "821104",
			occupationDescription: null,
		},
		{
			occupationCode: "912201",
			occupationDescription: null,
		},
		{
			occupationCode: "313904",
			occupationDescription: null,
		},
		{
			occupationCode: "333906",
			occupationDescription: null,
		},
		{
			occupationCode: "713203",
			occupationDescription: null,
		},
		{
			occupationCode: "723106",
			occupationDescription: null,
		},
		{
			occupationCode: "522319",
			occupationDescription: null,
		},
		{
			occupationCode: "524901",
			occupationDescription: null,
		},
		{
			occupationCode: "817208",
			occupationDescription: null,
		},
		{
			occupationCode: "261903",
			occupationDescription: null,
		},
		{
			occupationCode: "315201",
			occupationDescription: null,
		},
		{
			occupationCode: "225001",
			occupationDescription: null,
		},
		{
			occupationCode: "324001",
			occupationDescription: null,
		},
		{
			occupationCode: "225002",
			occupationDescription: null,
		},
		{
			occupationCode: "134210",
			occupationDescription: null,
		},
		{
			occupationCode: "231022",
			occupationDescription: null,
		},
		{
			occupationCode: "111108",
			occupationDescription: null,
		},
		{
			occupationCode: "352108",
			occupationDescription: null,
		},
		{
			occupationCode: "111301",
			occupationDescription: null,
		},
		{
			occupationCode: "265103",
			occupationDescription: null,
		},
		{
			occupationCode: "265104",
			occupationDescription: null,
		},
		{
			occupationCode: "242125",
			occupationDescription: null,
		},
		{
			occupationCode: "235401",
			occupationDescription: null,
		},
		{
			occupationCode: "233020",
			occupationDescription: null,
		},
		{
			occupationCode: "242306",
			occupationDescription: null,
		},
		{
			occupationCode: "313208",
			occupationDescription: null,
		},
		{
			occupationCode: "713102",
			occupationDescription: null,
		},
		{
			occupationCode: "132418",
			occupationDescription: null,
		},
		{
			occupationCode: "241110",
			occupationDescription: null,
		},
		{
			occupationCode: "313907",
			occupationDescription: null,
		},
		{
			occupationCode: "933402",
			occupationDescription: null,
		},
		{
			occupationCode: "21003",
			occupationDescription: null,
		},
		{
			occupationCode: "21004",
			occupationDescription: null,
		},
		{
			occupationCode: "961101",
			occupationDescription: null,
		},
		{
			occupationCode: "313202",
			occupationDescription: null,
		},
		{
			occupationCode: "961201",
			occupationDescription: null,
		},
		{
			occupationCode: "313207",
			occupationDescription: null,
		},
		{
			occupationCode: "313203",
			occupationDescription: null,
		},
		{
			occupationCode: "731103",
			occupationDescription: null,
		},
		{
			occupationCode: "522314",
			occupationDescription: null,
		},
		{
			occupationCode: "134905",
			occupationDescription: null,
		},
		{
			occupationCode: "818202",
			occupationDescription: null,
		},
		{
			occupationCode: "962402",
			occupationDescription: null,
		},
		{
			occupationCode: "214504",
			occupationDescription: null,
		},
		{
			occupationCode: "132106",
			occupationDescription: null,
		},
		{
			occupationCode: "313204",
			occupationDescription: null,
		},
		{
			occupationCode: "313205",
			occupationDescription: null,
		},
		{
			occupationCode: "818903",
			occupationDescription: null,
		},
		{
			occupationCode: "213303",
			occupationDescription: null,
		},
		{
			occupationCode: "912902",
			occupationDescription: null,
		},
		{
			occupationCode: "214302",
			occupationDescription: null,
		},
		{
			occupationCode: "132107",
			occupationDescription: null,
		},
		{
			occupationCode: "811305",
			occupationDescription: null,
		},
		{
			occupationCode: "712404",
			occupationDescription: null,
		},
		{
			occupationCode: "731902",
			occupationDescription: null,
		},
		{
			occupationCode: "722201",
			occupationDescription: null,
		},
		{
			occupationCode: "134906",
			occupationDescription: null,
		},
		{
			occupationCode: "731701",
			occupationDescription: null,
		},
		{
			occupationCode: "351402",
			occupationDescription: null,
		},
		{
			occupationCode: "251301",
			occupationDescription: null,
		},
		{
			occupationCode: "351403",
			occupationDescription: null,
		},
		{
			occupationCode: "351401",
			occupationDescription: null,
		},
		{
			occupationCode: "214407",
			occupationDescription: null,
		},
		{
			occupationCode: "933101",
			occupationDescription: null,
		},
		{
			occupationCode: "723402",
			occupationDescription: null,
		},
		{
			occupationCode: "142003",
			occupationDescription: null,
		},
		{
			occupationCode: "634004",
			occupationDescription: null,
		},
		{
			occupationCode: "834302",
			occupationDescription: null,
		},
		{
			occupationCode: "912301",
			occupationDescription: null,
		},
		{
			occupationCode: "721501",
			occupationDescription: null,
		},
		{
			occupationCode: "352201",
			occupationDescription: null,
		},
		{
			occupationCode: "352202",
			occupationDescription: null,
		},
		{
			occupationCode: "215108",
			occupationDescription: null,
		},
		{
			occupationCode: "753101",
			occupationDescription: null,
		},
		{
			occupationCode: "712103",
			occupationDescription: null,
		},
		{
			occupationCode: "817209",
			occupationDescription: null,
		},
		{
			occupationCode: "817204",
			occupationDescription: null,
		},
		{
			occupationCode: "817207",
			occupationDescription: null,
		},
		{
			occupationCode: "752301",
			occupationDescription: null,
		},
		{
			occupationCode: "817205",
			occupationDescription: null,
		},
		{
			occupationCode: "752101",
			occupationDescription: null,
		},
		{
			occupationCode: "817206",
			occupationDescription: null,
		},
		{
			occupationCode: "817203",
			occupationDescription: null,
		},
		{
			occupationCode: "817202",
			occupationDescription: null,
		},
		{
			occupationCode: "711503",
			occupationDescription: null,
		},
		{
			occupationCode: "731702",
			occupationDescription: null,
		},
		{
			occupationCode: "817201",
			occupationDescription: null,
		},
		{
			occupationCode: "811307",
			occupationDescription: null,
		},
		{
			occupationCode: "815101",
			occupationDescription: null,
		},
		{
			occupationCode: "341203",
			occupationDescription: null,
		},
		{
			occupationCode: "143106",
			occupationDescription: null,
		},
		{
			occupationCode: "143108",
			occupationDescription: null,
		},
		{
			occupationCode: "516407",
			occupationDescription: null,
		},
		{
			occupationCode: "213106",
			occupationDescription: null,
		},
		{
			occupationCode: "800000",
			occupationDescription: null,
		},
		{
			occupationCode: "611",
			occupationDescription: "أب محرم",
		},
		{
			occupationCode: "951",
			occupationDescription: "أحصائي اكتواري",
		},
		{
			occupationCode: "950",
			occupationDescription: "أحصائي تطبيقي",
		},
		{
			occupationCode: "949",
			occupationDescription: "أحصائي عام",
		},
		{
			occupationCode: "572",
			occupationDescription: "أخ",
		},
		{
			occupationCode: "608",
			occupationDescription: "أخ محرم",
		},
		{
			occupationCode: "963",
			occupationDescription: "أختصاصي توثيق البرامج والنظم",
		},
		{
			occupationCode: "2",
			occupationDescription: "أخرى",
		},
		{
			occupationCode: "800001",
			occupationDescription: "أخرى",
		},
		{
			occupationCode: "1294",
			occupationDescription: "أخصائي أجهزة طبية",
		},
		{
			occupationCode: "49",
			occupationDescription: "أخصائي أسلحة",
		},
		{
			occupationCode: "984",
			occupationDescription: "أخصائي أمن م",
		},
		{
			occupationCode: "140",
			occupationDescription: "أخصائي أول",
		},
		{
			occupationCode: "1015",
			occupationDescription: "أخصائي أول فحص جودة/كارتوغرافي",
		},
		{
			occupationCode: "1288",
			occupationDescription: "أخصائي ابر صينية",
		},
		{
			occupationCode: "987",
			occupationDescription: "أخصائي ادارة الجودة",
		},
		{
			occupationCode: "967",
			occupationDescription: "أخصائي ادارة عقود التقنية",
		},
		{
			occupationCode: "162",
			occupationDescription: "أخصائي اشعة",
		},
		{
			occupationCode: "155",
			occupationDescription: "أخصائي اطفال",
		},
		{
			occupationCode: "1431",
			occupationDescription: "أخصائي اعاقة عقلية",
		},
		{
			occupationCode: "158",
			occupationDescription: "أخصائي اعصاب",
		},
		{
			occupationCode: "221221",
			occupationDescription: "أخصائي اعصاب",
		},
		{
			occupationCode: "161",
			occupationDescription: "أخصائي امراض تناسلية",
		},
		{
			occupationCode: "149",
			occupationDescription: "أخصائي امراض جلدية",
		},
		{
			occupationCode: "221213",
			occupationDescription: "أخصائي امراض جلدية",
		},
		{
			occupationCode: "154",
			occupationDescription: "أخصائي امراض صدرية",
		},
		{
			occupationCode: "221204",
			occupationDescription: "أخصائي امراض صدرية",
		},
		{
			occupationCode: "159",
			occupationDescription: "أخصائي امراض نفسية",
		},
		{
			occupationCode: "153",
			occupationDescription: "أخصائي انف واذن وحنجرة",
		},
		{
			occupationCode: "221225",
			occupationDescription: "أخصائي انف واذن وحنجرة",
		},
		{
			occupationCode: "156",
			occupationDescription: "أخصائي باطنية",
		},
		{
			occupationCode: "221202",
			occupationDescription: "أخصائي باطنية",
		},
		{
			occupationCode: "1100",
			occupationDescription: "أخصائي براءة اختراع",
		},
		{
			occupationCode: "264",
			occupationDescription: "أخصائي تأمينات",
		},
		{
			occupationCode: "241306",
			occupationDescription: "أخصائي تأمينات",
		},
		{
			occupationCode: "344",
			occupationDescription: "أخصائي تجميل",
		},
		{
			occupationCode: "966",
			occupationDescription: "أخصائي تحليل الأ عمال",
		},
		{
			occupationCode: "164",
			occupationDescription: "أخصائي تخدير",
		},
		{
			occupationCode: "1291",
			occupationDescription: "أخصائي تخطيط قلب",
		},
		{
			occupationCode: "1417",
			occupationDescription: "أخصائي تدريب",
		},
		{
			occupationCode: "1429",
			occupationDescription: "أخصائي تربية خاصة",
		},
		{
			occupationCode: "980",
			occupationDescription: "أخصائي تطوير البرمجيات",
		},
		{
			occupationCode: "187",
			occupationDescription: "أخصائي تغذية",
		},
		{
			occupationCode: "1251",
			occupationDescription: "أخصائي تقويم اسنان",
		},
		{
			occupationCode: "146",
			occupationDescription: "أخصائي ثاني",
		},
		{
			occupationCode: "141",
			occupationDescription: "أخصائي جراحة",
		},
		{
			occupationCode: "150",
			occupationDescription: "أخصائي جهاز هظمي",
		},
		{
			occupationCode: "221203",
			occupationDescription: "أخصائي جهاز هظمي",
		},
		{
			occupationCode: "976",
			occupationDescription: "أخصائي دعم فني",
		},
		{
			occupationCode: "1010",
			occupationDescription: "أخصائي رسم خرائط رقمية",
		},
		{
			occupationCode: null,
			occupationDescription: "أخصائي زجاج سيارات",
		},
		{
			occupationCode: "543",
			occupationDescription: "أخصائي زجاج سيارات",
		},
		{
			occupationCode: "1430",
			occupationDescription: "أخصائي صعوبات تعلم",
		},
		{
			occupationCode: "163",
			occupationDescription: "أخصائي عظام",
		},
		{
			occupationCode: "1541",
			occupationDescription: "أخصائي عقود",
		},
		{
			occupationCode: "243103",
			occupationDescription: "أخصائي عقود",
		},
		{
			occupationCode: "1318",
			occupationDescription: "أخصائي علاج بالفن التشكيلي",
		},
		{
			occupationCode: "195",
			occupationDescription: "أخصائي علاج طبيعي",
		},
		{
			occupationCode: "115",
			occupationDescription: "أخصائي علوم زراعية",
		},
		{
			occupationCode: "1293",
			occupationDescription: "أخصائي علوم طبية",
		},
		{
			occupationCode: "152",
			occupationDescription: "أخصائي عيون",
		},
		{
			occupationCode: "221223",
			occupationDescription: "أخصائي عيون",
		},
		{
			occupationCode: "160",
			occupationDescription: "أخصائي قلب",
		},
		{
			occupationCode: "1017",
			occupationDescription: "أخصائي كارتوغرافي رقمي",
		},
		{
			occupationCode: "1450",
			occupationDescription: "أخصائي لغات",
		},
		{
			occupationCode: null,
			occupationDescription: "أخصائي مجالس بلدية وانتخابات",
		},
		{
			occupationCode: "143",
			occupationDescription: "أخصائي مختبر",
		},
		{
			occupationCode: "973",
			occupationDescription: "أخصائي مركز بيانات",
		},
		{
			occupationCode: "157",
			occupationDescription: "أخصائي مسالك بولية",
		},
		{
			occupationCode: "1016",
			occupationDescription: "أخصائي مسح جوي رقمي",
		},
		{
			occupationCode: "448",
			occupationDescription: "أخصائي مفاتيح",
		},
		{
			occupationCode: "1289",
			occupationDescription: "أخصائي مكافحة عدوى",
		},
		{
			occupationCode: "974",
			occupationDescription: "أخصائي مكتب الدعم الفني",
		},
		{
			occupationCode: "151",
			occupationDescription: "أخصائي نساء وولادة",
		},
		{
			occupationCode: "194",
			occupationDescription: "أخصائي نظارات",
		},
		{
			occupationCode: "716",
			occupationDescription: "أرفق",
		},
		{
			occupationCode: "627",
			occupationDescription: "أرملة مواطن",
		},
		{
			occupationCode: "1372",
			occupationDescription: "أستاذ آثار",
		},
		{
			occupationCode: "1370",
			occupationDescription: "أستاذ آداب",
		},
		{
			occupationCode: "1337",
			occupationDescription: "أستاذ أرصاد",
		},
		{
			occupationCode: "1353",
			occupationDescription: "أستاذ بستنة وغابات",
		},
		{
			occupationCode: "1365",
			occupationDescription: "أستاذ تاريخ",
		},
		{
			occupationCode: "1367",
			occupationDescription: "أستاذ تربية",
		},
		{
			occupationCode: "1377",
			occupationDescription: "أستاذ تربية رياضية",
		},
		{
			occupationCode: "1356",
			occupationDescription: "أستاذ جراحة",
		},
		{
			occupationCode: "1366",
			occupationDescription: "أستاذ جغرافيا",
		},
		{
			occupationCode: "1342",
			occupationDescription: "أستاذ رياضيات",
		},
		{
			occupationCode: "1361",
			occupationDescription: "أستاذ صيدلة",
		},
		{
			occupationCode: "1357",
			occupationDescription: "أستاذ طب أسنان",
		},
		{
			occupationCode: "1355",
			occupationDescription: "أستاذ طب بشري",
		},
		{
			occupationCode: "1358",
			occupationDescription: "أستاذ طب بيطري",
		},
		{
			occupationCode: "1335",
			occupationDescription: "أستاذ طبقات الارض",
		},
		{
			occupationCode: "1341",
			occupationDescription: "أستاذ علم أحصاء",
		},
		{
			occupationCode: "1363",
			occupationDescription: "أستاذ علم اجتماع",
		},
		{
			occupationCode: "1360",
			occupationDescription: "أستاذ علم الادوية",
		},
		{
			occupationCode: "1340",
			occupationDescription: "أستاذ علم الامراض",
		},
		{
			occupationCode: "1364",
			occupationDescription: "أستاذ علم الانسان",
		},
		{
			occupationCode: "1338",
			occupationDescription: "أستاذ علم حيوان",
		},
		{
			occupationCode: "1373",
			occupationDescription: "أستاذ علم مكتبات",
		},
		{
			occupationCode: "1339",
			occupationDescription: "أستاذ علم نبات",
		},
		{
			occupationCode: "1362",
			occupationDescription: "أستاذ علم نفس",
		},
		{
			occupationCode: "1379",
			occupationDescription: "أستاذ علوم اقتصادية",
		},
		{
			occupationCode: "1368",
			occupationDescription: "أستاذ علوم دينية",
		},
		{
			occupationCode: "1352",
			occupationDescription: "أستاذ علوم زراعية",
		},
		{
			occupationCode: "1378",
			occupationDescription: "أستاذ علوم سياسية",
		},
		{
			occupationCode: "1359",
			occupationDescription: "أستاذ علوم طبية مساعدة",
		},
		{
			occupationCode: "1380",
			occupationDescription: "أستاذ علوم مالية وتجارية",
		},
		{
			occupationCode: "1336",
			occupationDescription: "أستاذ فلك",
		},
		{
			occupationCode: "1374",
			occupationDescription: "أستاذ فنون تشكيلة",
		},
		{
			occupationCode: "1376",
			occupationDescription: "أستاذ فنون تمثيلية",
		},
		{
			occupationCode: "1334",
			occupationDescription: "أستاذ فيزياء",
		},
		{
			occupationCode: "1369",
			occupationDescription: "أستاذ قانون",
		},
		{
			occupationCode: "1333",
			occupationDescription: "أستاذ كيمياء",
		},
		{
			occupationCode: "1371",
			occupationDescription: "أستاذ لغات",
		},
		{
			occupationCode: "1354",
			occupationDescription: "أستاذ ملاحة جوية",
		},
		{
			occupationCode: "1375",
			occupationDescription: "أستاذ موسيقى",
		},
		{
			occupationCode: "1343",
			occupationDescription: "أستاذ نظم معلومات",
		},
		{
			occupationCode: "1347",
			occupationDescription: "أستاذ هندسة ألكترونية",
		},
		{
			occupationCode: "1384",
			occupationDescription: "أستاذ هندسة حاسب آلي",
		},
		{
			occupationCode: "1351",
			occupationDescription: "أستاذ هندسة صحية وبيئة",
		},
		{
			occupationCode: "1350",
			occupationDescription: "أستاذ هندسة صناعية",
		},
		{
			occupationCode: "1346",
			occupationDescription: "أستاذ هندسة كهربائية",
		},
		{
			occupationCode: "1349",
			occupationDescription: "أستاذ هندسة كيميائية",
		},
		{
			occupationCode: "1345",
			occupationDescription: "أستاذ هندسة مدنية",
		},
		{
			occupationCode: "1344",
			occupationDescription: "أستاذ هندسة معمارية",
		},
		{
			occupationCode: "1348",
			occupationDescription: "أستاذ هندسة ميكانيكية",
		},
		{
			occupationCode: "1178",
			occupationDescription: "أطباء بشريون آخرون",
		},
		{
			occupationCode: "2204",
			occupationDescription: "أطفائي",
		},
		{
			occupationCode: "4",
			occupationDescription: "أعمال حرة",
		},
		{
			occupationCode: "353",
			occupationDescription: "أفراد القبائل",
		},
		{
			occupationCode: "3412",
			occupationDescription: "ألكتروني أجهزة تحكم",
		},
		{
			occupationCode: "3413",
			occupationDescription: "ألكتروني أجهزة حماية",
		},
		{
			occupationCode: "3414",
			occupationDescription: "ألكتروني صناعي عام",
		},
		{
			occupationCode: "3415",
			occupationDescription: "ألكتروني صيانة آلات مبرمجة",
		},
		{
			occupationCode: "3418",
			occupationDescription: "ألكتروني صيانة أجهزة رصد",
		},
		{
			occupationCode: "3417",
			occupationDescription: "ألكتروني صيانة أجهزة طبية",
		},
		{
			occupationCode: "3408",
			occupationDescription: "ألكتروني صيانة تلفاز",
		},
		{
			occupationCode: "3416",
			occupationDescription: "ألكتروني صيانة حاسبات",
		},
		{
			occupationCode: "3405",
			occupationDescription: "ألكتروني صيانة مبرقة",
		},
		{
			occupationCode: "3409",
			occupationDescription: "ألكتروني صيانة مذياع",
		},
		{
			occupationCode: "3407",
			occupationDescription: "ألكتروني صيانة مذياع وتلفاز",
		},
		{
			occupationCode: "3403",
			occupationDescription: "ألكتروني صيانة مقاسم",
		},
		{
			occupationCode: "3406",
			occupationDescription: "ألكتروني صيانة هاتف",
		},
		{
			occupationCode: "2194",
			occupationDescription: "أمام مسجد",
		},
		{
			occupationCode: null,
			occupationDescription: "أمير منطقة",
		},
		{
			occupationCode: "659",
			occupationDescription: "أمير منطقة",
		},
		{
			occupationCode: "285",
			occupationDescription: "أمين صندوق",
		},
		{
			occupationCode: "1456",
			occupationDescription: "أمين متحف",
		},
		{
			occupationCode: "256",
			occupationDescription: "أمين محفوظات",
		},
		{
			occupationCode: "1901",
			occupationDescription: "أمين مخزن",
		},
		{
			occupationCode: "522101",
			occupationDescription: "أمين مخزن",
		},
		{
			occupationCode: "307",
			occupationDescription: "أمين مستودع",
		},
		{
			occupationCode: "255",
			occupationDescription: "أمين مكتبة",
		},
		{
			occupationCode: "1459",
			occupationDescription: "أمين وثائق ومحفوظات",
		},
		{
			occupationCode: "262101",
			occupationDescription: "أمين وثائق ومحفوظات",
		},
		{
			occupationCode: "570",
			occupationDescription: "إبن",
		},
		{
			occupationCode: "619",
			occupationDescription: "ابن أخ محرم",
		},
		{
			occupationCode: "618",
			occupationDescription: "ابن الأخت محرم",
		},
		{
			occupationCode: "613",
			occupationDescription: "ابن الابن",
		},
		{
			occupationCode: "620",
			occupationDescription: "ابن الابن محرم",
		},
		{
			occupationCode: "610",
			occupationDescription: "ابن البنت",
		},
		{
			occupationCode: "622",
			occupationDescription: "ابن الزوج محرم",
		},
		{
			occupationCode: "573",
			occupationDescription: "ابن الزوجة",
		},
		{
			occupationCode: "617",
			occupationDescription: "ابن محرم",
		},
		{
			occupationCode: "1113",
			occupationDescription: "اختصاصي آفات زراعية",
		},
		{
			occupationCode: "1330",
			occupationDescription: "اختصاصي أجناس وسلالات",
		},
		{
			occupationCode: "953",
			occupationDescription: "اختصاصي أحصاء",
		},
		{
			occupationCode: "212003",
			occupationDescription: "اختصاصي أحصاء",
		},
		{
			occupationCode: null,
			occupationDescription: "اختصاصي أحياء مائية",
		},
		{
			occupationCode: "933",
			occupationDescription: "اختصاصي أحياء مائية",
		},
		{
			occupationCode: "1300",
			occupationDescription: "اختصاصي أدوية طبيعية",
		},
		{
			occupationCode: "1299",
			occupationDescription: "اختصاصي أدوية عام",
		},
		{
			occupationCode: "1303",
			occupationDescription: "اختصاصي أدوية كيميائية",
		},
		{
			occupationCode: "1112",
			occupationDescription: "اختصاصي أرشاد زراعي",
		},
		{
			occupationCode: "1556",
			occupationDescription: "اختصاصي أعادة تأمين",
		},
		{
			occupationCode: "944",
			occupationDescription: "اختصاصي أمراض",
		},
		{
			occupationCode: "947",
			occupationDescription: "اختصاصي أمراض الحيوان",
		},
		{
			occupationCode: "948",
			occupationDescription: "اختصاصي أمراض النبات",
		},
		{
			occupationCode: "1301",
			occupationDescription: "اختصاصي أمصال",
		},
		{
			occupationCode: "1502",
			occupationDescription: "اختصاصي أنتاج أفلام",
		},
		{
			occupationCode: "1316",
			occupationDescription: "اختصاصي اختبارات نفسية",
		},
		{
			occupationCode: null,
			occupationDescription: "اختصاصي البيئة البحرية",
		},
		{
			occupationCode: "939",
			occupationDescription: "اختصاصي البيئة البحرية",
		},
		{
			occupationCode: "1071",
			occupationDescription: "اختصاصي امدادات طائرات",
		},
		{
			occupationCode: "1115",
			occupationDescription: "اختصاصي بستنة عام",
		},
		{
			occupationCode: "946",
			occupationDescription: "اختصاصي بكتريا",
		},
		{
			occupationCode: "213112",
			occupationDescription: "اختصاصي بكتريا",
		},
		{
			occupationCode: "1308",
			occupationDescription: "اختصاصي بكتيريا وعقاقير",
		},
		{
			occupationCode: "1557",
			occupationDescription: "اختصاصي تأمين ضد المخاطر",
		},
		{
			occupationCode: "1260",
			occupationDescription: "اختصاصي تحاليل طبية",
		},
		{
			occupationCode: "1263",
			occupationDescription: "اختصاصي تخطيط طبي",
		},
		{
			occupationCode: "1259",
			occupationDescription: "اختصاصي تربية حيوان",
		},
		{
			occupationCode: "1120",
			occupationDescription: "اختصاصي تربية دواجن",
		},
		{
			occupationCode: "1123",
			occupationDescription: "اختصاصي تربية محار",
		},
		{
			occupationCode: "1119",
			occupationDescription: "اختصاصي تربية مواشي",
		},
		{
			occupationCode: "1121",
			occupationDescription: "اختصاصي تربية نحل",
		},
		{
			occupationCode: "1271",
			occupationDescription: "اختصاصي تركيب نظارات طبية",
		},
		{
			occupationCode: "226701",
			occupationDescription: "اختصاصي تركيب نظارات طبية",
		},
		{
			occupationCode: "1455",
			occupationDescription: "اختصاصي ترميم آثار",
		},
		{
			occupationCode: "1529",
			occupationDescription: "اختصاصي تسويق",
		},
		{
			occupationCode: "243110",
			occupationDescription: "اختصاصي تسويق",
		},
		{
			occupationCode: "1262",
			occupationDescription: "اختصاصي تصوير طبي",
		},
		{
			occupationCode: "1509",
			occupationDescription: "اختصاصي تصوير فوتوغرافي",
		},
		{
			occupationCode: "1415",
			occupationDescription: "اختصاصي تعليم سمعية وبصرية",
		},
		{
			occupationCode: "1295",
			occupationDescription: "اختصاصي تغذية عام",
		},
		{
			occupationCode: "1296",
			occupationDescription: "اختصاصي تغذية مرضى",
		},
		{
			occupationCode: "1267",
			occupationDescription: "اختصاصي تمريض جراحة",
		},
		{
			occupationCode: "1269",
			occupationDescription: "اختصاصي تمريض صحة عامة",
		},
		{
			occupationCode: "1266",
			occupationDescription: "اختصاصي تمريض عام",
		},
		{
			occupationCode: "1454",
			occupationDescription: "اختصاصي تنقيب آثار",
		},
		{
			occupationCode: null,
			occupationDescription: "اختصاصي تهجين حيوان علم وراثة",
		},
		{
			occupationCode: "932",
			occupationDescription: "اختصاصي تهجين حيوان علم وراثة",
		},
		{
			occupationCode: "943",
			occupationDescription: "اختصاصي تهجين نبات",
		},
		{
			occupationCode: "1118",
			occupationDescription: "اختصاصي ثروة حيوانية عام",
		},
		{
			occupationCode: "1116",
			occupationDescription: "اختصاصي حدائق",
		},
		{
			occupationCode: "945",
			occupationDescription: "اختصاصي حشرات",
		},
		{
			occupationCode: "213108",
			occupationDescription: "اختصاصي حشرات",
		},
		{
			occupationCode: "1320",
			occupationDescription: "اختصاصي خدمة اجتماعية",
		},
		{
			occupationCode: null,
			occupationDescription: "اختصاصي خلايا حية",
		},
		{
			occupationCode: "935",
			occupationDescription: "اختصاصي خلايا حية",
		},
		{
			occupationCode: "1322",
			occupationDescription: "اختصاصي رعاية أحداث",
		},
		{
			occupationCode: "1321",
			occupationDescription: "اختصاصي رعاية اجتماعية",
		},
		{
			occupationCode: "1323",
			occupationDescription: "اختصاصي رعاية معوقين",
		},
		{
			occupationCode: "952",
			occupationDescription: "اختصاصي رياضيات",
		},
		{
			occupationCode: "1111",
			occupationDescription: "اختصاصي زراعة محمية",
		},
		{
			occupationCode: "1319",
			occupationDescription: "اختصاصي علم اجتماع عام",
		},
		{
			occupationCode: "1329",
			occupationDescription: "اختصاصي علم الانسان / عام",
		},
		{
			occupationCode: "1177",
			occupationDescription: "اختصاصي علم التشريح",
		},
		{
			occupationCode: null,
			occupationDescription: "اختصاصي علم حيوان عام",
		},
		{
			occupationCode: "931",
			occupationDescription: "اختصاصي علم حيوان عام",
		},
		{
			occupationCode: "942",
			occupationDescription: "اختصاصي علم نبات عام",
		},
		{
			occupationCode: "213105",
			occupationDescription: "اختصاصي علم نبات عام",
		},
		{
			occupationCode: "1314",
			occupationDescription: "اختصاصي علم نفس اجتماعي",
		},
		{
			occupationCode: "1312",
			occupationDescription: "اختصاصي علم نفس تجريبي",
		},
		{
			occupationCode: "1315",
			occupationDescription: "اختصاصي علم نفس صناعي",
		},
		{
			occupationCode: "1311",
			occupationDescription: "اختصاصي علم نفس عام",
		},
		{
			occupationCode: "1313",
			occupationDescription: "اختصاصي علم نفس علاجي",
		},
		{
			occupationCode: "1527",
			occupationDescription: "اختصاصي علوم اقتصادية",
		},
		{
			occupationCode: "1525",
			occupationDescription: "اختصاصي علوم سياسية",
		},
		{
			occupationCode: "1117",
			occupationDescription: "اختصاصي غابات ومراعي",
		},
		{
			occupationCode: "940",
			occupationDescription: "اختصاصي في التلوث البحري",
		},
		{
			occupationCode: "1122",
			occupationDescription: "اختصاصي في تربية الأسماك",
		},
		{
			occupationCode: "1540",
			occupationDescription: "اختصاصي في شئون الافراد",
		},
		{
			occupationCode: "938",
			occupationDescription: "اختصاصي في علم الأحياء / عام",
		},
		{
			occupationCode: "1114",
			occupationDescription: "اختصاصي في علم التربة",
		},
		{
			occupationCode: null,
			occupationDescription: "اختصاصي فيزياء بحرية",
		},
		{
			occupationCode: "920",
			occupationDescription: "اختصاصي فيزياء بحرية",
		},
		{
			occupationCode: "937",
			occupationDescription: "اختصاصي فيزياء حيوية",
		},
		{
			occupationCode: "213103",
			occupationDescription: "اختصاصي فيزياء حيوية",
		},
		{
			occupationCode: "1270",
			occupationDescription: "اختصاصي قياس البصر",
		},
		{
			occupationCode: "1389",
			occupationDescription: "اختصاصي قياس وتقويم",
		},
		{
			occupationCode: null,
			occupationDescription: "اختصاصي كيمياء حيوية",
		},
		{
			occupationCode: "936",
			occupationDescription: "اختصاصي كيمياء حيوية",
		},
		{
			occupationCode: null,
			occupationDescription: "اختصاصي كيمياء وبيئة بحرية",
		},
		{
			occupationCode: "903",
			occupationDescription: "اختصاصي كيمياء وبيئة بحرية",
		},
		{
			occupationCode: null,
			occupationDescription: "اختصاصي ماكياج",
		},
		{
			occupationCode: "901",
			occupationDescription: "اختصاصي ماكياج",
		},
		{
			occupationCode: "1302",
			occupationDescription: "اختصاصي مبيدات حشرية",
		},
		{
			occupationCode: "1110",
			occupationDescription: "اختصاصي محاصيل حقلية عام",
		},
		{
			occupationCode: "1261",
			occupationDescription: "اختصاصي مختبر أنسجة حية",
		},
		{
			occupationCode: "941",
			occupationDescription: "اختصاصي مصائد",
		},
		{
			occupationCode: null,
			occupationDescription: "اختصاصي مطافىء طائرات",
		},
		{
			occupationCode: "904",
			occupationDescription: "اختصاصي مطافىء طائرات",
		},
		{
			occupationCode: "1264",
			occupationDescription: "اختصاصي معالجة الاشعة",
		},
		{
			occupationCode: "221229",
			occupationDescription: "اختصاصي معالجة الاشعة",
		},
		{
			occupationCode: "1265",
			occupationDescription: "اختصاصي معالجة طبيعية",
		},
		{
			occupationCode: "1486",
			occupationDescription: "اختصاصي نحت",
		},
		{
			occupationCode: "1390",
			occupationDescription: "اختصاصي وسائل تعليمية",
		},
		{
			occupationCode: null,
			occupationDescription: "اختصاصي وظائف أعضاء",
		},
		{
			occupationCode: "934",
			occupationDescription: "اختصاصي وظائف أعضاء",
		},
		{
			occupationCode: null,
			occupationDescription: "اختصاصي وقاية من الحريق",
		},
		{
			occupationCode: "902",
			occupationDescription: "اختصاصي وقاية من الحريق",
		},
		{
			occupationCode: "1268",
			occupationDescription: "اختصاصية تمريض أمومة وطفولة",
		},
		{
			occupationCode: "165",
			occupationDescription: "اخصائي",
		},
		{
			occupationCode: "200",
			occupationDescription: "اخصائي احصاء",
		},
		{
			occupationCode: "981",
			occupationDescription: "اخصائي ادارةالمعلومات والمعرفة",
		},
		{
			occupationCode: "206",
			occupationDescription: "اخصائي اقتصاد",
		},
		{
			occupationCode: "1254",
			occupationDescription: "اخصائي الاستعاضة السنية",
		},
		{
			occupationCode: "970",
			occupationDescription: "اخصائي البنية التحتية",
		},
		{
			occupationCode: "977",
			occupationDescription: "اخصائي التحول الا لكتروني",
		},
		{
			occupationCode: "1310",
			occupationDescription: "اخصائي امراض اللثه",
		},
		{
			occupationCode: "142",
			occupationDescription: "اخصائي تشريح",
		},
		{
			occupationCode: "969",
			occupationDescription: "اخصائي تشغيل الأ نظمة",
		},
		{
			occupationCode: "1404",
			occupationDescription: "اخصائي تطوير مناهج",
		},
		{
			occupationCode: "975",
			occupationDescription: "اخصائي خدمات التقنية",
		},
		{
			occupationCode: "201",
			occupationDescription: "اخصائي رياضيات",
		},
		{
			occupationCode: "1304",
			occupationDescription: "اخصائي سموم",
		},
		{
			occupationCode: "1253",
			occupationDescription: "اخصائي طب اسنان اطفال",
		},
		{
			occupationCode: "148",
			occupationDescription: "اخصائي طب نووي",
		},
		{
			occupationCode: "1272",
			occupationDescription: "اخصائي علاج تنفسي",
		},
		{
			occupationCode: "1252",
			occupationDescription: "اخصائي علاج جذور وعصب",
		},
		{
			occupationCode: "226104",
			occupationDescription: "اخصائي علاج جذور وعصب",
		},
		{
			occupationCode: "2240",
			occupationDescription: "اخصائي علاج طبيعي خاص",
		},
		{
			occupationCode: "443",
			occupationDescription: "اخصائي كهرباء وميكانيكي",
		},
		{
			occupationCode: "1061",
			occupationDescription: "اخصائي معدات بحرية",
		},
		{
			occupationCode: "978",
			occupationDescription: "اخصائي مكتب ادارة المشاريع",
		},
		{
			occupationCode: "2241",
			occupationDescription: "اخصائي نطق و سمع خاص",
		},
		{
			occupationCode: "986",
			occupationDescription: "اخصائي هندسة البرمجيات",
		},
		{
			occupationCode: "985",
			occupationDescription: "اداري أمن معلومات",
		},
		{
			occupationCode: "983",
			occupationDescription: "اداري انترنت",
		},
		{
			occupationCode: "982",
			occupationDescription: "اداري تقارير",
		},
		{
			occupationCode: "972",
			occupationDescription: "اداري شبكات",
		},
		{
			occupationCode: "968",
			occupationDescription: "اداري قواعدالبيانات",
		},
		{
			occupationCode: "1381",
			occupationDescription: "استاذ جامعي",
		},
		{
			occupationCode: "184",
			occupationDescription: "استشاري",
		},
		{
			occupationCode: "1305",
			occupationDescription: "استشاري أدوية",
		},
		{
			occupationCode: "1250",
			occupationDescription: "استشاري أسنان صحة عامة",
		},
		{
			occupationCode: "1201",
			occupationDescription: "استشاري أشعة",
		},
		{
			occupationCode: "1192",
			occupationDescription: "استشاري أمراض الدم",
		},
		{
			occupationCode: "1210",
			occupationDescription: "استشاري أمراض مهنية",
		},
		{
			occupationCode: "1187",
			occupationDescription: "استشاري أمعاء وقولون",
		},
		{
			occupationCode: "1191",
			occupationDescription: "استشاري أوعية دموية",
		},
		{
			occupationCode: "170",
			occupationDescription: "استشاري اسنان",
		},
		{
			occupationCode: "172",
			occupationDescription: "استشاري اطفال",
		},
		{
			occupationCode: "180",
			occupationDescription: "استشاري اعصاب",
		},
		{
			occupationCode: "183",
			occupationDescription: "استشاري امراض تناسلية",
		},
		{
			occupationCode: "182",
			occupationDescription: "استشاري امراض صدرية",
		},
		{
			occupationCode: "181",
			occupationDescription: "استشاري امراض نفسية",
		},
		{
			occupationCode: "1180",
			occupationDescription: "استشاري انتاج النويدات المشعة",
		},
		{
			occupationCode: "171",
			occupationDescription: "استشاري انف واذن وحنجرة",
		},
		{
			occupationCode: "177",
			occupationDescription: "استشاري باطنية",
		},
		{
			occupationCode: "1273",
			occupationDescription: "استشاري تحاليل طبية",
		},
		{
			occupationCode: "173",
			occupationDescription: "استشاري تخدير",
		},
		{
			occupationCode: "1276",
			occupationDescription: "استشاري تخطيط طبي",
		},
		{
			occupationCode: "1284",
			occupationDescription: "استشاري تركيب نظارات طبية",
		},
		{
			occupationCode: "1275",
			occupationDescription: "استشاري تصوير طبي",
		},
		{
			occupationCode: "1297",
			occupationDescription: "استشاري تغذية",
		},
		{
			occupationCode: "1298",
			occupationDescription: "استشاري تغذية مرضى",
		},
		{
			occupationCode: "1279",
			occupationDescription: "استشاري تمريض",
		},
		{
			occupationCode: "1281",
			occupationDescription: "استشاري تمريض أمومة وطفولة",
		},
		{
			occupationCode: "1280",
			occupationDescription: "استشاري تمريض جراحة",
		},
		{
			occupationCode: "1282",
			occupationDescription: "استشاري تمريض صحة عامة",
		},
		{
			occupationCode: "1202",
			occupationDescription: "استشاري تنظير",
		},
		{
			occupationCode: "1239",
			occupationDescription: "استشاري جراحة أوعية دموية",
		},
		{
			occupationCode: "1244",
			occupationDescription: "استشاري جراحة تجميل",
		},
		{
			occupationCode: "1240",
			occupationDescription: "استشاري جراحة دماغ وأعصاب",
		},
		{
			occupationCode: "1235",
			occupationDescription: "استشاري جراحة عامة",
		},
		{
			occupationCode: "1249",
			occupationDescription: "استشاري جراحة فم وأسنان",
		},
		{
			occupationCode: "1238",
			occupationDescription: "استشاري جراحة قلب",
		},
		{
			occupationCode: "178",
			occupationDescription: "استشاري جراحه",
		},
		{
			occupationCode: "1195",
			occupationDescription: "استشاري جلدية",
		},
		{
			occupationCode: "1194",
			occupationDescription: "استشاري حساسية",
		},
		{
			occupationCode: "1207",
			occupationDescription: "استشاري شرعي",
		},
		{
			occupationCode: "1185",
			occupationDescription: "استشاري صحة عامة",
		},
		{
			occupationCode: "1212",
			occupationDescription: "استشاري طب المناطق الحارة",
		},
		{
			occupationCode: "1208",
			occupationDescription: "استشاري طب رياضي",
		},
		{
			occupationCode: "1184",
			occupationDescription: "استشاري طب عام",
		},
		{
			occupationCode: "1206",
			occupationDescription: "استشاري طب نووي",
		},
		{
			occupationCode: "1203",
			occupationDescription: "استشاري عظام",
		},
		{
			occupationCode: "1285",
			occupationDescription: "استشاري علاج تنفسي",
		},
		{
			occupationCode: "1211",
			occupationDescription: "استشاري علاج طبيعي",
		},
		{
			occupationCode: "1213",
			occupationDescription: "استشاري علم التشريح",
		},
		{
			occupationCode: "179",
			occupationDescription: "استشاري عيون",
		},
		{
			occupationCode: "1189",
			occupationDescription: "استشاري غدد",
		},
		{
			occupationCode: "176",
			occupationDescription: "استشاري قلب",
		},
		{
			occupationCode: "1283",
			occupationDescription: "استشاري قياس البصر",
		},
		{
			occupationCode: "1274",
			occupationDescription: "استشاري مختبر أنسجة حية",
		},
		{
			occupationCode: "175",
			occupationDescription: "استشاري مسالك بولية",
		},
		{
			occupationCode: "1277",
			occupationDescription: "استشاري معالجة الأشعة",
		},
		{
			occupationCode: "174",
			occupationDescription: "استشاري نساء وولادة",
		},
		{
			occupationCode: "2208",
			occupationDescription: "اطفائي حرائق غابات",
		},
		{
			occupationCode: "571",
			occupationDescription: "الأب",
		},
		{
			occupationCode: "569",
			occupationDescription: "الزوج",
		},
		{
			occupationCode: "560",
			occupationDescription: "السائق",
		},
		{
			occupationCode: "1719",
			occupationDescription: "الفنيون في الهندسة /الآخرون",
		},
		{
			occupationCode: "3404",
			occupationDescription: "الكتروني صيانة أجهزة اتصال عام",
		},
		{
			occupationCode: "3402",
			occupationDescription: "الكتروني صيانة مقاسم عام",
		},
		{
			occupationCode: null,
			occupationDescription: "المسئول التنفيذي لمشروع سابك",
		},
		{
			occupationCode: "891",
			occupationDescription: "المسئول التنفيذي لمشروع سابك",
		},
		{
			occupationCode: "322",
			occupationDescription: "بائع",
		},
		{
			occupationCode: "522301",
			occupationDescription: "بائع",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع آلات تصوير",
		},
		{
			occupationCode: "2056",
			occupationDescription: "بائع آلات تصوير",
		},
		{
			occupationCode: "2109",
			occupationDescription: "بائع آلات صناعية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع آلات طابعة واستنساخ",
		},
		{
			occupationCode: "2076",
			occupationDescription: "بائع آلات طابعة واستنساخ",
		},
		{
			occupationCode: "2110",
			occupationDescription: "بائع آلات كهربائية",
		},
		{
			occupationCode: "2098",
			occupationDescription: "بائع آليات أنشاء",
		},
		{
			occupationCode: "2096",
			occupationDescription: "بائع آليات انشائية عام",
		},
		{
			occupationCode: "2097",
			occupationDescription: "بائع آليات طرق",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أثاث خشبي",
		},
		{
			occupationCode: "2045",
			occupationDescription: "بائع أثاث خشبي",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أثاث معدني",
		},
		{
			occupationCode: "2044",
			occupationDescription: "بائع أثاث معدني",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أجهزة دقيقة",
		},
		{
			occupationCode: "2079",
			occupationDescription: "بائع أجهزة دقيقة",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أجهزة طبية",
		},
		{
			occupationCode: "2082",
			occupationDescription: "بائع أجهزة طبية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أجهزة علمية عام",
		},
		{
			occupationCode: "2077",
			occupationDescription: "بائع أجهزة علمية عام",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أجهزة كهربائية منزلية",
		},
		{
			occupationCode: "2043",
			occupationDescription: "بائع أجهزة كهربائية منزلية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أجهزة مخبرية",
		},
		{
			occupationCode: "2078",
			occupationDescription: "بائع أجهزة مخبرية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أجهزة مساحة",
		},
		{
			occupationCode: "2058",
			occupationDescription: "بائع أجهزة مساحة",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أجهزة موسيقية كهربائية",
		},
		{
			occupationCode: "2069",
			occupationDescription: "بائع أجهزة موسيقية كهربائية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أحذية",
		},
		{
			occupationCode: "2037",
			occupationDescription: "بائع أحذية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أخشاب",
		},
		{
			occupationCode: "2087",
			occupationDescription: "بائع أخشاب",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أدوات جراحة",
		},
		{
			occupationCode: "2083",
			occupationDescription: "بائع أدوات جراحة",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أدوات رياضية",
		},
		{
			occupationCode: "2073",
			occupationDescription: "بائع أدوات رياضية",
		},
		{
			occupationCode: "2111",
			occupationDescription: "بائع أدوات صناعية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أدوات منزلية",
		},
		{
			occupationCode: "2042",
			occupationDescription: "بائع أدوات منزلية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أدوات موسيقية",
		},
		{
			occupationCode: "2068",
			occupationDescription: "بائع أدوات موسيقية",
		},
		{
			occupationCode: "2118",
			occupationDescription: "بائع أدوات وآلات زراعية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أدوات وأجهزة منزلية عام",
		},
		{
			occupationCode: "2041",
			occupationDescription: "بائع أدوات وأجهزة منزلية عام",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أشرطة تسجيل",
		},
		{
			occupationCode: "2070",
			occupationDescription: "بائع أشرطة تسجيل",
		},
		{
			occupationCode: "2105",
			occupationDescription: "بائع أطارات",
		},
		{
			occupationCode: "2119",
			occupationDescription: "بائع أعلاف",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أفلام وأشرطة فيديو",
		},
		{
			occupationCode: "2071",
			occupationDescription: "بائع أفلام وأشرطة فيديو",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع أقمشة",
		},
		{
			occupationCode: "2031",
			occupationDescription: "بائع أقمشة",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع ألعاب أطفال",
		},
		{
			occupationCode: "2047",
			occupationDescription: "بائع ألعاب أطفال",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع اسماك",
		},
		{
			occupationCode: "2019",
			occupationDescription: "بائع اسماك",
		},
		{
			occupationCode: "2090",
			occupationDescription: "بائع العدد ولوازم النجارة",
		},
		{
			occupationCode: "2113",
			occupationDescription: "بائع بذور وأسمدة زراعية",
		},
		{
			occupationCode: "2117",
			occupationDescription: "بائع تجهيزات الري",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع تجهيزات الطب البيطري",
		},
		{
			occupationCode: "2084",
			occupationDescription: "بائع تجهيزات الطب البيطري",
		},
		{
			occupationCode: "2112",
			occupationDescription: "بائع تجهيزات زراعية عام",
		},
		{
			occupationCode: "2108",
			occupationDescription: "بائع تجهيزات صناعية عام",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع تجهيزات طبية عام",
		},
		{
			occupationCode: "2081",
			occupationDescription: "بائع تجهيزات طبية عام",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع تجهيزات مكتبية عام",
		},
		{
			occupationCode: "2074",
			occupationDescription: "بائع تجهيزات مكتبية عام",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع تحف نحاسية",
		},
		{
			occupationCode: "2049",
			occupationDescription: "بائع تحف نحاسية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع حاسبات",
		},
		{
			occupationCode: "2080",
			occupationDescription: "بائع حاسبات",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع حقائب",
		},
		{
			occupationCode: "2038",
			occupationDescription: "بائع حقائب",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع حلويات",
		},
		{
			occupationCode: "2022",
			occupationDescription: "بائع حلويات",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع حلي اصطناعية",
		},
		{
			occupationCode: "2054",
			occupationDescription: "بائع حلي اصطناعية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع حلي ذهبية",
		},
		{
			occupationCode: "2052",
			occupationDescription: "بائع حلي ذهبية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع حلي فضية",
		},
		{
			occupationCode: "2053",
			occupationDescription: "بائع حلي فضية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع خبز ومعجنات",
		},
		{
			occupationCode: "2021",
			occupationDescription: "بائع خبز ومعجنات",
		},
		{
			occupationCode: "2015",
			occupationDescription: "بائع خضار وفواكه",
		},
		{
			occupationCode: "2101",
			occupationDescription: "بائع دراجات نارية",
		},
		{
			occupationCode: "2102",
			occupationDescription: "بائع دراجات هوائية",
		},
		{
			occupationCode: "2088",
			occupationDescription: "بائع دهانات ( أصباغ )",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع دوريات وصحف",
		},
		{
			occupationCode: "2065",
			occupationDescription: "بائع دوريات وصحف",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع زهور اصطناعية",
		},
		{
			occupationCode: "2062",
			occupationDescription: "بائع زهور اصطناعية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع زهور طبيعية",
		},
		{
			occupationCode: "2061",
			occupationDescription: "بائع زهور طبيعية",
		},
		{
			occupationCode: "2055",
			occupationDescription: "بائع ساعات",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع سجاد وبسط",
		},
		{
			occupationCode: "2030",
			occupationDescription: "بائع سجاد وبسط",
		},
		{
			occupationCode: "2114",
			occupationDescription: "بائع شتلات زراعية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع صحف",
		},
		{
			occupationCode: "2066",
			occupationDescription: "بائع صحف",
		},
		{
			occupationCode: "2060",
			occupationDescription: "بائع عطور",
		},
		{
			occupationCode: "2122",
			occupationDescription: "بائع غاز",
		},
		{
			occupationCode: "2123",
			occupationDescription: "بائع فحم وخشب وقود",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع قرطاسية",
		},
		{
			occupationCode: "2075",
			occupationDescription: "بائع قرطاسية",
		},
		{
			occupationCode: "2103",
			occupationDescription: "بائع قطع غيار جديدة للمركبات",
		},
		{
			occupationCode: "2104",
			occupationDescription: "بائع قطع غيار مستعملة للمركبات",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع كتب",
		},
		{
			occupationCode: "2064",
			occupationDescription: "بائع كتب",
		},
		{
			occupationCode: "2091",
			occupationDescription: "بائع لوازم انشائية عام",
		},
		{
			occupationCode: "2095",
			occupationDescription: "بائع لوازم تدفئة",
		},
		{
			occupationCode: "2094",
			occupationDescription: "بائع لوازم تكييف",
		},
		{
			occupationCode: "2093",
			occupationDescription: "بائع لوازم تمديدات صحية",
		},
		{
			occupationCode: "2092",
			occupationDescription: "بائع لوازم تمديدات كهربائية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع لوازم خياطة",
		},
		{
			occupationCode: "2039",
			occupationDescription: "بائع لوازم خياطة",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع لوازم رحلات",
		},
		{
			occupationCode: "2027",
			occupationDescription: "بائع لوازم رحلات",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع لوحات فنية",
		},
		{
			occupationCode: "2048",
			occupationDescription: "بائع لوحات فنية",
		},
		{
			occupationCode: "2115",
			occupationDescription: "بائع مبيدات آفات زراعية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع متجول",
		},
		{
			occupationCode: "2024",
			occupationDescription: "بائع متجول",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع مجوهرات",
		},
		{
			occupationCode: "2051",
			occupationDescription: "بائع مجوهرات",
		},
		{
			occupationCode: "2116",
			occupationDescription: "بائع مخصبات زراعية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع مرطبات",
		},
		{
			occupationCode: "2023",
			occupationDescription: "بائع مرطبات",
		},
		{
			occupationCode: "2099",
			occupationDescription: "بائع مركبات جديدة",
		},
		{
			occupationCode: "2100",
			occupationDescription: "بائع مركبات مستعملة",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع مستحضرات أدوات تجميل عام",
		},
		{
			occupationCode: "2059",
			occupationDescription: "بائع مستحضرات أدوات تجميل عام",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع معادن",
		},
		{
			occupationCode: "2086",
			occupationDescription: "بائع معادن",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع مفارش وبطانيات",
		},
		{
			occupationCode: "2040",
			occupationDescription: "بائع مفارش وبطانيات",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع ملابس أطفال",
		},
		{
			occupationCode: "2033",
			occupationDescription: "بائع ملابس أطفال",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع ملابس جاهزة",
		},
		{
			occupationCode: "2032",
			occupationDescription: "بائع ملابس جاهزة",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع ملابس جلدية",
		},
		{
			occupationCode: "2036",
			occupationDescription: "بائع ملابس جلدية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع ملابس رجالية",
		},
		{
			occupationCode: "2034",
			occupationDescription: "بائع ملابس رجالية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع ملابس رياضية",
		},
		{
			occupationCode: "2072",
			occupationDescription: "بائع ملابس رياضية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع ملابس نسائية",
		},
		{
			occupationCode: "2035",
			occupationDescription: "بائع ملابس نسائية",
		},
		{
			occupationCode: "2017",
			occupationDescription: "بائع منتجات ألبان",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع منتجات تراثية ( سياحية)",
		},
		{
			occupationCode: "2050",
			occupationDescription: "بائع منتجات تراثية ( سياحية)",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع منتجات دواجن",
		},
		{
			occupationCode: "2020",
			occupationDescription: "بائع منتجات دواجن",
		},
		{
			occupationCode: "2120",
			occupationDescription: "بائع منتجات نفطية عام",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع منسوجات وجلود عام",
		},
		{
			occupationCode: "2029",
			occupationDescription: "بائع منسوجات وجلود عام",
		},
		{
			occupationCode: "2089",
			occupationDescription: "بائع مواد أبنية",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع مواد انشائية عام",
		},
		{
			occupationCode: "2085",
			occupationDescription: "بائع مواد انشائية عام",
		},
		{
			occupationCode: "2014",
			occupationDescription: "بائع مواد تموينية/ عام",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع مواشي",
		},
		{
			occupationCode: "2026",
			occupationDescription: "بائع مواشي",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع نظارات",
		},
		{
			occupationCode: "2057",
			occupationDescription: "بائع نظارات",
		},
		{
			occupationCode: null,
			occupationDescription: "بائع هدايا وتحف عام",
		},
		{
			occupationCode: "2046",
			occupationDescription: "بائع هدايا وتحف عام",
		},
		{
			occupationCode: "2121",
			occupationDescription: "بائع وقود سائل محطة تعبئة",
		},
		{
			occupationCode: "258",
			occupationDescription: "باحث",
		},
		{
			occupationCode: "259",
			occupationDescription: "باحث اجتماعي",
		},
		{
			occupationCode: "1325",
			occupationDescription: "باحث اجتماعي عام",
		},
		{
			occupationCode: "113",
			occupationDescription: "باحث احياء",
		},
		{
			occupationCode: "1542",
			occupationDescription: "باحث تنظيم",
		},
		{
			occupationCode: "17",
			occupationDescription: "باحث فيزيائي",
		},
		{
			occupationCode: "257",
			occupationDescription: "باحث مكتبات",
		},
		{
			occupationCode: "1317",
			occupationDescription: "باحث نفسي",
		},
		{
			occupationCode: "108",
			occupationDescription: "بحار",
		},
		{
			occupationCode: "835002",
			occupationDescription: "بحار",
		},
		{
			occupationCode: "1129",
			occupationDescription: "بحار متمرس",
		},
		{
			occupationCode: "445",
			occupationDescription: "براد",
		},
		{
			occupationCode: "3020",
			occupationDescription: "براد أنابيب",
		},
		{
			occupationCode: "3019",
			occupationDescription: "براد أنابيب عام",
		},
		{
			occupationCode: "2995",
			occupationDescription: "براد عام",
		},
		{
			occupationCode: "3047",
			occupationDescription: "براد عده",
		},
		{
			occupationCode: "3023",
			occupationDescription: "براد عده ( صانع عده )",
		},
		{
			occupationCode: "3040",
			occupationDescription: "براد ميكانيكي آلات التعدين",
		},
		{
			occupationCode: "3039",
			occupationDescription: "براد ميكانيكي أدوات معدنية",
		},
		{
			occupationCode: "3033",
			occupationDescription: "براد ميكانيكي تجميع",
		},
		{
			occupationCode: "3038",
			occupationDescription: "براد ميكانيكي تربين",
		},
		{
			occupationCode: "3032",
			occupationDescription: "براد ميكانيكي تركيب",
		},
		{
			occupationCode: "3043",
			occupationDescription: "براد ميكانيكي خشب",
		},
		{
			occupationCode: "3035",
			occupationDescription: "براد ميكانيكي محرك احتراق",
		},
		{
			occupationCode: "3037",
			occupationDescription: "براد ميكانيكي محرك بحري",
		},
		{
			occupationCode: "3036",
			occupationDescription: "براد ميكانيكي محرك طائرة",
		},
		{
			occupationCode: "3045",
			occupationDescription: "براد ميكانيكي معدات حفر",
		},
		{
			occupationCode: "3042",
			occupationDescription: "براد ميكانيكي نسيج",
		},
		{
			occupationCode: "2016",
			occupationDescription: "بقال",
		},
		{
			occupationCode: "522102",
			occupationDescription: "بقال",
		},
		{
			occupationCode: "532",
			occupationDescription: "بناء",
		},
		{
			occupationCode: "711101",
			occupationDescription: "بناء",
		},
		{
			occupationCode: "3482",
			occupationDescription: "بناء حجر",
		},
		{
			occupationCode: "3485",
			occupationDescription: "بناء خرسانة",
		},
		{
			occupationCode: "3487",
			occupationDescription: "بناء طوب",
		},
		{
			occupationCode: null,
			occupationDescription: "بناء طوب حراري",
		},
		{
			occupationCode: "3521",
			occupationDescription: "بناء طوب حراري",
		},
		{
			occupationCode: "3520",
			occupationDescription: "بناء طوب مداخن المباني",
		},
		{
			occupationCode: "711202",
			occupationDescription: "بناء طوب مداخن المباني",
		},
		{
			occupationCode: "3481",
			occupationDescription: "بناء عام",
		},
		{
			occupationCode: "3489",
			occupationDescription: "بناء قرميد",
		},
		{
			occupationCode: "347",
			occupationDescription: "بواب",
		},
		{
			occupationCode: "325",
			occupationDescription: "تاجر",
		},
		{
			occupationCode: "1096",
			occupationDescription: "تكنولوجي في الزجاج والخزف",
		},
		{
			occupationCode: "2632",
			occupationDescription: "جامع عينات",
		},
		{
			occupationCode: "3184",
			occupationDescription: "جامع عينات في تحلية المياه",
		},
		{
			occupationCode: "625",
			occupationDescription: "جد محرم",
		},
		{
			occupationCode: "1232",
			occupationDescription: "جراح اختصاصي انف وأذن وحنجرة",
		},
		{
			occupationCode: "1234",
			occupationDescription: "جراح اختصاصي تجميل",
		},
		{
			occupationCode: "1230",
			occupationDescription: "جراح اختصاصي دماغ وأعصاب",
		},
		{
			occupationCode: "1231",
			occupationDescription: "جراح اختصاصي عيون",
		},
		{
			occupationCode: "1228",
			occupationDescription: "جراح اختصاصي قلب",
		},
		{
			occupationCode: "1227",
			occupationDescription: "جراح اختصاصي مسالك بولية",
		},
		{
			occupationCode: "138",
			occupationDescription: "جراح عام",
		},
		{
			occupationCode: "221218",
			occupationDescription: "جراح عام",
		},
		{
			occupationCode: "402",
			occupationDescription: "جزار",
		},
		{
			occupationCode: "751101",
			occupationDescription: "جزار",
		},
		{
			occupationCode: "2895",
			occupationDescription: "جزار بالمجزرة",
		},
		{
			occupationCode: "2894",
			occupationDescription: "جزار حيوانات",
		},
		{
			occupationCode: "2896",
			occupationDescription: "جزار دواجن",
		},
		{
			occupationCode: "2893",
			occupationDescription: "جزار عام",
		},
		{
			occupationCode: "1332",
			occupationDescription: "جغرافي",
		},
		{
			occupationCode: "263202",
			occupationDescription: "جغرافي",
		},
		{
			occupationCode: null,
			occupationDescription: "جلاء بلاط",
		},
		{
			occupationCode: "3508",
			occupationDescription: "جلاء بلاط",
		},
		{
			occupationCode: "3116",
			occupationDescription: "جواهرجي",
		},
		{
			occupationCode: "18",
			occupationDescription: "جيولوجي",
		},
		{
			occupationCode: "211401",
			occupationDescription: "جيولوجي",
		},
		{
			occupationCode: null,
			occupationDescription: "جيولوجي تعدين (مصادر طبيعية)",
		},
		{
			occupationCode: "925",
			occupationDescription: "جيولوجي تعدين (مصادر طبيعية)",
		},
		{
			occupationCode: null,
			occupationDescription: "جيولوجي عام",
		},
		{
			occupationCode: "921",
			occupationDescription: "جيولوجي عام",
		},
		{
			occupationCode: null,
			occupationDescription: "جيولوجي فيزيائي",
		},
		{
			occupationCode: "922",
			occupationDescription: "جيولوجي فيزيائي",
		},
		{
			occupationCode: null,
			occupationDescription: "جيولوجي مياه",
		},
		{
			occupationCode: "924",
			occupationDescription: "جيولوجي مياه",
		},
		{
			occupationCode: "923",
			occupationDescription: "جيولوجي نفط",
		},
		{
			occupationCode: "211403",
			occupationDescription: "جيولوجي نفط",
		},
		{
			occupationCode: "2494",
			occupationDescription: "حائك شباك صيد باليد",
		},
		{
			occupationCode: "2493",
			occupationDescription: "حائك شبك صيد بالالة",
		},
		{
			occupationCode: "2490",
			occupationDescription: "حائك يدوي",
		},
		{
			occupationCode: "346",
			occupationDescription: "حارس",
		},
		{
			occupationCode: "2213",
			occupationDescription: "حارس أمن خاص",
		},
		{
			occupationCode: "2230",
			occupationDescription: "حارس استراحة",
		},
		{
			occupationCode: "2229",
			occupationDescription: "حارس عمارة",
		},
		{
			occupationCode: "2228",
			occupationDescription: "حارس منزلي",
		},
		{
			occupationCode: "2631",
			occupationDescription: "حجار",
		},
		{
			occupationCode: "1800",
			occupationDescription: "حجام",
		},
		{
			occupationCode: "439",
			occupationDescription: "حداد",
		},
		{
			occupationCode: "722101",
			occupationDescription: "حداد",
		},
		{
			occupationCode: "3050",
			occupationDescription: "حداد أبواب فولاذية",
		},
		{
			occupationCode: "3049",
			occupationDescription: "حداد أبواب معدنية",
		},
		{
			occupationCode: "3006",
			occupationDescription: "حداد أثاث معدني",
		},
		{
			occupationCode: "3005",
			occupationDescription: "حداد أثاث معدني عام",
		},
		{
			occupationCode: "2932",
			occupationDescription: "حداد أسلحة",
		},
		{
			occupationCode: "3027",
			occupationDescription: "حداد أقفال",
		},
		{
			occupationCode: "3014",
			occupationDescription: "حداد ألواح معدنية",
		},
		{
			occupationCode: "3013",
			occupationDescription: "حداد ألواح معدنية عام",
		},
		{
			occupationCode: "3054",
			occupationDescription: "حداد انشاءات معدنية",
		},
		{
			occupationCode: "3053",
			occupationDescription: "حداد انشاءات معدنية عام",
		},
		{
			occupationCode: "3250",
			occupationDescription: "حداد ترميم هياكل مركبات",
		},
		{
			occupationCode: "3493",
			occupationDescription: "حداد تسليح بناء",
		},
		{
			occupationCode: "2931",
			occupationDescription: "حداد كيرعربي",
		},
		{
			occupationCode: "440",
			occupationDescription: "حداد لوحات",
		},
		{
			occupationCode: "442",
			occupationDescription: "حداد مسلح",
		},
		{
			occupationCode: "3260",
			occupationDescription: "حداد نوابض ( زنبركات )",
		},
		{
			occupationCode: "355",
			occupationDescription: "حذاء خيل",
		},
		{
			occupationCode: "373",
			occupationDescription: "حفار",
		},
		{
			occupationCode: "2564",
			occupationDescription: "حفار أختام",
		},
		{
			occupationCode: "3499",
			occupationDescription: "حفار أساسات ( قواعد )",
		},
		{
			occupationCode: "2562",
			occupationDescription: "حفار تصويري عام",
		},
		{
			occupationCode: "2599",
			occupationDescription: "حفار حروف على الاحجار",
		},
		{
			occupationCode: "2342",
			occupationDescription: "حفار خشب",
		},
		{
			occupationCode: "2586",
			occupationDescription: "حفار فوتوغرافي عام",
		},
		{
			occupationCode: "2202",
			occupationDescription: "حفار قبور",
		},
		{
			occupationCode: "2565",
			occupationDescription: "حفار معادن بالاحماض",
		},
		{
			occupationCode: "2567",
			occupationDescription: "حفارألواح طباعة معدنيه يدوي",
		},
		{
			occupationCode: "1513",
			occupationDescription: "حكم رياضي",
		},
		{
			occupationCode: "2283",
			occupationDescription: "حلاب مواشي",
		},
		{
			occupationCode: "343",
			occupationDescription: "حلاق",
		},
		{
			occupationCode: "514101",
			occupationDescription: "حلاق",
		},
		{
			occupationCode: "2368",
			occupationDescription: "حلاق جلود بالالة",
		},
		{
			occupationCode: "2367",
			occupationDescription: "حلاق جلود باليد",
		},
		{
			occupationCode: "2124",
			occupationDescription: "حلاق رجالي",
		},
		{
			occupationCode: "334",
			occupationDescription: "حلواني",
		},
		{
			occupationCode: "751202",
			occupationDescription: "حلواني",
		},
		{
			occupationCode: "2220",
			occupationDescription: "حمال",
		},
		{
			occupationCode: "511203",
			occupationDescription: "حمال",
		},
		{
			occupationCode: "1903",
			occupationDescription: "خازن",
		},
		{
			occupationCode: "2106",
			occupationDescription: "خازن قطع غيار المركبات",
		},
		{
			occupationCode: "624",
			occupationDescription: "خال",
		},
		{
			occupationCode: "409",
			occupationDescription: "خباز",
		},
		{
			occupationCode: "751201",
			occupationDescription: "خباز",
		},
		{
			occupationCode: "2129",
			occupationDescription: "خباز تنور",
		},
		{
			occupationCode: "2840",
			occupationDescription: "خباز عام",
		},
		{
			occupationCode: "2128",
			occupationDescription: "خباز فرن",
		},
		{
			occupationCode: "276",
			occupationDescription: "خبير",
		},
		{
			occupationCode: "964",
			occupationDescription: "خبير الا ستراتيجية والتخطيط",
		},
		{
			occupationCode: "1558",
			occupationDescription: "خبير تأمين",
		},
		{
			occupationCode: "1425",
			occupationDescription: "خبير تجميل وتصفيف شعر",
		},
		{
			occupationCode: "1543",
			occupationDescription: "خبير تنظيم",
		},
		{
			occupationCode: "1013",
			occupationDescription: "خبير جيوديسي",
		},
		{
			occupationCode: "1423",
			occupationDescription: "خبير خطوط انتاج",
		},
		{
			occupationCode: "1424",
			occupationDescription: "خبير خياطة",
		},
		{
			occupationCode: "1524",
			occupationDescription: "خبير رياضي",
		},
		{
			occupationCode: "1145",
			occupationDescription: "خبير عمليات موانىء",
		},
		{
			occupationCode: "1532",
			occupationDescription: "خبير قوى عاملة",
		},
		{
			occupationCode: "1422",
			occupationDescription: "خبير مبيعات تسويق",
		},
		{
			occupationCode: null,
			occupationDescription: "خبير مياه",
		},
		{
			occupationCode: "926",
			occupationDescription: "خبير مياه",
		},
		{
			occupationCode: "1012",
			occupationDescription: "خبير نظم معلومات جغرافية",
		},
		{
			occupationCode: "433",
			occupationDescription: "خراز",
		},
		{
			occupationCode: "434",
			occupationDescription: "خراط",
		},
		{
			occupationCode: "3249",
			occupationDescription: "خراط اسطوانات المحرك",
		},
		{
			occupationCode: "3434",
			occupationDescription: "خراط خشب",
		},
		{
			occupationCode: "2988",
			occupationDescription: "خراط عام",
		},
		{
			occupationCode: "3246",
			occupationDescription: "خراط محركات / عام",
		},
		{
			occupationCode: "2785",
			occupationDescription: "خزاف تشكيل بالقوالب",
		},
		{
			occupationCode: "2782",
			occupationDescription: "خزاف عام",
		},
		{
			occupationCode: "2270",
			occupationDescription: "خشاب ( حطاب )",
		},
		{
			occupationCode: "233",
			occupationDescription: "خطاط",
		},
		{
			occupationCode: "731603",
			occupationDescription: "خطاط",
		},
		{
			occupationCode: "1435",
			occupationDescription: "خطيب وأمام مسجد",
		},
		{
			occupationCode: "2919",
			occupationDescription: "خلاط شاي",
		},
		{
			occupationCode: "2394",
			occupationDescription: "خياط أحذية",
		},
		{
			occupationCode: "2509",
			occupationDescription: "خياط أغطية المركبات",
		},
		{
			occupationCode: "2501",
			occupationDescription: "خياط بدل جاهزة",
		},
		{
			occupationCode: "422",
			occupationDescription: "خياط بدل عسكرية",
		},
		{
			occupationCode: "423",
			occupationDescription: "خياط بشوت",
		},
		{
			occupationCode: "2503",
			occupationDescription: "خياط بنطلون",
		},
		{
			occupationCode: "2395",
			occupationDescription: "خياط حذاء بالالة",
		},
		{
			occupationCode: null,
			occupationDescription: "خياط خيام",
		},
		{
			occupationCode: "431",
			occupationDescription: "خياط خيام",
		},
		{
			occupationCode: "2496",
			occupationDescription: "خياط عام",
		},
		{
			occupationCode: "2504",
			occupationDescription: "خياط قمصان وبيجامات",
		},
		{
			occupationCode: "2558",
			occupationDescription: "خياط كتب",
		},
		{
			occupationCode: "424",
			occupationDescription: "خياط مجالس",
		},
		{
			occupationCode: null,
			occupationDescription: "خياط ملا بس عسكرية",
		},
		{
			occupationCode: "2520",
			occupationDescription: "خياط ملا بس عسكرية",
		},
		{
			occupationCode: "2500",
			occupationDescription: "خياط ملابس أطفال عام",
		},
		{
			occupationCode: "421",
			occupationDescription: "خياط ملابس رجالية",
		},
		{
			occupationCode: "2498",
			occupationDescription: "خياط ملابس رجالية عام",
		},
		{
			occupationCode: "2505",
			occupationDescription: "خياط ملابس شعبيه",
		},
		{
			occupationCode: "419",
			occupationDescription: "خياط ملابس نسائية",
		},
		{
			occupationCode: "2499",
			occupationDescription: "خياط ملابس نسائية عام",
		},
		{
			occupationCode: "2232",
			occupationDescription: "خياط منزلي",
		},
		{
			occupationCode: null,
			occupationDescription: "خياط ومفصل ملابس عربية",
		},
		{
			occupationCode: "2518",
			occupationDescription: "خياط ومفصل ملابس عربية",
		},
		{
			occupationCode: "420",
			occupationDescription: "خياطة",
		},
		{
			occupationCode: "354",
			occupationDescription: "خيال",
		},
		{
			occupationCode: "397",
			occupationDescription: "دباغ",
		},
		{
			occupationCode: "2376",
			occupationDescription: "دباغ الجلود",
		},
		{
			occupationCode: "2203",
			occupationDescription: "دفان موتى",
		},
		{
			occupationCode: "2001",
			occupationDescription: "دلال مزاد",
		},
		{
			occupationCode: "2199",
			occupationDescription: "دليل زوار بالمدينة",
		},
		{
			occupationCode: "1836",
			occupationDescription: "دليل متحف",
		},
		{
			occupationCode: "511302",
			occupationDescription: "دليل متحف",
		},
		{
			occupationCode: "1837",
			occupationDescription: "دليل معرض",
		},
		{
			occupationCode: "527",
			occupationDescription: "دهان",
		},
		{
			occupationCode: "713101",
			occupationDescription: "دهان",
		},
		{
			occupationCode: "3457",
			occupationDescription: "دهان أبواب خشبية",
		},
		{
			occupationCode: null,
			occupationDescription: "دهان أثاث",
		},
		{
			occupationCode: "529",
			occupationDescription: "دهان أثاث",
		},
		{
			occupationCode: "3456",
			occupationDescription: "دهان أثاث خشبي",
		},
		{
			occupationCode: "3461",
			occupationDescription: "دهان بالرش عدا الانشاءات",
		},
		{
			occupationCode: "3110",
			occupationDescription: "دهان بالغمر يدويا",
		},
		{
			occupationCode: "3460",
			occupationDescription: "دهان بالفرشاة ماعدا الانشاءات",
		},
		{
			occupationCode: "515",
			occupationDescription: "دهان زجاج",
		},
		{
			occupationCode: "731604",
			occupationDescription: "دهان زجاج",
		},
		{
			occupationCode: "3459",
			occupationDescription: "دهان سفن وانشاءات فولاذية",
		},
		{
			occupationCode: null,
			occupationDescription: "دهان سيارات",
		},
		{
			occupationCode: "530",
			occupationDescription: "دهان سيارات",
		},
		{
			occupationCode: "3555",
			occupationDescription: "دهان لافتات",
		},
		{
			occupationCode: null,
			occupationDescription: "دهان مباني",
		},
		{
			occupationCode: "528",
			occupationDescription: "دهان مباني",
		},
		{
			occupationCode: "3254",
			occupationDescription: "دهان مركبات",
		},
		{
			occupationCode: "3455",
			occupationDescription: "دهان مشغولات خشبية عام",
		},
		{
			occupationCode: "3021",
			occupationDescription: "دهان معادن",
		},
		{
			occupationCode: "792",
			occupationDescription: "رئيس ادارة شبكات الطيران",
		},
		{
			occupationCode: "675",
			occupationDescription: "رئيس بحري",
		},
		{
			occupationCode: "1105",
			occupationDescription: "رئيس برامج التدقيق الداخلي",
		},
		{
			occupationCode: null,
			occupationDescription: "رئيس بلدية أو مجمع قروي",
		},
		{
			occupationCode: "661",
			occupationDescription: "رئيس بلدية أو مجمع قروي",
		},
		{
			occupationCode: "1465",
			occupationDescription: "رئيس تحرير",
		},
		{
			occupationCode: "189",
			occupationDescription: "رئيس تمريض",
		},
		{
			occupationCode: "134209",
			occupationDescription: "رئيس تمريض",
		},
		{
			occupationCode: "731",
			occupationDescription: "رئيس خدمة",
		},
		{
			occupationCode: "788",
			occupationDescription: "رئيس شؤون عمليات التشغيل",
		},
		{
			occupationCode: null,
			occupationDescription: "رئيس شركة",
		},
		{
			occupationCode: "887",
			occupationDescription: "رئيس شركة",
		},
		{
			occupationCode: "329",
			occupationDescription: "رئيس طباخين",
		},
		{
			occupationCode: "512001",
			occupationDescription: "رئيس طباخين",
		},
		{
			occupationCode: null,
			occupationDescription: "رئيس قسم",
		},
		{
			occupationCode: "888",
			occupationDescription: "رئيس قسم",
		},
		{
			occupationCode: null,
			occupationDescription: "رئيس قطاع",
		},
		{
			occupationCode: "889",
			occupationDescription: "رئيس قطاع",
		},
		{
			occupationCode: "631",
			occupationDescription: "رئيس مجلس ادارة",
		},
		{
			occupationCode: null,
			occupationDescription: "راصد أحوال مناخية",
		},
		{
			occupationCode: "929",
			occupationDescription: "راصد أحوال مناخية",
		},
		{
			occupationCode: null,
			occupationDescription: "راصد هزات أرضية",
		},
		{
			occupationCode: "930",
			occupationDescription: "راصد هزات أرضية",
		},
		{
			occupationCode: "1451",
			occupationDescription: "راوي قصص أدبية",
		},
		{
			occupationCode: "3104",
			occupationDescription: "رباب أواني نحاسية",
		},
		{
			occupationCode: "1140",
			occupationDescription: "ربان سفينة ركاب",
		},
		{
			occupationCode: "1141",
			occupationDescription: "ربان سفينة شحن",
		},
		{
			occupationCode: "1143",
			occupationDescription: "ربان عبارة ( معديه)",
		},
		{
			occupationCode: "1142",
			occupationDescription: "ربان ناقلة بترول",
		},
		{
			occupationCode: "576",
			occupationDescription: "ربة بيت",
		},
		{
			occupationCode: "566",
			occupationDescription: "رجل أمن",
		},
		{
			occupationCode: "345",
			occupationDescription: "رجل مطافى",
		},
		{
			occupationCode: "79",
			occupationDescription: "رسام",
		},
		{
			occupationCode: "1597",
			occupationDescription: "رسام أنشائي أبنية",
		},
		{
			occupationCode: "1598",
			occupationDescription: "رسام أنشائي طرق",
		},
		{
			occupationCode: "1643",
			occupationDescription: "رسام الكتروني",
		},
		{
			occupationCode: "1710",
			occupationDescription: "رسام تخطيط مصانع",
		},
		{
			occupationCode: "1483",
			occupationDescription: "رسام تشكيلي",
		},
		{
			occupationCode: "1623",
			occupationDescription: "رسام تصاميم كهربائية",
		},
		{
			occupationCode: "1655",
			occupationDescription: "رسام تمديدات صحية",
		},
		{
			occupationCode: "82",
			occupationDescription: "رسام خرائط",
		},
		{
			occupationCode: "216502",
			occupationDescription: "رسام خرائط",
		},
		{
			occupationCode: "1575",
			occupationDescription: "رسام خرائط فلكية",
		},
		{
			occupationCode: "1485",
			occupationDescription: "رسام رسوم متحركة ( كرتون )",
		},
		{
			occupationCode: "1491",
			occupationDescription: "رسام صور زيتيه أو آثار",
		},
		{
			occupationCode: "1607",
			occupationDescription: "رسام عام",
		},
		{
			occupationCode: "1484",
			occupationDescription: "رسام كاريكاتير",
		},
		{
			occupationCode: "1621",
			occupationDescription: "رسام كهربائي",
		},
		{
			occupationCode: "80",
			occupationDescription: "رسام معماري",
		},
		{
			occupationCode: "1622",
			occupationDescription: "رسام ميكانيكي",
		},
		{
			occupationCode: "1656",
			occupationDescription: "رسام ميكانيكي تكييف وتبريد",
		},
		{
			occupationCode: "1657",
			occupationDescription: "رسام ميكانيكي لحام وصفيح",
		},
		{
			occupationCode: "1835",
			occupationDescription: "رسام نشرات فنية",
		},
		{
			occupationCode: "1608",
			occupationDescription: "رسام هندسة مدنية",
		},
		{
			occupationCode: "81",
			occupationDescription: "رسام هندسي",
		},
		{
			occupationCode: "1833",
			occupationDescription: "رسام وسائل تعليمية",
		},
		{
			occupationCode: "954",
			occupationDescription: "رياضي تطبيقي",
		},
		{
			occupationCode: "1515",
			occupationDescription: "رياضي محترف",
		},
		{
			occupationCode: "1386",
			occupationDescription: "زمالة بحثية مابعد الدكتوراه",
		},
		{
			occupationCode: "2198",
			occupationDescription: "زمزمي",
		},
		{
			occupationCode: "609",
			occupationDescription: "زوج محرم",
		},
		{
			occupationCode: "568",
			occupationDescription: "زوجة مواطن",
		},
		{
			occupationCode: "616",
			occupationDescription: "زيارة تجارية",
		},
		{
			occupationCode: "615",
			occupationDescription: "زيارة شخصية",
		},
		{
			occupationCode: "2280",
			occupationDescription: "سائس خيول",
		},
		{
			occupationCode: "2291",
			occupationDescription: "سائس كلاب جمركية",
		},
		{
			occupationCode: "3205",
			occupationDescription: "سائق آلية تسوية",
		},
		{
			occupationCode: "3211",
			occupationDescription: "سائق آلية سفلتة",
		},
		{
			occupationCode: "2258",
			occupationDescription: "سائق تسويق منتجات زراعية",
		},
		{
			occupationCode: "3206",
			occupationDescription: "سائق جرافه",
		},
		{
			occupationCode: "3190",
			occupationDescription: "سائق حافلة",
		},
		{
			occupationCode: "564",
			occupationDescription: "سائق خاص",
		},
		{
			occupationCode: "3194",
			occupationDescription: "سائق دراجة نارية",
		},
		{
			occupationCode: "3212",
			occupationDescription: "سائق رافعة شوكية",
		},
		{
			occupationCode: "834401",
			occupationDescription: "سائق رافعة شوكية",
		},
		{
			occupationCode: "563",
			occupationDescription: "سائق زراعي",
		},
		{
			occupationCode: "3195",
			occupationDescription: "سائق سيارة أجرة",
		},
		{
			occupationCode: "3192",
			occupationDescription: "سائق سيارة عمومي",
		},
		{
			occupationCode: "3196",
			occupationDescription: "سائق سيارة نقل صغيرة",
		},
		{
			occupationCode: "562",
			occupationDescription: "سائق عام",
		},
		{
			occupationCode: "3204",
			occupationDescription: "سائق عموم آليات الطرق",
		},
		{
			occupationCode: "3207",
			occupationDescription: "سائق غارفة",
		},
		{
			occupationCode: "3199",
			occupationDescription: "سائق قارب",
		},
		{
			occupationCode: "3217",
			occupationDescription: "سائق قاطرة منجم أو محجر",
		},
		{
			occupationCode: "3200",
			occupationDescription: "سائق قطار",
		},
		{
			occupationCode: "3218",
			occupationDescription: "سائق كاشطة ( جريدر)",
		},
		{
			occupationCode: "3210",
			occupationDescription: "سائق مدحلة ( رصاصة )",
		},
		{
			occupationCode: "3197",
			occupationDescription: "سائق مركبة يجرها الحيوان",
		},
		{
			occupationCode: null,
			occupationDescription: "سائق معدات",
		},
		{
			occupationCode: "559",
			occupationDescription: "سائق معدات",
		},
		{
			occupationCode: "2253",
			occupationDescription: "سائق معدات زراعيه",
		},
		{
			occupationCode: "3216",
			occupationDescription: "سائق ناقلة خشب",
		},
		{
			occupationCode: "561",
			occupationDescription: "سائق نقل",
		},
		{
			occupationCode: "833201",
			occupationDescription: "سائق نقل",
		},
		{
			occupationCode: "3224",
			occupationDescription: "سائق نقل وقود",
		},
		{
			occupationCode: "3219",
			occupationDescription: "سائق هراسة",
		},
		{
			occupationCode: "3222",
			occupationDescription: "سائق وايت ماء",
		},
		{
			occupationCode: "3198",
			occupationDescription: "سائق يخت",
		},
		{
			occupationCode: "3146",
			occupationDescription: "ساعاتي",
		},
		{
			occupationCode: "305",
			occupationDescription: "ساعي بريد",
		},
		{
			occupationCode: "356",
			occupationDescription: "سايس خيل",
		},
		{
			occupationCode: "497",
			occupationDescription: "سباك",
		},
		{
			occupationCode: "712601",
			occupationDescription: "سباك",
		},
		{
			occupationCode: "2971",
			occupationDescription: "سباك عام",
		},
		{
			occupationCode: "2408",
			occupationDescription: "سراج",
		},
		{
			occupationCode: "331",
			occupationDescription: "سفرجي",
		},
		{
			occupationCode: "513101",
			occupationDescription: "سفرجي",
		},
		{
			occupationCode: "2237",
			occupationDescription: "سفرجي منزلي",
		},
		{
			occupationCode: "638",
			occupationDescription: "سفير بالسلك الدبلوماسي",
		},
		{
			occupationCode: "278",
			occupationDescription: "سكرتير",
		},
		{
			occupationCode: "412002",
			occupationDescription: "سكرتير",
		},
		{
			occupationCode: "711",
			occupationDescription: "سكرتير أول /أ",
		},
		{
			occupationCode: "712",
			occupationDescription: "سكرتير أول /ب",
		},
		{
			occupationCode: "1861",
			occupationDescription: "سكرتير تنفيذي",
		},
		{
			occupationCode: "715",
			occupationDescription: "سكرتير ثالث",
		},
		{
			occupationCode: "713",
			occupationDescription: "سكرتير ثاني /أ",
		},
		{
			occupationCode: "714",
			occupationDescription: "سكرتير ثاني /ب",
		},
		{
			occupationCode: "145",
			occupationDescription: "سكرتير طبي",
		},
		{
			occupationCode: "334401",
			occupationDescription: "سكرتير طبي",
		},
		{
			occupationCode: "1880",
			occupationDescription: "سكرتير وكاتب اختزال",
		},
		{
			occupationCode: "1998",
			occupationDescription: "سمسار أراض وعقارات",
		},
		{
			occupationCode: "2000",
			occupationDescription: "سمسار أوراق مالية",
		},
		{
			occupationCode: "3017",
			occupationDescription: "سمكري",
		},
		{
			occupationCode: "721303",
			occupationDescription: "سمكري",
		},
		{
			occupationCode: "3251",
			occupationDescription: "سمكري أجسام مركبات",
		},
		{
			occupationCode: "2983",
			occupationDescription: "سمكري أنابيب البخار",
		},
		{
			occupationCode: null,
			occupationDescription: "سمكري سيارات",
		},
		{
			occupationCode: "504",
			occupationDescription: "سمكري سيارات",
		},
		{
			occupationCode: "3253",
			occupationDescription: "سمكري طائرات",
		},
		{
			occupationCode: "1447",
			occupationDescription: "شاعر",
		},
		{
			occupationCode: "264102",
			occupationDescription: "شاعر",
		},
		{
			occupationCode: "2136",
			occupationDescription: "شواء دجاج",
		},
		{
			occupationCode: "2137",
			occupationDescription: "شواء شاورما",
		},
		{
			occupationCode: "2134",
			occupationDescription: "شواء لحوم",
		},
		{
			occupationCode: "2135",
			occupationDescription: "شواء و قلاي سمك",
		},
		{
			occupationCode: "612",
			occupationDescription: "شيخ قبيلة",
		},
		{
			occupationCode: "3114",
			occupationDescription: "صائغ حلي ذهبية",
		},
		{
			occupationCode: "3115",
			occupationDescription: "صائغ حلي فضية",
		},
		{
			occupationCode: "505",
			occupationDescription: "صائغ ذهب",
		},
		{
			occupationCode: "731301",
			occupationDescription: "صائغ ذهب",
		},
		{
			occupationCode: "3118",
			occupationDescription: "صائغ ذهب وفضة",
		},
		{
			occupationCode: "3119",
			occupationDescription: "صائغ زخرفة معادن ثمينة",
		},
		{
			occupationCode: "776",
			occupationDescription: "صاحب فندق",
		},
		{
			occupationCode: null,
			occupationDescription: "صانع آيسكريم بالماكينة",
		},
		{
			occupationCode: "2853",
			occupationDescription: "صانع آيسكريم بالماكينة",
		},
		{
			occupationCode: "2286",
			occupationDescription: "صانع أجبان",
		},
		{
			occupationCode: "2392",
			occupationDescription: "صانع أحذية بلاستيكية ومطاطية",
		},
		{
			occupationCode: "2391",
			occupationDescription: "صانع أحذية طبية",
		},
		{
			occupationCode: "2389",
			occupationDescription: "صانع أحذية عام",
		},
		{
			occupationCode: "2401",
			occupationDescription: "صانع أحذية من المنسوجات",
		},
		{
			occupationCode: "2506",
			occupationDescription: "صانع أغطية الرأس العسكرية",
		},
		{
			occupationCode: "2336",
			occupationDescription: "صانع أقلام رصاص",
		},
		{
			occupationCode: "2563",
			occupationDescription: "صانع ألواح الطباعة بالصب",
		},
		{
			occupationCode: "2285",
			occupationDescription: "صانع الالبان",
		},
		{
			occupationCode: "2823",
			occupationDescription: "صانع الشمع",
		},
		{
			occupationCode: "2356",
			occupationDescription: "صانع الظروف الورقية",
		},
		{
			occupationCode: "2845",
			occupationDescription: "صانع بسكويت",
		},
		{
			occupationCode: "2921",
			occupationDescription: "صانع ثلج",
		},
		{
			occupationCode: "2405",
			occupationDescription: "صانع حقائب سفر",
		},
		{
			occupationCode: "2404",
			occupationDescription: "صانع حقائب يد",
		},
		{
			occupationCode: "2140",
			occupationDescription: "صانع حلويات",
		},
		{
			occupationCode: "2849",
			occupationDescription: "صانع حلويات شرقية",
		},
		{
			occupationCode: "2847",
			occupationDescription: "صانع حلويات عام",
		},
		{
			occupationCode: null,
			occupationDescription: "صانع حلويات غربية",
		},
		{
			occupationCode: "2850",
			occupationDescription: "صانع حلويات غربية",
		},
		{
			occupationCode: "3113",
			occupationDescription: "صانع حلي ومجوهرات عام",
		},
		{
			occupationCode: null,
			occupationDescription: "صانع خل",
		},
		{
			occupationCode: "2869",
			occupationDescription: "صانع خل",
		},
		{
			occupationCode: null,
			occupationDescription: "صانع خمائر عام",
		},
		{
			occupationCode: "2863",
			occupationDescription: "صانع خمائر عام",
		},
		{
			occupationCode: null,
			occupationDescription: "صانع دبس",
		},
		{
			occupationCode: "2877",
			occupationDescription: "صانع دبس",
		},
		{
			occupationCode: "2917",
			occupationDescription: "صانع زبادي",
		},
		{
			occupationCode: "2913",
			occupationDescription: "صانع زبدة",
		},
		{
			occupationCode: null,
			occupationDescription: "صانع زهور اصطناعية",
		},
		{
			occupationCode: "2063",
			occupationDescription: "صانع زهور اصطناعية",
		},
		{
			occupationCode: "2848",
			occupationDescription: "صانع شوكولاته",
		},
		{
			occupationCode: "3121",
			occupationDescription: "صانع صفائح",
		},
		{
			occupationCode: "2390",
			occupationDescription: "صانع صنادل",
		},
		{
			occupationCode: "2890",
			occupationDescription: "صانع طحينة",
		},
		{
			occupationCode: "2156",
			occupationDescription: "صانع عصير فواكه",
		},
		{
			occupationCode: "2139",
			occupationDescription: "صانع فلافل",
		},
		{
			occupationCode: "2142",
			occupationDescription: "صانع فول مدمس",
		},
		{
			occupationCode: "2912",
			occupationDescription: "صانع قشدة",
		},
		{
			occupationCode: "2427",
			occupationDescription: "صانع قطن طبي",
		},
		{
			occupationCode: "2157",
			occupationDescription: "صانع قهوة عربية",
		},
		{
			occupationCode: "2158",
			occupationDescription: "صانع قهوة وشاي وغيرها",
		},
		{
			occupationCode: "2967",
			occupationDescription: "صانع قوالب رملية",
		},
		{
			occupationCode: "2393",
			occupationDescription: "صانع قوالب للاحذية",
		},
		{
			occupationCode: "3001",
			occupationDescription: "صانع قوالب وأدوات",
		},
		{
			occupationCode: null,
			occupationDescription: "صانع لبان ( علك )",
		},
		{
			occupationCode: "2851",
			occupationDescription: "صانع لبان ( علك )",
		},
		{
			occupationCode: "2915",
			occupationDescription: "صانع لبن",
		},
		{
			occupationCode: "2916",
			occupationDescription: "صانع مثلجات",
		},
		{
			occupationCode: null,
			occupationDescription: "صانع مخللات",
		},
		{
			occupationCode: "407",
			occupationDescription: "صانع مخللات",
		},
		{
			occupationCode: null,
			occupationDescription: "صانع مخللات ( طرشي )",
		},
		{
			occupationCode: "2870",
			occupationDescription: "صانع مخللات ( طرشي )",
		},
		{
			occupationCode: null,
			occupationDescription: "صانع مربى",
		},
		{
			occupationCode: "2876",
			occupationDescription: "صانع مربى",
		},
		{
			occupationCode: "2141",
			occupationDescription: "صانع معجنات",
		},
		{
			occupationCode: "2844",
			occupationDescription: "صانع معجنات وفطائر",
		},
		{
			occupationCode: "2834",
			occupationDescription: "صانع مكرونة عام",
		},
		{
			occupationCode: "2909",
			occupationDescription: "صانع منتجات ألبان عام",
		},
		{
			occupationCode: "2403",
			occupationDescription: "صانع منتجات جلود عام",
		},
		{
			occupationCode: "2900",
			occupationDescription: "صانع منتجات لحوم",
		},
		{
			occupationCode: "2966",
			occupationDescription: "صانع نماذج",
		},
		{
			occupationCode: "2386",
			occupationDescription: "صانع نماذج أحذية",
		},
		{
			occupationCode: "2789",
			occupationDescription: "صانع نماذج للمنتجات الخزفية",
		},
		{
			occupationCode: "1596",
			occupationDescription: "صانع نماذج معمارية ( ماكيت )",
		},
		{
			occupationCode: "2507",
			occupationDescription: "صانع نماذج ملابس",
		},
		{
			occupationCode: "2968",
			occupationDescription: "صانع نوى (دلاليك ) رملية",
		},
		{
			occupationCode: "2385",
			occupationDescription: "صانع ومفصل أحذية عام",
		},
		{
			occupationCode: "396",
			occupationDescription: "صباغ أقمشة",
		},
		{
			occupationCode: "2437",
			occupationDescription: "صباغ خيوط",
		},
		{
			occupationCode: "229",
			occupationDescription: "صحفي",
		},
		{
			occupationCode: "286",
			occupationDescription: "صراف",
		},
		{
			occupationCode: "421101",
			occupationDescription: "صراف",
		},
		{
			occupationCode: "1860",
			occupationDescription: "صراف أوراق مالية وعمله",
		},
		{
			occupationCode: "1944",
			occupationDescription: "صراف نقود في المؤسسات التجارية",
		},
		{
			occupationCode: "2396",
			occupationDescription: "صقال أحذية",
		},
		{
			occupationCode: "2755",
			occupationDescription: "صقال زجاج",
		},
		{
			occupationCode: "2757",
			occupationDescription: "صقال عدسات",
		},
		{
			occupationCode: "2318",
			occupationDescription: "صياد بري",
		},
		{
			occupationCode: "2312",
			occupationDescription: "صياد سمك بحري",
		},
		{
			occupationCode: "2313",
			occupationDescription: "صياد سمك مياه داخلية",
		},
		{
			occupationCode: "365",
			occupationDescription: "صيادأسماك",
		},
		{
			occupationCode: "185",
			occupationDescription: "صيدلي",
		},
		{
			occupationCode: "226201",
			occupationDescription: "صيدلي",
		},
		{
			occupationCode: "574",
			occupationDescription: "ضابط",
		},
		{
			occupationCode: "575",
			occupationDescription: "ضابط صف",
		},
		{
			occupationCode: "595",
			occupationDescription: "ضابط طبيب",
		},
		{
			occupationCode: "1973",
			occupationDescription: "ضابط عمليات طيران",
		},
		{
			occupationCode: "596",
			occupationDescription: "ضابط معار",
		},
		{
			occupationCode: "1885",
			occupationDescription: "طابع عام",
		},
		{
			occupationCode: "5",
			occupationDescription: "طالب",
		},
		{
			occupationCode: "2133",
			occupationDescription: "طاهي أطعمة أجنبية",
		},
		{
			occupationCode: "2132",
			occupationDescription: "طاهي أطعمة عربية",
		},
		{
			occupationCode: "2146",
			occupationDescription: "طاهي جوي",
		},
		{
			occupationCode: "2131",
			occupationDescription: "طاهي عام",
		},
		{
			occupationCode: "330",
			occupationDescription: "طباخ",
		},
		{
			occupationCode: "2905",
			occupationDescription: "طباخ اسماك",
		},
		{
			occupationCode: null,
			occupationDescription: "طباخ تمور",
		},
		{
			occupationCode: "2878",
			occupationDescription: "طباخ تمور",
		},
		{
			occupationCode: null,
			occupationDescription: "طباخ فواكه وخضراوات  او  عام",
		},
		{
			occupationCode: "2871",
			occupationDescription: "طباخ فواكه وخضراوات  او  عام",
		},
		{
			occupationCode: "2233",
			occupationDescription: "طباخ منزلي",
		},
		{
			occupationCode: "2532",
			occupationDescription: "طباع بالاختام",
		},
		{
			occupationCode: "2531",
			occupationDescription: "طباع بالشبكة الحريرية",
		},
		{
			occupationCode: "2570",
			occupationDescription: "طباع صور فوتوغرافية",
		},
		{
			occupationCode: "2535",
			occupationDescription: "طباع عام",
		},
		{
			occupationCode: "2533",
			occupationDescription: "طباع نسيج",
		},
		{
			occupationCode: "137",
			occupationDescription: "طبيب",
		},
		{
			occupationCode: "166",
			occupationDescription: "طبيب أسنان",
		},
		{
			occupationCode: "226101",
			occupationDescription: "طبيب أسنان",
		},
		{
			occupationCode: "1247",
			occupationDescription: "طبيب أسنان /صحة عامة",
		},
		{
			occupationCode: "1245",
			occupationDescription: "طبيب أسنان عام",
		},
		{
			occupationCode: "1156",
			occupationDescription: "طبيب اختصاصي أمراض الدم",
		},
		{
			occupationCode: "1174",
			occupationDescription: "طبيب اختصاصي أمراض مهنية",
		},
		{
			occupationCode: "1151",
			occupationDescription: "طبيب اختصاصي أمعاء وقولون",
		},
		{
			occupationCode: "1155",
			occupationDescription: "طبيب اختصاصي أوعية دموية",
		},
		{
			occupationCode: "1168",
			occupationDescription: "طبيب اختصاصي تخدير",
		},
		{
			occupationCode: "1166",
			occupationDescription: "طبيب اختصاصي تنظير",
		},
		{
			occupationCode: "1246",
			occupationDescription: "طبيب اختصاصي جراحةفم وأسنان",
		},
		{
			occupationCode: "1158",
			occupationDescription: "طبيب اختصاصي حساسية",
		},
		{
			occupationCode: "1171",
			occupationDescription: "طبيب اختصاصي شرعي",
		},
		{
			occupationCode: "1149",
			occupationDescription: "طبيب اختصاصي صحة عامة",
		},
		{
			occupationCode: "1176",
			occupationDescription: "طبيب اختصاصي طب المناطق الحارة",
		},
		{
			occupationCode: "1172",
			occupationDescription: "طبيب اختصاصي طب رياضي",
		},
		{
			occupationCode: "1148",
			occupationDescription: "طبيب اختصاصي طب عام",
		},
		{
			occupationCode: "1170",
			occupationDescription: "طبيب اختصاصي طب نووي",
		},
		{
			occupationCode: "1175",
			occupationDescription: "طبيب اختصاصي علاج طبيعي",
		},
		{
			occupationCode: "1153",
			occupationDescription: "طبيب اختصاصي غدد",
		},
		{
			occupationCode: "221207",
			occupationDescription: "طبيب اختصاصي غدد",
		},
		{
			occupationCode: "1161",
			occupationDescription: "طبيب اختصاصي نساء وولادة",
		},
		{
			occupationCode: "139",
			occupationDescription: "طبيب استشاري",
		},
		{
			occupationCode: "168",
			occupationDescription: "طبيب بيطري",
		},
		{
			occupationCode: "1257",
			occupationDescription: "طبيب بيطري اختصاصي دواجن",
		},
		{
			occupationCode: "1256",
			occupationDescription: "طبيب بيطري اختصاصي مواشي",
		},
		{
			occupationCode: "1255",
			occupationDescription: "طبيب بيطري عام",
		},
		{
			occupationCode: "144",
			occupationDescription: "طبيب طواريء",
		},
		{
			occupationCode: "221215",
			occupationDescription: "طبيب طواريء",
		},
		{
			occupationCode: "1215",
			occupationDescription: "طبيب كلى",
		},
		{
			occupationCode: "1222",
			occupationDescription: "طبيب مقيم طوارىء",
		},
		{
			occupationCode: "136",
			occupationDescription: "طبيب ممارس",
		},
		{
			occupationCode: "221101",
			occupationDescription: "طبيب ممارس",
		},
		{
			occupationCode: "2832",
			occupationDescription: "طحان توابل",
		},
		{
			occupationCode: "2825",
			occupationDescription: "طحان حبوب عام",
		},
		{
			occupationCode: "2639",
			occupationDescription: "طحان خامات",
		},
		{
			occupationCode: "2783",
			occupationDescription: "طحان خامات الخزف",
		},
		{
			occupationCode: "103",
			occupationDescription: "طيار",
		},
		{
			occupationCode: "1132",
			occupationDescription: "طيار تجاري",
		},
		{
			occupationCode: "1136",
			occupationDescription: "طيار تجريبي",
		},
		{
			occupationCode: "1134",
			occupationDescription: "طيار تدريب",
		},
		{
			occupationCode: "1135",
			occupationDescription: "طيار زراعي",
		},
		{
			occupationCode: "1133",
			occupationDescription: "طيار سمتيات هليوكوبتر",
		},
		{
			occupationCode: "1137",
			occupationDescription: "طيار عام لغير النقل",
		},
		{
			occupationCode: "906",
			occupationDescription: "عالم أو خبير",
		},
		{
			occupationCode: "1181",
			occupationDescription: "عالم ابحاث طبية",
		},
		{
			occupationCode: "19",
			occupationDescription: "عالم فلك",
		},
		{
			occupationCode: "565",
			occupationDescription: "عامل",
		},
		{
			occupationCode: "437",
			occupationDescription: "عامل أحجار",
		},
		{
			occupationCode: "2380",
			occupationDescription: "عامل أزالة اللحم من جلود ال",
		},
		{
			occupationCode: "3202",
			occupationDescription: "عامل أشارة",
		},
		{
			occupationCode: "2636",
			occupationDescription: "عامل أشارة منجم",
		},
		{
			occupationCode: "2941",
			occupationDescription: "عامل أصلاح المناشير وسنها",
		},
		{
			occupationCode: "2409",
			occupationDescription: "عامل أصلاح حقائب",
		},
		{
			occupationCode: "2476",
			occupationDescription: "عامل أصلاح عيوب المنسوجات",
		},
		{
			occupationCode: "2486",
			occupationDescription: "عامل أعداد شبكة آليا",
		},
		{
			occupationCode: "2489",
			occupationDescription: "عامل أعداد ضفيرة آليا",
		},
		{
			occupationCode: "2481",
			occupationDescription: "عامل أعداد نسيج مطرز يدويا",
		},
		{
			occupationCode: "3122",
			occupationDescription: "عامل اصلاح جواهر ثمينة",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل اطارات",
		},
		{
			occupationCode: "517",
			occupationDescription: "عامل اطارات",
		},
		{
			occupationCode: "2701",
			occupationDescription: "عامل التحميص",
		},
		{
			occupationCode: "2196",
			occupationDescription: "عامل المسجد",
		},
		{
			occupationCode: "2566",
			occupationDescription: "عامل النكلشة بالطلاء الكهربائي",
		},
		{
			occupationCode: "391",
			occupationDescription: "عامل انتاج ألياف",
		},
		{
			occupationCode: "3085",
			occupationDescription: "عامل برشمة  او  آليا",
		},
		{
			occupationCode: "3084",
			occupationDescription: "عامل برشمة  او  يدويا",
		},
		{
			occupationCode: "3086",
			occupationDescription: "عامل برشمة ضغط هوائي",
		},
		{
			occupationCode: "2918",
			occupationDescription: "عامل بسترة منتجات الألبان",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل بلاط",
		},
		{
			occupationCode: "511",
			occupationDescription: "عامل بلاط",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل بوفيه",
		},
		{
			occupationCode: "413",
			occupationDescription: "عامل بوفيه",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل بياض بالجبس ( المصيص )",
		},
		{
			occupationCode: "3531",
			occupationDescription: "عامل بياض بالجبس ( المصيص )",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل بياض زخرفي",
		},
		{
			occupationCode: "3530",
			occupationDescription: "عامل بياض زخرفي",
		},
		{
			occupationCode: "2327",
			occupationDescription: "عامل تبخير",
		},
		{
			occupationCode: "2478",
			occupationDescription: "عامل تبريز",
		},
		{
			occupationCode: "2666",
			occupationDescription: "عامل تبطين آبار النفط والغاز",
		},
		{
			occupationCode: "3117",
			occupationDescription: "عامل تثبيت أحجار كريمة",
		},
		{
			occupationCode: "2596",
			occupationDescription: "عامل تثقيب الاحجار",
		},
		{
			occupationCode: "2455",
			occupationDescription: "عامل تثقيل الحرير الطبيعي",
		},
		{
			occupationCode: "2702",
			occupationDescription: "عامل تجفيف معالجة كيميائية",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تجليد",
		},
		{
			occupationCode: "524",
			occupationDescription: "عامل تجليد",
		},
		{
			occupationCode: "3591",
			occupationDescription: "عامل تجميع أجهزة قياس كهرباء",
		},
		{
			occupationCode: "3574",
			occupationDescription: "عامل تجميع أفران ومدافي غاز",
		},
		{
			occupationCode: "3572",
			occupationDescription: "عامل تجميع اجهزة تبريد",
		},
		{
			occupationCode: "3592",
			occupationDescription: "عامل تجميع اجهزة تسخين",
		},
		{
			occupationCode: "3593",
			occupationDescription: "عامل تجميع اجهزة تهوية",
		},
		{
			occupationCode: "3596",
			occupationDescription: "عامل تجميع اجهزة رصد",
		},
		{
			occupationCode: "3595",
			occupationDescription: "عامل تجميع اجهزة طبية",
		},
		{
			occupationCode: "3570",
			occupationDescription: "عامل تجميع اجهزة عرض",
		},
		{
			occupationCode: "3571",
			occupationDescription: "عامل تجميع اجهزة مساحة",
		},
		{
			occupationCode: "3597",
			occupationDescription: "عامل تجميع الأجهزة الالكترونية",
		},
		{
			occupationCode: "3565",
			occupationDescription: "عامل تجميع الات الخياطة",
		},
		{
			occupationCode: "3563",
			occupationDescription: "عامل تجميع الات الغزل",
		},
		{
			occupationCode: "3566",
			occupationDescription: "عامل تجميع الات المطابع",
		},
		{
			occupationCode: "3562",
			occupationDescription: "عامل تجميع الات النجارة",
		},
		{
			occupationCode: "3564",
			occupationDescription: "عامل تجميع الات النسيج",
		},
		{
			occupationCode: "3561",
			occupationDescription: "عامل تجميع الات تشغيل",
		},
		{
			occupationCode: "3568",
			occupationDescription: "عامل تجميع الات تصوير",
		},
		{
			occupationCode: "3567",
			occupationDescription: "عامل تجميع الات دقيقة",
		},
		{
			occupationCode: "3594",
			occupationDescription: "عامل تجميع الحاسبات",
		},
		{
			occupationCode: "3580",
			occupationDescription: "عامل تجميع اليات الطرق",
		},
		{
			occupationCode: "3579",
			occupationDescription: "عامل تجميع اليات زراعية",
		},
		{
			occupationCode: "3601",
			occupationDescription: "عامل تجميع تلفاز",
		},
		{
			occupationCode: "3577",
			occupationDescription: "عامل تجميع دراجات",
		},
		{
			occupationCode: "3578",
			occupationDescription: "عامل تجميع دراجات هوائية",
		},
		{
			occupationCode: "3573",
			occupationDescription: "عامل تجميع غسالات",
		},
		{
			occupationCode: "3585",
			occupationDescription: "عامل تجميع قواطع كهربائية",
		},
		{
			occupationCode: "3587",
			occupationDescription: "عامل تجميع لوحات توزيع",
		},
		{
			occupationCode: "3599",
			occupationDescription: "عامل تجميع مبرقات",
		},
		{
			occupationCode: "3569",
			occupationDescription: "عامل تجميع مجهرات",
		},
		{
			occupationCode: "3581",
			occupationDescription: "عامل تجميع محركات توربينية",
		},
		{
			occupationCode: "3583",
			occupationDescription: "عامل تجميع محركات كهربائية",
		},
		{
			occupationCode: "3584",
			occupationDescription: "عامل تجميع محولات كهربائية",
		},
		{
			occupationCode: "3602",
			occupationDescription: "عامل تجميع مذياع",
		},
		{
			occupationCode: "3576",
			occupationDescription: "عامل تجميع مركبات",
		},
		{
			occupationCode: "3590",
			occupationDescription: "عامل تجميع معدات كهربائية",
		},
		{
			occupationCode: "3586",
			occupationDescription: "عامل تجميع مفاتيح كهربائية",
		},
		{
			occupationCode: "3598",
			occupationDescription: "عامل تجميع مقاسم ألكترونيه",
		},
		{
			occupationCode: "2731",
			occupationDescription: "عامل تجميع منتجات المطاط",
		},
		{
			occupationCode: "2735",
			occupationDescription: "عامل تجميع منتجات بلاستيك",
		},
		{
			occupationCode: "3582",
			occupationDescription: "عامل تجميع مولدات كهربائية",
		},
		{
			occupationCode: "3600",
			occupationDescription: "عامل تجميع هاتف",
		},
		{
			occupationCode: "2955",
			occupationDescription: "عامل تجميع هياكل معدنية",
		},
		{
			occupationCode: "2432",
			occupationDescription: "عامل تجميع وحزم الألياف",
		},
		{
			occupationCode: "2298",
			occupationDescription: "عامل تجميع وفرز البيض",
		},
		{
			occupationCode: "2436",
			occupationDescription: "عامل تجهيز (توضيب) الأنوال",
		},
		{
			occupationCode: "2541",
			occupationDescription: "عامل تجهيز أفلام ألاوفست",
		},
		{
			occupationCode: "2846",
			occupationDescription: "عامل تجهيز الخبز وصناعته",
		},
		{
			occupationCode: "3051",
			occupationDescription: "عامل تجهيز انشاءات فولاذية",
		},
		{
			occupationCode: "2462",
			occupationDescription: "عامل تجهيز بطاقات الجاكارد",
		},
		{
			occupationCode: "2610",
			occupationDescription: "عامل تجهيز خلط بلاط خزفي",
		},
		{
			occupationCode: "2602",
			occupationDescription: "عامل تجهيز خلطات طوب اسمنتي",
		},
		{
			occupationCode: "3065",
			occupationDescription: "عامل تجهيز ماكينة ثقب وتشغيلها",
		},
		{
			occupationCode: "3068",
			occupationDescription: "عامل تجهيز ماكينة رش",
		},
		{
			occupationCode: "3067",
			occupationDescription: "عامل تجهيز ماكينة صقل",
		},
		{
			occupationCode: "3350",
			occupationDescription: "عامل تجهيز مفاتيح تحكم",
		},
		{
			occupationCode: "3348",
			occupationDescription: "عامل تجهيز وتركيب محول",
		},
		{
			occupationCode: "3421",
			occupationDescription: "عامل تجهيز وتركيب نظام الاش",
		},
		{
			occupationCode: "2397",
			occupationDescription: "عامل تجهيز وجه الحذاء",
		},
		{
			occupationCode: "3381",
			occupationDescription: "عامل تجهيزأدوات كهربائية",
		},
		{
			occupationCode: "2822",
			occupationDescription: "عامل تجهيزالطيور وتحنيطها",
		},
		{
			occupationCode: "2943",
			occupationDescription: "عامل تجهيزماكينة",
		},
		{
			occupationCode: "3420",
			occupationDescription: "عامل تجهيزمعدات ألكترونيه",
		},
		{
			occupationCode: "2431",
			occupationDescription: "عامل تحضير ألياف الصوف وغسلها",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تحضير الخضراوات والفواكه",
		},
		{
			occupationCode: "2872",
			occupationDescription: "عامل تحضير الخضراوات والفواكه",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تحضيرمواد أولية للزيوت",
		},
		{
			occupationCode: "2886",
			occupationDescription: "عامل تحضيرمواد أولية للزيوت",
		},
		{
			occupationCode: "2589",
			occupationDescription: "عامل تحميض فوتوغرافي",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تحميض وطبع",
		},
		{
			occupationCode: "526",
			occupationDescription: "عامل تحميض وطبع",
		},
		{
			occupationCode: "3203",
			occupationDescription: "عامل تحويل سكك",
		},
		{
			occupationCode: "283",
			occupationDescription: "عامل تخريم",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تخشين حجر الطاحونة",
		},
		{
			occupationCode: "3518",
			occupationDescription: "عامل تخشين حجر الطاحونة",
		},
		{
			occupationCode: "3098",
			occupationDescription: "عامل تخمير ( لحفر المعادن)",
		},
		{
			occupationCode: "2421",
			occupationDescription: "عامل تدوير الخيوط المبرومة",
		},
		{
			occupationCode: "2287",
			occupationDescription: "عامل تربية حيوان الفراء",
		},
		{
			occupationCode: "2273",
			occupationDescription: "عامل تربية حيوان عام",
		},
		{
			occupationCode: "358",
			occupationDescription: "عامل تربية دواجن",
		},
		{
			occupationCode: "352",
			occupationDescription: "عامل تربية مواشي",
		},
		{
			occupationCode: "364",
			occupationDescription: "عامل تربيةأسماك",
		},
		{
			occupationCode: "2734",
			occupationDescription: "عامل ترقيق بلاستيك",
		},
		{
			occupationCode: "2982",
			occupationDescription: "عامل تركيب",
		},
		{
			occupationCode: "3453",
			occupationDescription: "عامل تركيب أرضية خشبيه",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تركيب أزرار",
		},
		{
			occupationCode: "2528",
			occupationDescription: "عامل تركيب أزرار",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تركيب أنابيب",
		},
		{
			occupationCode: "498",
			occupationDescription: "عامل تركيب أنابيب",
		},
		{
			occupationCode: "3447",
			occupationDescription: "عامل تركيب السقايل المعدنية",
		},
		{
			occupationCode: "2736",
			occupationDescription: "عامل تركيب منتجات بلاستيك",
		},
		{
			occupationCode: "2981",
			occupationDescription: "عامل تركيب مواسير سفينة",
		},
		{
			occupationCode: "2979",
			occupationDescription: "عامل تركيب مواسير عام",
		},
		{
			occupationCode: "2980",
			occupationDescription: "عامل تركيب مواسير غاز",
		},
		{
			occupationCode: "2487",
			occupationDescription: "عامل تريكو نسيج",
		},
		{
			occupationCode: "2480",
			occupationDescription: "عامل تريكو يدوي",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تسقيف بالاسفلت",
		},
		{
			occupationCode: "3512",
			occupationDescription: "عامل تسقيف بالاسفلت",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تسليح خرسانة حديدية",
		},
		{
			occupationCode: "3522",
			occupationDescription: "عامل تسليح خرسانة حديدية",
		},
		{
			occupationCode: "2250",
			occupationDescription: "عامل تسميد",
		},
		{
			occupationCode: "2513",
			occupationDescription: "عامل تشغيل آلة خياطة الملبوسات",
		},
		{
			occupationCode: "3422",
			occupationDescription: "عامل تشغيل أجهزة البث",
		},
		{
			occupationCode: "2660",
			occupationDescription: "عامل تشغيل أجهزة الضبط",
		},
		{
			occupationCode: "3423",
			occupationDescription: "عامل تشغيل استديو",
		},
		{
			occupationCode: "2704",
			occupationDescription: "عامل تشغيل اسطوانة ترشيح دواره",
		},
		{
			occupationCode: "2769",
			occupationDescription: "عامل تشغيل تقويم الزجاج",
		},
		{
			occupationCode: "3424",
			occupationDescription: "عامل تشغيل جهاز الصوت",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تشغيل جهاز تبريد",
		},
		{
			occupationCode: "551",
			occupationDescription: "عامل تشغيل جهاز تبريد",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تشغيل خلاطة",
		},
		{
			occupationCode: "557",
			occupationDescription: "عامل تشغيل خلاطة",
		},
		{
			occupationCode: "2697",
			occupationDescription: "عامل تشغيل سحق كيميائي",
		},
		{
			occupationCode: "3227",
			occupationDescription: "عامل تشغيل عربة منجم",
		},
		{
			occupationCode: "2615",
			occupationDescription: "عامل تشغيل فرن طوب وبلاط",
		},
		{
			occupationCode: "1921",
			occupationDescription: "عامل تشغيل لاسلكي سفن",
		},
		{
			occupationCode: "1922",
			occupationDescription: "عامل تشغيل لاسلكي طائرة",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تشغيل ماكينات ثابتة",
		},
		{
			occupationCode: "550",
			occupationDescription: "عامل تشغيل ماكينات ثابتة",
		},
		{
			occupationCode: "2944",
			occupationDescription: "عامل تشغيل ماكينة",
		},
		{
			occupationCode: "2936",
			occupationDescription: "عامل تشغيل ماكينة تجويف",
		},
		{
			occupationCode: "2733",
			occupationDescription: "عامل تشغيل ماكينة تشكيل بالبثق",
		},
		{
			occupationCode: "2945",
			occupationDescription: "عامل تشغيل ماكينة تلميع",
		},
		{
			occupationCode: "2937",
			occupationDescription: "عامل تشغيل ماكينة ثقب",
		},
		{
			occupationCode: "3534",
			occupationDescription: "عامل تشغيل ماكينة حفر",
		},
		{
			occupationCode: "3535",
			occupationDescription: "عامل تشغيل ماكينة حفر القنوات",
		},
		{
			occupationCode: "2935",
			occupationDescription: "عامل تشغيل ماكينة سحج",
		},
		{
			occupationCode: "3426",
			occupationDescription: "عامل تشغيل ماكينة سينما",
		},
		{
			occupationCode: "2357",
			occupationDescription: "عامل تشغيل ماكينة صنع الورق",
		},
		{
			occupationCode: "2549",
			occupationDescription: "عامل تشغيل ماكينة طباعة حجرية",
		},
		{
			occupationCode: "2933",
			occupationDescription: "عامل تشغيل ماكينة عام",
		},
		{
			occupationCode: "3031",
			occupationDescription: "عامل تشغيل ماكينة قص المعادن",
		},
		{
			occupationCode: "2340",
			occupationDescription: "عامل تشغيل ماكينة قطع الخشب",
		},
		{
			occupationCode: "2633",
			occupationDescription: "عامل تشغيل ماكينة قطع معدن",
		},
		{
			occupationCode: "3064",
			occupationDescription: "عامل تشغيل ماكينة مقشطة",
		},
		{
			occupationCode: "2361",
			occupationDescription: "عامل تشغيل ماكينة مكبس كرتون",
		},
		{
			occupationCode: "2772",
			occupationDescription: "عامل تشغيل ماكينة نفخ الزجاج",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تشغيل مخرطة أحجار",
		},
		{
			occupationCode: "3515",
			occupationDescription: "عامل تشغيل مخرطة أحجار",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تشغيل معدات",
		},
		{
			occupationCode: "496",
			occupationDescription: "عامل تشغيل معدات",
		},
		{
			occupationCode: "2693",
			occupationDescription: "عامل تشغيل معدات ساحبة",
		},
		{
			occupationCode: "3425",
			occupationDescription: "عامل تشغيل مكبر صوت",
		},
		{
			occupationCode: "2703",
			occupationDescription: "عامل تشغيل مكبس ترشيح",
		},
		{
			occupationCode: "3063",
			occupationDescription: "عامل تشغيل مكبس تشكيل",
		},
		{
			occupationCode: "2339",
			occupationDescription: "عامل تشغيل مكبس خشب الأبلكاش",
		},
		{
			occupationCode: "2360",
			occupationDescription: "عامل تشغيل مكبس قص الكرتون",
		},
		{
			occupationCode: "3278",
			occupationDescription: "عامل تشغيل منارة ارشاد السفن",
		},
		{
			occupationCode: "555",
			occupationDescription: "عامل تشغيل ونش",
		},
		{
			occupationCode: "2956",
			occupationDescription: "عامل تشكيل ألواح فولاذية",
		},
		{
			occupationCode: "2948",
			occupationDescription: "عامل تشكيل ألواح معدنية رقي",
		},
		{
			occupationCode: "2759",
			occupationDescription: "عامل تشكيل أنابيب الزجاج",
		},
		{
			occupationCode: "2793",
			occupationDescription: "عامل تشكيل الصلصال والفخار",
		},
		{
			occupationCode: "2758",
			occupationDescription: "عامل تشكيل العدسات",
		},
		{
			occupationCode: "3028",
			occupationDescription: "عامل تشكيل المعدن يدويا",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تشكيل الموزايك",
		},
		{
			occupationCode: "2796",
			occupationDescription: "عامل تشكيل طوب وبلاط يدويا",
		},
		{
			occupationCode: "2797",
			occupationDescription: "عامل تشكيل عجلة جلخ",
		},
		{
			occupationCode: "2611",
			occupationDescription: "عامل تشكيل فسيفساء",
		},
		{
			occupationCode: "2969",
			occupationDescription: "عامل تشكيل قوالب رملية",
		},
		{
			occupationCode: "2951",
			occupationDescription: "عامل تشكيل مشغولات القصدير",
		},
		{
			occupationCode: "2953",
			occupationDescription: "عامل تشكيل مشغولات زخرفية",
		},
		{
			occupationCode: "2950",
			occupationDescription: "عامل تشكيل مشغولات نحاسية",
		},
		{
			occupationCode: "2970",
			occupationDescription: "عامل تشكيل مكبس",
		},
		{
			occupationCode: "2986",
			occupationDescription: "عامل تشكيل مكبس المسبوك",
		},
		{
			occupationCode: "3029",
			occupationDescription: "عامل تشكيل مكبس المعادن",
		},
		{
			occupationCode: "3055",
			occupationDescription: "عامل تشييد انشاءات فولاذية",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تصفيف حروف",
		},
		{
			occupationCode: "520",
			occupationDescription: "عامل تصفيف حروف",
		},
		{
			occupationCode: "3026",
			occupationDescription: "عامل تصليح بنادق صيد",
		},
		{
			occupationCode: "3261",
			occupationDescription: "عامل تصليح دراجة ببدال",
		},
		{
			occupationCode: "2954",
			occupationDescription: "عامل تصنيع ألواح المراجل",
		},
		{
			occupationCode: "2337",
			occupationDescription: "عامل تصنيع ثقاب",
		},
		{
			occupationCode: "2622",
			occupationDescription: "عامل تصنيع خرسانة مسبقة الصب",
		},
		{
			occupationCode: "2332",
			occupationDescription: "عامل تصنيع خشب مضغوط",
		},
		{
			occupationCode: "2331",
			occupationDescription: "عامل تصنيع خشب معاكس",
		},
		{
			occupationCode: "2330",
			occupationDescription: "عامل تصنيع خشب مكبوس",
		},
		{
			occupationCode: "2761",
			occupationDescription: "عامل تصنيع صوف الزجاج",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تصنيع عصير",
		},
		{
			occupationCode: "2883",
			occupationDescription: "عامل تصنيع عصير",
		},
		{
			occupationCode: "2744",
			occupationDescription: "عامل تصنيع عطور زيتية",
		},
		{
			occupationCode: "2333",
			occupationDescription: "عامل تصنيع قشرة خشبية",
		},
		{
			occupationCode: "2907",
			occupationDescription: "عامل تصنيع مخلفات الاسماك",
		},
		{
			occupationCode: "2745",
			occupationDescription: "عامل تصنيع معاجين ومواد تجميل",
		},
		{
			occupationCode: "2920",
			occupationDescription: "عامل تصنيع ملح",
		},
		{
			occupationCode: "2767",
			occupationDescription: "عامل تصنيع ورق الصنفرة",
		},
		{
			occupationCode: "2425",
			occupationDescription: "عامل تطبيق",
		},
		{
			occupationCode: "2523",
			occupationDescription: "عامل تطريز",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تطريز يدوي ( كروشيه)",
		},
		{
			occupationCode: "2530",
			occupationDescription: "عامل تطريز يدوي ( كروشيه)",
		},
		{
			occupationCode: "2892",
			occupationDescription: "عامل تعبئة منتجات وزيوت",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تعبئة وتغليف الحلويات",
		},
		{
			occupationCode: "2852",
			occupationDescription: "عامل تعبئة وتغليف الحلويات",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تعبئة وتغليف الخضراوات",
		},
		{
			occupationCode: "2881",
			occupationDescription: "عامل تعبئة وتغليف الخضراوات",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تعبئة وتغليف السكر",
		},
		{
			occupationCode: "2862",
			occupationDescription: "عامل تعبئة وتغليف السكر",
		},
		{
			occupationCode: "2839",
			occupationDescription: "عامل تعبئة وتغليف المكرونة",
		},
		{
			occupationCode: "2648",
			occupationDescription: "عامل تعبئة وتغليف خامات مصنعه",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تعبئة وتغليف خميرة الخبز",
		},
		{
			occupationCode: "2868",
			occupationDescription: "عامل تعبئة وتغليف خميرة الخبز",
		},
		{
			occupationCode: "2224",
			occupationDescription: "عامل تعبئه باليد",
		},
		{
			occupationCode: "2222",
			occupationDescription: "عامل تعبئه وتغليف",
		},
		{
			occupationCode: "3525",
			occupationDescription: "عامل تغطية الاسقف",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تغطية الاسقف",
		},
		{
			occupationCode: "3526",
			occupationDescription: "عامل تغطية الاسقف بالاسفلت",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تغطية الاسقف بالاسفلت",
		},
		{
			occupationCode: "3527",
			occupationDescription: "عامل تغطية الاسقف بالالواح",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تغطية الاسقف بالالواح",
		},
		{
			occupationCode: "3528",
			occupationDescription: "عامل تغطية الاسقف بالخشب",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تغطية الاسقف بالخشب",
		},
		{
			occupationCode: "2738",
			occupationDescription: "عامل تغليف أطارات مستعمله",
		},
		{
			occupationCode: "416",
			occupationDescription: "عامل تغيير زيت",
		},
		{
			occupationCode: "2299",
			occupationDescription: "عامل تفريخ الدواجن",
		},
		{
			occupationCode: "2406",
			occupationDescription: "عامل تفصيل منتجات جلدية",
		},
		{
			occupationCode: "2774",
			occupationDescription: "عامل تقسية الزجاج",
		},
		{
			occupationCode: "387",
			occupationDescription: "عامل تقطير",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل تكرير بترول",
		},
		{
			occupationCode: "554",
			occupationDescription: "عامل تكرير بترول",
		},
		{
			occupationCode: "389",
			occupationDescription: "عامل تكرير نفط",
		},
		{
			occupationCode: "3095",
			occupationDescription: "عامل تكسية كهربائية للمعادن",
		},
		{
			occupationCode: "3093",
			occupationDescription: "عامل تكسيه",
		},
		{
			occupationCode: "3097",
			occupationDescription: "عامل تكسيه معادن بالرش",
		},
		{
			occupationCode: "3096",
			occupationDescription: "عامل تكسيه معادن بالغمر",
		},
		{
			occupationCode: "3109",
			occupationDescription: "عامل تلميع معادن بالفرشاة",
		},
		{
			occupationCode: "2433",
			occupationDescription: "عامل تمشيط الالياف",
		},
		{
			occupationCode: "3543",
			occupationDescription: "عامل تنظيف الاسطح",
		},
		{
			occupationCode: "3106",
			occupationDescription: "عامل تنظيف المعادن",
		},
		{
			occupationCode: "3108",
			occupationDescription: "عامل تنظيف المعادن بالرش",
		},
		{
			occupationCode: "2171",
			occupationDescription: "عامل تنظيف جاف",
		},
		{
			occupationCode: "2181",
			occupationDescription: "عامل تنظيف سجاد",
		},
		{
			occupationCode: "2175",
			occupationDescription: "عامل تنظيف على الجاف ( يدويا )",
		},
		{
			occupationCode: "2178",
			occupationDescription: "عامل تنظيف غرف الفنادق",
		},
		{
			occupationCode: "2180",
			occupationDescription: "عامل تنظيف مباني عامه",
		},
		{
			occupationCode: "911203",
			occupationDescription: "عامل تنظيف مباني عامه",
		},
		{
			occupationCode: "3178",
			occupationDescription: "عامل تنظيف مجاري",
		},
		{
			occupationCode: "2182",
			occupationDescription: "عامل تنظيف مداخن",
		},
		{
			occupationCode: "2179",
			occupationDescription: "عامل تنظيف مستشفيات",
		},
		{
			occupationCode: "911204",
			occupationDescription: "عامل تنظيف مستشفيات",
		},
		{
			occupationCode: "381",
			occupationDescription: "عامل تنظيف معادن",
		},
		{
			occupationCode: "2669",
			occupationDescription: "عامل تنقية النفط الخام",
		},
		{
			occupationCode: "2154",
			occupationDescription: "عامل توزيع وجبات مرضي",
		},
		{
			occupationCode: "2578",
			occupationDescription: "عامل توضيب",
		},
		{
			occupationCode: "2375",
			occupationDescription: "عامل توضيب الجلود",
		},
		{
			occupationCode: "2579",
			occupationDescription: "عامل توضيب المسبك الفوتوغرافي",
		},
		{
			occupationCode: "2771",
			occupationDescription: "عامل ثني أنبوب زجاجي",
		},
		{
			occupationCode: "541",
			occupationDescription: "عامل جبس",
		},
		{
			occupationCode: "712301",
			occupationDescription: "عامل جبس",
		},
		{
			occupationCode: "385",
			occupationDescription: "عامل جرش",
		},
		{
			occupationCode: "2756",
			occupationDescription: "عامل جلخ العدسات",
		},
		{
			occupationCode: "377",
			occupationDescription: "عامل جلفنة معادن",
		},
		{
			occupationCode: "3188",
			occupationDescription: "عامل جير في محطة تحلية",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل حديد",
		},
		{
			occupationCode: "535",
			occupationDescription: "عامل حديد",
		},
		{
			occupationCode: "360",
			occupationDescription: "عامل حديقة",
		},
		{
			occupationCode: "2265",
			occupationDescription: "عامل حديقة او بستان",
		},
		{
			occupationCode: "2451",
			occupationDescription: "عامل حرق الوبر",
		},
		{
			occupationCode: "2814",
			occupationDescription: "عامل حرق نفايات",
		},
		{
			occupationCode: "2581",
			occupationDescription: "عامل حفر أحجار الليثوغرافية",
		},
		{
			occupationCode: "2583",
			occupationDescription: "عامل حفر اكليشهات الطبع آليا",
		},
		{
			occupationCode: "2775",
			occupationDescription: "عامل حفر الزجاج",
		},
		{
			occupationCode: "2585",
			occupationDescription: "عامل حفر المعدن بالحامض",
		},
		{
			occupationCode: "2582",
			occupationDescription: "عامل حفر خشب أو مطاط أو مشم",
		},
		{
			occupationCode: "2587",
			occupationDescription: "عامل حفر فوتوغرافي ميكانيكا",
		},
		{
			occupationCode: "2903",
			occupationDescription: "عامل حفظ السمك وتعليبه /عام",
		},
		{
			occupationCode: "2908",
			occupationDescription: "عامل حفظ وتجميد الاسماك",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل حلويات",
		},
		{
			occupationCode: "410",
			occupationDescription: "عامل حلويات",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل خرسانة",
		},
		{
			occupationCode: "534",
			occupationDescription: "عامل خرسانة",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل خزف",
		},
		{
			occupationCode: "510",
			occupationDescription: "عامل خزف",
		},
		{
			occupationCode: "382",
			occupationDescription: "عامل خشب",
		},
		{
			occupationCode: "2719",
			occupationDescription: "عامل خط انتاج أكياس بلاستيكية",
		},
		{
			occupationCode: "3347",
			occupationDescription: "عامل خطوط كهربائية ضغط عال",
		},
		{
			occupationCode: "2799",
			occupationDescription: "عامل خلط العجينة/الصلصال",
		},
		{
			occupationCode: "2686",
			occupationDescription: "عامل خلط النفط",
		},
		{
			occupationCode: "2434",
			occupationDescription: "عامل خلط توليف الصوف",
		},
		{
			occupationCode: "2778",
			occupationDescription: "عامل خلط مكونات الصنفرة",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل خياطة الجلود باليد",
		},
		{
			occupationCode: "2512",
			occupationDescription: "عامل خياطة الجلود باليد",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل خياطة باليد أو بالالة",
		},
		{
			occupationCode: "2511",
			occupationDescription: "عامل خياطة باليد أو بالالة",
		},
		{
			occupationCode: "2407",
			occupationDescription: "عامل خياطة جلود",
		},
		{
			occupationCode: "2657",
			occupationDescription: "عامل درفلة صلب",
		},
		{
			occupationCode: "2656",
			occupationDescription: "عامل درفلة على الساخن",
		},
		{
			occupationCode: "2661",
			occupationDescription: "عامل درفلة معادن على البارد",
		},
		{
			occupationCode: "2658",
			occupationDescription: "عامل درفلة معادن غير حديدية",
		},
		{
			occupationCode: "417",
			occupationDescription: "عامل ذبح دواجن",
		},
		{
			occupationCode: "2217",
			occupationDescription: "عامل ربط السفن وتثبيتها",
		},
		{
			occupationCode: "2588",
			occupationDescription: "عامل رتوش على الالواح معدني",
		},
		{
			occupationCode: "2791",
			occupationDescription: "عامل رش الخزفيات بالطلاء",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل رصف طرق",
		},
		{
			occupationCode: "556",
			occupationDescription: "عامل رصف طرق",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل رفي الملابس ( رفاء )",
		},
		{
			occupationCode: "2529",
			occupationDescription: "عامل رفي الملابس ( رفاء )",
		},
		{
			occupationCode: "363",
			occupationDescription: "عامل ري",
		},
		{
			occupationCode: "509",
			occupationDescription: "عامل زجاج",
		},
		{
			occupationCode: "2802",
			occupationDescription: "عامل زخرفة الخزفيات",
		},
		{
			occupationCode: "350",
			occupationDescription: "عامل زراعي",
		},
		{
			occupationCode: "2435",
			occupationDescription: "عامل سحب الالياف",
		},
		{
			occupationCode: "3070",
			occupationDescription: "عامل سحب سلك ميكانيكيا",
		},
		{
			occupationCode: "3069",
			occupationDescription: "عامل سحب سلك يدويا",
		},
		{
			occupationCode: "380",
			occupationDescription: "عامل سحب معادن",
		},
		{
			occupationCode: "3120",
			occupationDescription: "عامل سحب وتسطيح معادن ثمينة",
		},
		{
			occupationCode: "2939",
			occupationDescription: "عامل سن أدوات قطع المعادن",
		},
		{
			occupationCode: "2940",
			occupationDescription: "عامل سن عدد القطع",
		},
		{
			occupationCode: "2942",
			occupationDescription: "عامل سن ماكينة تسريح النسيج",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل شحن وتفريغ",
		},
		{
			occupationCode: "553",
			occupationDescription: "عامل شحن وتفريغ",
		},
		{
			occupationCode: "2221",
			occupationDescription: "عامل شحن وتفريغ بالسفن",
		},
		{
			occupationCode: "2384",
			occupationDescription: "عامل شد الجلود",
		},
		{
			occupationCode: "427",
			occupationDescription: "عامل شك",
		},
		{
			occupationCode: "2448",
			occupationDescription: "عامل شلح الصوف",
		},
		{
			occupationCode: "3061",
			occupationDescription: "عامل شنكار عوارض وألواح معدن",
		},
		{
			occupationCode: "2949",
			occupationDescription: "عامل شنكرة المشغولات المعدنية",
		},
		{
			occupationCode: "3025",
			occupationDescription: "عامل شنكرة معادن",
		},
		{
			occupationCode: "3401",
			occupationDescription: "عامل صاري لاسلكي",
		},
		{
			occupationCode: "2754",
			occupationDescription: "عامل صب الزجاج",
		},
		{
			occupationCode: "2795",
			occupationDescription: "عامل صب العجينه يدويا",
		},
		{
			occupationCode: "2984",
			occupationDescription: "عامل صب المعدن",
		},
		{
			occupationCode: "721101",
			occupationDescription: "عامل صب المعدن",
		},
		{
			occupationCode: "379",
			occupationDescription: "عامل صب معادن",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل صب مقالب جبس",
		},
		{
			occupationCode: "3532",
			occupationDescription: "عامل صب مقالب جبس",
		},
		{
			occupationCode: "2456",
			occupationDescription: "عامل صباغة الملابس",
		},
		{
			occupationCode: "2377",
			occupationDescription: "عامل صبغ الجلود",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل صفائح معدنية",
		},
		{
			occupationCode: "503",
			occupationDescription: "عامل صفائح معدنية",
		},
		{
			occupationCode: "2595",
			occupationDescription: "عامل صقل الاحجار باليد",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل صقل الاسمنت",
		},
		{
			occupationCode: "3523",
			occupationDescription: "عامل صقل الاسمنت",
		},
		{
			occupationCode: "2488",
			occupationDescription: "عامل صقل المنسوجات تشطيب",
		},
		{
			occupationCode: "2762",
			occupationDescription: "عامل صقل وطلي المرايا",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل صناعة الزيوت النباتية عام",
		},
		{
			occupationCode: "2885",
			occupationDescription: "عامل صناعة الزيوت النباتية عام",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل صناعة الورق",
		},
		{
			occupationCode: "518",
			occupationDescription: "عامل صناعة الورق",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل صناعة سكر عام",
		},
		{
			occupationCode: "2854",
			occupationDescription: "عامل صناعة سكر عام",
		},
		{
			occupationCode: "2816",
			occupationDescription: "عامل صنع آلة نفخ",
		},
		{
			occupationCode: "2815",
			occupationDescription: "عامل صنع آلة وترية",
		},
		{
			occupationCode: "2821",
			occupationDescription: "عامل صنع أثاث من خوص النخيل",
		},
		{
			occupationCode: "2723",
			occupationDescription: "عامل صنع أطارات",
		},
		{
			occupationCode: "3544",
			occupationDescription: "عامل صنع الاحجار الصناعية",
		},
		{
			occupationCode: "2901",
			occupationDescription: "عامل صنع البسطرمة",
		},
		{
			occupationCode: "2800",
			occupationDescription: "عامل صنع العجينة السائلة",
		},
		{
			occupationCode: "2626",
			occupationDescription: "عامل صنع حجر صناعي موزاييك",
		},
		{
			occupationCode: "2561",
			occupationDescription: "عامل صنع ختم مطاطي",
		},
		{
			occupationCode: "2779",
			occupationDescription: "عامل صنع زجاج ليفي (فايبرجلاس )",
		},
		{
			occupationCode: "2818",
			occupationDescription: "عامل صنع سلال",
		},
		{
			occupationCode: "2358",
			occupationDescription: "عامل صنع صناديق الورق آليا",
		},
		{
			occupationCode: "2712",
			occupationDescription: "عامل صنع طقم أسنان واصلاحها",
		},
		{
			occupationCode: "2777",
			occupationDescription: "عامل صنع مادة طلاء الزجاج",
		},
		{
			occupationCode: "3469",
			occupationDescription: "عامل صنع مراتب",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل صنع مظلة يدوية",
		},
		{
			occupationCode: "2519",
			occupationDescription: "عامل صنع مظلة يدوية",
		},
		{
			occupationCode: "2946",
			occupationDescription: "عامل صنع معدات العجزة",
		},
		{
			occupationCode: "2820",
			occupationDescription: "عامل صنع مكنسة يدويا",
		},
		{
			occupationCode: "2625",
			occupationDescription: "عامل صنع منتجات الاسبستوس",
		},
		{
			occupationCode: "2624",
			occupationDescription: "عامل صنع منتجات خرسانية",
		},
		{
			occupationCode: "3024",
			occupationDescription: "عامل صنع نماذج معدنية",
		},
		{
			occupationCode: "376",
			occupationDescription: "عامل صهر معادن",
		},
		{
			occupationCode: "3410",
			occupationDescription: "عامل صيانة أجهزة استقبال",
		},
		{
			occupationCode: "3411",
			occupationDescription: "عامل صيانة جهاز هاتف وبرق",
		},
		{
			occupationCode: "3556",
			occupationDescription: "عامل صيانة طرق",
		},
		{
			occupationCode: "2817",
			occupationDescription: "عامل ضبط أيقاع آلة موسيقية",
		},
		{
			occupationCode: "2801",
			occupationDescription: "عامل ضغط العجينة يدويا",
		},
		{
			occupationCode: "2159",
			occupationDescription: "عامل ضيافة",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل طباعة",
		},
		{
			occupationCode: "519",
			occupationDescription: "عامل طباعة",
		},
		{
			occupationCode: "2830",
			occupationDescription: "عامل طحن الارز",
		},
		{
			occupationCode: "398",
			occupationDescription: "عامل طحن حبوب",
		},
		{
			occupationCode: "3102",
			occupationDescription: "عامل طلاء السلك بالماكينة",
		},
		{
			occupationCode: "3105",
			occupationDescription: "عامل طلاء المعادن بالأزرق",
		},
		{
			occupationCode: "3100",
			occupationDescription: "عامل طلاء المعادن بالكهرباء",
		},
		{
			occupationCode: "3101",
			occupationDescription: "عامل طلاء بالغمس الساخن",
		},
		{
			occupationCode: "3103",
			occupationDescription: "عامل طلاء بجهاز رش المعادن",
		},
		{
			occupationCode: "2780",
			occupationDescription: "عامل طلى الزجاج",
		},
		{
			occupationCode: "2792",
			occupationDescription: "عامل طلي الخزفيات",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل طوب",
		},
		{
			occupationCode: "512",
			occupationDescription: "عامل طوب",
		},
		{
			occupationCode: "2364",
			occupationDescription: "عامل طي الورق بالماكينة",
		},
		{
			occupationCode: "2223",
			occupationDescription: "عامل عادي",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل عراوي",
		},
		{
			occupationCode: "2527",
			occupationDescription: "عامل عراوي",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل عزل حراري",
		},
		{
			occupationCode: "542",
			occupationDescription: "عامل عزل حراري",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل عصير",
		},
		{
			occupationCode: "399",
			occupationDescription: "عامل عصير",
		},
		{
			occupationCode: "2267",
			occupationDescription: "عامل عناية بأراضي ملاعب رياضية",
		},
		{
			occupationCode: "2192",
			occupationDescription: "عامل عناية شخصية",
		},
		{
			occupationCode: "2794",
			occupationDescription: "عامل غربلة العجينة",
		},
		{
			occupationCode: "2189",
			occupationDescription: "عامل غرف",
		},
		{
			occupationCode: "393",
			occupationDescription: "عامل غزل",
		},
		{
			occupationCode: "3259",
			occupationDescription: "عامل غسيل وتشحيم مركبات",
		},
		{
			occupationCode: "2174",
			occupationDescription: "عامل غسيل وكي",
		},
		{
			occupationCode: "2798",
			occupationDescription: "عامل غمس الخزفيات",
		},
		{
			occupationCode: "3262",
			occupationDescription: "عامل فحص المنتجات الميكانيك",
		},
		{
			occupationCode: "3379",
			occupationDescription: "عامل فحص معدات كهربائية",
		},
		{
			occupationCode: "2597",
			occupationDescription: "عامل فرز الاحجار",
		},
		{
			occupationCode: "2430",
			occupationDescription: "عامل فرز الالياف وتصنيفها",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل فرز وتصنيف الاحجار",
		},
		{
			occupationCode: "3513",
			occupationDescription: "عامل فرز وتصنيف الاحجار",
		},
		{
			occupationCode: "2819",
			occupationDescription: "عامل فرشاة يدويا",
		},
		{
			occupationCode: "3230",
			occupationDescription: "عامل فرملة قاطرة منجم أو محجر",
		},
		{
			occupationCode: "3228",
			occupationDescription: "عامل فرملة قطار بضاعة",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل فني",
		},
		{
			occupationCode: "558",
			occupationDescription: "عامل فني",
		},
		{
			occupationCode: "383",
			occupationDescription: "عامل في صناعةالورق",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل قص القفازات الجلدية",
		},
		{
			occupationCode: "2517",
			occupationDescription: "عامل قص القفازات الجلدية",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل قص الملابس الجاهزة",
		},
		{
			occupationCode: "2514",
			occupationDescription: "عامل قص الملابس الجاهزة",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل قص الملابس الجلدية",
		},
		{
			occupationCode: "2515",
			occupationDescription: "عامل قص الملابس الجلدية",
		},
		{
			occupationCode: "2770",
			occupationDescription: "عامل قص زجاج بصري",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل قص قفازات (عدا الجلدية)",
		},
		{
			occupationCode: "2516",
			occupationDescription: "عامل قص قفازات (عدا الجلدية)",
		},
		{
			occupationCode: "2534",
			occupationDescription: "عامل قطع أستنسل",
		},
		{
			occupationCode: "2781",
			occupationDescription: "عامل قطع الزجاج أو قصه",
		},
		{
			occupationCode: "3091",
			occupationDescription: "عامل قطع بالآلة آليا",
		},
		{
			occupationCode: "3090",
			occupationDescription: "عامل قطع بالآلة يدويا",
		},
		{
			occupationCode: "2590",
			occupationDescription: "عامل قطع وصقل الاحجار",
		},
		{
			occupationCode: "2591",
			occupationDescription: "عامل قطع ونشر الأحجار والرخام",
		},
		{
			occupationCode: "2891",
			occupationDescription: "عامل كبس مخلفات زيوت نباتية",
		},
		{
			occupationCode: "384",
			occupationDescription: "عامل كسارة",
		},
		{
			occupationCode: "2450",
			occupationDescription: "عامل كستره",
		},
		{
			occupationCode: "2226",
			occupationDescription: "عامل لصق بطاقات تمييز",
		},
		{
			occupationCode: "3588",
			occupationDescription: "عامل لف الاسلاك الكهربائية آليا",
		},
		{
			occupationCode: "3589",
			occupationDescription: "عامل لف الاسلاك يدويا",
		},
		{
			occupationCode: "2464",
			occupationDescription: "عامل لف الخيوط",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل لقط",
		},
		{
			occupationCode: "2526",
			occupationDescription: "عامل لقط",
		},
		{
			occupationCode: "2732",
			occupationDescription: "عامل ماكينة بلاستيك بالحقن",
		},
		{
			occupationCode: "2359",
			occupationDescription: "عامل ماكينة تبطين الكرتون",
		},
		{
			occupationCode: "2721",
			occupationDescription: "عامل ماكينة تشكيل البلاستيك",
		},
		{
			occupationCode: "2934",
			occupationDescription: "عامل ماكينة تفريز",
		},
		{
			occupationCode: "2938",
			occupationDescription: "عامل ماكينة تلميع المعادن",
		},
		{
			occupationCode: "2698",
			occupationDescription: "عامل ماكينة جرش وطحن",
		},
		{
			occupationCode: "2699",
			occupationDescription: "عامل ماكينة خلط ومزج",
		},
		{
			occupationCode: "3537",
			occupationDescription: "عامل ماكينة خوازيق الاساسات",
		},
		{
			occupationCode: "3071",
			occupationDescription: "عامل ماكينة سحب مواسير",
		},
		{
			occupationCode: "2338",
			occupationDescription: "عامل ماكينة صنع الابلكاش",
		},
		{
			occupationCode: "2363",
			occupationDescription: "عامل ماكينة ضرب عجينة الورق",
		},
		{
			occupationCode: "2577",
			occupationDescription: "عامل ماكينة طباعة المونوتيب",
		},
		{
			occupationCode: "2576",
			occupationDescription: "عامل ماكينة طباعة بالليونتي",
		},
		{
			occupationCode: "2700",
			occupationDescription: "عامل ماكينة طبخ",
		},
		{
			occupationCode: "2705",
			occupationDescription: "عامل ماكينة فصل",
		},
		{
			occupationCode: "2227",
			occupationDescription: "عامل ماكينة لف المنتجات",
		},
		{
			occupationCode: "3002",
			occupationDescription: "عامل ماكينة معادن أوتوماتيك",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل مبخرة تمور",
		},
		{
			occupationCode: "2880",
			occupationDescription: "عامل مبخرة تمور",
		},
		{
			occupationCode: "282",
			occupationDescription: "عامل مبرقة",
		},
		{
			occupationCode: "2635",
			occupationDescription: "عامل محجر",
		},
		{
			occupationCode: "450",
			occupationDescription: "عامل محركات",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل محطة وقود",
		},
		{
			occupationCode: "414",
			occupationDescription: "عامل محطة وقود",
		},
		{
			occupationCode: "444",
			occupationDescription: "عامل مخرطة",
		},
		{
			occupationCode: "3542",
			occupationDescription: "عامل مد أنابيب ومواسير",
		},
		{
			occupationCode: "3099",
			occupationDescription: "عامل مراجعة معادن",
		},
		{
			occupationCode: "359",
			occupationDescription: "عامل مشتل",
		},
		{
			occupationCode: "2765",
			occupationDescription: "عامل مشغل فرن تلدين الزجاج",
		},
		{
			occupationCode: "2211",
			occupationDescription: "عامل مصعد",
		},
		{
			occupationCode: "2152",
			occupationDescription: "عامل مطبخ",
		},
		{
			occupationCode: "941202",
			occupationDescription: "عامل مطبخ",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل مطعم",
		},
		{
			occupationCode: "412",
			occupationDescription: "عامل مطعم",
		},
		{
			occupationCode: "2328",
			occupationDescription: "عامل معالجة الاخشاب",
		},
		{
			occupationCode: "2453",
			occupationDescription: "عامل معالجة المنسوجات  او  عام",
		},
		{
			occupationCode: "2429",
			occupationDescription: "عامل معالجة خيوط الغزل",
		},
		{
			occupationCode: "392",
			occupationDescription: "عامل معالجة كيميائية",
		},
		{
			occupationCode: "372",
			occupationDescription: "عامل معالجة معادن",
		},
		{
			occupationCode: "446",
			occupationDescription: "عامل معدات",
		},
		{
			occupationCode: "3502",
			occupationDescription: "عامل معماري",
		},
		{
			occupationCode: "2301",
			occupationDescription: "عامل معمل تفريخ بلدي / عام",
		},
		{
			occupationCode: "341",
			occupationDescription: "عامل مغسلة",
		},
		{
			occupationCode: "912101",
			occupationDescription: "عامل مغسلة",
		},
		{
			occupationCode: "2249",
			occupationDescription: "عامل مكافحة آفات زراعية",
		},
		{
			occupationCode: "386",
			occupationDescription: "عامل مكبس",
		},
		{
			occupationCode: "394",
			occupationDescription: "عامل مكينات التريكو",
		},
		{
			occupationCode: "3229",
			occupationDescription: "عامل منارة",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل منتجات ألبان",
		},
		{
			occupationCode: "408",
			occupationDescription: "عامل منتجات ألبان",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل منتجات الاسمنت والجبس",
		},
		{
			occupationCode: "531",
			occupationDescription: "عامل منتجات الاسمنت والجبس",
		},
		{
			occupationCode: "371",
			occupationDescription: "عامل منجم",
		},
		{
			occupationCode: "2627",
			occupationDescription: "عامل منجم عام",
		},
		{
			occupationCode: "326",
			occupationDescription: "عامل منزلي",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل موانيء",
		},
		{
			occupationCode: "552",
			occupationDescription: "عامل موانيء",
		},
		{
			occupationCode: "2548",
			occupationDescription: "عامل مونتاج طباعة",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل نحت أحجار المجسمات",
		},
		{
			occupationCode: "3519",
			occupationDescription: "عامل نحت أحجار المجسمات",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل نحت الاحجار",
		},
		{
			occupationCode: "3517",
			occupationDescription: "عامل نحت الاحجار",
		},
		{
			occupationCode: "395",
			occupationDescription: "عامل نسيج",
		},
		{
			occupationCode: "2468",
			occupationDescription: "عامل نسيج القماش ( يدويا)",
		},
		{
			occupationCode: "2485",
			occupationDescription: "عامل نسيج سجاد آليا",
		},
		{
			occupationCode: "2484",
			occupationDescription: "عامل نسيج سجاد يدوي",
		},
		{
			occupationCode: "2483",
			occupationDescription: "عامل نسيج على أنوال الجاكار",
		},
		{
			occupationCode: "2482",
			occupationDescription: "عامل نسيج قماش آليا",
		},
		{
			occupationCode: "2341",
			occupationDescription: "عامل نشر أطراف الخشب والزوايا",
		},
		{
			occupationCode: "340",
			occupationDescription: "عامل نظافة",
		},
		{
			occupationCode: "3107",
			occupationDescription: "عامل نظافة المعادن",
		},
		{
			occupationCode: "2190",
			occupationDescription: "عامل نظافة نوافذ",
		},
		{
			occupationCode: "2740",
			occupationDescription: "عامل نفخ عجلات",
		},
		{
			occupationCode: "2768",
			occupationDescription: "عامل نفخ معدات زجاجية علمية",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل نقش  حروف على الحجر يدويا",
		},
		{
			occupationCode: "2776",
			occupationDescription: "عامل نقش الزجاج بالسفح الرم",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل نقش حجارة",
		},
		{
			occupationCode: "521",
			occupationDescription: "عامل نقش حجارة",
		},
		{
			occupationCode: "3516",
			occupationDescription: "عامل نقش حروف على الحجر يدويا",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل نقش خشب",
		},
		{
			occupationCode: "522",
			occupationDescription: "عامل نقش خشب",
		},
		{
			occupationCode: "3123",
			occupationDescription: "عامل نقش مجوهرات",
		},
		{
			occupationCode: null,
			occupationDescription: "عامل نقل تصميم الاحجار",
		},
		{
			occupationCode: "3514",
			occupationDescription: "عامل نقل تصميم الاحجار",
		},
		{
			occupationCode: "2584",
			occupationDescription: "عامل نقل ليثوغرافي",
		},
		{
			occupationCode: "2580",
			occupationDescription: "عامل نماذج استريوتيب",
		},
		{
			occupationCode: "3454",
			occupationDescription: "عامل هدم مباني",
		},
		{
			occupationCode: "435",
			occupationDescription: "عامل هياكل",
		},
		{
			occupationCode: "436",
			occupationDescription: "عامل ورشة",
		},
		{
			occupationCode: "932903",
			occupationDescription: "عامل ورشة",
		},
		{
			occupationCode: "336",
			occupationDescription: "عاملة منزلية",
		},
		{
			occupationCode: "333",
			occupationDescription: "عجان",
		},
		{
			occupationCode: "2835",
			occupationDescription: "عجان مكرونة",
		},
		{
			occupationCode: "1946",
			occupationDescription: "عداد نقد معدني",
		},
		{
			occupationCode: "1945",
			occupationDescription: "عداد نقد ورقي",
		},
		{
			occupationCode: "13",
			occupationDescription: "عسكري",
		},
		{
			occupationCode: "637",
			occupationDescription: "عضو مجلس ادارة",
		},
		{
			occupationCode: "1382",
			occupationDescription: "عضو هيئة تدريس",
		},
		{
			occupationCode: null,
			occupationDescription: "عطار ( حواج )",
		},
		{
			occupationCode: "2025",
			occupationDescription: "عطار ( حواج )",
		},
		{
			occupationCode: "2306",
			occupationDescription: "علاف أسماك",
		},
		{
			occupationCode: "2282",
			occupationDescription: "علاف حيوان",
		},
		{
			occupationCode: "2300",
			occupationDescription: "علاف دواجن",
		},
		{
			occupationCode: "623",
			occupationDescription: "عم محرم",
		},
		{
			occupationCode: "2713",
			occupationDescription: "عمال المعالجة الكيميائية اخ",
		},
		{
			occupationCode: "3276",
			occupationDescription: "عمال تزييت وتشحيم السفن",
		},
		{
			occupationCode: "2452",
			occupationDescription: "عمال معالجة المنسوجات",
		},
		{
			occupationCode: "10",
			occupationDescription: "عمل حر",
		},
		{
			occupationCode: "682",
			occupationDescription: "عميد كلية",
		},
		{
			occupationCode: "2424",
			occupationDescription: "غزال",
		},
		{
			occupationCode: "731802",
			occupationDescription: "غزال",
		},
		{
			occupationCode: "2438",
			occupationDescription: "غسال منسوجات باليد",
		},
		{
			occupationCode: "109",
			occupationDescription: "غواص",
		},
		{
			occupationCode: "754102",
			occupationDescription: "غواص",
		},
		{
			occupationCode: "2315",
			occupationDescription: "غواص محار",
		},
		{
			occupationCode: "26",
			occupationDescription: "غير ذالك",
		},
		{
			occupationCode: "6",
			occupationDescription: "غير موظف",
		},
		{
			occupationCode: "2728",
			occupationDescription: "فاحص أطارات",
		},
		{
			occupationCode: "2477",
			occupationDescription: "فاحص أقمشة",
		},
		{
			occupationCode: "2824",
			occupationDescription: "فاحص جودة",
		},
		{
			occupationCode: "2428",
			occupationDescription: "فاحص خيوط",
		},
		{
			occupationCode: "1661",
			occupationDescription: "فاحص لحام",
		},
		{
			occupationCode: "2474",
			occupationDescription: "فاحص منسوجات",
		},
		{
			occupationCode: "2998",
			occupationDescription: "فراز",
		},
		{
			occupationCode: "1917",
			occupationDescription: "فراز بريدي",
		},
		{
			occupationCode: "2655",
			occupationDescription: "فران لتحويل معادن حديدية",
		},
		{
			occupationCode: null,
			occupationDescription: "فلكي رصد",
		},
		{
			occupationCode: "928",
			occupationDescription: "فلكي رصد",
		},
		{
			occupationCode: null,
			occupationDescription: "فلكي عام",
		},
		{
			occupationCode: "927",
			occupationDescription: "فلكي عام",
		},
		{
			occupationCode: "1844",
			occupationDescription: "فنان أعلانات تجارية",
		},
		{
			occupationCode: "477",
			occupationDescription: "فني آلات كهربائية",
		},
		{
			occupationCode: "1579",
			occupationDescription: "فني أبحاث أغذية الحيوان",
		},
		{
			occupationCode: "1581",
			occupationDescription: "فني أبحاث تهجين",
		},
		{
			occupationCode: "1599",
			occupationDescription: "فني أبنية( مراقب أبنية )",
		},
		{
			occupationCode: "1637",
			occupationDescription: "فني أجهزة أنذار حريق",
		},
		{
			occupationCode: "375",
			occupationDescription: "فني أجهزة تصوير جوي",
		},
		{
			occupationCode: "460",
			occupationDescription: "فني أجهزة تقويم أعضاء",
		},
		{
			occupationCode: "459",
			occupationDescription: "فني أجهزة دقيقة",
		},
		{
			occupationCode: "1830",
			occupationDescription: "فني أجهزة مخبرية",
		},
		{
			occupationCode: "2550",
			occupationDescription: "فني أحبار طباعة",
		},
		{
			occupationCode: "461",
			occupationDescription: "فني أسنان صناعية",
		},
		{
			occupationCode: "197",
			occupationDescription: "فني أشعة",
		},
		{
			occupationCode: "1839",
			occupationDescription: "فني أضاءة",
		},
		{
			occupationCode: "199",
			occupationDescription: "فني أطراف صناعية",
		},
		{
			occupationCode: "374",
			occupationDescription: "فني أفران معادن",
		},
		{
			occupationCode: "1712",
			occupationDescription: "فني أمن وسلامة مهنية",
		},
		{
			occupationCode: "43",
			occupationDescription: "فني أنظمة",
		},
		{
			occupationCode: "42",
			occupationDescription: "فني أنظمة الليزر",
		},
		{
			occupationCode: "1850",
			occupationDescription: "فني أوراق مالية",
		},
		{
			occupationCode: "1182",
			occupationDescription: "فني ابحاث طبية",
		},
		{
			occupationCode: "92",
			occupationDescription: "فني اتصالات",
		},
		{
			occupationCode: "1636",
			occupationDescription: "فني اتصالات سلكية ولاسلكية",
		},
		{
			occupationCode: "88",
			occupationDescription: "فني اجهزة كهربائية",
		},
		{
			occupationCode: "120",
			occupationDescription: "فني احياء",
		},
		{
			occupationCode: "91",
			occupationDescription: "فني ادارة عقود",
		},
		{
			occupationCode: "34",
			occupationDescription: "فني اسلحة",
		},
		{
			occupationCode: "357",
			occupationDescription: "فني البان",
		},
		{
			occupationCode: "3244",
			occupationDescription: "فني الديترات سيارات",
		},
		{
			occupationCode: "1645",
			occupationDescription: "فني الكتروني / بث تلفزيوني",
		},
		{
			occupationCode: "352104",
			occupationDescription: "فني الكتروني / بث تلفزيوني",
		},
		{
			occupationCode: "1648",
			occupationDescription: "فني الكتروني / صيانة تلفزيون",
		},
		{
			occupationCode: "1650",
			occupationDescription: "فني الكتروني أجهزة تحكم",
		},
		{
			occupationCode: "1647",
			occupationDescription: "فني الكتروني أجهزة طبية",
		},
		{
			occupationCode: "1644",
			occupationDescription: "فني الكتروني ارسال اذاعي",
		},
		{
			occupationCode: "352103",
			occupationDescription: "فني الكتروني ارسال اذاعي",
		},
		{
			occupationCode: "479",
			occupationDescription: "فني الكترونيات",
		},
		{
			occupationCode: "507",
			occupationDescription: "فني المونيوم",
		},
		{
			occupationCode: "118",
			occupationDescription: "فني انتاج",
		},
		{
			occupationCode: "37",
			occupationDescription: "فني انظمة تسليح",
		},
		{
			occupationCode: "38",
			occupationDescription: "فني انظمة ملاحة",
		},
		{
			occupationCode: "1805",
			occupationDescription: "فني بحث اجتماعي",
		},
		{
			occupationCode: "1725",
			occupationDescription: "فني بستنة عام",
		},
		{
			occupationCode: "480",
			occupationDescription: "فني بصريات",
		},
		{
			occupationCode: "463",
			occupationDescription: "فني بلاستيك",
		},
		{
			occupationCode: "1782",
			occupationDescription: "فني تأهيل مهني",
		},
		{
			occupationCode: "456",
			occupationDescription: "فني تبريد",
		},
		{
			occupationCode: "98",
			occupationDescription: "فني تبريد وتكييف",
		},
		{
			occupationCode: "135",
			occupationDescription: "فني تجبير",
		},
		{
			occupationCode: "1843",
			occupationDescription: "فني تجميل",
		},
		{
			occupationCode: "124",
			occupationDescription: "فني تحليل",
		},
		{
			occupationCode: "378",
			occupationDescription: "فني تحميض",
		},
		{
			occupationCode: "127",
			occupationDescription: "فني تخدير",
		},
		{
			occupationCode: "308",
			occupationDescription: "فني تخطيط",
		},
		{
			occupationCode: "126",
			occupationDescription: "فني تخطيط قلب",
		},
		{
			occupationCode: "1779",
			occupationDescription: "فني تدليك",
		},
		{
			occupationCode: "1739",
			occupationDescription: "فني تربية اسماك الزينة",
		},
		{
			occupationCode: "1737",
			occupationDescription: "فني تربية الاسماك",
		},
		{
			occupationCode: "1734",
			occupationDescription: "فني تربية الخيول",
		},
		{
			occupationCode: "1732",
			occupationDescription: "فني تربية دواجن",
		},
		{
			occupationCode: "1733",
			occupationDescription: "فني تربية طيور الزينة",
		},
		{
			occupationCode: "1738",
			occupationDescription: "فني تربية محار",
		},
		{
			occupationCode: "1731",
			occupationDescription: "فني تربية مواشي",
		},
		{
			occupationCode: "1735",
			occupationDescription: "فني تربية نحل",
		},
		{
			occupationCode: "48",
			occupationDescription: "فني تركيب عوازل",
		},
		{
			occupationCode: "1711",
			occupationDescription: "فني تركيب معدات صناعية",
		},
		{
			occupationCode: "1897",
			occupationDescription: "فني ترميز طبي",
		},
		{
			occupationCode: "325202",
			occupationDescription: "فني ترميز طبي",
		},
		{
			occupationCode: "1802",
			occupationDescription: "فني تسويق الادوية",
		},
		{
			occupationCode: "1799",
			occupationDescription: "فني تشريح",
		},
		{
			occupationCode: "494",
			occupationDescription: "فني تشغيل اجهزةاتصالات",
		},
		{
			occupationCode: "288",
			occupationDescription: "فني تشغيل حاسب آلي",
		},
		{
			occupationCode: "492",
			occupationDescription: "فني تشغيل لاسلكي",
		},
		{
			occupationCode: null,
			occupationDescription: "فني تشغيل مولدات كهربائية",
		},
		{
			occupationCode: "549",
			occupationDescription: "فني تشغيل مولدات كهربائية",
		},
		{
			occupationCode: "464",
			occupationDescription: "فني تصليح دراجات",
		},
		{
			occupationCode: "28",
			occupationDescription: "فني تصوير",
		},
		{
			occupationCode: "1592",
			occupationDescription: "فني تصوير دقيق ( ميكروفيش )",
		},
		{
			occupationCode: "1792",
			occupationDescription: "فني تصوير شعاعي",
		},
		{
			occupationCode: "1793",
			occupationDescription: "فني تصوير موجي",
		},
		{
			occupationCode: "1703",
			occupationDescription: "فني تعدين",
		},
		{
			occupationCode: "130",
			occupationDescription: "فني تعقيم",
		},
		{
			occupationCode: "325910",
			occupationDescription: "فني تعقيم",
		},
		{
			occupationCode: "1768",
			occupationDescription: "فني تغذية",
		},
		{
			occupationCode: "1706",
			occupationDescription: "فني تفجير",
		},
		{
			occupationCode: "1667",
			occupationDescription: "فني تكييف وتبريد/ تركيب",
		},
		{
			occupationCode: "1668",
			occupationDescription: "فني تكييف وتبريد/ تشغيل وصيانة",
		},
		{
			occupationCode: "493",
			occupationDescription: "فني تلفونات",
		},
		{
			occupationCode: "1665",
			occupationDescription: "فني تمديدات صحية وتدفئة/تركيب",
		},
		{
			occupationCode: "452",
			occupationDescription: "فني توربينات",
		},
		{
			occupationCode: "1682",
			occupationDescription: "فني توربينات بخارية / صيانة",
		},
		{
			occupationCode: "1681",
			occupationDescription: "فني توربينات بخارية تشغيل",
		},
		{
			occupationCode: "1683",
			occupationDescription: "فني توربينات غازية",
		},
		{
			occupationCode: "1615",
			occupationDescription: "فني توقيع مسح جوي رقمي",
		},
		{
			occupationCode: "131",
			occupationDescription: "فني جهاز عصبي",
		},
		{
			occupationCode: "134",
			occupationDescription: "فني جودة ونوعية",
		},
		{
			occupationCode: "1571",
			occupationDescription: "فني جيولوجي عام",
		},
		{
			occupationCode: "481",
			occupationDescription: "فني حاسب آلي",
		},
		{
			occupationCode: "1728",
			occupationDescription: "فني حدائق",
		},
		{
			occupationCode: "1853",
			occupationDescription: "فني حسابات عام",
		},
		{
			occupationCode: "1855",
			occupationDescription: "فني حسابات كلفة",
		},
		{
			occupationCode: "1705",
			occupationDescription: "فني حفر آبار",
		},
		{
			occupationCode: "1806",
			occupationDescription: "فني خدمة اجتماعية",
		},
		{
			occupationCode: "1674",
			occupationDescription: "فني خراطة محركات",
		},
		{
			occupationCode: "76",
			occupationDescription: "فني خزف وزجاج",
		},
		{
			occupationCode: "1686",
			occupationDescription: "فني دراسة الوقت والحركة",
		},
		{
			occupationCode: "47",
			occupationDescription: "فني دعاية واعلان",
		},
		{
			occupationCode: "1594",
			occupationDescription: "فني دعم",
		},
		{
			occupationCode: "454",
			occupationDescription: "فني ديكور",
		},
		{
			occupationCode: "35",
			occupationDescription: "فني ذخيرة",
		},
		{
			occupationCode: "32",
			occupationDescription: "فني راديو",
		},
		{
			occupationCode: "483",
			occupationDescription: "فني راديو وتلفزيون",
		},
		{
			occupationCode: "1614",
			occupationDescription: "فني رسم خرائط رقمية",
		},
		{
			occupationCode: "1574",
			occupationDescription: "فني رصد فلكي",
		},
		{
			occupationCode: "1576",
			occupationDescription: "فني رصد مناخ",
		},
		{
			occupationCode: "211201",
			occupationDescription: "فني رصد مناخ",
		},
		{
			occupationCode: "1808",
			occupationDescription: "فني رعاية أحداث",
		},
		{
			occupationCode: "1809",
			occupationDescription: "فني رعاية شباب",
		},
		{
			occupationCode: "1756",
			occupationDescription: "فني رعاية صحية",
		},
		{
			occupationCode: "1811",
			occupationDescription: "فني رعاية عجزة",
		},
		{
			occupationCode: "1810",
			occupationDescription: "فني رعاية معوقين",
		},
		{
			occupationCode: "46",
			occupationDescription: "فني رقابة",
		},
		{
			occupationCode: "40",
			occupationDescription: "فني رماية",
		},
		{
			occupationCode: "1724",
			occupationDescription: "فني ري",
		},
		{
			occupationCode: null,
			occupationDescription: "فني زجاج",
		},
		{
			occupationCode: "513",
			occupationDescription: "فني زجاج",
		},
		{
			occupationCode: "1690",
			occupationDescription: "فني زخرفة سيارات",
		},
		{
			occupationCode: "1726",
			occupationDescription: "فني زراعة الحمضيات",
		},
		{
			occupationCode: "1727",
			occupationDescription: "فني زراعة النخيل",
		},
		{
			occupationCode: "1721",
			occupationDescription: "فني زراعة حبوب",
		},
		{
			occupationCode: "1722",
			occupationDescription: "فني زراعة خضراوات",
		},
		{
			occupationCode: "1723",
			occupationDescription: "فني زراعة محمية",
		},
		{
			occupationCode: "116",
			occupationDescription: "فني زراعي",
		},
		{
			occupationCode: "314201",
			occupationDescription: "فني زراعي",
		},
		{
			occupationCode: "1707",
			occupationDescription: "فني سجل أداء بئر نفط",
		},
		{
			occupationCode: "128",
			occupationDescription: "فني سجلات طبية",
		},
		{
			occupationCode: "1662",
			occupationDescription: "فني سكب",
		},
		{
			occupationCode: "97",
			occupationDescription: "فني سيارات",
		},
		{
			occupationCode: "29",
			occupationDescription: "فني شبكات",
		},
		{
			occupationCode: "1593",
			occupationDescription: "فني شبكات حاسب",
		},
		{
			occupationCode: "1713",
			occupationDescription: "فني صحة مهنية",
		},
		{
			occupationCode: "1701",
			occupationDescription: "فني صناعات دهان",
		},
		{
			occupationCode: "1801",
			occupationDescription: "فني صناعات دوائية عام",
		},
		{
			occupationCode: "1700",
			occupationDescription: "فني صناعات غذائية",
		},
		{
			occupationCode: "1699",
			occupationDescription: "فني صناعة منظفات كيميائية",
		},
		{
			occupationCode: "1838",
			occupationDescription: "فني صوت",
		},
		{
			occupationCode: "352105",
			occupationDescription: "فني صوت",
		},
		{
			occupationCode: "473",
			occupationDescription: "فني صيانة",
		},
		{
			occupationCode: "1673",
			occupationDescription: "فني صيانة آلات زراعية",
		},
		{
			occupationCode: "1672",
			occupationDescription: "فني صيانة آلات طرق",
		},
		{
			occupationCode: "1666",
			occupationDescription: "فني صيانة تمديدات صحية وتدف",
		},
		{
			occupationCode: "1671",
			occupationDescription: "فني صيانة حافلات وشاحنات",
		},
		{
			occupationCode: "36",
			occupationDescription: "فني صيانة طائرات",
		},
		{
			occupationCode: "1675",
			occupationDescription: "فني صيانة طائرات مروحية",
		},
		{
			occupationCode: "1677",
			occupationDescription: "فني صيانة طائرات نفاثة",
		},
		{
			occupationCode: "1679",
			occupationDescription: "فني صيانة قاطرات",
		},
		{
			occupationCode: "1678",
			occupationDescription: "فني صيانة محركات سفن",
		},
		{
			occupationCode: "1670",
			occupationDescription: "فني صيانة مركبات خفيفة",
		},
		{
			occupationCode: "1688",
			occupationDescription: "فني صيانة مسابح",
		},
		{
			occupationCode: "1784",
			occupationDescription: "فني طب أسنان",
		},
		{
			occupationCode: "1789",
			occupationDescription: "فني طب بيطري",
		},
		{
			occupationCode: "83",
			occupationDescription: "فني طباعة",
		},
		{
			occupationCode: "119",
			occupationDescription: "فني طبي",
		},
		{
			occupationCode: "1600",
			occupationDescription: "فني طرق( مراقب طرق )",
		},
		{
			occupationCode: "311209",
			occupationDescription: "فني طرق( مراقب طرق )",
		},
		{
			occupationCode: "1755",
			occupationDescription: "فني عدسات طبية",
		},
		{
			occupationCode: "1785",
			occupationDescription: "فني علاج أسنان",
		},
		{
			occupationCode: "132",
			occupationDescription: "فني علاج بالاشعاع",
		},
		{
			occupationCode: "125",
			occupationDescription: "فني علاج تنفسي",
		},
		{
			occupationCode: "1781",
			occupationDescription: "فني علاج طبيعي تقويمي",
		},
		{
			occupationCode: "122",
			occupationDescription: "فني علوم طبية",
		},
		{
			occupationCode: "21",
			occupationDescription: "فني علوم طبيعة",
		},
		{
			occupationCode: "33",
			occupationDescription: "فني عمليات",
		},
		{
			occupationCode: "123",
			occupationDescription: "فني عينات",
		},
		{
			occupationCode: "1580",
			occupationDescription: "فني عينات نباتية",
		},
		{
			occupationCode: "1730",
			occupationDescription: "فني غابات ومراعي",
		},
		{
			occupationCode: "1772",
			occupationDescription: "فني غسيل كلى",
		},
		{
			occupationCode: "44",
			occupationDescription: "فني فحص",
		},
		{
			occupationCode: "1689",
			occupationDescription: "فني فحص سيارات",
		},
		{
			occupationCode: "1634",
			occupationDescription: "فني في الهندسة الكهربائية او عام",
		},
		{
			occupationCode: "133",
			occupationDescription: "فني فيزيائي اعصاب",
		},
		{
			occupationCode: "31",
			occupationDescription: "فني قذائف",
		},
		{
			occupationCode: "129",
			occupationDescription: "فني قسطرة قلب",
		},
		{
			occupationCode: "1663",
			occupationDescription: "فني قوالب",
		},
		{
			occupationCode: "90",
			occupationDescription: "فني قوى كهربائية",
		},
		{
			occupationCode: "94",
			occupationDescription: "فني كهرباء",
		},
		{
			occupationCode: "89",
			occupationDescription: "فني كهرباء ضغط عالي",
		},
		{
			occupationCode: "1633",
			occupationDescription: "فني كهربائي أجهزة دقيقة",
		},
		{
			occupationCode: "1631",
			occupationDescription: "فني كهربائي تمديدات",
		},
		{
			occupationCode: "1630",
			occupationDescription: "فني كهربائي خدمات مشتركين",
		},
		{
			occupationCode: "1628",
			occupationDescription: "فني كهربائي خطوط هوائية",
		},
		{
			occupationCode: "1632",
			occupationDescription: "فني كهربائي صيانة آلات",
		},
		{
			occupationCode: "1629",
			occupationDescription: "فني كهربائي كابلات أرضية",
		},
		{
			occupationCode: "1639",
			occupationDescription: "فني كهربائي مولدات وموترات",
		},
		{
			occupationCode: "495",
			occupationDescription: "فني كيابل",
		},
		{
			occupationCode: "20",
			occupationDescription: "فني كيميائي",
		},
		{
			occupationCode: "311104",
			occupationDescription: "فني كيميائي",
		},
		{
			occupationCode: "1698",
			occupationDescription: "فني كيميائي تكرير نفط",
		},
		{
			occupationCode: "1697",
			occupationDescription: "فني كيميائي عام",
		},
		{
			occupationCode: "1660",
			occupationDescription: "فني لحام",
		},
		{
			occupationCode: "482",
			occupationDescription: "فني لف دينمو",
		},
		{
			occupationCode: null,
			occupationDescription: "فني لف معادن",
		},
		{
			occupationCode: "508",
			occupationDescription: "فني لف معادن",
		},
		{
			occupationCode: "470",
			occupationDescription: "فني ماكينات",
		},
		{
			occupationCode: "23",
			occupationDescription: "فني مبيدات حشرية",
		},
		{
			occupationCode: "1716",
			occupationDescription: "فني مجاري شبكات",
		},
		{
			occupationCode: "1720",
			occupationDescription: "فني محاصيل حقلية عام",
		},
		{
			occupationCode: "96",
			occupationDescription: "فني محركات",
		},
		{
			occupationCode: "451",
			occupationDescription: "فني محركات بحرية",
		},
		{
			occupationCode: "469",
			occupationDescription: "فني محركات طائرات",
		},
		{
			occupationCode: "475",
			occupationDescription: "فني محركات كهربائية",
		},
		{
			occupationCode: "27",
			occupationDescription: "فني محطات",
		},
		{
			occupationCode: "1627",
			occupationDescription: "فني محطات تحويل تشغيل وصيانة",
		},
		{
			occupationCode: "1626",
			occupationDescription: "فني محطات تحويل وتركيب",
		},
		{
			occupationCode: "1624",
			occupationDescription: "فني محطات توليد وتركيب",
		},
		{
			occupationCode: "1625",
			occupationDescription: "فني محطات توليد/ تشغيل وصيانة",
		},
		{
			occupationCode: "1717",
			occupationDescription: "فني محطة تنقية مجاري",
		},
		{
			occupationCode: "117",
			occupationDescription: "فني مختبر",
		},
		{
			occupationCode: "1563",
			occupationDescription: "فني مختبر أغذية",
		},
		{
			occupationCode: "1796",
			occupationDescription: "فني مختبر بنك الدم",
		},
		{
			occupationCode: "1578",
			occupationDescription: "فني مختبر بيولوجي",
		},
		{
			occupationCode: "1584",
			occupationDescription: "فني مختبر جراثيم ( بكتيريا )",
		},
		{
			occupationCode: "1572",
			occupationDescription: "فني مختبر جيولوجي",
		},
		{
			occupationCode: "1583",
			occupationDescription: "فني مختبر حشرات",
		},
		{
			occupationCode: "1831",
			occupationDescription: "فني مختبر علوم",
		},
		{
			occupationCode: "1570",
			occupationDescription: "فني مختبر فيزيائي  او  الكترونيات",
		},
		{
			occupationCode: "1566",
			occupationDescription: "فني مختبر فيزيائي  او  حرارة",
		},
		{
			occupationCode: "1568",
			occupationDescription: "فني مختبر فيزيائي  او  صوت",
		},
		{
			occupationCode: "1564",
			occupationDescription: "فني مختبر فيزيائي  او  عام",
		},
		{
			occupationCode: "1565",
			occupationDescription: "فني مختبر فيزيائي  او  ميكانيكا",
		},
		{
			occupationCode: "1567",
			occupationDescription: "فني مختبر فيزيائي او ضوء وبصريات",
		},
		{
			occupationCode: "1569",
			occupationDescription: "فني مختبر كهرومغناطيسية",
		},
		{
			occupationCode: "1560",
			occupationDescription: "فني مختبر كيمياء عام",
		},
		{
			occupationCode: "1606",
			occupationDescription: "فني مختبر مواد أنشائية",
		},
		{
			occupationCode: "1562",
			occupationDescription: "فني مختبر مياه",
		},
		{
			occupationCode: "1605",
			occupationDescription: "فني مختبر ميكانيكا التربة",
		},
		{
			occupationCode: "1561",
			occupationDescription: "فني مختبر نفط خام",
		},
		{
			occupationCode: "1795",
			occupationDescription: "فني مختبرات طبية / عام",
		},
		{
			occupationCode: "471",
			occupationDescription: "فني مركبات",
		},
		{
			occupationCode: "478",
			occupationDescription: "فني مصاعد",
		},
		{
			occupationCode: "41",
			occupationDescription: "فني مضلات",
		},
		{
			occupationCode: "100",
			occupationDescription: "فني معادن",
		},
		{
			occupationCode: "1708",
			occupationDescription: "فني معادن طبيعية",
		},
		{
			occupationCode: "1780",
			occupationDescription: "فني معالجة فيزيائية",
		},
		{
			occupationCode: "1664",
			occupationDescription: "فني معاملات حرارية",
		},
		{
			occupationCode: "449",
			occupationDescription: "فني معدات",
		},
		{
			occupationCode: "101",
			occupationDescription: "فني معدات سلامة",
		},
		{
			occupationCode: "415",
			occupationDescription: "فني معصرة زيوت",
		},
		{
			occupationCode: "39",
			occupationDescription: "فني مفرقعات",
		},
		{
			occupationCode: "30",
			occupationDescription: "فني مقاسم",
		},
		{
			occupationCode: "1714",
			occupationDescription: "فني مكافحة الحرائق",
		},
		{
			occupationCode: "24",
			occupationDescription: "فني مكافحة حشرات",
		},
		{
			occupationCode: "314206",
			occupationDescription: "فني مكافحة حشرات",
		},
		{
			occupationCode: "955",
			occupationDescription: "فني مكتب الدعم الفني",
		},
		{
			occupationCode: "455",
			occupationDescription: "فني مكنات زراعية",
		},
		{
			occupationCode: "453",
			occupationDescription: "فني مكنات طباعة",
		},
		{
			occupationCode: "1702",
			occupationDescription: "فني مناجم",
		},
		{
			occupationCode: null,
			occupationDescription: "فني منتجات بلاستيكية",
		},
		{
			occupationCode: "516",
			occupationDescription: "فني منتجات بلاستيكية",
		},
		{
			occupationCode: "1680",
			occupationDescription: "فني موائع هيدروليك",
		},
		{
			occupationCode: "1763",
			occupationDescription: "فني مواد تعقيم",
		},
		{
			occupationCode: "1715",
			occupationDescription: "فني مياه شبكات",
		},
		{
			occupationCode: "1718",
			occupationDescription: "فني مياه ومجاري/خدمات مشتركين",
		},
		{
			occupationCode: "25",
			occupationDescription: "فني ميزان",
		},
		{
			occupationCode: "1659",
			occupationDescription: "فني ميكانيكي أنتاج",
		},
		{
			occupationCode: "1729",
			occupationDescription: "فني نباتات زينة",
		},
		{
			occupationCode: "472",
			occupationDescription: "فني نجارة",
		},
		{
			occupationCode: "1764",
			occupationDescription: "فني نظارات",
		},
		{
			occupationCode: "1704",
			occupationDescription: "فني نفط",
		},
		{
			occupationCode: "1834",
			occupationDescription: "فني نماذج تعليمية",
		},
		{
			occupationCode: null,
			occupationDescription: "فني نيون",
		},
		{
			occupationCode: "525",
			occupationDescription: "فني نيون",
		},
		{
			occupationCode: "491",
			occupationDescription: "فني هاتف سيار",
		},
		{
			occupationCode: null,
			occupationDescription: "فني هناجر",
		},
		{
			occupationCode: "506",
			occupationDescription: "فني هناجر",
		},
		{
			occupationCode: "93",
			occupationDescription: "فني هندسة اتصالات",
		},
		{
			occupationCode: "87",
			occupationDescription: "فني هندسة الكترونية",
		},
		{
			occupationCode: "102",
			occupationDescription: "فني هندسة انتاج",
		},
		{
			occupationCode: "1676",
			occupationDescription: "فني هندسة طيران",
		},
		{
			occupationCode: "86",
			occupationDescription: "فني هندسة كهربائية",
		},
		{
			occupationCode: "99",
			occupationDescription: "فني هندسة كيميائية",
		},
		{
			occupationCode: "84",
			occupationDescription: "فني هندسة مدنية",
		},
		{
			occupationCode: "311201",
			occupationDescription: "فني هندسة مدنية",
		},
		{
			occupationCode: "95",
			occupationDescription: "فني هندسة ميكانيكية",
		},
		{
			occupationCode: "1669",
			occupationDescription: "فني هندسة ميكانيكية ومحركات",
		},
		{
			occupationCode: "457",
			occupationDescription: "فني هياكل طائرات",
		},
		{
			occupationCode: "1783",
			occupationDescription: "فني وخز ابر صينية",
		},
		{
			occupationCode: "1832",
			occupationDescription: "فني وسائل تعليمية",
		},
		{
			occupationCode: "1687",
			occupationDescription: "فني وقاية مهبطية",
		},
		{
			occupationCode: "597",
			occupationDescription: "في انتظار التجنس",
		},
		{
			occupationCode: "211101",
			occupationDescription: "فيزيائي",
		},
		{
			occupationCode: null,
			occupationDescription: "فيزيائي ألكترونيات",
		},
		{
			occupationCode: "16",
			occupationDescription: "فيزيائي الكترونيات",
		},
		{
			occupationCode: "15",
			occupationDescription: "فيزيائي تخصص حرارة",
		},
		{
			occupationCode: "14",
			occupationDescription: "فيزيائي تخصص ميكانيكا",
		},
		{
			occupationCode: null,
			occupationDescription: "فيزيائي حرارة",
		},
		{
			occupationCode: "912",
			occupationDescription: "فيزيائي حرارة",
		},
		{
			occupationCode: null,
			occupationDescription: "فيزيائي صوت",
		},
		{
			occupationCode: "914",
			occupationDescription: "فيزيائي صوت",
		},
		{
			occupationCode: null,
			occupationDescription: "فيزيائي ضوء",
		},
		{
			occupationCode: "913",
			occupationDescription: "فيزيائي ضوء",
		},
		{
			occupationCode: "1292",
			occupationDescription: "فيزيائي طبي",
		},
		{
			occupationCode: null,
			occupationDescription: "فيزيائي عام",
		},
		{
			occupationCode: "910",
			occupationDescription: "فيزيائي عام",
		},
		{
			occupationCode: null,
			occupationDescription: "فيزيائي كهرومغناطيسية",
		},
		{
			occupationCode: "915",
			occupationDescription: "فيزيائي كهرومغناطيسية",
		},
		{
			occupationCode: null,
			occupationDescription: "فيزيائي متخصص في علم الفلك",
		},
		{
			occupationCode: "918",
			occupationDescription: "فيزيائي متخصص في علم الفلك",
		},
		{
			occupationCode: null,
			occupationDescription: "فيزيائي نووي",
		},
		{
			occupationCode: "917",
			occupationDescription: "فيزيائي نووي",
		},
		{
			occupationCode: null,
			occupationDescription: "فيزيائيون آخرون",
		},
		{
			occupationCode: "919",
			occupationDescription: "فيزيائيون آخرون",
		},
		{
			occupationCode: "673",
			occupationDescription: "قائد السفينة في البحر",
		},
		{
			occupationCode: "1501",
			occupationDescription: "قائد فرقة غنائية",
		},
		{
			occupationCode: "1498",
			occupationDescription: "قائد فرقة موسيقية ( مايسترو )",
		},
		{
			occupationCode: null,
			occupationDescription: "قائم بأعمال",
		},
		{
			occupationCode: "707",
			occupationDescription: "قائم بأعمال",
		},
		{
			occupationCode: null,
			occupationDescription: "قائم بأعمال بالنيابة",
		},
		{
			occupationCode: "708",
			occupationDescription: "قائم بأعمال بالنيابة",
		},
		{
			occupationCode: "192",
			occupationDescription: "قابل",
		},
		{
			occupationCode: "1750",
			occupationDescription: "قابلة قانونية",
		},
		{
			occupationCode: "1947",
			occupationDescription: "قارىء عداد المياه",
		},
		{
			occupationCode: "1949",
			occupationDescription: "قارىء عداد غاز",
		},
		{
			occupationCode: "1948",
			occupationDescription: "قارىء عداد كهرباء",
		},
		{
			occupationCode: "1436",
			occupationDescription: "قارىء متخصص (مقريء)",
		},
		{
			occupationCode: "1440",
			occupationDescription: "قاضي",
		},
		{
			occupationCode: "261201",
			occupationDescription: "قاضي",
		},
		{
			occupationCode: "1441",
			occupationDescription: "قاضي شرعي",
		},
		{
			occupationCode: "2281",
			occupationDescription: "قصاص صوف",
		},
		{
			occupationCode: "3",
			occupationDescription: "قطاع خاص",
		},
		{
			occupationCode: "700",
			occupationDescription: "قنصل",
		},
		{
			occupationCode: "111208",
			occupationDescription: "قنصل",
		},
		{
			occupationCode: "701",
			occupationDescription: "قنصل عام",
		},
		{
			occupationCode: null,
			occupationDescription: "قهوجي",
		},
		{
			occupationCode: "411",
			occupationDescription: "قهوجي",
		},
		{
			occupationCode: "2236",
			occupationDescription: "قهوجي منزلي",
		},
		{
			occupationCode: "1914",
			occupationDescription: "كاتب أتصالات برقية",
		},
		{
			occupationCode: "1916",
			occupationDescription: "كاتب أتصالات بريدية",
		},
		{
			occupationCode: "1913",
			occupationDescription: "كاتب أتصالات هاتفية",
		},
		{
			occupationCode: "1929",
			occupationDescription: "كاتب أجور",
		},
		{
			occupationCode: "431301",
			occupationDescription: "كاتب أجور",
		},
		{
			occupationCode: "1976",
			occupationDescription: "كاتب أحصائي",
		},
		{
			occupationCode: "1865",
			occupationDescription: "كاتب أحوال مدنية عام",
		},
		{
			occupationCode: "1875",
			occupationDescription: "كاتب أداري عام",
		},
		{
			occupationCode: "1445",
			occupationDescription: "كاتب أدبي",
		},
		{
			occupationCode: "1452",
			occupationDescription: "كاتب أدلة كتالوجات فنية",
		},
		{
			occupationCode: "1940",
			occupationDescription: "كاتب أسهم وسندات مالية",
		},
		{
			occupationCode: "1930",
			occupationDescription: "كاتب أنتاج",
		},
		{
			occupationCode: "432201",
			occupationDescription: "كاتب أنتاج",
		},
		{
			occupationCode: "279",
			occupationDescription: "كاتب اختزال",
		},
		{
			occupationCode: "265",
			occupationDescription: "كاتب اداري",
		},
		{
			occupationCode: "1912",
			occupationDescription: "كاتب استعلامات سياحية",
		},
		{
			occupationCode: "1910",
			occupationDescription: "كاتب استعلامات عامة",
		},
		{
			occupationCode: "1906",
			occupationDescription: "كاتب استقبال عام",
		},
		{
			occupationCode: "1907",
			occupationDescription: "كاتب استقبال فندقي",
		},
		{
			occupationCode: "1908",
			occupationDescription: "كاتب استقبال مرضى",
		},
		{
			occupationCode: "1902",
			occupationDescription: "كاتب استلام بضائع",
		},
		{
			occupationCode: "1887",
			occupationDescription: "كاتب بروفات ومدقق لها",
		},
		{
			occupationCode: "1963",
			occupationDescription: "كاتب تأجير سيارات سياحية",
		},
		{
			occupationCode: "309",
			occupationDescription: "كاتب تأمين",
		},
		{
			occupationCode: "431202",
			occupationDescription: "كاتب تأمين",
		},
		{
			occupationCode: "1933",
			occupationDescription: "كاتب تأمينات اجتماعية",
		},
		{
			occupationCode: "1882",
			occupationDescription: "كاتب تحرير مراسلات",
		},
		{
			occupationCode: "421102",
			occupationDescription: "كاتب تحرير مراسلات",
		},
		{
			occupationCode: "1941",
			occupationDescription: "كاتب تخطيط مواد",
		},
		{
			occupationCode: "1935",
			occupationDescription: "كاتب تخليص جمركي",
		},
		{
			occupationCode: "1938",
			occupationDescription: "كاتب تدقيق توقيعات",
		},
		{
			occupationCode: "1954",
			occupationDescription: "كاتب تذاكر سفر",
		},
		{
			occupationCode: "1977",
			occupationDescription: "كاتب ترميز ( معالجة بيانات )",
		},
		{
			occupationCode: "1890",
			occupationDescription: "كاتب تسجيل أراضي وعقارات",
		},
		{
			occupationCode: "1889",
			occupationDescription: "كاتب تسجيل شئون طلاب",
		},
		{
			occupationCode: "1867",
			occupationDescription: "كاتب تسجيل مواليد",
		},
		{
			occupationCode: "1868",
			occupationDescription: "كاتب تسجيل وفيات",
		},
		{
			occupationCode: "1891",
			occupationDescription: "كاتب تصديق وثائق",
		},
		{
			occupationCode: "1942",
			occupationDescription: "كاتب تكاليف",
		},
		{
			occupationCode: "1915",
			occupationDescription: "كاتب تلكس",
		},
		{
			occupationCode: "1898",
			occupationDescription: "كاتب توظيف",
		},
		{
			occupationCode: "1934",
			occupationDescription: "كاتب جمركي",
		},
		{
			occupationCode: "1869",
			occupationDescription: "كاتب جنسية",
		},
		{
			occupationCode: "1950",
			occupationDescription: "كاتب حجز سياحي",
		},
		{
			occupationCode: "284",
			occupationDescription: "كاتب حسابات",
		},
		{
			occupationCode: "1932",
			occupationDescription: "كاتب حسابات رسوم",
		},
		{
			occupationCode: "1956",
			occupationDescription: "كاتب خدمات أمتعة",
		},
		{
			occupationCode: "1957",
			occupationDescription: "كاتب خدمات شحن وتفريغ",
		},
		{
			occupationCode: "1958",
			occupationDescription: "كاتب خدمات عبور",
		},
		{
			occupationCode: "1955",
			occupationDescription: "كاتب خدمات مسافرين",
		},
		{
			occupationCode: "1900",
			occupationDescription: "كاتب دوام",
		},
		{
			occupationCode: "1506",
			occupationDescription: "كاتب سيناريو وحوار",
		},
		{
			occupationCode: "1893",
			occupationDescription: "كاتب شئون أفراد",
		},
		{
			occupationCode: "1874",
			occupationDescription: "كاتب شئون قانونية",
		},
		{
			occupationCode: "1909",
			occupationDescription: "كاتب شكاوى",
		},
		{
			occupationCode: "1466",
			occupationDescription: "كاتب صحفي",
		},
		{
			occupationCode: "1444",
			occupationDescription: "كاتب عدل",
		},
		{
			occupationCode: "1911",
			occupationDescription: "كاتب علاقات عامة",
		},
		{
			occupationCode: "1943",
			occupationDescription: "كاتب مالية",
		},
		{
			occupationCode: "431201",
			occupationDescription: "كاتب مالية",
		},
		{
			occupationCode: "1879",
			occupationDescription: "كاتب متابع",
		},
		{
			occupationCode: "1873",
			occupationDescription: "كاتب محامي",
		},
		{
			occupationCode: "1884",
			occupationDescription: "كاتب محكمة",
		},
		{
			occupationCode: "1878",
			occupationDescription: "كاتب مسك الدفاتر",
		},
		{
			occupationCode: "1926",
			occupationDescription: "كاتب مصرفي",
		},
		{
			occupationCode: "1892",
			occupationDescription: "كاتب مكتبة",
		},
		{
			occupationCode: "1881",
			occupationDescription: "كاتب ملفات ( محفوظات )",
		},
		{
			occupationCode: "1876",
			occupationDescription: "كاتب وارد وصادر",
		},
		{
			occupationCode: "1866",
			occupationDescription: "كاتب وثائق اثبات الشخصية",
		},
		{
			occupationCode: "2151",
			occupationDescription: "كبير الطهاة",
		},
		{
			occupationCode: "674",
			occupationDescription: "كبير المهندسين في السفينة",
		},
		{
			occupationCode: "1131",
			occupationDescription: "كبير ضباط بحريين",
		},
		{
			occupationCode: "1062",
			occupationDescription: "كبير فني أنظمةالمراقبةالبيئية",
		},
		{
			occupationCode: "1103",
			occupationDescription: "كبير مدققي أنظمة جودة",
		},
		{
			occupationCode: "1066",
			occupationDescription: "كبير مفتشين فحص غير الاتلافي",
		},
		{
			occupationCode: "3503",
			occupationDescription: "كحيل حجر",
		},
		{
			occupationCode: "3355",
			occupationDescription: "كهربائي آلات كهربائية عام",
		},
		{
			occupationCode: "488",
			occupationDescription: "كهربائي أجهزة تبريد",
		},
		{
			occupationCode: "476",
			occupationDescription: "كهربائي أجهزة تحكم",
		},
		{
			occupationCode: "3346",
			occupationDescription: "كهربائي أجهزة قياس",
		},
		{
			occupationCode: "3358",
			occupationDescription: "كهربائي أجهزة منزلية",
		},
		{
			occupationCode: "3357",
			occupationDescription: "كهربائي أجهزة منزلية عام",
		},
		{
			occupationCode: "3378",
			occupationDescription: "كهربائي أصلاح",
		},
		{
			occupationCode: "3380",
			occupationDescription: "كهربائي تبريد وتكييف",
		},
		{
			occupationCode: "3337",
			occupationDescription: "كهربائي تركيب محطات تحويل",
		},
		{
			occupationCode: "3336",
			occupationDescription: "كهربائي تركيب محطات تحويل/عام",
		},
		{
			occupationCode: "3320",
			occupationDescription: "كهربائي تركيب محطات توليد",
		},
		{
			occupationCode: "3419",
			occupationDescription: "كهربائي تركيب معدات ألكترون",
		},
		{
			occupationCode: "3349",
			occupationDescription: "كهربائي تركيب وصيانة لوحات",
		},
		{
			occupationCode: "3339",
			occupationDescription: "كهربائي تشغيل محطات تحويل",
		},
		{
			occupationCode: "3338",
			occupationDescription: "كهربائي تشغيل محطات تحويل عام",
		},
		{
			occupationCode: "3324",
			occupationDescription: "كهربائي تشغيل محطات توليد",
		},
		{
			occupationCode: "3323",
			occupationDescription: "كهربائي تشغيل محطات توليد/عام",
		},
		{
			occupationCode: "3353",
			occupationDescription: "كهربائي تمديدات صناعية",
		},
		{
			occupationCode: "3351",
			occupationDescription: "كهربائي تمديدات كهربائية عام",
		},
		{
			occupationCode: "3352",
			occupationDescription: "كهربائي تمديدات منزلية",
		},
		{
			occupationCode: "3343",
			occupationDescription: "كهربائي خدمات المشتركين",
		},
		{
			occupationCode: "3370",
			occupationDescription: "كهربائي سفن",
		},
		{
			occupationCode: "741205",
			occupationDescription: "كهربائي سفن",
		},
		{
			occupationCode: "3369",
			occupationDescription: "كهربائي سفن عام",
		},
		{
			occupationCode: "487",
			occupationDescription: "كهربائي سيارات",
		},
		{
			occupationCode: "3363",
			occupationDescription: "كهربائي سيارات عام",
		},
		{
			occupationCode: "3331",
			occupationDescription: "كهربائي شبكات توزيع كهرباء",
		},
		{
			occupationCode: "3330",
			occupationDescription: "كهربائي شبكات هوائية عام",
		},
		{
			occupationCode: "489",
			occupationDescription: "كهربائي صيانة",
		},
		{
			occupationCode: "3361",
			occupationDescription: "كهربائي صيانة أجهزة تحكم",
		},
		{
			occupationCode: "3345",
			occupationDescription: "كهربائي صيانة أجهزة دقيقه/عام",
		},
		{
			occupationCode: "3341",
			occupationDescription: "كهربائي صيانة محطات تحويل",
		},
		{
			occupationCode: "3327",
			occupationDescription: "كهربائي صيانة محطات توليد",
		},
		{
			occupationCode: "3326",
			occupationDescription: "كهربائي صيانة محطات توليد/عام",
		},
		{
			occupationCode: "3329",
			occupationDescription: "كهربائي صيانة مفاتيح تحكم",
		},
		{
			occupationCode: "486",
			occupationDescription: "كهربائي طائرات",
		},
		{
			occupationCode: "741208",
			occupationDescription: "كهربائي طائرات",
		},
		{
			occupationCode: "3372",
			occupationDescription: "كهربائي طائرات عام",
		},
		{
			occupationCode: "3374",
			occupationDescription: "كهربائي عام",
		},
		{
			occupationCode: "3344",
			occupationDescription: "كهربائي عداد طاقة",
		},
		{
			occupationCode: "3367",
			occupationDescription: "كهربائي قطارات",
		},
		{
			occupationCode: "741204",
			occupationDescription: "كهربائي قطارات",
		},
		{
			occupationCode: "3366",
			occupationDescription: "كهربائي قطارات عام",
		},
		{
			occupationCode: "3333",
			occupationDescription: "كهربائي كابلات أرضية عام",
		},
		{
			occupationCode: "3334",
			occupationDescription: "كهربائي كابلات توزيع",
		},
		{
			occupationCode: "3356",
			occupationDescription: "كهربائي لف محركات",
		},
		{
			occupationCode: "3325",
			occupationDescription: "كهربائي لوحات مراقبة وتحكم",
		},
		{
			occupationCode: "485",
			occupationDescription: "كهربائي مباني",
		},
		{
			occupationCode: "741101",
			occupationDescription: "كهربائي مباني",
		},
		{
			occupationCode: "548",
			occupationDescription: "كهربائي محطات",
		},
		{
			occupationCode: "3376",
			occupationDescription: "كهربائي مسرح وأستوديو",
		},
		{
			occupationCode: "3359",
			occupationDescription: "كهربائي مصاعد",
		},
		{
			occupationCode: "3362",
			occupationDescription: "كهربائي معدات زراعية",
		},
		{
			occupationCode: "3322",
			occupationDescription: "كهروميكانيكي محطات توليد صغيرة",
		},
		{
			occupationCode: "2168",
			occupationDescription: "كواء عام",
		},
		{
			occupationCode: "2169",
			occupationDescription: "كواء ملابس بالبخار",
		},
		{
			occupationCode: "2170",
			occupationDescription: "كواء يدوي",
		},
		{
			occupationCode: "9",
			occupationDescription: "كيميائي",
		},
		{
			occupationCode: "211301",
			occupationDescription: "كيميائي",
		},
		{
			occupationCode: null,
			occupationDescription: "كيميائي أغذية",
		},
		{
			occupationCode: "897",
			occupationDescription: "كيميائي أغذية",
		},
		{
			occupationCode: null,
			occupationDescription: "كيميائي تنقية مياه",
		},
		{
			occupationCode: "899",
			occupationDescription: "كيميائي تنقية مياه",
		},
		{
			occupationCode: null,
			occupationDescription: "كيميائي دهان ( أصباغ )",
		},
		{
			occupationCode: "900",
			occupationDescription: "كيميائي دهان ( أصباغ )",
		},
		{
			occupationCode: null,
			occupationDescription: "كيميائي عام",
		},
		{
			occupationCode: "892",
			occupationDescription: "كيميائي عام",
		},
		{
			occupationCode: null,
			occupationDescription: "كيميائي عضوي",
		},
		{
			occupationCode: "8",
			occupationDescription: "كيميائي عضوي",
		},
		{
			occupationCode: null,
			occupationDescription: "كيميائي فيزيائي",
		},
		{
			occupationCode: "896",
			occupationDescription: "كيميائي فيزيائي",
		},
		{
			occupationCode: null,
			occupationDescription: "كيميائي لا عضوي",
		},
		{
			occupationCode: "894",
			occupationDescription: "كيميائي لا عضوي",
		},
		{
			occupationCode: "246",
			occupationDescription: "لاعب",
		},
		{
			occupationCode: "1523",
			occupationDescription: "لاعب كرة قدم محترف",
		},
		{
			occupationCode: "500",
			occupationDescription: "لحام",
		},
		{
			occupationCode: "721201",
			occupationDescription: "لحام",
		},
		{
			occupationCode: "3141",
			occupationDescription: "لحام أقشطه ناقلة",
		},
		{
			occupationCode: "3081",
			occupationDescription: "لحام أنابيب",
		},
		{
			occupationCode: "3080",
			occupationDescription: "لحام أنابيب عام",
		},
		{
			occupationCode: "3078",
			occupationDescription: "لحام أوكسجين",
		},
		{
			occupationCode: "3087",
			occupationDescription: "لحام المركبات المعدنية",
		},
		{
			occupationCode: "3088",
			occupationDescription: "لحام بالرصاص",
		},
		{
			occupationCode: "3076",
			occupationDescription: "لحام بالقوس الكهربائي آليا",
		},
		{
			occupationCode: "3092",
			occupationDescription: "لحام بالمكواة",
		},
		{
			occupationCode: "3073",
			occupationDescription: "لحام عام",
		},
		{
			occupationCode: null,
			occupationDescription: "لحام كهرباء",
		},
		{
			occupationCode: "499",
			occupationDescription: "لحام كهرباء",
		},
		{
			occupationCode: "3074",
			occupationDescription: "لحام كهرباء عام",
		},
		{
			occupationCode: "490",
			occupationDescription: "لحام كيابل",
		},
		{
			occupationCode: null,
			occupationDescription: "لحام معادن",
		},
		{
			occupationCode: "502",
			occupationDescription: "لحام معادن",
		},
		{
			occupationCode: "501",
			occupationDescription: "لحام نحاس",
		},
		{
			occupationCode: "1871",
			occupationDescription: "مأذون شرعي",
		},
		{
			occupationCode: "1965",
			occupationDescription: "مأمور حركة سير القطارات",
		},
		{
			occupationCode: "1923",
			occupationDescription: "مأمور سنترال",
		},
		{
			occupationCode: "2195",
			occupationDescription: "مؤذن",
		},
		{
			occupationCode: "1331",
			occupationDescription: "مؤرخ",
		},
		{
			occupationCode: "263302",
			occupationDescription: "مؤرخ",
		},
		{
			occupationCode: "228",
			occupationDescription: "مؤلف",
		},
		{
			occupationCode: "264101",
			occupationDescription: "مؤلف",
		},
		{
			occupationCode: "1494",
			occupationDescription: "مؤلف موسيقى",
		},
		{
			occupationCode: "107",
			occupationDescription: "ماجستير",
		},
		{
			occupationCode: "1928",
			occupationDescription: "ماسك دفاتر عام",
		},
		{
			occupationCode: "321",
			occupationDescription: "مباشر",
		},
		{
			occupationCode: "2238",
			occupationDescription: "مباشر منزلي",
		},
		{
			occupationCode: "958",
			occupationDescription: "مبرمج كمبيوتر",
		},
		{
			occupationCode: "205",
			occupationDescription: "مبرمج كمبيوتر",
		},
		{
			occupationCode: "960",
			occupationDescription: "مبرمج نظم بنك المعلومات",
		},
		{
			occupationCode: null,
			occupationDescription: "مبلط",
		},
		{
			occupationCode: null,
			occupationDescription: "مبلط",
		},
		{
			occupationCode: "533",
			occupationDescription: "مبلط",
		},
		{
			occupationCode: "3541",
			occupationDescription: "مبلط الرخام",
		},
		{
			occupationCode: "3549",
			occupationDescription: "مبلط طرق",
		},
		{
			occupationCode: "1872",
			occupationDescription: "مبلغ حكم",
		},
		{
			occupationCode: "2829",
			occupationDescription: "مبيض أرز",
		},
		{
			occupationCode: "2439",
			occupationDescription: "مبيض منسوجات",
		},
		{
			occupationCode: "614",
			occupationDescription: "متدرب",
		},
		{
			occupationCode: "262",
			occupationDescription: "مترجم",
		},
		{
			occupationCode: "264301",
			occupationDescription: "مترجم",
		},
		{
			occupationCode: "1449",
			occupationDescription: "مترجم فوري",
		},
		{
			occupationCode: "264302",
			occupationDescription: "مترجم فوري",
		},
		{
			occupationCode: "1851",
			occupationDescription: "متعامل بالقطع الاجنبية",
		},
		{
			occupationCode: "7",
			occupationDescription: "متقاعد",
		},
		{
			occupationCode: "2012",
			occupationDescription: "مثمـن",
		},
		{
			occupationCode: "1753",
			occupationDescription: "مجبر سلسلة فقارية",
		},
		{
			occupationCode: null,
			occupationDescription: "مجفف خميرة الخبز",
		},
		{
			occupationCode: "2865",
			occupationDescription: "مجفف خميرة الخبز",
		},
		{
			occupationCode: null,
			occupationDescription: "مجفف مواد غذائية",
		},
		{
			occupationCode: "2875",
			occupationDescription: "مجفف مواد غذائية",
		},
		{
			occupationCode: "2993",
			occupationDescription: "مجلخ",
		},
		{
			occupationCode: "2994",
			occupationDescription: "مجلخ أدوات قطع",
		},
		{
			occupationCode: "3248",
			occupationDescription: "مجلخ رأس المحرك",
		},
		{
			occupationCode: "2992",
			occupationDescription: "مجلخ عام",
		},
		{
			occupationCode: "3247",
			occupationDescription: "مجلخ عمود المرفق",
		},
		{
			occupationCode: "2551",
			occupationDescription: "مجلد كتب عام",
		},
		{
			occupationCode: "2554",
			occupationDescription: "مجلد كتب يدوي",
		},
		{
			occupationCode: null,
			occupationDescription: "مجمد مواد غذائية",
		},
		{
			occupationCode: "2874",
			occupationDescription: "مجمد مواد غذائية",
		},
		{
			occupationCode: "2642",
			occupationDescription: "مجهز أفران الصهر",
		},
		{
			occupationCode: "2443",
			occupationDescription: "مجهز الاصباغ",
		},
		{
			occupationCode: "2747",
			occupationDescription: "مجهز خلطات الزجاج",
		},
		{
			occupationCode: "2715",
			occupationDescription: "مجهز خلطات للدائن",
		},
		{
			occupationCode: "2746",
			occupationDescription: "مجهز خلطات مستحضرات تجميل",
		},
		{
			occupationCode: "2663",
			occupationDescription: "مجهز منصة حفر الآبار",
		},
		{
			occupationCode: "2399",
			occupationDescription: "مجهز نعال",
		},
		{
			occupationCode: "208",
			occupationDescription: "محاسب",
		},
		{
			occupationCode: "241101",
			occupationDescription: "محاسب",
		},
		{
			occupationCode: "1553",
			occupationDescription: "محاسب تكاليف",
		},
		{
			occupationCode: "1552",
			occupationDescription: "محاسب عام",
		},
		{
			occupationCode: "225",
			occupationDescription: "محاضر",
		},
		{
			occupationCode: "231026",
			occupationDescription: "محاضر",
		},
		{
			occupationCode: "1419",
			occupationDescription: "محاضر سجلا ت طبية",
		},
		{
			occupationCode: null,
			occupationDescription: "محافظ",
		},
		{
			occupationCode: "660",
			occupationDescription: "محافظ",
		},
		{
			occupationCode: "210",
			occupationDescription: "محامي",
		},
		{
			occupationCode: "261101",
			occupationDescription: "محامي",
		},
		{
			occupationCode: "231",
			occupationDescription: "محرر",
		},
		{
			occupationCode: "1474",
			occupationDescription: "محرر أعلانات",
		},
		{
			occupationCode: "1477",
			occupationDescription: "محرر دعاية نشر",
		},
		{
			occupationCode: "1467",
			occupationDescription: "محرر صحفي",
		},
		{
			occupationCode: "1962",
			occupationDescription: "محصل ( جابي)",
		},
		{
			occupationCode: "421402",
			occupationDescription: "محصل ( جابي)",
		},
		{
			occupationCode: "303",
			occupationDescription: "محصل تذاكر",
		},
		{
			occupationCode: "1972",
			occupationDescription: "محصل حافلة",
		},
		{
			occupationCode: "1939",
			occupationDescription: "محصل ديون",
		},
		{
			occupationCode: "304",
			occupationDescription: "محصل نقود",
		},
		{
			occupationCode: "2144",
			occupationDescription: "محضر سلطات",
		},
		{
			occupationCode: null,
			occupationDescription: "محضر عصير مشروبات",
		},
		{
			occupationCode: "2884",
			occupationDescription: "محضر عصير مشروبات",
		},
		{
			occupationCode: "2373",
			occupationDescription: "محضر محلول الدباغة",
		},
		{
			occupationCode: "2711",
			occupationDescription: "محضر مواد تجميل ومعاجين أسن",
		},
		{
			occupationCode: "203",
			occupationDescription: "محلل أنظمة",
		},
		{
			occupationCode: "1530",
			occupationDescription: "محلل ائتمان",
		},
		{
			occupationCode: "1528",
			occupationDescription: "محلل اقتصادي",
		},
		{
			occupationCode: "1526",
			occupationDescription: "محلل سياسي",
		},
		{
			occupationCode: "202",
			occupationDescription: "محلل عمليات",
		},
		{
			occupationCode: "277",
			occupationDescription: "محلل مالي",
		},
		{
			occupationCode: "204",
			occupationDescription: "محلل مشاريع",
		},
		{
			occupationCode: "1407",
			occupationDescription: "محلل مهني",
		},
		{
			occupationCode: "956",
			occupationDescription: "محلل نظم عام",
		},
		{
			occupationCode: "2833",
			occupationDescription: "محمص وطحان بن",
		},
		{
			occupationCode: "2569",
			occupationDescription: "محمض أفلام فوتوغرافية",
		},
		{
			occupationCode: "2374",
			occupationDescription: "محمض جلود",
		},
		{
			occupationCode: "2201",
			occupationDescription: "محنط جثث",
		},
		{
			occupationCode: "2212",
			occupationDescription: "مخبر",
		},
		{
			occupationCode: "335502",
			occupationDescription: "مخبر",
		},
		{
			occupationCode: "1894",
			occupationDescription: "مختزل وطابع آلة كاتبة او  عام",
		},
		{
			occupationCode: "1503",
			occupationDescription: "مخرج أذاعي وتلفازي",
		},
		{
			occupationCode: "265406",
			occupationDescription: "مخرج أذاعي وتلفازي",
		},
		{
			occupationCode: "1468",
			occupationDescription: "مخرج صحفي",
		},
		{
			occupationCode: "2461",
			occupationDescription: "مخرم ورق الجاكارد",
		},
		{
			occupationCode: "1531",
			occupationDescription: "مخطط عروض",
		},
		{
			occupationCode: "291",
			occupationDescription: "مدخل بيانات",
		},
		{
			occupationCode: "248",
			occupationDescription: "مدرب",
		},
		{
			occupationCode: "1286",
			occupationDescription: "مدرب اختصاصي اشعة",
		},
		{
			occupationCode: "252",
			occupationDescription: "مدرب تنس",
		},
		{
			occupationCode: "1421",
			occupationDescription: "مدرب جمركي",
		},
		{
			occupationCode: "962",
			occupationDescription: "مدرب حاسب آلي",
		},
		{
			occupationCode: "253",
			occupationDescription: "مدرب حرف",
		},
		{
			occupationCode: "1326",
			occupationDescription: "مدرب دراسات اجتماعية وسكانية",
		},
		{
			occupationCode: "247",
			occupationDescription: "مدرب رياضي",
		},
		{
			occupationCode: "251",
			occupationDescription: "مدرب سباحة",
		},
		{
			occupationCode: "249",
			occupationDescription: "مدرب سلة",
		},
		{
			occupationCode: "2316",
			occupationDescription: "مدرب صقور الصيد",
		},
		{
			occupationCode: "254",
			occupationDescription: "مدرب صناعي",
		},
		{
			occupationCode: "1309",
			occupationDescription: "مدرب صيدلة",
		},
		{
			occupationCode: "250",
			occupationDescription: "مدرب طائرة",
		},
		{
			occupationCode: "1214",
			occupationDescription: "مدرب طب عام",
		},
		{
			occupationCode: "106",
			occupationDescription: "مدرب طيران",
		},
		{
			occupationCode: "587",
			occupationDescription: "مدرب عسكري",
		},
		{
			occupationCode: null,
			occupationDescription: "مدرب علوم كيمياء حيوية",
		},
		{
			occupationCode: "905",
			occupationDescription: "مدرب علوم كيمياء حيوية",
		},
		{
			occupationCode: "1306",
			occupationDescription: "مدرب علوم مخبرية",
		},
		{
			occupationCode: "1766",
			occupationDescription: "مدرب فني اشعة",
		},
		{
			occupationCode: "1804",
			occupationDescription: "مدرب فني صيدلة",
		},
		{
			occupationCode: "1075",
			occupationDescription: "مدرب فني مختبرات",
		},
		{
			occupationCode: "1828",
			occupationDescription: "مدرب قيادة سيارات",
		},
		{
			occupationCode: "245",
			occupationDescription: "مدرب كرة قدم",
		},
		{
			occupationCode: "244",
			occupationDescription: "مدرب كرة يد",
		},
		{
			occupationCode: "2317",
			occupationDescription: "مدرب كلاب الصيد",
		},
		{
			occupationCode: "1512",
			occupationDescription: "مدرب لياقة بدنية",
		},
		{
			occupationCode: "1829",
			occupationDescription: "مدرب مبيعات الذهب والمجوهرات",
		},
		{
			occupationCode: "588",
			occupationDescription: "مدرب معدات عسكرية",
		},
		{
			occupationCode: "1827",
			occupationDescription: "مدرب مهني بريدي",
		},
		{
			occupationCode: "1824",
			occupationDescription: "مدرب مهني تجاري",
		},
		{
			occupationCode: "1826",
			occupationDescription: "مدرب مهني تمريض",
		},
		{
			occupationCode: "1823",
			occupationDescription: "مدرب مهني زراعي",
		},
		{
			occupationCode: "1822",
			occupationDescription: "مدرب مهني صناعي",
		},
		{
			occupationCode: "1825",
			occupationDescription: "مدرب مهني فندقي",
		},
		{
			occupationCode: "221",
			occupationDescription: "مدرس",
		},
		{
			occupationCode: "1395",
			occupationDescription: "مدرس أحياء",
		},
		{
			occupationCode: "1406",
			occupationDescription: "مدرس أنظمة تموين بحرية",
		},
		{
			occupationCode: "216",
			occupationDescription: "مدرس اجتماعيات",
		},
		{
			occupationCode: "1416",
			occupationDescription: "مدرس ادارة أعمال",
		},
		{
			occupationCode: "1405",
			occupationDescription: "مدرس تخصصات بحرية",
		},
		{
			occupationCode: "1402",
			occupationDescription: "مدرس تدبير منزلي",
		},
		{
			occupationCode: "223",
			occupationDescription: "مدرس تربية خاصة",
		},
		{
			occupationCode: "1398",
			occupationDescription: "مدرس تربية دينية",
		},
		{
			occupationCode: "1401",
			occupationDescription: "مدرس تربية رياضية",
		},
		{
			occupationCode: "220",
			occupationDescription: "مدرس تربية فنية",
		},
		{
			occupationCode: "212",
			occupationDescription: "مدرس تمريض",
		},
		{
			occupationCode: "1394",
			occupationDescription: "مدرس جيولوجيا",
		},
		{
			occupationCode: "1403",
			occupationDescription: "مدرس حاسب الي",
		},
		{
			occupationCode: "222",
			occupationDescription: "مدرس حضانة",
		},
		{
			occupationCode: "234202",
			occupationDescription: "مدرس حضانة",
		},
		{
			occupationCode: "2231",
			occupationDescription: "مدرس خاص",
		},
		{
			occupationCode: "214",
			occupationDescription: "مدرس رياضيات",
		},
		{
			occupationCode: "1427",
			occupationDescription: "مدرس صم وبكم",
		},
		{
			occupationCode: "215",
			occupationDescription: "مدرس علوم تجارية",
		},
		{
			occupationCode: "218",
			occupationDescription: "مدرس علوم طبية",
		},
		{
			occupationCode: "213",
			occupationDescription: "مدرس علوم طبيعية",
		},
		{
			occupationCode: "1392",
			occupationDescription: "مدرس كيمياء",
		},
		{
			occupationCode: "1397",
			occupationDescription: "مدرس لغات",
		},
		{
			occupationCode: "217",
			occupationDescription: "مدرس لغة",
		},
		{
			occupationCode: "1428",
			occupationDescription: "مدرس متخلفين عقليا",
		},
		{
			occupationCode: "1426",
			occupationDescription: "مدرس مكفوفين",
		},
		{
			occupationCode: "219",
			occupationDescription: "مدرس مهني",
		},
		{
			occupationCode: "1414",
			occupationDescription: "مدرس مهني بريدي",
		},
		{
			occupationCode: "1411",
			occupationDescription: "مدرس مهني تجاري",
		},
		{
			occupationCode: "1413",
			occupationDescription: "مدرس مهني تمريض",
		},
		{
			occupationCode: "1410",
			occupationDescription: "مدرس مهني زراعي",
		},
		{
			occupationCode: "1409",
			occupationDescription: "مدرس مهني صناعي",
		},
		{
			occupationCode: "1412",
			occupationDescription: "مدرس مهني فندقة",
		},
		{
			occupationCode: "1442",
			occupationDescription: "مدعي عام",
		},
		{
			occupationCode: "111105",
			occupationDescription: "مدعي عام",
		},
		{
			occupationCode: "1102",
			occupationDescription: "مدقق داخلي أنظمة جودة",
		},
		{
			occupationCode: "196",
			occupationDescription: "مدلك",
		},
		{
			occupationCode: "808",
			occupationDescription: "مدير آثار",
		},
		{
			occupationCode: "653",
			occupationDescription: "مدير أبحاث ودراسات",
		},
		{
			occupationCode: "647",
			occupationDescription: "مدير أشغال ومرافق عامة",
		},
		{
			occupationCode: "799",
			occupationDescription: "مدير أعمال تأمين",
		},
		{
			occupationCode: "800",
			occupationDescription: "مدير أعمال مصرفية",
		},
		{
			occupationCode: "801",
			occupationDescription: "مدير ائتمان",
		},
		{
			occupationCode: "121112",
			occupationDescription: "مدير ائتمان",
		},
		{
			occupationCode: "270",
			occupationDescription: "مدير اتصالات",
		},
		{
			occupationCode: "133003",
			occupationDescription: "مدير اتصالات",
		},
		{
			occupationCode: null,
			occupationDescription: "مدير اتصالات سلكية ولاسلكية",
		},
		{
			occupationCode: "667",
			occupationDescription: "مدير اتصالات سلكية ولاسلكية",
		},
		{
			occupationCode: "654",
			occupationDescription: "مدير احصاء",
		},
		{
			occupationCode: "811",
			occupationDescription: "مدير ادارة استثمار النقد",
		},
		{
			occupationCode: "812",
			occupationDescription: "مدير ادارة الأسهم",
		},
		{
			occupationCode: "760",
			occupationDescription: "مدير ادارة الأمن والسلامة",
		},
		{
			occupationCode: "813",
			occupationDescription: "مدير ادارة الأنظمة",
		},
		{
			occupationCode: "814",
			occupationDescription: "مدير ادارة التجارة الدولية",
		},
		{
			occupationCode: "815",
			occupationDescription: "مدير ادارة التحصيل والائتمان",
		},
		{
			occupationCode: "816",
			occupationDescription: "مدير ادارة التخطيط الاستراتيجي",
		},
		{
			occupationCode: "819",
			occupationDescription: "مدير ادارة التدفق النقدي",
		},
		{
			occupationCode: "820",
			occupationDescription: "مدير ادارة التطوير الوظيفي",
		},
		{
			occupationCode: "821",
			occupationDescription: "مدير ادارة التقارير المالية",
		},
		{
			occupationCode: "822",
			occupationDescription: "مدير ادارة التمويل",
		},
		{
			occupationCode: "823",
			occupationDescription: "مدير ادارة الخدمات المساندة",
		},
		{
			occupationCode: "824",
			occupationDescription: "مدير ادارة الخطط السنوية",
		},
		{
			occupationCode: "825",
			occupationDescription: "مدير ادارة الدعاية والاعلان",
		},
		{
			occupationCode: "826",
			occupationDescription: "مدير ادارة الزكاة والضرائب",
		},
		{
			occupationCode: "827",
			occupationDescription: "مدير ادارة السفن",
		},
		{
			occupationCode: "856",
			occupationDescription: "مدير ادارة السياسات التجارية",
		},
		{
			occupationCode: "857",
			occupationDescription: "مدير ادارة الشئون القانونية",
		},
		{
			occupationCode: "828",
			occupationDescription: "مدير ادارة الصيانة والاتصالات",
		},
		{
			occupationCode: "829",
			occupationDescription: "مدير ادارة العقود والمناقصات",
		},
		{
			occupationCode: "830",
			occupationDescription: "مدير ادارة العمليات النقدية",
		},
		{
			occupationCode: "844",
			occupationDescription: "مدير ادارة المخاطر",
		},
		{
			occupationCode: "831",
			occupationDescription: "مدير ادارة المراجعة الداخلية",
		},
		{
			occupationCode: "832",
			occupationDescription: "مدير ادارة المنافع",
		},
		{
			occupationCode: "833",
			occupationDescription: "مدير ادارة المواد الخام",
		},
		{
			occupationCode: "810",
			occupationDescription: "مدير ادارة النظم الادارية",
		},
		{
			occupationCode: "835",
			occupationDescription: "مدير ادارة تعويضات الموظفين",
		},
		{
			occupationCode: "743",
			occupationDescription: "مدير ادارة تقارير التشغيل",
		},
		{
			occupationCode: "836",
			occupationDescription: "مدير ادارة خدمات المكاتب",
		},
		{
			occupationCode: "837",
			occupationDescription: "مدير ادارة شحن وتوزيع الشرق",
		},
		{
			occupationCode: "838",
			occupationDescription: "مدير ادارة شحن وتوزيع الغاز",
		},
		{
			occupationCode: "839",
			occupationDescription: "مدير ادارة شحن وتوزيع الغرب",
		},
		{
			occupationCode: "695",
			occupationDescription: "مدير ادارة صحفية",
		},
		{
			occupationCode: "841",
			occupationDescription: "مدير ادارة مدفوعات الموردين",
		},
		{
			occupationCode: "842",
			occupationDescription: "مدير ادارة مدفوعات الموظفين",
		},
		{
			occupationCode: "744",
			occupationDescription: "مدير ادارة مستندات البوليمرات",
		},
		{
			occupationCode: "863",
			occupationDescription: "مدير ادارة مكتب العضو المنتدب",
		},
		{
			occupationCode: "834",
			occupationDescription: "مدير ادارةتخطيط القوى العاملة",
		},
		{
			occupationCode: "273",
			occupationDescription: "مدير اداري",
		},
		{
			occupationCode: "688",
			occupationDescription: "مدير اذاعة",
		},
		{
			occupationCode: null,
			occupationDescription: "مدير استثمار",
		},
		{
			occupationCode: "657",
			occupationDescription: "مدير استثمار",
		},
		{
			occupationCode: "764",
			occupationDescription: "مدير استكشاف حقول الغاز",
		},
		{
			occupationCode: "687",
			occupationDescription: "مدير اعلام",
		},
		{
			occupationCode: "845",
			occupationDescription: "مدير اقليمي لمبيعات البلاستيك",
		},
		{
			occupationCode: "802",
			occupationDescription: "مدير الادارة",
		},
		{
			occupationCode: "859",
			occupationDescription: "مدير الادارة العامة للمراجعة",
		},
		{
			occupationCode: "861",
			occupationDescription: "مدير الادارة العامة للنقد",
		},
		{
			occupationCode: "846",
			occupationDescription: "مدير الادارة لخدمات الزبائن",
		},
		{
			occupationCode: "847",
			occupationDescription: "مدير الادارة للأمن الصناعي",
		},
		{
			occupationCode: "855",
			occupationDescription: "مدير الادارة للخطط والتشغيل",
		},
		{
			occupationCode: "858",
			occupationDescription: "مدير الادارة للفرص الجديدة",
		},
		{
			occupationCode: "862",
			occupationDescription: "مدير الادارة لمحاسبةالمنتجات",
		},
		{
			occupationCode: "763",
			occupationDescription: "مدير الاسكان والمواد",
		},
		{
			occupationCode: "851",
			occupationDescription: "مدير الاعتمادات المستندية",
		},
		{
			occupationCode: "805",
			occupationDescription: "مدير البحوث و التنمية",
		},
		{
			occupationCode: "864",
			occupationDescription: "مدير التخطيط الاستراتيجي",
		},
		{
			occupationCode: "761",
			occupationDescription: "مدير التخطيط المالي والقروض",
		},
		{
			occupationCode: "817",
			occupationDescription: "مدير التخطيط والتنسيق المالي",
		},
		{
			occupationCode: "818",
			occupationDescription: "مدير التدريب والبرامج الخاصة",
		},
		{
			occupationCode: "748",
			occupationDescription: "مدير التشغيل الفني",
		},
		{
			occupationCode: "762",
			occupationDescription: "مدير التطوير للخدمات الادارية",
		},
		{
			occupationCode: "790",
			occupationDescription: "مدير الخدمات الارضية",
		},
		{
			occupationCode: "854",
			occupationDescription: "مدير الخدمات الفنية للمعلومات",
		},
		{
			occupationCode: "804",
			occupationDescription: "مدير الدعاية و العلاقات العامة",
		},
		{
			occupationCode: "868",
			occupationDescription: "مدير المبيعات وخدمات الزبائن",
		},
		{
			occupationCode: "886",
			occupationDescription: "مدير المساندة الفنية للزبائن",
		},
		{
			occupationCode: "860",
			occupationDescription: "مدير المواد الخام والمنافع",
		},
		{
			occupationCode: "271",
			occupationDescription: "مدير انتاج",
		},
		{
			occupationCode: "797",
			occupationDescription: "مدير انتاج أذاعي وتلفازي",
		},
		{
			occupationCode: "796",
			occupationDescription: "مدير انتاج سينمائي",
		},
		{
			occupationCode: "795",
			occupationDescription: "مدير انتاج مسرحي",
		},
		{
			occupationCode: null,
			occupationDescription: "مدير بريد",
		},
		{
			occupationCode: "665",
			occupationDescription: "مدير بريد",
		},
		{
			occupationCode: "771",
			occupationDescription: "مدير بنك",
		},
		{
			occupationCode: "775",
			occupationDescription: "مدير بيت ضيافة",
		},
		{
			occupationCode: "314",
			occupationDescription: "مدير تجاري",
		},
		{
			occupationCode: "696",
			occupationDescription: "مدير تحرير",
		},
		{
			occupationCode: "871",
			occupationDescription: "مدير تحليل تجاري وبحوث",
		},
		{
			occupationCode: null,
			occupationDescription: "مدير تحليل وبحوث تخطيط وتشغيل",
		},
		{
			occupationCode: "872",
			occupationDescription: "مدير تحليل وبحوث تخطيط وتشغيل",
		},
		{
			occupationCode: null,
			occupationDescription: "مدير تخطيط",
		},
		{
			occupationCode: "655",
			occupationDescription: "مدير تخطيط",
		},
		{
			occupationCode: "873",
			occupationDescription: "مدير تخطيط استراتيجي واستثمار",
		},
		{
			occupationCode: "874",
			occupationDescription: "مدير تخطيط التشغيل",
		},
		{
			occupationCode: "875",
			occupationDescription: "مدير تخطيط التشغيل والتقنية",
		},
		{
			occupationCode: "876",
			occupationDescription: "مدير تخطيط العمليات",
		},
		{
			occupationCode: "877",
			occupationDescription: "مدير تخطيط العمليات والتقنية",
		},
		{
			occupationCode: "878",
			occupationDescription: "مدير تخطيط عمليات اليوريا",
		},
		{
			occupationCode: "852",
			occupationDescription: "مدير تخطيط واستثمار الألمنيوم",
		},
		{
			occupationCode: "269",
			occupationDescription: "مدير تدريب",
		},
		{
			occupationCode: "134509",
			occupationDescription: "مدير تدريب",
		},
		{
			occupationCode: "267",
			occupationDescription: "مدير تسويق",
		},
		{
			occupationCode: "122103",
			occupationDescription: "مدير تسويق",
		},
		{
			occupationCode: "879",
			occupationDescription: "مدير تشغيل منتجات بلاستيكية",
		},
		{
			occupationCode: "880",
			occupationDescription: "مدير تشغيل نظام تقويم الوظائف",
		},
		{
			occupationCode: "749",
			occupationDescription: "مدير تشغيل واستثمار الغازات",
		},
		{
			occupationCode: "750",
			occupationDescription: "مدير تشغيل واستثمار النسيج",
		},
		{
			occupationCode: "849",
			occupationDescription: "مدير تشغيل وتسويق الألمنيوم",
		},
		{
			occupationCode: "853",
			occupationDescription: "مدير تشغيل ومساندة المعلومات",
		},
		{
			occupationCode: "798",
			occupationDescription: "مدير تصوير سينمائي",
		},
		{
			occupationCode: "848",
			occupationDescription: "مدير تطبيقات تقنية المعلومات",
		},
		{
			occupationCode: "751",
			occupationDescription: "مدير تطوير الأعمال للغازات",
		},
		{
			occupationCode: "756",
			occupationDescription: "مدير تقنيات البولي اوليفينات",
		},
		{
			occupationCode: "689",
			occupationDescription: "مدير تليفزيون",
		},
		{
			occupationCode: "881",
			occupationDescription: "مدير تنسيق التعاون الدولي",
		},
		{
			occupationCode: "809",
			occupationDescription: "مدير تنفيذي",
		},
		{
			occupationCode: "882",
			occupationDescription: "مدير تنمية السوق الداخلي",
		},
		{
			occupationCode: "787",
			occupationDescription: "مدير توثيق سلامة الرحلات",
		},
		{
			occupationCode: "681",
			occupationDescription: "مدير جامعة",
		},
		{
			occupationCode: "697",
			occupationDescription: "مدير جمعيه",
		},
		{
			occupationCode: "806",
			occupationDescription: "مدير حسابات وميزانية",
		},
		{
			occupationCode: "757",
			occupationDescription: "مدير حفازات البولي اوليفينات",
		},
		{
			occupationCode: "786",
			occupationDescription: "مدير خدمات الرحلات",
		},
		{
			occupationCode: "791",
			occupationDescription: "مدير خدمات الشحن",
		},
		{
			occupationCode: "772",
			occupationDescription: "مدير خدمات عملاء",
		},
		{
			occupationCode: "883",
			occupationDescription: "مدير خدمات فنية ومنسق التقنية",
		},
		{
			occupationCode: "698",
			occupationDescription: "مدير دار رعاية اجتماعية",
		},
		{
			occupationCode: "646",
			occupationDescription: "مدير رعاية شباب ورياضة",
		},
		{
			occupationCode: null,
			occupationDescription: "مدير سكة حديد",
		},
		{
			occupationCode: "662",
			occupationDescription: "مدير سكة حديد",
		},
		{
			occupationCode: "641",
			occupationDescription: "مدير شئون اجتماعية",
		},
		{
			occupationCode: "649",
			occupationDescription: "مدير شئون اقتصادية وتجارية",
		},
		{
			occupationCode: "884",
			occupationDescription: "مدير شئون المكاتب الاقليمية",
		},
		{
			occupationCode: "648",
			occupationDescription: "مدير شئون بلدية وقروية",
		},
		{
			occupationCode: "639",
			occupationDescription: "مدير شئون تعليمية",
		},
		{
			occupationCode: "643",
			occupationDescription: "مدير شئون ثقافة واعلام",
		},
		{
			occupationCode: "652",
			occupationDescription: "مدير شئون دينية",
		},
		{
			occupationCode: "644",
			occupationDescription: "مدير شئون زراعة وري",
		},
		{
			occupationCode: "640",
			occupationDescription: "مدير شئون صحية",
		},
		{
			occupationCode: "645",
			occupationDescription: "مدير شئون صناعية",
		},
		{
			occupationCode: "642",
			occupationDescription: "مدير شئون عمل وعمال",
		},
		{
			occupationCode: "651",
			occupationDescription: "مدير شئون قضائية",
		},
		{
			occupationCode: "650",
			occupationDescription: "مدير شئون مالية ومحاسبية",
		},
		{
			occupationCode: "634",
			occupationDescription: "مدير شئون موظفين",
		},
		{
			occupationCode: "793",
			occupationDescription: "مدير شبكات الطيران",
		},
		{
			occupationCode: "866",
			occupationDescription: "مدير شحن منطقة أوربا وأمريكا",
		},
		{
			occupationCode: "867",
			occupationDescription: "مدير شحن منطقة جنوب شرق آسيا",
		},
		{
			occupationCode: "742",
			occupationDescription: "مدير صيانة",
		},
		{
			occupationCode: "694",
			occupationDescription: "مدير طباعة و نشر",
		},
		{
			occupationCode: "266",
			occupationDescription: "مدير عام",
		},
		{
			occupationCode: "803",
			occupationDescription: "مدير علاقات الافراد",
		},
		{
			occupationCode: "850",
			occupationDescription: "مدير علاقات القطاع الخاص",
		},
		{
			occupationCode: "636",
			occupationDescription: "مدير علاقات صناعية",
		},
		{
			occupationCode: "635",
			occupationDescription: "مدير علاقات عامة",
		},
		{
			occupationCode: "122203",
			occupationDescription: "مدير علاقات عامة",
		},
		{
			occupationCode: "740",
			occupationDescription: "مدير عمليات تشغيل",
		},
		{
			occupationCode: "699",
			occupationDescription: "مدير غرفة تجارية صناعية",
		},
		{
			occupationCode: "323",
			occupationDescription: "مدير فندق",
		},
		{
			occupationCode: "769",
			occupationDescription: "مدير في تجارة التجزئة",
		},
		{
			occupationCode: "752",
			occupationDescription: "مدير قسم البولي استر",
		},
		{
			occupationCode: "753",
			occupationDescription: "مدير قسم البي.في.سي",
		},
		{
			occupationCode: "885",
			occupationDescription: "مدير قسم التراخيص",
		},
		{
			occupationCode: "754",
			occupationDescription: "مدير قسم المصانع التجريبية",
		},
		{
			occupationCode: "755",
			occupationDescription: "مدير قسم تقنيات الأسمدة",
		},
		{
			occupationCode: "758",
			occupationDescription: "مدير قسم مختبر التصنيع",
		},
		{
			occupationCode: "759",
			occupationDescription: "مدير قسم مختبر خواص فيزيائية",
		},
		{
			occupationCode: null,
			occupationDescription: "مدير كهرباء",
		},
		{
			occupationCode: "669",
			occupationDescription: "مدير كهرباء",
		},
		{
			occupationCode: "272",
			occupationDescription: "مدير مبيعات",
		},
		{
			occupationCode: "122104",
			occupationDescription: "مدير مبيعات",
		},
		{
			occupationCode: null,
			occupationDescription: "مدير متابعة",
		},
		{
			occupationCode: "658",
			occupationDescription: "مدير متابعة",
		},
		{
			occupationCode: "691",
			occupationDescription: "مدير متحف",
		},
		{
			occupationCode: "784",
			occupationDescription: "مدير محطة طيران",
		},
		{
			occupationCode: "777",
			occupationDescription: "مدير محل تناول الوجبات السريعة",
		},
		{
			occupationCode: "782",
			occupationDescription: "مدير مخازن (مستودعات )",
		},
		{
			occupationCode: "142002",
			occupationDescription: "مدير مخازن (مستودعات )",
		},
		{
			occupationCode: "679",
			occupationDescription: "مدير مختبر تحليلات",
		},
		{
			occupationCode: "683",
			occupationDescription: "مدير مدرسة",
		},
		{
			occupationCode: "676",
			occupationDescription: "مدير مدينة صناعية",
		},
		{
			occupationCode: "686",
			occupationDescription: "مدير مركز تدريب",
		},
		{
			occupationCode: "732",
			occupationDescription: "مدير مزرعة",
		},
		{
			occupationCode: "738",
			occupationDescription: "مدير مزرعة بحرية",
		},
		{
			occupationCode: "733",
			occupationDescription: "مدير مزرعة تربية حيوان",
		},
		{
			occupationCode: "734",
			occupationDescription: "مدير مزرعة دواجن",
		},
		{
			occupationCode: "843",
			occupationDescription: "مدير مساندة تقنية المعلومات",
		},
		{
			occupationCode: "677",
			occupationDescription: "مدير مستشفى",
		},
		{
			occupationCode: "680",
			occupationDescription: "مدير مستشفى بيطري",
		},
		{
			occupationCode: "745",
			occupationDescription: "مدير مستندات كيماويات وأسمدة",
		},
		{
			occupationCode: "678",
			occupationDescription: "مدير مستوصف",
		},
		{
			occupationCode: "690",
			occupationDescription: "مدير مسرح",
		},
		{
			occupationCode: null,
			occupationDescription: "مدير مشاريع",
		},
		{
			occupationCode: "656",
			occupationDescription: "مدير مشاريع",
		},
		{
			occupationCode: "768",
			occupationDescription: "مدير مشتريات",
		},
		{
			occupationCode: "268",
			occupationDescription: "مدير مشروع",
		},
		{
			occupationCode: "794",
			occupationDescription: "مدير مشروع لخدمات الأعمال",
		},
		{
			occupationCode: "781",
			occupationDescription: "مدير مشروع نقل",
		},
		{
			occupationCode: "739",
			occupationDescription: "مدير مصنع",
		},
		{
			occupationCode: "132103",
			occupationDescription: "مدير مصنع",
		},
		{
			occupationCode: null,
			occupationDescription: "مدير مطار",
		},
		{
			occupationCode: "664",
			occupationDescription: "مدير مطار",
		},
		{
			occupationCode: "324",
			occupationDescription: "مدير مطعم",
		},
		{
			occupationCode: "774",
			occupationDescription: "مدير مطعم ومقهى",
		},
		{
			occupationCode: "870",
			occupationDescription: "مدير معلومات تجارية وبحوث",
		},
		{
			occupationCode: "869",
			occupationDescription: "مدير معلومات وأبحاث تسويقية",
		},
		{
			occupationCode: "2176",
			occupationDescription: "مدير مغسله",
		},
		{
			occupationCode: "737",
			occupationDescription: "مدير مفارخ الأسماك",
		},
		{
			occupationCode: "692",
			occupationDescription: "مدير مكتبة",
		},
		{
			occupationCode: "747",
			occupationDescription: "مدير مناولة المنتجات الصلبة",
		},
		{
			occupationCode: "746",
			occupationDescription: "مدير مناولة المواد السائلة",
		},
		{
			occupationCode: "735",
			occupationDescription: "مدير منحل",
		},
		{
			occupationCode: "2234",
			occupationDescription: "مدير منزل",
		},
		{
			occupationCode: "911101",
			occupationDescription: "مدير منزل",
		},
		{
			occupationCode: "779",
			occupationDescription: "مدير موقع تغذية",
		},
		{
			occupationCode: null,
			occupationDescription: "مدير مياه وصرف صحي",
		},
		{
			occupationCode: "668",
			occupationDescription: "مدير مياه وصرف صحي",
		},
		{
			occupationCode: null,
			occupationDescription: "مدير ميناء",
		},
		{
			occupationCode: "663",
			occupationDescription: "مدير ميناء",
		},
		{
			occupationCode: "693",
			occupationDescription: "مدير نادي",
		},
		{
			occupationCode: "789",
			occupationDescription: "مدير نظام مغادرة الركاب",
		},
		{
			occupationCode: null,
			occupationDescription: "مدير نقل بحري",
		},
		{
			occupationCode: "671",
			occupationDescription: "مدير نقل بحري",
		},
		{
			occupationCode: null,
			occupationDescription: "مدير نقل بري",
		},
		{
			occupationCode: "670",
			occupationDescription: "مدير نقل بري",
		},
		{
			occupationCode: null,
			occupationDescription: "مدير نقل جوي",
		},
		{
			occupationCode: "672",
			occupationDescription: "مدير نقل جوي",
		},
		{
			occupationCode: null,
			occupationDescription: "مدير هاتف",
		},
		{
			occupationCode: "666",
			occupationDescription: "مدير هاتف",
		},
		{
			occupationCode: "685",
			occupationDescription: "مدير ورش تدريب صناعي",
		},
		{
			occupationCode: "807",
			occupationDescription: "مدير وكالة سياحة",
		},
		{
			occupationCode: "243",
			occupationDescription: "مذيع",
		},
		{
			occupationCode: "1473",
			occupationDescription: "مذيع بالاذاعة والتلفاز",
		},
		{
			occupationCode: "209",
			occupationDescription: "مراجع حسابات",
		},
		{
			occupationCode: "1544",
			occupationDescription: "مراجع داخلي",
		},
		{
			occupationCode: "1460",
			occupationDescription: "مراجع كتب",
		},
		{
			occupationCode: "230",
			occupationDescription: "مراسل",
		},
		{
			occupationCode: "1479",
			occupationDescription: "مراسل أذاعي وتلفزيوني",
		},
		{
			occupationCode: "1471",
			occupationDescription: "مراسل صحفي",
		},
		{
			occupationCode: "337",
			occupationDescription: "مرافق",
		},
		{
			occupationCode: "1470",
			occupationDescription: "مراقب أخبار",
		},
		{
			occupationCode: "2614",
			occupationDescription: "مراقب أنتاج أسمنت",
		},
		{
			occupationCode: "2741",
			occupationDescription: "مراقب أنتاج صناعة البلاستيك",
		},
		{
			occupationCode: "3003",
			occupationDescription: "مراقب أنتاج في أعمال الخراط",
		},
		{
			occupationCode: "3386",
			occupationDescription: "مراقب أنتاج في صناعة الكهرب",
		},
		{
			occupationCode: "2739",
			occupationDescription: "مراقب أنتاج في صناعة المطاط",
		},
		{
			occupationCode: "2362",
			occupationDescription: "مراقب أنتاج في صناعة الورق",
		},
		{
			occupationCode: "3604",
			occupationDescription: "مراقب أنتاج هاتف ومبرقات",
		},
		{
			occupationCode: "1741",
			occupationDescription: "مراقب اقلاع طائرات",
		},
		{
			occupationCode: "294",
			occupationDescription: "مراقب انابيب",
		},
		{
			occupationCode: "3603",
			occupationDescription: "مراقب انتاج وأصلاح الكتروني",
		},
		{
			occupationCode: "1744",
			occupationDescription: "مراقب بحري",
		},
		{
			occupationCode: "3046",
			occupationDescription: "مراقب براده",
		},
		{
			occupationCode: "2670",
			occupationDescription: "مراقب بناء وأجهزة حفر",
		},
		{
			occupationCode: "2674",
			occupationDescription: "مراقب تشغيل برج الحفر",
		},
		{
			occupationCode: "3290",
			occupationDescription: "مراقب تشغيل توربين بخاري",
		},
		{
			occupationCode: "3303",
			occupationDescription: "مراقب تشغيل توربين مائي",
		},
		{
			occupationCode: "2675",
			occupationDescription: "مراقب تشغيل معدات الحفر",
		},
		{
			occupationCode: "3277",
			occupationDescription: "مراقب تصليح السفن",
		},
		{
			occupationCode: "388",
			occupationDescription: "مراقب تكرير النفط",
		},
		{
			occupationCode: "301",
			occupationDescription: "مراقب جوي",
		},
		{
			occupationCode: "1905",
			occupationDescription: "مراقب حركة المخزون",
		},
		{
			occupationCode: "1967",
			occupationDescription: "مراقب حركة جوية",
		},
		{
			occupationCode: "1745",
			occupationDescription: "مراقب حركة سفن",
		},
		{
			occupationCode: "1960",
			occupationDescription: "مراقب حركة سيارات",
		},
		{
			occupationCode: "3550",
			occupationDescription: "مراقب خلطات أسفلتيه",
		},
		{
			occupationCode: "3495",
			occupationDescription: "مراقب خلطات خرسانية",
		},
		{
			occupationCode: "2651",
			occupationDescription: "مراقب سباكة المعادن",
		},
		{
			occupationCode: "3553",
			occupationDescription: "مراقب شواخص مروريه",
		},
		{
			occupationCode: "121",
			occupationDescription: "مراقب صحي",
		},
		{
			occupationCode: "3575",
			occupationDescription: "مراقب صناعة ادوات منزلية",
		},
		{
			occupationCode: "2773",
			occupationDescription: "مراقب صناعة الياف صناعية",
		},
		{
			occupationCode: "1769",
			occupationDescription: "مراقب طبي",
		},
		{
			occupationCode: "366",
			occupationDescription: "مراقب عام",
		},
		{
			occupationCode: "2672",
			occupationDescription: "مراقب على اختبار الابار",
		},
		{
			occupationCode: "2649",
			occupationDescription: "مراقب على استخراج الحديد",
		},
		{
			occupationCode: "2673",
			occupationDescription: "مراقب على حفر آبار المياه",
		},
		{
			occupationCode: "2650",
			occupationDescription: "مراقب على درفلة المعادن",
		},
		{
			occupationCode: "3034",
			occupationDescription: "مراقب على صناعة الماكينات",
		},
		{
			occupationCode: "3385",
			occupationDescription: "مراقب عمل توصيلات كهربائية",
		},
		{
			occupationCode: "2271",
			occupationDescription: "مراقب غابات",
		},
		{
			occupationCode: "2843",
			occupationDescription: "مراقب فرن خبز آلي",
		},
		{
			occupationCode: "2634",
			occupationDescription: "مراقب في المحاجر",
		},
		{
			occupationCode: "312102",
			occupationDescription: "مراقب في المحاجر",
		},
		{
			occupationCode: "3490",
			occupationDescription: "مراقب قوالب خرسانيه",
		},
		{
			occupationCode: "2684",
			occupationDescription: "مراقب لوحات تحكم مصاف",
		},
		{
			occupationCode: "2678",
			occupationDescription: "مراقب لوحة تحكم /تكرير البترول",
		},
		{
			occupationCode: "2696",
			occupationDescription: "مراقب لوحة تحكم تنقيةالمياه",
		},
		{
			occupationCode: "1539",
			occupationDescription: "مراقب مالي",
		},
		{
			occupationCode: "390",
			occupationDescription: "مراقب مصنع",
		},
		{
			occupationCode: "1742",
			occupationDescription: "مراقب هبوط طائرات",
		},
		{
			occupationCode: "2671",
			occupationDescription: "مراقب ومشرف حقول النفط",
		},
		{
			occupationCode: "2275",
			occupationDescription: "مربى أبقار",
		},
		{
			occupationCode: "2274",
			occupationDescription: "مربى مواشي عام",
		},
		{
			occupationCode: "2278",
			occupationDescription: "مربي أرانب",
		},
		{
			occupationCode: "2305",
			occupationDescription: "مربي أسماك زينه",
		},
		{
			occupationCode: "2304",
			occupationDescription: "مربي أسماك عام",
		},
		{
			occupationCode: "338",
			occupationDescription: "مربي أطفال",
		},
		{
			occupationCode: "2277",
			occupationDescription: "مربي أغنام",
		},
		{
			occupationCode: "2276",
			occupationDescription: "مربي جمال",
		},
		{
			occupationCode: "612106",
			occupationDescription: "مربي جمال",
		},
		{
			occupationCode: "2279",
			occupationDescription: "مربي خيول",
		},
		{
			occupationCode: "2295",
			occupationDescription: "مربي دجاج البيض",
		},
		{
			occupationCode: "2296",
			occupationDescription: "مربي دجاج لاحم",
		},
		{
			occupationCode: "2294",
			occupationDescription: "مربي دواجن عام",
		},
		{
			occupationCode: "2303",
			occupationDescription: "مربي دودة القز",
		},
		{
			occupationCode: "2297",
			occupationDescription: "مربي طيور الزينة",
		},
		{
			occupationCode: "2309",
			occupationDescription: "مربي قشريات",
		},
		{
			occupationCode: "2308",
			occupationDescription: "مربي محار",
		},
		{
			occupationCode: "2307",
			occupationDescription: "مربي محار وقشريات عام",
		},
		{
			occupationCode: "2302",
			occupationDescription: "مربي نحل",
		},
		{
			occupationCode: "2188",
			occupationDescription: "مربية",
		},
		{
			occupationCode: "1812",
			occupationDescription: "مربية أطفال ( معلمة )",
		},
		{
			occupationCode: "2540",
			occupationDescription: "مرتب صفحات",
		},
		{
			occupationCode: null,
			occupationDescription: "مرشح خميرة الخبز",
		},
		{
			occupationCode: "2867",
			occupationDescription: "مرشح خميرة الخبز",
		},
		{
			occupationCode: "227",
			occupationDescription: "مرشد",
		},
		{
			occupationCode: "226",
			occupationDescription: "مرشد ديني",
		},
		{
			occupationCode: "1462",
			occupationDescription: "مرشد زائرين",
		},
		{
			occupationCode: "1128",
			occupationDescription: "مرشد سفن",
		},
		{
			occupationCode: "348",
			occupationDescription: "مرشد سياحي",
		},
		{
			occupationCode: "1463",
			occupationDescription: "مرشد سياحي بحري",
		},
		{
			occupationCode: "1586",
			occupationDescription: "مرشد صحة",
		},
		{
			occupationCode: "1327",
			occupationDescription: "مرشد طلابي",
		},
		{
			occupationCode: "1408",
			occupationDescription: "مرشد مهني",
		},
		{
			occupationCode: "114",
			occupationDescription: "مركب أدوية",
		},
		{
			occupationCode: "3480",
			occupationDescription: "مركب أرضيات لدائنية",
		},
		{
			occupationCode: "3472",
			occupationDescription: "مركب أطر لوحات",
		},
		{
			occupationCode: null,
			occupationDescription: "مركب الفسيفساء",
		},
		{
			occupationCode: "3509",
			occupationDescription: "مركب الفسيفساء",
		},
		{
			occupationCode: "3060",
			occupationDescription: "مركب انشاءات معدنية",
		},
		{
			occupationCode: "3059",
			occupationDescription: "مركب انشاءات معدنية عام",
		},
		{
			occupationCode: "3177",
			occupationDescription: "مركب تمديدات صحية منزلية",
		},
		{
			occupationCode: "3392",
			occupationDescription: "مركب خطوط المشتركين",
		},
		{
			occupationCode: "2629",
			occupationDescription: "مركب دعائم أنفاق",
		},
		{
			occupationCode: "3471",
			occupationDescription: "مركب زجاج",
		},
		{
			occupationCode: "3256",
			occupationDescription: "مركب زجاج مركبات",
		},
		{
			occupationCode: "3477",
			occupationDescription: "مركب ستائر",
		},
		{
			occupationCode: "3478",
			occupationDescription: "مركب سجاد وموكيت",
		},
		{
			occupationCode: "3476",
			occupationDescription: "مركب سقوف اصطناعية",
		},
		{
			occupationCode: "3558",
			occupationDescription: "مركب سكك حديدية",
		},
		{
			occupationCode: "3557",
			occupationDescription: "مركب سكك حديدية عام",
		},
		{
			occupationCode: "3390",
			occupationDescription: "مركب شبكات هاتف أرضية",
		},
		{
			occupationCode: "3388",
			occupationDescription: "مركب شبكات هاتف عام",
		},
		{
			occupationCode: "3389",
			occupationDescription: "مركب شبكات هاتف هوائي",
		},
		{
			occupationCode: "3554",
			occupationDescription: "مركب شواخص",
		},
		{
			occupationCode: "3560",
			occupationDescription: "مركب عوارض سكك حديدية",
		},
		{
			occupationCode: "3492",
			occupationDescription: "مركب قوالب خرسانيه معدنيه",
		},
		{
			occupationCode: "3394",
			occupationDescription: "مركب مقاسم ألكترونية",
		},
		{
			occupationCode: "3393",
			occupationDescription: "مركب مقاسم ألكترونية عام",
		},
		{
			occupationCode: "2400",
			occupationDescription: "مركب نعال",
		},
		{
			occupationCode: "3397",
			occupationDescription: "مركب هوائي اتصالات عام",
		},
		{
			occupationCode: "3399",
			occupationDescription: "مركب هوائي تلفزيوني",
		},
		{
			occupationCode: "3398",
			occupationDescription: "مركب هوائي رئيسي ( مركزي )",
		},
		{
			occupationCode: "3501",
			occupationDescription: "مركب هياكل خرسانية",
		},
		{
			occupationCode: "3479",
			occupationDescription: "مركب ورق جدران",
		},
		{
			occupationCode: "1487",
			occupationDescription: "مرمم لوحات فنية",
		},
		{
			occupationCode: "351",
			occupationDescription: "مزارع",
		},
		{
			occupationCode: "2259",
			occupationDescription: "مزارع بستنة عام",
		},
		{
			occupationCode: "2245",
			occupationDescription: "مزارع حبوب",
		},
		{
			occupationCode: "2260",
			occupationDescription: "مزارع حمضيات",
		},
		{
			occupationCode: "2246",
			occupationDescription: "مزارع خضار",
		},
		{
			occupationCode: "2248",
			occupationDescription: "مزارع زراعة محمية",
		},
		{
			occupationCode: "2261",
			occupationDescription: "مزارع عنب",
		},
		{
			occupationCode: "2269",
			occupationDescription: "مزارع غابات",
		},
		{
			occupationCode: "2247",
			occupationDescription: "مزارع قطن",
		},
		{
			occupationCode: "2244",
			occupationDescription: "مزارع محاصيل حقلية عام",
		},
		{
			occupationCode: "2263",
			occupationDescription: "مزارع مشاتل",
		},
		{
			occupationCode: "2235",
			occupationDescription: "مزارع منزلي",
		},
		{
			occupationCode: "2262",
			occupationDescription: "مزارع نخيل",
		},
		{
			occupationCode: "2559",
			occupationDescription: "مزخرف كتب باليد",
		},
		{
			occupationCode: "2372",
			occupationDescription: "مزيل الجير بالالة",
		},
		{
			occupationCode: "2444",
			occupationDescription: "مزيل صمغ الحرير الطبيعي",
		},
		{
			occupationCode: "2310",
			occupationDescription: "مسؤول حصاد",
		},
		{
			occupationCode: "232",
			occupationDescription: "مسؤول علاقات عامة",
		},
		{
			occupationCode: "1124",
			occupationDescription: "مسؤول عمليات الامن الحيوي",
		},
		{
			occupationCode: "207",
			occupationDescription: "مسئول تأمين",
		},
		{
			occupationCode: "2215",
			occupationDescription: "مسئول علاقات حكومية",
		},
		{
			occupationCode: "78",
			occupationDescription: "مساح",
		},
		{
			occupationCode: "1601",
			occupationDescription: "مساح أبنية",
		},
		{
			occupationCode: "2184",
			occupationDescription: "مساح أحذية",
		},
		{
			occupationCode: "1590",
			occupationDescription: "مساح أحصائي",
		},
		{
			occupationCode: "1603",
			occupationDescription: "مساح أراضي",
		},
		{
			occupationCode: "1611",
			occupationDescription: "مساح تصويري",
		},
		{
			occupationCode: "1573",
			occupationDescription: "مساح جيولوجي",
		},
		{
			occupationCode: "1602",
			occupationDescription: "مساح طرق",
		},
		{
			occupationCode: "1609",
			occupationDescription: "مساح عام",
		},
		{
			occupationCode: "85",
			occupationDescription: "مساح كميات",
		},
		{
			occupationCode: "1610",
			occupationDescription: "مساح مناجم",
		},
		{
			occupationCode: "1616",
			occupationDescription: "مساح ومحقق حقلي",
		},
		{
			occupationCode: "1883",
			occupationDescription: "مساعد اداري",
		},
		{
			occupationCode: "1995",
			occupationDescription: "مساعد بائع",
		},
		{
			occupationCode: "2997",
			occupationDescription: "مساعد براد",
		},
		{
			occupationCode: "3483",
			occupationDescription: "مساعد بناء حجر",
		},
		{
			occupationCode: "3486",
			occupationDescription: "مساعد بناء خرسانة",
		},
		{
			occupationCode: "3488",
			occupationDescription: "مساعد بناء طوب",
		},
		{
			occupationCode: "441",
			occupationDescription: "مساعد حداد",
		},
		{
			occupationCode: "3008",
			occupationDescription: "مساعد حداد أثاث معدني",
		},
		{
			occupationCode: "3015",
			occupationDescription: "مساعد حداد ألواح معدنية",
		},
		{
			occupationCode: "3056",
			occupationDescription: "مساعد حداد انشاءات معدنية",
		},
		{
			occupationCode: "3494",
			occupationDescription: "مساعد حداد تسليح",
		},
		{
			occupationCode: "2990",
			occupationDescription: "مساعد خراط",
		},
		{
			occupationCode: "3458",
			occupationDescription: "مساعد دهان خشب",
		},
		{
			occupationCode: null,
			occupationDescription: "مساعد دهان مباني",
		},
		{
			occupationCode: "3511",
			occupationDescription: "مساعد دهان مباني",
		},
		{
			occupationCode: "3255",
			occupationDescription: "مساعد دهان مركبات",
		},
		{
			occupationCode: "3022",
			occupationDescription: "مساعد دهان معادن",
		},
		{
			occupationCode: "1475",
			occupationDescription: "مساعد رئيس تحرير (صحيفة او مجلة)",
		},
		{
			occupationCode: "327",
			occupationDescription: "مساعد رئيس طباخ",
		},
		{
			occupationCode: "3201",
			occupationDescription: "مساعد سائق قطار",
		},
		{
			occupationCode: "2973",
			occupationDescription: "مساعد سباك",
		},
		{
			occupationCode: "332",
			occupationDescription: "مساعد سفرجي",
		},
		{
			occupationCode: "3252",
			occupationDescription: "مساعد سمكري ترميم مركبات",
		},
		{
			occupationCode: "2243",
			occupationDescription: "مساعد شخصي",
		},
		{
			occupationCode: "1771",
			occupationDescription: "مساعد صحي",
		},
		{
			occupationCode: "186",
			occupationDescription: "مساعد صيدلي",
		},
		{
			occupationCode: "328",
			occupationDescription: "مساعد طباخ",
		},
		{
			occupationCode: "147",
			occupationDescription: "مساعد طبيب",
		},
		{
			occupationCode: "167",
			occupationDescription: "مساعد طبيب اسنان",
		},
		{
			occupationCode: "169",
			occupationDescription: "مساعد طبيب بيطري",
		},
		{
			occupationCode: "2999",
			occupationDescription: "مساعد فراز",
		},
		{
			occupationCode: "2978",
			occupationDescription: "مساعد فني مختبر معالجة حرارية",
		},
		{
			occupationCode: "193",
			occupationDescription: "مساعد قابل",
		},
		{
			occupationCode: null,
			occupationDescription: "مساعد قصير ( مليس )",
		},
		{
			occupationCode: "3505",
			occupationDescription: "مساعد قصير ( مليس )",
		},
		{
			occupationCode: "704",
			occupationDescription: "مساعد قنصل",
		},
		{
			occupationCode: "3354",
			occupationDescription: "مساعد كهربائي تمديدات",
		},
		{
			occupationCode: "3371",
			occupationDescription: "مساعد كهربائي سفن",
		},
		{
			occupationCode: "3365",
			occupationDescription: "مساعد كهربائي سيارات",
		},
		{
			occupationCode: "3332",
			occupationDescription: "مساعد كهربائي شبكات هوائية",
		},
		{
			occupationCode: "3328",
			occupationDescription: "مساعد كهربائي صيانة محطات",
		},
		{
			occupationCode: "3368",
			occupationDescription: "مساعد كهربائي قطارات",
		},
		{
			occupationCode: "3335",
			occupationDescription: "مساعد كهربائي لحام كابلات",
		},
		{
			occupationCode: "3342",
			occupationDescription: "مساعد كهربائي محطات تحويل",
		},
		{
			occupationCode: "3321",
			occupationDescription: "مساعد كهربائي محطات توليد",
		},
		{
			occupationCode: "3360",
			occupationDescription: "مساعد كهربائي مصاعد",
		},
		{
			occupationCode: "3079",
			occupationDescription: "مساعد لحام أوكسجين",
		},
		{
			occupationCode: "3077",
			occupationDescription: "مساعد لحام كهرباء",
		},
		{
			occupationCode: null,
			occupationDescription: "مساعد مبلط",
		},
		{
			occupationCode: "3507",
			occupationDescription: "مساعد مبلط",
		},
		{
			occupationCode: "785",
			occupationDescription: "مساعد مدير محطة طيران",
		},
		{
			occupationCode: "780",
			occupationDescription: "مساعد مدير موقع تغذية",
		},
		{
			occupationCode: "3062",
			occupationDescription: "مساعد مركب انشاءات معدنية",
		},
		{
			occupationCode: "3559",
			occupationDescription: "مساعد مركب سكك حديدية",
		},
		{
			occupationCode: "3391",
			occupationDescription: "مساعد مركب شبكات هاتف",
		},
		{
			occupationCode: "2257",
			occupationDescription: "مساعد مزارع / عام",
		},
		{
			occupationCode: "2977",
			occupationDescription: "مساعد مشغل أفران الصهر",
		},
		{
			occupationCode: "2167",
			occupationDescription: "مساعد مضيف جوي",
		},
		{
			occupationCode: "724",
			occupationDescription: "مساعد ملحق اداري",
		},
		{
			occupationCode: "717",
			occupationDescription: "مساعد ملحق دبلوماسي",
		},
		{
			occupationCode: "720",
			occupationDescription: "مساعد ملحق عسكري",
		},
		{
			occupationCode: "3466",
			occupationDescription: "مساعد منجد",
		},
		{
			occupationCode: "3316",
			occupationDescription: "مساعد ميكانيكي آلات زراعية",
		},
		{
			occupationCode: "3310",
			occupationDescription: "مساعد ميكانيكي آليات ثقيلة",
		},
		{
			occupationCode: "3167",
			occupationDescription: "مساعد ميكانيكي أجهزة تكييف",
		},
		{
			occupationCode: "3171",
			occupationDescription: "مساعد ميكانيكي تدفئة مركزية",
		},
		{
			occupationCode: "3126",
			occupationDescription: "مساعد ميكانيكي تركيب معدات",
		},
		{
			occupationCode: "3162",
			occupationDescription: "مساعد ميكانيكي تكييف",
		},
		{
			occupationCode: "3176",
			occupationDescription: "مساعد ميكانيكي تمديدات صحية",
		},
		{
			occupationCode: "3289",
			occupationDescription: "مساعد ميكانيكي توربين بخاري",
		},
		{
			occupationCode: "3298",
			occupationDescription: "مساعد ميكانيكي توربين غازي",
		},
		{
			occupationCode: "3302",
			occupationDescription: "مساعد ميكانيكي توربين مائي",
		},
		{
			occupationCode: "3318",
			occupationDescription: "مساعد ميكانيكي ري ورش",
		},
		{
			occupationCode: "3140",
			occupationDescription: "مساعد ميكانيكي صيانة",
		},
		{
			occupationCode: "3282",
			occupationDescription: "مساعد ميكانيكي محرك توربيني",
		},
		{
			occupationCode: "3312",
			occupationDescription: "مساعد ميكانيكي هيدروليك",
		},
		{
			occupationCode: "3429",
			occupationDescription: "مساعد نجار أثاث",
		},
		{
			occupationCode: "3444",
			occupationDescription: "مساعد نجار مباني",
		},
		{
			occupationCode: "770",
			occupationDescription: "مستثمر",
		},
		{
			occupationCode: "112009",
			occupationDescription: "مستثمر",
		},
		{
			occupationCode: "261",
			occupationDescription: "مستشار",
		},
		{
			occupationCode: null,
			occupationDescription: "مستشار /أ",
		},
		{
			occupationCode: "709",
			occupationDescription: "مستشار /أ",
		},
		{
			occupationCode: "710",
			occupationDescription: "مستشار /ب",
		},
		{
			occupationCode: "1546",
			occupationDescription: "مستشار اداري",
		},
		{
			occupationCode: "1418",
			occupationDescription: "مستشار تدريب",
		},
		{
			occupationCode: "1986",
			occupationDescription: "مستشار خدمات فنية",
		},
		{
			occupationCode: "211",
			occupationDescription: "مستشار قانوني",
		},
		{
			occupationCode: "1438",
			occupationDescription: "مستشار قانوني نظم خاصة",
		},
		{
			occupationCode: "1437",
			occupationDescription: "مستشار قانوني نظم عامة",
		},
		{
			occupationCode: "2207",
			occupationDescription: "مسعف",
		},
		{
			occupationCode: "3263",
			occupationDescription: "مشحم ومزيت سيارات",
		},
		{
			occupationCode: "1478",
			occupationDescription: "مشرف أزياء مسرح أو أستوديو",
		},
		{
			occupationCode: "2150",
			occupationDescription: "مشرف أغذيه",
		},
		{
			occupationCode: "2255",
			occupationDescription: "مشرف أو مراقب مزرعة",
		},
		{
			occupationCode: "611105",
			occupationDescription: "مشرف أو مراقب مزرعة",
		},
		{
			occupationCode: "1011",
			occupationDescription: "مشرف أول مسح جوي رقمي",
		},
		{
			occupationCode: "260",
			occupationDescription: "مشرف اجتماعي",
		},
		{
			occupationCode: "274",
			occupationDescription: "مشرف اعمال مكتبية",
		},
		{
			occupationCode: "367",
			occupationDescription: "مشرف انتاج",
		},
		{
			occupationCode: "312202",
			occupationDescription: "مشرف انتاج",
		},
		{
			occupationCode: "112",
			occupationDescription: "مشرف بحري",
		},
		{
			occupationCode: "370",
			occupationDescription: "مشرف تغذية",
		},
		{
			occupationCode: "1482",
			occupationDescription: "مشرف ثقافي",
		},
		{
			occupationCode: "290",
			occupationDescription: "مشرف حاسب آلي",
		},
		{
			occupationCode: "368",
			occupationDescription: "مشرف حفر ابار",
		},
		{
			occupationCode: "1970",
			occupationDescription: "مشرف خدمات اتصالات لاسلكية",
		},
		{
			occupationCode: "1545",
			occupationDescription: "مشرف خدمات المرافق",
		},
		{
			occupationCode: "1144",
			occupationDescription: "مشرف خدمات بحرية في الموانىء",
		},
		{
			occupationCode: "302",
			occupationDescription: "مشرف خدمات بريدية",
		},
		{
			occupationCode: "1776",
			occupationDescription: "مشرف خدمات صحية وبائية",
		},
		{
			occupationCode: "2130",
			occupationDescription: "مشرف خدمات طعام",
		},
		{
			occupationCode: "300",
			occupationDescription: "مشرف خدمات عامة",
		},
		{
			occupationCode: "2186",
			occupationDescription: "مشرف خدمات عامه في سفينة",
		},
		{
			occupationCode: "2185",
			occupationDescription: "مشرف خدمات عامه في فندق",
		},
		{
			occupationCode: "2177",
			occupationDescription: "مشرف خدمات غرف",
		},
		{
			occupationCode: "1969",
			occupationDescription: "مشرف خدمات نقل بري",
		},
		{
			occupationCode: "1924",
			occupationDescription: "مشرف خدمات نقل جوي",
		},
		{
			occupationCode: "349",
			occupationDescription: "مشرف زراعي",
		},
		{
			occupationCode: "959",
			occupationDescription: "مشرف شبكات الحاسب",
		},
		{
			occupationCode: "298",
			occupationDescription: "مشرف صيانة",
		},
		{
			occupationCode: "312203",
			occupationDescription: "مشرف صيانة",
		},
		{
			occupationCode: "369",
			occupationDescription: "مشرف على انتاج الالكترونيات",
		},
		{
			occupationCode: "2165",
			occupationDescription: "مشرف على مسكن خاص",
		},
		{
			occupationCode: "2164",
			occupationDescription: "مشرف على مسكن عام",
		},
		{
			occupationCode: "297",
			occupationDescription: "مشرف عمال",
		},
		{
			occupationCode: "299",
			occupationDescription: "مشرف غرف",
		},
		{
			occupationCode: "1638",
			occupationDescription: "مشرف فني بحري في الموانىء",
		},
		{
			occupationCode: "1993",
			occupationDescription: "مشرف في تجارة التجزئة",
		},
		{
			occupationCode: "1992",
			occupationDescription: "مشرف في تجارة الجملة",
		},
		{
			occupationCode: "289",
			occupationDescription: "مشرف قاعدة بيانات",
		},
		{
			occupationCode: "315",
			occupationDescription: "مشرف مبيعات",
		},
		{
			occupationCode: "1548",
			occupationDescription: "مشرف مراجعة ادارية",
		},
		{
			occupationCode: "339",
			occupationDescription: "مشرف نظافة",
		},
		{
			occupationCode: "188",
			occupationDescription: "مشرف وردية",
		},
		{
			occupationCode: "2667",
			occupationDescription: "مشغل آبار النفط بالاحماض",
		},
		{
			occupationCode: null,
			occupationDescription: "مشغل آلات",
		},
		{
			occupationCode: "544",
			occupationDescription: "مشغل آلات",
		},
		{
			occupationCode: "1886",
			occupationDescription: "مشغل آلات استنساخ",
		},
		{
			occupationCode: "2628",
			occupationDescription: "مشغل آلات الثقب في المناجم",
		},
		{
			occupationCode: "3182",
			occupationDescription: "مشغل آلات تحلية مياه",
		},
		{
			occupationCode: "2838",
			occupationDescription: "مشغل آلات تقطيع المكرونة",
		},
		{
			occupationCode: "2640",
			occupationDescription: "مشغل آلات تنظيف وفصل الركاز",
		},
		{
			occupationCode: "2641",
			occupationDescription: "مشغل آلات تنقية الخامات",
		},
		{
			occupationCode: "2568",
			occupationDescription: "مشغل آلات حفر",
		},
		{
			occupationCode: "361",
			occupationDescription: "مشغل آلات زراعية",
		},
		{
			occupationCode: "3436",
			occupationDescription: "مشغل آلات مسح وتسوية الخشب",
		},
		{
			occupationCode: "3435",
			occupationDescription: "مشغل آلات نشر الخشب",
		},
		{
			occupationCode: "2416",
			occupationDescription: "مشغل آلة البرم",
		},
		{
			occupationCode: "2414",
			occupationDescription: "مشغل آلة التمشيط",
		},
		{
			occupationCode: "2410",
			occupationDescription: "مشغل آلة الحلج",
		},
		{
			occupationCode: "2418",
			occupationDescription: "مشغل آلة الزوي",
		},
		{
			occupationCode: "2415",
			occupationDescription: "مشغل آلة السحب",
		},
		{
			occupationCode: "2975",
			occupationDescription: "مشغل آلة السكب بالطرد المركزي",
		},
		{
			occupationCode: "2974",
			occupationDescription: "مشغل آلة السكب بالقوالب",
		},
		{
			occupationCode: "2545",
			occupationDescription: "مشغل آلة الطبع الغائر",
		},
		{
			occupationCode: "2417",
			occupationDescription: "مشغل آلة اللف",
		},
		{
			occupationCode: "2925",
			occupationDescription: "مشغل آلة بثق الانابيب",
		},
		{
			occupationCode: "2787",
			occupationDescription: "مشغل آلة بثق الخزف",
		},
		{
			occupationCode: "2717",
			occupationDescription: "مشغل آلة بثق اللدائن",
		},
		{
			occupationCode: "2726",
			occupationDescription: "مشغل آلة تبريد وتجفيف المطاط",
		},
		{
			occupationCode: "2349",
			occupationDescription: "مشغل آلة تبييض عجينة الورق",
		},
		{
			occupationCode: "2350",
			occupationDescription: "مشغل آلة تجفيف الورق",
		},
		{
			occupationCode: "2552",
			occupationDescription: "مشغل آلة تجليد",
		},
		{
			occupationCode: "2553",
			occupationDescription: "مشغل آلة تجميع ملزم",
		},
		{
			occupationCode: "2334",
			occupationDescription: "مشغل آلة تجهيز قشره",
		},
		{
			occupationCode: "2445",
			occupationDescription: "مشغل آلة ترطيب",
		},
		{
			occupationCode: "2475",
			occupationDescription: "مشغل آلة تريكو",
		},
		{
			occupationCode: "2413",
			occupationDescription: "مشغل آلة تسريح",
		},
		{
			occupationCode: "3000",
			occupationDescription: "مشغل آلة تشغيل مبرمجة",
		},
		{
			occupationCode: null,
			occupationDescription: "مشغل آلة تشكيل السكر",
		},
		{
			occupationCode: "2861",
			occupationDescription: "مشغل آلة تشكيل السكر",
		},
		{
			occupationCode: "2836",
			occupationDescription: "مشغل آلة تشكيل المكرونة",
		},
		{
			occupationCode: "2724",
			occupationDescription: "مشغل آلة تصفيح المطاط",
		},
		{
			occupationCode: "2730",
			occupationDescription: "مشغل آلة تصنيع الالياف",
		},
		{
			occupationCode: "2524",
			occupationDescription: "مشغل آلة تطريز",
		},
		{
			occupationCode: "815307",
			occupationDescription: "مشغل آلة تطريز",
		},
		{
			occupationCode: "2743",
			occupationDescription: "مشغل آلة تعبئة الصابون وتغليفه",
		},
		{
			occupationCode: "2805",
			occupationDescription: "مشغل آلة تعبئة الكبسولات",
		},
		{
			occupationCode: "2809",
			occupationDescription: "مشغل آلة تغليف الاقراص",
		},
		{
			occupationCode: "2347",
			occupationDescription: "مشغل آلة تفتيت العجينة الورقية",
		},
		{
			occupationCode: "2323",
			occupationDescription: "مشغل آلة تقشير الجذوع",
		},
		{
			occupationCode: "2842",
			occupationDescription: "مشغل آلة تقطيع العجين",
		},
		{
			occupationCode: "3094",
			occupationDescription: "مشغل آلة تكسيه",
		},
		{
			occupationCode: "2383",
			occupationDescription: "مشغل آلة تلحيم الجلود",
		},
		{
			occupationCode: "2346",
			occupationDescription: "مشغل آلة تنظيف عجينة الورق",
		},
		{
			occupationCode: "2412",
			occupationDescription: "مشغل آلة تنظيف ومزج الألياف",
		},
		{
			occupationCode: "2426",
			occupationDescription: "مشغل آلة تنعيم ألياف الجوت",
		},
		{
			occupationCode: "2348",
			occupationDescription: "مشغل آلة تنعيم العجينة الورقية",
		},
		{
			occupationCode: "2827",
			occupationDescription: "مشغل آلة جرش الحبوب",
		},
		{
			occupationCode: "2324",
			occupationDescription: "مشغل آلة جرش الخشب",
		},
		{
			occupationCode: "2753",
			occupationDescription: "مشغل آلة جلخ الزجاج",
		},
		{
			occupationCode: "2716",
			occupationDescription: "مشغل آلة حقن اللدائن",
		},
		{
			occupationCode: "2492",
			occupationDescription: "مشغل آلة حياكة جوارب",
		},
		{
			occupationCode: "2491",
			occupationDescription: "مشغل آلة حياكة كهربائية",
		},
		{
			occupationCode: "2508",
			occupationDescription: "مشغل آلة خياطة صناعية",
		},
		{
			occupationCode: "3215",
			occupationDescription: "مشغل آلة دق",
		},
		{
			occupationCode: "3220",
			occupationDescription: "مشغل آلة رافعة",
		},
		{
			occupationCode: "2560",
			occupationDescription: "مشغل آلة زخرفة الكتب",
		},
		{
			occupationCode: "2926",
			occupationDescription: "مشغل آلة سحب الأسلاك المعدنية",
		},
		{
			occupationCode: "2763",
			occupationDescription: "مشغل آلة سحب الزجاج",
		},
		{
			occupationCode: "2371",
			occupationDescription: "مشغل آلة سحب وكي الجلود",
		},
		{
			occupationCode: "2537",
			occupationDescription: "مشغل آلة سكب الحروف",
		},
		{
			occupationCode: "2538",
			occupationDescription: "مشغل آلة سكب السطور",
		},
		{
			occupationCode: "2619",
			occupationDescription: "مشغل آلة صب الأعمدة الخرسانية",
		},
		{
			occupationCode: "2620",
			occupationDescription: "مشغل آلة صب الأنابيب الاسمنتية",
		},
		{
			occupationCode: "2621",
			occupationDescription: "مشغل آلة صب الأنابيب الخزفية",
		},
		{
			occupationCode: "2440",
			occupationDescription: "مشغل آلة صباغة الخيوط",
		},
		{
			occupationCode: "2441",
			occupationDescription: "مشغل آلة صباغة المنسوجات",
		},
		{
			occupationCode: "2592",
			occupationDescription: "مشغل آلة صقل الاحجار والرخا",
		},
		{
			occupationCode: "2379",
			occupationDescription: "مشغل آلة صقل الجلود",
		},
		{
			occupationCode: "2806",
			occupationDescription: "مشغل آلة صقل الكبسولات",
		},
		{
			occupationCode: "2351",
			occupationDescription: "مشغل آلة صقل الورق",
		},
		{
			occupationCode: "2725",
			occupationDescription: "مشغل آلة صقل منتجات للدائن",
		},
		{
			occupationCode: "2355",
			occupationDescription: "مشغل آلة صنع الاكياس",
		},
		{
			occupationCode: "2419",
			occupationDescription: "مشغل آلة صنع الحبال",
		},
		{
			occupationCode: "2927",
			occupationDescription: "مشغل آلة صنع المسامير",
		},
		{
			occupationCode: "2353",
			occupationDescription: "مشغل آلة صنع الورق",
		},
		{
			occupationCode: "2354",
			occupationDescription: "مشغل آلة صنع صناديق الورق",
		},
		{
			occupationCode: "2329",
			occupationDescription: "مشغل آلة صنفرة",
		},
		{
			occupationCode: "2542",
			occupationDescription: "مشغل آلة طباعة أسطوانية",
		},
		{
			occupationCode: "2544",
			occupationDescription: "مشغل آلة طباعة أوفست",
		},
		{
			occupationCode: "2543",
			occupationDescription: "مشغل آلة طباعة دوارة",
		},
		{
			occupationCode: "2547",
			occupationDescription: "مشغل آلة طباعة مسطحة",
		},
		{
			occupationCode: "2546",
			occupationDescription: "مشغل آلة طباعة ملونة",
		},
		{
			occupationCode: "2742",
			occupationDescription: "مشغل آلة طبخ مواد الصابون",
		},
		{
			occupationCode: "2352",
			occupationDescription: "مشغل آلة طلاء الورق",
		},
		{
			occupationCode: "2557",
			occupationDescription: "مشغل آلة طي الورق المطبوع",
		},
		{
			occupationCode: "2370",
			occupationDescription: "مشغل آلة فتق الجلد",
		},
		{
			occupationCode: null,
			occupationDescription: "مشغل آلة فرز التمور عن النواة",
		},
		{
			occupationCode: "2879",
			occupationDescription: "مشغل آلة فرز التمور عن النواة",
		},
		{
			occupationCode: "2910",
			occupationDescription: "مشغل آلة فرز الدهون",
		},
		{
			occupationCode: "2752",
			occupationDescription: "مشغل آلة قص الزجاج",
		},
		{
			occupationCode: "2727",
			occupationDescription: "مشغل آلة كساء النسيج بالمطاط",
		},
		{
			occupationCode: "3083",
			occupationDescription: "مشغل آلة لحام كهربائي",
		},
		{
			occupationCode: "3082",
			occupationDescription: "مشغل آلة لحام مقاومة",
		},
		{
			occupationCode: "2420",
			occupationDescription: "مشغل آلة لف الشلائل",
		},
		{
			occupationCode: "2766",
			occupationDescription: "مشغل آلة نفخ الزجاج",
		},
		{
			occupationCode: "2454",
			occupationDescription: "مشغل آلةتنهيةصنع المنسوجات",
		},
		{
			occupationCode: "3209",
			occupationDescription: "مشغل آلية تحميل",
		},
		{
			occupationCode: "3174",
			occupationDescription: "مشغل أجهزة التهوية والتدفئة",
		},
		{
			occupationCode: "3168",
			occupationDescription: "مشغل أجهزة تبريد مركزي",
		},
		{
			occupationCode: "3163",
			occupationDescription: "مشغل أجهزة تكييف مركزي",
		},
		{
			occupationCode: "1617",
			occupationDescription: "مشغل أجهزة مسح جوي ورقمي",
		},
		{
			occupationCode: "2618",
			occupationDescription: "مشغل أفران القرميد",
		},
		{
			occupationCode: "2378",
			occupationDescription: "مشغل أفران تجفيف الجلود",
		},
		{
			occupationCode: "2442",
			occupationDescription: "مشغل أفران تجفيف المنسوجات",
		},
		{
			occupationCode: "2976",
			occupationDescription: "مشغل أفران صهر معادن",
		},
		{
			occupationCode: "3173",
			occupationDescription: "مشغل أنظمة التدفئة المركزية",
		},
		{
			occupationCode: "1981",
			occupationDescription: "مشغل الالة الحاسبة",
		},
		{
			occupationCode: "2643",
			occupationDescription: "مشغل الفرن العالي",
		},
		{
			occupationCode: "1919",
			occupationDescription: "مشغل بدالة",
		},
		{
			occupationCode: "2685",
			occupationDescription: "مشغل برج فصل زيت البرافين",
		},
		{
			occupationCode: "3291",
			occupationDescription: "مشغل توربين بخاري",
		},
		{
			occupationCode: "3299",
			occupationDescription: "مشغل توربين غازي",
		},
		{
			occupationCode: "3306",
			occupationDescription: "مشغل توربين كهربائي",
		},
		{
			occupationCode: "3304",
			occupationDescription: "مشغل توربين مائي",
		},
		{
			occupationCode: "3384",
			occupationDescription: "مشغل توزيع الحمل كهربائي",
		},
		{
			occupationCode: "3010",
			occupationDescription: "مشغل ثناية صفيح آلية",
		},
		{
			occupationCode: "2613",
			occupationDescription: "مشغل جلايه بلاط",
		},
		{
			occupationCode: "1920",
			occupationDescription: "مشغل جهاز برقي ( تلغراف )",
		},
		{
			occupationCode: null,
			occupationDescription: "مشغل جهاز بلورة السكر",
		},
		{
			occupationCode: "2858",
			occupationDescription: "مشغل جهاز بلورة السكر",
		},
		{
			occupationCode: "2709",
			occupationDescription: "مشغل جهاز تبخير",
		},
		{
			occupationCode: "3142",
			occupationDescription: "مشغل جهاز تبريد",
		},
		{
			occupationCode: "2688",
			occupationDescription: "مشغل جهاز تعبئة ناقلات",
		},
		{
			occupationCode: "2687",
			occupationDescription: "مشغل جهاز تعبئة يعمل بالطاقة",
		},
		{
			occupationCode: "2708",
			occupationDescription: "مشغل جهاز تفاعل",
		},
		{
			occupationCode: "2682",
			occupationDescription: "مشغل جهاز تفاعل النفط",
		},
		{
			occupationCode: "2706",
			occupationDescription: "مشغل جهاز تقطير",
		},
		{
			occupationCode: "2683",
			occupationDescription: "مشغل جهاز تقطير النفط",
		},
		{
			occupationCode: "2707",
			occupationDescription: "مشغل جهاز تقطير مستمر",
		},
		{
			occupationCode: "2722",
			occupationDescription: "مشغل جهاز تكسية الاطارات",
		},
		{
			occupationCode: "2623",
			occupationDescription: "مشغل جهاز شد فولاذ التسليح",
		},
		{
			occupationCode: null,
			occupationDescription: "مشغل جهاز طحن وعصر البنجر",
		},
		{
			occupationCode: "2856",
			occupationDescription: "مشغل جهاز طحن وعصر البنجر",
		},
		{
			occupationCode: "3400",
			occupationDescription: "مشغل جهاز عرض سينمائي",
		},
		{
			occupationCode: null,
			occupationDescription: "مشغل جهاز فصل السكر",
		},
		{
			occupationCode: "2859",
			occupationDescription: "مشغل جهاز فصل السكر",
		},
		{
			occupationCode: null,
			occupationDescription: "مشغل جهاز كربنه السكر",
		},
		{
			occupationCode: "2857",
			occupationDescription: "مشغل جهاز كربنه السكر",
		},
		{
			occupationCode: "2808",
			occupationDescription: "مشغل جهاز مراقبة الاقراص",
		},
		{
			occupationCode: "2680",
			occupationDescription: "مشغل جهاز معالجة النفط",
		},
		{
			occupationCode: "2889",
			occupationDescription: "مشغل جهاز هدرجة زيوت نباتية",
		},
		{
			occupationCode: "1591",
			occupationDescription: "مشغل حاسب الكتروني",
		},
		{
			occupationCode: "3185",
			occupationDescription: "مشغل حراري غرفة تحكم",
		},
		{
			occupationCode: "3540",
			occupationDescription: "مشغل حزام ناقل",
		},
		{
			occupationCode: "2665",
			occupationDescription: "مشغل حفار ترددي للآبار",
		},
		{
			occupationCode: "3208",
			occupationDescription: "مشغل حفارة",
		},
		{
			occupationCode: "834204",
			occupationDescription: "مشغل حفارة",
		},
		{
			occupationCode: null,
			occupationDescription: "مشغل حقل التخمير لخميرة الخبز",
		},
		{
			occupationCode: "2864",
			occupationDescription: "مشغل حقل التخمير لخميرة الخبز",
		},
		{
			occupationCode: "2325",
			occupationDescription: "مشغل خلاط تغرية",
		},
		{
			occupationCode: "3551",
			occupationDescription: "مشغل خلاطة أسفلت",
		},
		{
			occupationCode: "3497",
			occupationDescription: "مشغل خلاطة خرسانية",
		},
		{
			occupationCode: "3496",
			occupationDescription: "مشغل خلاطة خرسانيه مركزية",
		},
		{
			occupationCode: "2922",
			occupationDescription: "مشغل درافيل الألواح المعدنية",
		},
		{
			occupationCode: "2924",
			occupationDescription: "مشغل درافيل الأنابيب المعدنية",
		},
		{
			occupationCode: "2923",
			occupationDescription: "مشغل درافيل المقاطع المعدنية",
		},
		{
			occupationCode: "2784",
			occupationDescription: "مشغل دولاب خزف",
		},
		{
			occupationCode: "1925",
			occupationDescription: "مشغل راديو بمحطة أرضية",
		},
		{
			occupationCode: "3214",
			occupationDescription: "مشغل رافعة برجيه",
		},
		{
			occupationCode: "834402",
			occupationDescription: "مشغل رافعة برجيه",
		},
		{
			occupationCode: "2638",
			occupationDescription: "مشغل رجاج",
		},
		{
			occupationCode: "3552",
			occupationDescription: "مشغل سخان اسفلت",
		},
		{
			occupationCode: "3500",
			occupationDescription: "مشغل ضاغطة هواء حفر",
		},
		{
			occupationCode: "1979",
			occupationDescription: "مشغل طباعة وتصوير",
		},
		{
			occupationCode: "2841",
			occupationDescription: "مشغل عجان فرن آلي",
		},
		{
			occupationCode: "2344",
			occupationDescription: "مشغل عجان ورق",
		},
		{
			occupationCode: "3221",
			occupationDescription: "مشغل عربة رفع بضائع",
		},
		{
			occupationCode: null,
			occupationDescription: "مشغل عصارة قصب السكر",
		},
		{
			occupationCode: "2855",
			occupationDescription: "مشغل عصارة قصب السكر",
		},
		{
			occupationCode: "2826",
			occupationDescription: "مشغل غرابيل حبوب",
		},
		{
			occupationCode: "3186",
			occupationDescription: "مشغل غرفة تحكم في محطة تحلي",
		},
		{
			occupationCode: "2172",
			occupationDescription: "مشغل غسالات ملابس",
		},
		{
			occupationCode: "2411",
			occupationDescription: "مشغل غسالة الصوف",
		},
		{
			occupationCode: "2694",
			occupationDescription: "مشغل غلايات مياه",
		},
		{
			occupationCode: null,
			occupationDescription: "مشغل فاصلات خميرة الخبز",
		},
		{
			occupationCode: "2866",
			occupationDescription: "مشغل فاصلات خميرة الخبز",
		},
		{
			occupationCode: "2646",
			occupationDescription: "مشغل فرن أحجار",
		},
		{
			occupationCode: "2644",
			occupationDescription: "مشغل فرن الالمنيوم",
		},
		{
			occupationCode: "2985",
			occupationDescription: "مشغل فرن الدست",
		},
		{
			occupationCode: "2645",
			occupationDescription: "مشغل فرن الفولاذ",
		},
		{
			occupationCode: "2272",
			occupationDescription: "مشغل فرن انتاج الفحم النباتي",
		},
		{
			occupationCode: "2326",
			occupationDescription: "مشغل فرن تجفيف الخشب",
		},
		{
			occupationCode: "2606",
			occupationDescription: "مشغل فرن تجفيف الطوب الرملي",
		},
		{
			occupationCode: "2837",
			occupationDescription: "مشغل فرن تجفيف المكرونة",
		},
		{
			occupationCode: "2607",
			occupationDescription: "مشغل فرن تحميض الطوب",
		},
		{
			occupationCode: "2647",
			occupationDescription: "مشغل فرن تحميض خامات",
		},
		{
			occupationCode: "2930",
			occupationDescription: "مشغل فرن تسخين معادن",
		},
		{
			occupationCode: "2764",
			occupationDescription: "مشغل فرن تكوين الزجاج",
		},
		{
			occupationCode: "2788",
			occupationDescription: "مشغل فرن حرق الخزف",
		},
		{
			occupationCode: "2601",
			occupationDescription: "مشغل فرن صناعة الاسمنت",
		},
		{
			occupationCode: "2748",
			occupationDescription: "مشغل فرن صهر الزجاج",
		},
		{
			occupationCode: "3383",
			occupationDescription: "مشغل في محطة توليد الكهرباء",
		},
		{
			occupationCode: "2689",
			occupationDescription: "مشغل في معمل تكرير",
		},
		{
			occupationCode: "2637",
			occupationDescription: "مشغل كسارة أحجار",
		},
		{
			occupationCode: "1982",
			occupationDescription: "مشغل ماكينة التثقيب",
		},
		{
			occupationCode: "2692",
			occupationDescription: "مشغل ماكينة التعدين",
		},
		{
			occupationCode: "2737",
			occupationDescription: "مشغل ماكينة تخشين الاطارات",
		},
		{
			occupationCode: "2365",
			occupationDescription: "مشغل ماكينة تسمير الكتب بالسلك",
		},
		{
			occupationCode: "2225",
			occupationDescription: "مشغل ماكينة تعبئة معلبات",
		},
		{
			occupationCode: "3382",
			occupationDescription: "مشغل ماكينة توليد الطاقة",
		},
		{
			occupationCode: "3231",
			occupationDescription: "مشغل ماكينة ثابتة",
		},
		{
			occupationCode: "3030",
			occupationDescription: "مشغل ماكينة ثنى المعادن",
		},
		{
			occupationCode: "3536",
			occupationDescription: "مشغل ماكينة رصف الطرق",
		},
		{
			occupationCode: "2659",
			occupationDescription: "مشغل ماكينة سحب مواسير",
		},
		{
			occupationCode: "2662",
			occupationDescription: "مشغل ماكينة صب القضبان",
		},
		{
			occupationCode: "3305",
			occupationDescription: "مشغل ماكينة ضخ",
		},
		{
			occupationCode: "3297",
			occupationDescription: "مشغل ماكينة ضغط غازات",
		},
		{
			occupationCode: "3292",
			occupationDescription: "مشغل ماكينة ضغط هواء",
		},
		{
			occupationCode: "2556",
			occupationDescription: "مشغل ماكينة قص الكتب والسجلات",
		},
		{
			occupationCode: null,
			occupationDescription: "مشغل ماكينة قطع أحجار",
		},
		{
			occupationCode: "3533",
			occupationDescription: "مشغل ماكينة قطع أحجار",
		},
		{
			occupationCode: "1980",
			occupationDescription: "مشغل ماكينة مسك الدفاتر",
		},
		{
			occupationCode: "3181",
			occupationDescription: "مشغل ماكينة معالجة المياه",
		},
		{
			occupationCode: "3538",
			occupationDescription: "مشغل ماكينة نشر القار",
		},
		{
			occupationCode: "2710",
			occupationDescription: "مشغل مبيض كيميائي",
		},
		{
			occupationCode: "2664",
			occupationDescription: "مشغل مثقاب حفر الآبار",
		},
		{
			occupationCode: null,
			occupationDescription: "مشغل مجففات السكر",
		},
		{
			occupationCode: "2860",
			occupationDescription: "مشغل مجففات السكر",
		},
		{
			occupationCode: "3225",
			occupationDescription: "مشغل محركات ديزل",
		},
		{
			occupationCode: "3226",
			occupationDescription: "مشغل محركات سفن",
		},
		{
			occupationCode: "3183",
			occupationDescription: "مشغل محطة خلط في تحلية المياه",
		},
		{
			occupationCode: "3187",
			occupationDescription: "مشغل محطة ضخ في محطة تحلية",
		},
		{
			occupationCode: "2695",
			occupationDescription: "مشغل محطة لمعالجة المياه",
		},
		{
			occupationCode: "2991",
			occupationDescription: "مشغل مخرطة أوتوماتيكية",
		},
		{
			occupationCode: "2594",
			occupationDescription: "مشغل مخرطة الاحجار",
		},
		{
			occupationCode: "3012",
			occupationDescription: "مشغل مخرطة تشكيل ألواح معدنية",
		},
		{
			occupationCode: "3018",
			occupationDescription: "مشغل مخرطة تشكيل صفيح",
		},
		{
			occupationCode: "2345",
			occupationDescription: "مشغل مرجل قص عجينة الورق",
		},
		{
			occupationCode: null,
			occupationDescription: "مشغل مصافي الزيوت النباتية",
		},
		{
			occupationCode: "2888",
			occupationDescription: "مشغل مصافي الزيوت النباتية",
		},
		{
			occupationCode: "545",
			occupationDescription: "مشغل مصنع",
		},
		{
			occupationCode: null,
			occupationDescription: "مشغل مضخات",
		},
		{
			occupationCode: "546",
			occupationDescription: "مشغل مضخات",
		},
		{
			occupationCode: "2668",
			occupationDescription: "مشغل مضخات خطوط الانابيب",
		},
		{
			occupationCode: "2681",
			occupationDescription: "مشغل مضخات مصاف",
		},
		{
			occupationCode: "3498",
			occupationDescription: "مشغل مضخة خرسانية",
		},
		{
			occupationCode: "2828",
			occupationDescription: "مشغل مطحنة حبوب",
		},
		{
			occupationCode: "2343",
			occupationDescription: "مشغل مطحنة لب الخشب",
		},
		{
			occupationCode: "2928",
			occupationDescription: "مشغل مطرقة آلية",
		},
		{
			occupationCode: null,
			occupationDescription: "مشغل معدات",
		},
		{
			occupationCode: "547",
			occupationDescription: "مشغل معدات",
		},
		{
			occupationCode: null,
			occupationDescription: "مشغل معصرة تمور",
		},
		{
			occupationCode: "2882",
			occupationDescription: "مشغل معصرة تمور",
		},
		{
			occupationCode: "3396",
			occupationDescription: "مشغل مقاسم ألكترونية",
		},
		{
			occupationCode: "3395",
			occupationDescription: "مشغل مقاسم ألكترونية عام",
		},
		{
			occupationCode: "2617",
			occupationDescription: "مشغل مقص القرميد",
		},
		{
			occupationCode: "3009",
			occupationDescription: "مشغل مقص صفيح آلي",
		},
		{
			occupationCode: "2555",
			occupationDescription: "مشغل مقص ورق",
		},
		{
			occupationCode: null,
			occupationDescription: "مشغل مكابس الزيوت النباتية",
		},
		{
			occupationCode: "2887",
			occupationDescription: "مشغل مكابس الزيوت النباتية",
		},
		{
			occupationCode: "2720",
			occupationDescription: "مشغل مكبس اطارات مطاطية",
		},
		{
			occupationCode: "2804",
			occupationDescription: "مشغل مكبس الأقراص الدوائية",
		},
		{
			occupationCode: "2786",
			occupationDescription: "مشغل مكبس الخزف",
		},
		{
			occupationCode: "2609",
			occupationDescription: "مشغل مكبس بلاط أسمنتي يدوي",
		},
		{
			occupationCode: "2612",
			occupationDescription: "مشغل مكبس بلاط خزفي",
		},
		{
			occupationCode: "2947",
			occupationDescription: "مشغل مكبس تشكيل المعادن",
		},
		{
			occupationCode: "2929",
			occupationDescription: "مشغل مكبس حدادة",
		},
		{
			occupationCode: "2750",
			occupationDescription: "مشغل مكبس زجاج",
		},
		{
			occupationCode: "3011",
			occupationDescription: "مشغل مكبس صفيح",
		},
		{
			occupationCode: "2604",
			occupationDescription: "مشغل مكبس طوب أسمنتي آلي",
		},
		{
			occupationCode: "2603",
			occupationDescription: "مشغل مكبس طوب أسمنتي يدوي",
		},
		{
			occupationCode: "2605",
			occupationDescription: "مشغل مكبس طوب رملي آلي",
		},
		{
			occupationCode: "2616",
			occupationDescription: "مشغل مكبس قرميد",
		},
		{
			occupationCode: "2718",
			occupationDescription: "مشغل مكبس قوالب تشكيل اللدائن",
		},
		{
			occupationCode: "2593",
			occupationDescription: "مشغل منشار حجر قرصي",
		},
		{
			occupationCode: "2320",
			occupationDescription: "مشغل منشار شريطي",
		},
		{
			occupationCode: "2321",
			occupationDescription: "مشغل منشار شريطي متعدد",
		},
		{
			occupationCode: "2322",
			occupationDescription: "مشغل منشار صينية",
		},
		{
			occupationCode: "3058",
			occupationDescription: "مشغل منشار معادن آلي",
		},
		{
			occupationCode: "3293",
			occupationDescription: "مشغل مولد بخار",
		},
		{
			occupationCode: "2466",
			occupationDescription: "مشغل نول آلي",
		},
		{
			occupationCode: "2469",
			occupationDescription: "مشغل نول اشرطه",
		},
		{
			occupationCode: "2471",
			occupationDescription: "مشغل نول بساط",
		},
		{
			occupationCode: "2472",
			occupationDescription: "مشغل نول بطاطين",
		},
		{
			occupationCode: "2467",
			occupationDescription: "مشغل نول جاكارد",
		},
		{
			occupationCode: "2470",
			occupationDescription: "مشغل نول سجاد",
		},
		{
			occupationCode: "2473",
			occupationDescription: "مشغل نول مخمل",
		},
		{
			occupationCode: "2465",
			occupationDescription: "مشغل نول يدوي",
		},
		{
			occupationCode: "2810",
			occupationDescription: "مشغل وحدة أنتاج الادوية",
		},
		{
			occupationCode: "2811",
			occupationDescription: "مشغل وحدة أنتاج المراهم",
		},
		{
			occupationCode: "2608",
			occupationDescription: "مشغل وحدة البلاط الاسمنتي",
		},
		{
			occupationCode: "2812",
			occupationDescription: "مشغل وحدة انتاج الحقن الدوائية",
		},
		{
			occupationCode: "2803",
			occupationDescription: "مشغل وحدة تحضير المساحيق",
		},
		{
			occupationCode: "2751",
			occupationDescription: "مشغل وحدة تشكيل ألواح الزجاج",
		},
		{
			occupationCode: "2807",
			occupationDescription: "مشغل وحدة تلبيس الاقراص",
		},
		{
			occupationCode: "3539",
			occupationDescription: "مشغل وحدة خلط الخرسانة",
		},
		{
			occupationCode: "2381",
			occupationDescription: "مشغل وحدة طلاء الجلود",
		},
		{
			occupationCode: "2729",
			occupationDescription: "مشكل أطارات",
		},
		{
			occupationCode: "2125",
			occupationDescription: "مصفف شعر",
		},
		{
			occupationCode: "514102",
			occupationDescription: "مصفف شعر",
		},
		{
			occupationCode: "2402",
			occupationDescription: "مصلح أحذية جلدية (اسكافي )",
		},
		{
			occupationCode: "3243",
			occupationDescription: "مصلح أطارات مركبات",
		},
		{
			occupationCode: "432",
			occupationDescription: "مصلح احذية",
		},
		{
			occupationCode: "447",
			occupationDescription: "مصلح بنادق",
		},
		{
			occupationCode: "458",
			occupationDescription: "مصلح ساعات",
		},
		{
			occupationCode: "425",
			occupationDescription: "مصمم أزياء",
		},
		{
			occupationCode: "1493",
			occupationDescription: "مصمم أفراح",
		},
		{
			occupationCode: "988",
			occupationDescription: "مصمم اعلامي رقمي",
		},
		{
			occupationCode: "1388",
			occupationDescription: "مصمم برامج تعليمية",
		},
		{
			occupationCode: "965",
			occupationDescription: "مصمم تصميم البنية المؤسسية",
		},
		{
			occupationCode: "263",
			occupationDescription: "مصمم دعاية واعلان",
		},
		{
			occupationCode: "1888",
			occupationDescription: "مصمم طباعة",
		},
		{
			occupationCode: "1457",
			occupationDescription: "مصمم عرض",
		},
		{
			occupationCode: "1845",
			occupationDescription: "مصمم منتجات صناعية وتجارية",
		},
		{
			occupationCode: "2335",
			occupationDescription: "مصنف أخشاب",
		},
		{
			occupationCode: "2423",
			occupationDescription: "مصنف ألياف",
		},
		{
			occupationCode: "2382",
			occupationDescription: "مصنف جلود خام",
		},
		{
			occupationCode: "2173",
			occupationDescription: "مصنف ملابس وبياضات",
		},
		{
			occupationCode: "3462",
			occupationDescription: "مصنفر ودهان أخشاب",
		},
		{
			occupationCode: "2572",
			occupationDescription: "مصور الحفر الضوئي",
		},
		{
			occupationCode: "1510",
			occupationDescription: "مصور تلفازي",
		},
		{
			occupationCode: "1508",
			occupationDescription: "مصور سينمائي",
		},
		{
			occupationCode: "352107",
			occupationDescription: "مصور سينمائي",
		},
		{
			occupationCode: "1842",
			occupationDescription: "مصور صحفي",
		},
		{
			occupationCode: "1846",
			occupationDescription: "مصورأستوديو",
		},
		{
			occupationCode: "1847",
			occupationDescription: "مصورالاعلانات التجارية",
		},
		{
			occupationCode: "2205",
			occupationDescription: "مضمد",
		},
		{
			occupationCode: "320",
			occupationDescription: "مضيف",
		},
		{
			occupationCode: "2160",
			occupationDescription: "مضيف أرضي",
		},
		{
			occupationCode: "2161",
			occupationDescription: "مضيف جوي",
		},
		{
			occupationCode: "2162",
			occupationDescription: "مضيف سفينة",
		},
		{
			occupationCode: "2163",
			occupationDescription: "مضيف قطار/ حافلة",
		},
		{
			occupationCode: "428",
			occupationDescription: "مطرز",
		},
		{
			occupationCode: "2197",
			occupationDescription: "مطوف",
		},
		{
			occupationCode: "2573",
			occupationDescription: "مظهر طباعة صور",
		},
		{
			occupationCode: "2690",
			occupationDescription: "معالج أزالة الكبريت",
		},
		{
			occupationCode: "2446",
			occupationDescription: "معالج منسوجات صوفية بالأحماض",
		},
		{
			occupationCode: "2813",
			occupationDescription: "معالج نفايات",
		},
		{
			occupationCode: "1613",
			occupationDescription: "معاون مساح",
		},
		{
			occupationCode: "1559",
			occupationDescription: "معاين حوادث",
		},
		{
			occupationCode: "2539",
			occupationDescription: "معد صفحات",
		},
		{
			occupationCode: "2911",
			occupationDescription: "معقم منتجات الالبان",
		},
		{
			occupationCode: null,
			occupationDescription: "معقم مواد غذائية",
		},
		{
			occupationCode: "2873",
			occupationDescription: "معقم مواد غذائية",
		},
		{
			occupationCode: "2906",
			occupationDescription: "معلب اسماك",
		},
		{
			occupationCode: "1514",
			occupationDescription: "معلق رياضي",
		},
		{
			occupationCode: "1817",
			occupationDescription: "معلم اجتماعيات",
		},
		{
			occupationCode: null,
			occupationDescription: "معلم بروست",
		},
		{
			occupationCode: "405",
			occupationDescription: "معلم بروست",
		},
		{
			occupationCode: null,
			occupationDescription: "معلم حلويات",
		},
		{
			occupationCode: "400",
			occupationDescription: "معلم حلويات",
		},
		{
			occupationCode: "234",
			occupationDescription: "معلم ديكور",
		},
		{
			occupationCode: "335",
			occupationDescription: "معلم سندوتشات",
		},
		{
			occupationCode: null,
			occupationDescription: "معلم شاورما",
		},
		{
			occupationCode: "403",
			occupationDescription: "معلم شاورما",
		},
		{
			occupationCode: null,
			occupationDescription: "معلم عصيرات",
		},
		{
			occupationCode: "401",
			occupationDescription: "معلم عصيرات",
		},
		{
			occupationCode: "1818",
			occupationDescription: "معلم علوم",
		},
		{
			occupationCode: null,
			occupationDescription: "معلم فطائر",
		},
		{
			occupationCode: "404",
			occupationDescription: "معلم فطائر",
		},
		{
			occupationCode: null,
			occupationDescription: "معلم فول وفلافل",
		},
		{
			occupationCode: "406",
			occupationDescription: "معلم فول وفلافل",
		},
		{
			occupationCode: "1815",
			occupationDescription: "معلم لغة أجنبية",
		},
		{
			occupationCode: "1814",
			occupationDescription: "معلم لغة عربية",
		},
		{
			occupationCode: "418",
			occupationDescription: "معلم مشويات",
		},
		{
			occupationCode: "1383",
			occupationDescription: "معيد",
		},
		{
			occupationCode: "2200",
			occupationDescription: "مغسل موتى",
		},
		{
			occupationCode: "238",
			occupationDescription: "مغني",
		},
		{
			occupationCode: "265201",
			occupationDescription: "مغني",
		},
		{
			occupationCode: "1961",
			occupationDescription: "مفتش تذاكر",
		},
		{
			occupationCode: "1966",
			occupationDescription: "مفتش خدمات النقل البري للركاب",
		},
		{
			occupationCode: "1964",
			occupationDescription: "مفتش خدمات نقل سكك حديدية",
		},
		{
			occupationCode: "1433",
			occupationDescription: "مفتي",
		},
		{
			occupationCode: "2630",
			occupationDescription: "مفجر",
		},
		{
			occupationCode: "2388",
			occupationDescription: "مفصل أحذية بالالة",
		},
		{
			occupationCode: "2387",
			occupationDescription: "مفصل أحذية يدوي",
		},
		{
			occupationCode: "2495",
			occupationDescription: "مفصل أزياء عام",
		},
		{
			occupationCode: null,
			occupationDescription: "مفصل عقال",
		},
		{
			occupationCode: "2522",
			occupationDescription: "مفصل عقال",
		},
		{
			occupationCode: "426",
			occupationDescription: "مفصل ملابس",
		},
		{
			occupationCode: "2497",
			occupationDescription: "مفصل ملابس أفرنجي",
		},
		{
			occupationCode: "2398",
			occupationDescription: "مفصل نعال",
		},
		{
			occupationCode: "2502",
			occupationDescription: "مفصل وخياط كوت (جاكت)",
		},
		{
			occupationCode: "1464",
			occupationDescription: "مفهرس كتب ومطبوعات",
		},
		{
			occupationCode: "2148",
			occupationDescription: "مقدم طعام",
		},
		{
			occupationCode: "2147",
			occupationDescription: "مقدم طعام رئيسي",
		},
		{
			occupationCode: "2155",
			occupationDescription: "مقدم قهوة",
		},
		{
			occupationCode: "1862",
			occupationDescription: "مقرر اجتماعات",
		},
		{
			occupationCode: "2193",
			occupationDescription: "مقرىء",
		},
		{
			occupationCode: "2899",
			occupationDescription: "مقطع لحم",
		},
		{
			occupationCode: "2904",
			occupationDescription: "مقطع ومنظف أسماك",
		},
		{
			occupationCode: "2264",
			occupationDescription: "مقلم أشجار",
		},
		{
			occupationCode: "2126",
			occupationDescription: "مقلم أظافر",
		},
		{
			occupationCode: "1534",
			occupationDescription: "مقيم آلات ومعدات",
		},
		{
			occupationCode: "1536",
			occupationDescription: "مقيم اضرار حوادث مركبات",
		},
		{
			occupationCode: "1533",
			occupationDescription: "مقيم عقار",
		},
		{
			occupationCode: null,
			occupationDescription: "مقيم مصوغات ومعادن نفيسة",
		},
		{
			occupationCode: "1535",
			occupationDescription: "مقيم منشآت اقتصادية",
		},
		{
			occupationCode: "2571",
			occupationDescription: "مكبر صور فوتوغرافية",
		},
		{
			occupationCode: "342",
			occupationDescription: "مكوجي",
		},
		{
			occupationCode: "110",
			occupationDescription: "ملاح بحري",
		},
		{
			occupationCode: "104",
			occupationDescription: "ملاح جوي",
		},
		{
			occupationCode: "295",
			occupationDescription: "ملاحظ",
		},
		{
			occupationCode: "2676",
			occupationDescription: "ملاحظ تشغيل حفارة بالحبل",
		},
		{
			occupationCode: "2653",
			occupationDescription: "ملاحظ تشغيل فرن توماس للصلب",
		},
		{
			occupationCode: "2987",
			occupationDescription: "ملاحظ تشغيل فرن صهر المعادن",
		},
		{
			occupationCode: "3387",
			occupationDescription: "ملاحظ تشغيل فرن كهربائي",
		},
		{
			occupationCode: "2679",
			occupationDescription: "ملاحظ جهاز تقطير/تكرير البترول",
		},
		{
			occupationCode: "296",
			occupationDescription: "ملاحظ خطوط",
		},
		{
			occupationCode: "1031",
			occupationDescription: "ملاحظ متابعة مواد",
		},
		{
			occupationCode: "2677",
			occupationDescription: "ملاحظ معالجة آبار زيت وغاز",
		},
		{
			occupationCode: "2691",
			occupationDescription: "ملاحظ معالجة الزيت",
		},
		{
			occupationCode: "2652",
			occupationDescription: "ملاحظ معدات ترسيب المعادن",
		},
		{
			occupationCode: "2447",
			occupationDescription: "ملبد صوف",
		},
		{
			occupationCode: "723",
			occupationDescription: "ملحق اداري",
		},
		{
			occupationCode: "725",
			occupationDescription: "ملحق تعليمي",
		},
		{
			occupationCode: "718",
			occupationDescription: "ملحق ثقافي",
		},
		{
			occupationCode: "726",
			occupationDescription: "ملحق صحي",
		},
		{
			occupationCode: "719",
			occupationDescription: "ملحق عسكري",
		},
		{
			occupationCode: "722",
			occupationDescription: "ملحق عمالي",
		},
		{
			occupationCode: "239",
			occupationDescription: "ملحن",
		},
		{
			occupationCode: "265202",
			occupationDescription: "ملحن",
		},
		{
			occupationCode: null,
			occupationDescription: "مليس",
		},
		{
			occupationCode: "540",
			occupationDescription: "مليس",
		},
		{
			occupationCode: "240",
			occupationDescription: "ممثل",
		},
		{
			occupationCode: "190",
			occupationDescription: "ممرض",
		},
		{
			occupationCode: "1748",
			occupationDescription: "ممرض أسعاف أولي  او  طواريء",
		},
		{
			occupationCode: "1790",
			occupationDescription: "ممرض بيطري",
		},
		{
			occupationCode: "1747",
			occupationDescription: "ممرض عام",
		},
		{
			occupationCode: "1757",
			occupationDescription: "ممرض متخصص",
		},
		{
			occupationCode: "191",
			occupationDescription: "ممرض مساعد",
		},
		{
			occupationCode: "2239",
			occupationDescription: "ممرض منزلي",
		},
		{
			occupationCode: "1751",
			occupationDescription: "ممرض نقل دم",
		},
		{
			occupationCode: "1749",
			occupationDescription: "ممرضة توليد وأمراض نسائية",
		},
		{
			occupationCode: "736",
			occupationDescription: "منتج ألبان",
		},
		{
			occupationCode: "242",
			occupationDescription: "منتج سينمائي",
		},
		{
			occupationCode: "241",
			occupationDescription: "منتج مسرحي",
		},
		{
			occupationCode: "429",
			occupationDescription: "منجد أثاث",
		},
		{
			occupationCode: "3467",
			occupationDescription: "منجد ستائر",
		},
		{
			occupationCode: "430",
			occupationDescription: "منجد سيارات",
		},
		{
			occupationCode: "3463",
			occupationDescription: "منجد عام",
		},
		{
			occupationCode: "3468",
			occupationDescription: "منجد فرش",
		},
		{
			occupationCode: "3465",
			occupationDescription: "منجد مركبات",
		},
		{
			occupationCode: "316",
			occupationDescription: "مندوب",
		},
		{
			occupationCode: "1994",
			occupationDescription: "مندوب خدمات سلعية",
		},
		{
			occupationCode: "727",
			occupationDescription: "مندوب دائم",
		},
		{
			occupationCode: "318",
			occupationDescription: "مندوب دعاية واعلان",
		},
		{
			occupationCode: "317",
			occupationDescription: "مندوب مشتريات",
		},
		{
			occupationCode: "1104",
			occupationDescription: "منسق أنظمة جودة",
		},
		{
			occupationCode: "1896",
			occupationDescription: "منسق اداري طبي",
		},
		{
			occupationCode: "292",
			occupationDescription: "منسق برامج",
		},
		{
			occupationCode: "293",
			occupationDescription: "منسق جودة ونوعية",
		},
		{
			occupationCode: "2536",
			occupationDescription: "منضد حروف",
		},
		{
			occupationCode: "2897",
			occupationDescription: "منظف أحشاء وأطراف الذبائح",
		},
		{
			occupationCode: "2898",
			occupationDescription: "منظف أحشاء وريش الدواجن",
		},
		{
			occupationCode: "1787",
			occupationDescription: "منظف أسنان",
		},
		{
			occupationCode: "2149",
			occupationDescription: "منظف أواني",
		},
		{
			occupationCode: "2369",
			occupationDescription: "منظف الادمة",
		},
		{
			occupationCode: "2366",
			occupationDescription: "منظف ومجفف جلود",
		},
		{
			occupationCode: "1472",
			occupationDescription: "منظم برامج أعلامية",
		},
		{
			occupationCode: "1537",
			occupationDescription: "منظم ميزانية",
		},
		{
			occupationCode: "2206",
			occupationDescription: "منقذ",
		},
		{
			occupationCode: "2209",
			occupationDescription: "منقذ سباحة",
		},
		{
			occupationCode: "53",
			occupationDescription: "مهندس",
		},
		{
			occupationCode: "1055",
			occupationDescription: "مهندس آلات زراعية",
		},
		{
			occupationCode: "1059",
			occupationDescription: "مهندس آلات وماكينات صناعية",
		},
		{
			occupationCode: "1034",
			occupationDescription: "مهندس أذاعة وتلفزة",
		},
		{
			occupationCode: "1039",
			occupationDescription: "مهندس ألكتروني صيانة",
		},
		{
			occupationCode: "1014",
			occupationDescription: "مهندس أول مساحة",
		},
		{
			occupationCode: "62",
			occupationDescription: "مهندس اتصالات",
		},
		{
			occupationCode: "215301",
			occupationDescription: "مهندس اتصالات",
		},
		{
			occupationCode: "1083",
			occupationDescription: "مهندس استخراج معادن",
		},
		{
			occupationCode: "65",
			occupationDescription: "مهندس الآت",
		},
		{
			occupationCode: "1023",
			occupationDescription: "مهندس الطاقة الكهربائية",
		},
		{
			occupationCode: "1037",
			occupationDescription: "مهندس الكتروني أجهزة طبية",
		},
		{
			occupationCode: "1033",
			occupationDescription: "مهندس الكتروني عام",
		},
		{
			occupationCode: "51",
			occupationDescription: "مهندس الكترونيات",
		},
		{
			occupationCode: "63",
			occupationDescription: "مهندس انتاج",
		},
		{
			occupationCode: "214102",
			occupationDescription: "مهندس انتاج",
		},
		{
			occupationCode: "73",
			occupationDescription: "مهندس بترول",
		},
		{
			occupationCode: "1035",
			occupationDescription: "مهندس بث أرسال",
		},
		{
			occupationCode: "1107",
			occupationDescription: "مهندس بيئة",
		},
		{
			occupationCode: "56",
			occupationDescription: "مهندس تبريد",
		},
		{
			occupationCode: "59",
			occupationDescription: "مهندس تخطيط شبكة",
		},
		{
			occupationCode: "991",
			occupationDescription: "مهندس تخطيط مدن",
		},
		{
			occupationCode: "1088",
			occupationDescription: "مهندس تخطيط مصانع",
		},
		{
			occupationCode: "57",
			occupationDescription: "مهندس تراسل",
		},
		{
			occupationCode: "1065",
			occupationDescription: "مهندس ترس هبوط الطائرة",
		},
		{
			occupationCode: "1089",
			occupationDescription: "مهندس تركيب معدات صناعية",
		},
		{
			occupationCode: "992",
			occupationDescription: "مهندس تصميم داخلي",
		},
		{
			occupationCode: "1090",
			occupationDescription: "مهندس تصنيع",
		},
		{
			occupationCode: "1067",
			occupationDescription: "مهندس تطوير انتاج ورش الطائرات",
		},
		{
			occupationCode: "1093",
			occupationDescription: "مهندس تطوير ومواصفات",
		},
		{
			occupationCode: "1082",
			occupationDescription: "مهندس تفجير",
		},
		{
			occupationCode: "52",
			occupationDescription: "مهندس تكييف",
		},
		{
			occupationCode: "990",
			occupationDescription: "مهندس تنسيق مواقع",
		},
		{
			occupationCode: "66",
			occupationDescription: "مهندس جوي",
		},
		{
			occupationCode: "1070",
			occupationDescription: "مهندس جيربوكس طائرات ومدفعية",
		},
		{
			occupationCode: "1078",
			occupationDescription: "مهندس جيولوجي",
		},
		{
			occupationCode: "75",
			occupationDescription: "مهندس حاسب ألي",
		},
		{
			occupationCode: "1081",
			occupationDescription: "مهندس حفر آبار",
		},
		{
			occupationCode: "1101",
			occupationDescription: "مهندس حماية كاثودية",
		},
		{
			occupationCode: "1099",
			occupationDescription: "مهندس دراسة الوقت والحركة",
		},
		{
			occupationCode: "72",
			occupationDescription: "مهندس ديكور",
		},
		{
			occupationCode: "1040",
			occupationDescription: "مهندس راديو ورادار طائرات",
		},
		{
			occupationCode: "77",
			occupationDescription: "مهندس زراعي",
		},
		{
			occupationCode: "213201",
			occupationDescription: "مهندس زراعي",
		},
		{
			occupationCode: "111",
			occupationDescription: "مهندس سفن",
		},
		{
			occupationCode: "1091",
			occupationDescription: "مهندس سلامة وصحة مهنية",
		},
		{
			occupationCode: "68",
			occupationDescription: "مهندس سيارات",
		},
		{
			occupationCode: "971",
			occupationDescription: "مهندس شبكات",
		},
		{
			occupationCode: "60",
			occupationDescription: "مهندس شبكات الأقمار الصناعية",
		},
		{
			occupationCode: "1009",
			occupationDescription: "مهندس شبكات الضبط المساحي",
		},
		{
			occupationCode: "1106",
			occupationDescription: "مهندس صحي مياه ومجاري",
		},
		{
			occupationCode: "214303",
			occupationDescription: "مهندس صحي مياه ومجاري",
		},
		{
			occupationCode: "74",
			occupationDescription: "مهندس صناعي",
		},
		{
			occupationCode: "54",
			occupationDescription: "مهندس صيانة",
		},
		{
			occupationCode: "1056",
			occupationDescription: "مهندس طاقة وتقنية نووية",
		},
		{
			occupationCode: "105",
			occupationDescription: "مهندس طيار",
		},
		{
			occupationCode: "1098",
			occupationDescription: "مهندس طيران",
		},
		{
			occupationCode: "214404",
			occupationDescription: "مهندس طيران",
		},
		{
			occupationCode: "1108",
			occupationDescription: "مهندس كفاءة في تحلية المياه",
		},
		{
			occupationCode: "50",
			occupationDescription: "مهندس كهرباء",
		},
		{
			occupationCode: "1029",
			occupationDescription: "مهندس كهربائي أجهزة دقيقة",
		},
		{
			occupationCode: "1027",
			occupationDescription: "مهندس كهربائي تمديدات",
		},
		{
			occupationCode: "1026",
			occupationDescription: "مهندس كهربائي توزيع",
		},
		{
			occupationCode: "1030",
			occupationDescription: "مهندس كهربائي مراقبة وتحكم",
		},
		{
			occupationCode: "1025",
			occupationDescription: "مهندس كهربائي نقل",
		},
		{
			occupationCode: "1024",
			occupationDescription: "مهندس كهربائي نقل وتوزيع",
		},
		{
			occupationCode: "1032",
			occupationDescription: "مهندس كهربائي وقاية",
		},
		{
			occupationCode: "69",
			occupationDescription: "مهندس كيميائي",
		},
		{
			occupationCode: "1073",
			occupationDescription: "مهندس كيميائي ( بحث وتطوير)",
		},
		{
			occupationCode: "1076",
			occupationDescription: "مهندس كيميائي صناعات أسمدة",
		},
		{
			occupationCode: "1077",
			occupationDescription: "مهندس كيميائي صناعات غذائية",
		},
		{
			occupationCode: "1074",
			occupationDescription: "مهندس كيميائي صناعات نفطية",
		},
		{
			occupationCode: "1086",
			occupationDescription: "مهندس محاجر",
		},
		{
			occupationCode: "45",
			occupationDescription: "مهندس مدني",
		},
		{
			occupationCode: "214201",
			occupationDescription: "مهندس مدني",
		},
		{
			occupationCode: "996",
			occupationDescription: "مهندس مدني ( انشاءات معدنية )",
		},
		{
			occupationCode: "998",
			occupationDescription: "مهندس مدني ( جسور )",
		},
		{
			occupationCode: "1003",
			occupationDescription: "مهندس مدني ( ري )",
		},
		{
			occupationCode: "1002",
			occupationDescription: "مهندس مدني ( سدود )",
		},
		{
			occupationCode: "1001",
			occupationDescription: "مهندس مدني ( سكك حديدية )",
		},
		{
			occupationCode: "997",
			occupationDescription: "مهندس مدني ( طرق )",
		},
		{
			occupationCode: "214206",
			occupationDescription: "مهندس مدني ( طرق )",
		},
		{
			occupationCode: "1004",
			occupationDescription: "مهندس مدني ( مرور)",
		},
		{
			occupationCode: "999",
			occupationDescription: "مهندس مدني ( مطارات)",
		},
		{
			occupationCode: "1000",
			occupationDescription: "مهندس مدني ( موانىء )",
		},
		{
			occupationCode: "1094",
			occupationDescription: "مهندس مراقبة جودة",
		},
		{
			occupationCode: "1069",
			occupationDescription: "مهندس مراوح دفع للطائرات",
		},
		{
			occupationCode: "1008",
			occupationDescription: "مهندس مساحة بحريه",
		},
		{
			occupationCode: "1007",
			occupationDescription: "مهندس مساحة جوية",
		},
		{
			occupationCode: "1006",
			occupationDescription: "مهندس مساحة عام",
		},
		{
			occupationCode: "55",
			occupationDescription: "مهندس مشروع",
		},
		{
			occupationCode: "70",
			occupationDescription: "مهندس معادن",
		},
		{
			occupationCode: "1064",
			occupationDescription: "مهندس معالجة مكونات فرامل",
		},
		{
			occupationCode: "1068",
			occupationDescription: "مهندس معايرة طائرات عسكرية",
		},
		{
			occupationCode: "22",
			occupationDescription: "مهندس معماري",
		},
		{
			occupationCode: "216101",
			occupationDescription: "مهندس معماري",
		},
		{
			occupationCode: "61",
			occupationDescription: "مهندس مكالمات بعيدة المدى",
		},
		{
			occupationCode: "71",
			occupationDescription: "مهندس مناجم",
		},
		{
			occupationCode: "1092",
			occupationDescription: "مهندس مناولة مواد",
		},
		{
			occupationCode: "1095",
			occupationDescription: "مهندس مواد",
		},
		{
			occupationCode: "1005",
			occupationDescription: "مهندس ميكانيكا التربة",
		},
		{
			occupationCode: "64",
			occupationDescription: "مهندس ميكانيكي",
		},
		{
			occupationCode: "1051",
			occupationDescription: "مهندس ميكانيكي آليات طرق",
		},
		{
			occupationCode: "1044",
			occupationDescription: "مهندس ميكانيكي أنتاج",
		},
		{
			occupationCode: "1047",
			occupationDescription: "مهندس ميكانيكي تكييف مركزي",
		},
		{
			occupationCode: "1045",
			occupationDescription: "مهندس ميكانيكي سكب",
		},
		{
			occupationCode: "1058",
			occupationDescription: "مهندس ميكانيكي صناعة السفن",
		},
		{
			occupationCode: "1054",
			occupationDescription: "مهندس ميكانيكي صيانة سفن",
		},
		{
			occupationCode: "1053",
			occupationDescription: "مهندس ميكانيكي صيانة طائرات",
		},
		{
			occupationCode: "1052",
			occupationDescription: "مهندس ميكانيكي صيانة قطارات",
		},
		{
			occupationCode: "1057",
			occupationDescription: "مهندس ميكانيكي عام",
		},
		{
			occupationCode: "1046",
			occupationDescription: "مهندس ميكانيكي لحام",
		},
		{
			occupationCode: "1060",
			occupationDescription: "مهندس ميكانيكي محركات",
		},
		{
			occupationCode: "1050",
			occupationDescription: "مهندس ميكانيكي مركبات",
		},
		{
			occupationCode: "1049",
			occupationDescription: "مهندس ميكانيكي موائع هيدروليك",
		},
		{
			occupationCode: "58",
			occupationDescription: "مهندس ميكرويف",
		},
		{
			occupationCode: "67",
			occupationDescription: "مهندس هياكل طيارات",
		},
		{
			occupationCode: "1063",
			occupationDescription: "مهندس وحدات الطاقة المساعدة",
		},
		{
			occupationCode: "2459",
			occupationDescription: "مهيىء آلة التريكو",
		},
		{
			occupationCode: "224",
			occupationDescription: "موجه تربوي",
		},
		{
			occupationCode: "1918",
			occupationDescription: "موزع بريد ( ساعي )",
		},
		{
			occupationCode: null,
			occupationDescription: "موزع صحف ومطبوعات",
		},
		{
			occupationCode: "2067",
			occupationDescription: "موزع صحف ومطبوعات",
		},
		{
			occupationCode: "1495",
			occupationDescription: "موزع موسيقى",
		},
		{
			occupationCode: "237",
			occupationDescription: "موسيقي",
		},
		{
			occupationCode: "275",
			occupationDescription: "موظف اداري",
		},
		{
			occupationCode: "310",
			occupationDescription: "موظف استقبال",
		},
		{
			occupationCode: "422601",
			occupationDescription: "موظف استقبال",
		},
		{
			occupationCode: "319",
			occupationDescription: "موظف المبيعات",
		},
		{
			occupationCode: "311",
			occupationDescription: "موظف حجز",
		},
		{
			occupationCode: "1",
			occupationDescription: "موظف حكومي",
		},
		{
			occupationCode: "12",
			occupationDescription: "موظف حكومي",
		},
		{
			occupationCode: "312",
			occupationDescription: "موظف طيران",
		},
		{
			occupationCode: "11",
			occupationDescription: "موظف قطاع خاص",
		},
		{
			occupationCode: "474",
			occupationDescription: "ميكانيكي",
		},
		{
			occupationCode: "466",
			occupationDescription: "ميكانيكي آلات",
		},
		{
			occupationCode: "3138",
			occupationDescription: "ميكانيكي آلات غسيل وكي",
		},
		{
			occupationCode: "3307",
			occupationDescription: "ميكانيكي آليات ثقيلة  او  عام",
		},
		{
			occupationCode: "3309",
			occupationDescription: "ميكانيكي آليات ثقيلة عجلات",
		},
		{
			occupationCode: "3308",
			occupationDescription: "ميكانيكي آليات ثقيلة مجنزرة",
		},
		{
			occupationCode: "3313",
			occupationDescription: "ميكانيكي آليات زراعية  او  عام",
		},
		{
			occupationCode: "3165",
			occupationDescription: "ميكانيكي أجهزة تبريد مركزي",
		},
		{
			occupationCode: "3166",
			occupationDescription: "ميكانيكي أجهزة تبريد منزلية",
		},
		{
			occupationCode: "3159",
			occupationDescription: "ميكانيكي أجهزة تكييف مركزي",
		},
		{
			occupationCode: "3143",
			occupationDescription: "ميكانيكي أجهزة دقيقة عام",
		},
		{
			occupationCode: "3145",
			occupationDescription: "ميكانيكي أجهزة قياس",
		},
		{
			occupationCode: "3139",
			occupationDescription: "ميكانيكي أجهزة مناولة الموا",
		},
		{
			occupationCode: "3157",
			occupationDescription: "ميكانيكي أصلاح بوتاجاز منزل",
		},
		{
			occupationCode: "3285",
			occupationDescription: "ميكانيكي اصلاح جسم الطائرة",
		},
		{
			occupationCode: "3164",
			occupationDescription: "ميكانيكي تبريد  او  عام",
		},
		{
			occupationCode: "3044",
			occupationDescription: "ميكانيكي تجميع ماكينة زراعي",
		},
		{
			occupationCode: "3041",
			occupationDescription: "ميكانيكي تجميع ماكينة طباعة",
		},
		{
			occupationCode: "2458",
			occupationDescription: "ميكانيكي تجهيز أنوال الجاكارد",
		},
		{
			occupationCode: "3317",
			occupationDescription: "ميكانيكي تجهيزات الري والرش",
		},
		{
			occupationCode: "2457",
			occupationDescription: "ميكانيكي تجهيزالانوال الالي",
		},
		{
			occupationCode: "3170",
			occupationDescription: "ميكانيكي تدفئة مركزية",
		},
		{
			occupationCode: "3169",
			occupationDescription: "ميكانيكي تدفئة مركزية عام",
		},
		{
			occupationCode: "3125",
			occupationDescription: "ميكانيكي تركيب معدات صناعية",
		},
		{
			occupationCode: "3124",
			occupationDescription: "ميكانيكي تركيب معدات عام",
		},
		{
			occupationCode: "3268",
			occupationDescription: "ميكانيكي ترميم عجلات قطار",
		},
		{
			occupationCode: "3158",
			occupationDescription: "ميكانيكي تكييف عام",
		},
		{
			occupationCode: "3180",
			occupationDescription: "ميكانيكي تمديد شبكات غاز",
		},
		{
			occupationCode: "3179",
			occupationDescription: "ميكانيكي تمديد شبكات نفط",
		},
		{
			occupationCode: "3175",
			occupationDescription: "ميكانيكي تمديدات صحية عام",
		},
		{
			occupationCode: "3288",
			occupationDescription: "ميكانيكي توربين بخاري",
		},
		{
			occupationCode: "3287",
			occupationDescription: "ميكانيكي توربين بخاري عام",
		},
		{
			occupationCode: "3296",
			occupationDescription: "ميكانيكي توربين غازي",
		},
		{
			occupationCode: "3301",
			occupationDescription: "ميكانيكي توربين مائي",
		},
		{
			occupationCode: "3300",
			occupationDescription: "ميكانيكي توربين مائي  او  عام",
		},
		{
			occupationCode: "3314",
			occupationDescription: "ميكانيكي جرار زراعي",
		},
		{
			occupationCode: "3235",
			occupationDescription: "ميكانيكي جرارات",
		},
		{
			occupationCode: "3233",
			occupationDescription: "ميكانيكي حافلات وشاحنات عام",
		},
		{
			occupationCode: "3315",
			occupationDescription: "ميكانيكي حصاده",
		},
		{
			occupationCode: "3241",
			occupationDescription: "ميكانيكي خدمة سريعة",
		},
		{
			occupationCode: "3283",
			occupationDescription: "ميكانيكي خدمة ميدانية للطائرات",
		},
		{
			occupationCode: "3257",
			occupationDescription: "ميكانيكي دراجة نارية",
		},
		{
			occupationCode: "3258",
			occupationDescription: "ميكانيكي دراجة هوائية",
		},
		{
			occupationCode: "3271",
			occupationDescription: "ميكانيكي سفن عام",
		},
		{
			occupationCode: "467",
			occupationDescription: "ميكانيكي سيارات",
		},
		{
			occupationCode: "3269",
			occupationDescription: "ميكانيكي صمامات قطار",
		},
		{
			occupationCode: "3150",
			occupationDescription: "ميكانيكي صيانة آلات الاستنساخ",
		},
		{
			occupationCode: "3132",
			occupationDescription: "ميكانيكي صيانة آلات الخياطة",
		},
		{
			occupationCode: "3130",
			occupationDescription: "ميكانيكي صيانة آلات الغزل",
		},
		{
			occupationCode: "3133",
			occupationDescription: "ميكانيكي صيانة آلات المطابع",
		},
		{
			occupationCode: "3131",
			occupationDescription: "ميكانيكي صيانة آلات النسيج",
		},
		{
			occupationCode: "3149",
			occupationDescription: "ميكانيكي صيانة آلات كاتبة",
		},
		{
			occupationCode: "3148",
			occupationDescription: "ميكانيكي صيانة آلات مكتبية عام",
		},
		{
			occupationCode: "3151",
			occupationDescription: "ميكانيكي صيانة آلة موسيقية",
		},
		{
			occupationCode: "3154",
			occupationDescription: "ميكانيكي صيانة أفران عام",
		},
		{
			occupationCode: "3155",
			occupationDescription: "ميكانيكي صيانة أفران غاز",
		},
		{
			occupationCode: "3156",
			occupationDescription: "ميكانيكي صيانة أفران نفط",
		},
		{
			occupationCode: "3147",
			occupationDescription: "ميكانيكي صيانة بصريات",
		},
		{
			occupationCode: "3286",
			occupationDescription: "ميكانيكي صيانة طائرات",
		},
		{
			occupationCode: "3172",
			occupationDescription: "ميكانيكي صيانة مراجل",
		},
		{
			occupationCode: "3137",
			occupationDescription: "ميكانيكي صيانة مضخات وضواغط",
		},
		{
			occupationCode: "3128",
			occupationDescription: "ميكانيكي صيانة معدات صناعية",
		},
		{
			occupationCode: "3153",
			occupationDescription: "ميكانيكي صيانة منشأة صناعية",
		},
		{
			occupationCode: "3127",
			occupationDescription: "ميكانيكي صيانة ميكانيكية عام",
		},
		{
			occupationCode: "3239",
			occupationDescription: "ميكانيكي فرامل",
		},
		{
			occupationCode: "3267",
			occupationDescription: "ميكانيكي فرامل قطار",
		},
		{
			occupationCode: "3265",
			occupationDescription: "ميكانيكي قطارات / عام",
		},
		{
			occupationCode: "3274",
			occupationDescription: "ميكانيكي قوارب صغيرة",
		},
		{
			occupationCode: "3136",
			occupationDescription: "ميكانيكي ماكينة أشغال الخشب",
		},
		{
			occupationCode: "3134",
			occupationDescription: "ميكانيكي ماكينة تعدين",
		},
		{
			occupationCode: "3152",
			occupationDescription: "ميكانيكي ماكينة مكتبية",
		},
		{
			occupationCode: "3238",
			occupationDescription: "ميكانيكي مجموعة التوجيه",
		},
		{
			occupationCode: "3273",
			occupationDescription: "ميكانيكي مجموعة الدفع والتوجيه",
		},
		{
			occupationCode: "3245",
			occupationDescription: "ميكانيكي مجموعة العادم",
		},
		{
			occupationCode: "3284",
			occupationDescription: "ميكانيكي مجموعة العجلات",
		},
		{
			occupationCode: "3240",
			occupationDescription: "ميكانيكي مجموعة نقل الحركة",
		},
		{
			occupationCode: "3237",
			occupationDescription: "ميكانيكي محرك بنزين",
		},
		{
			occupationCode: "3236",
			occupationDescription: "ميكانيكي محرك ديزل",
		},
		{
			occupationCode: "3279",
			occupationDescription: "ميكانيكي محرك طائرات توربين",
		},
		{
			occupationCode: "3281",
			occupationDescription: "ميكانيكي محرك طائرات توربيني",
		},
		{
			occupationCode: "3280",
			occupationDescription: "ميكانيكي محرك طائره/عام",
		},
		{
			occupationCode: "3266",
			occupationDescription: "ميكانيكي محرك قطار",
		},
		{
			occupationCode: "465",
			occupationDescription: "ميكانيكي محركات",
		},
		{
			occupationCode: "3272",
			occupationDescription: "ميكانيكي محركات سفن",
		},
		{
			occupationCode: "3234",
			occupationDescription: "ميكانيكي مركبات خفيفة/عام",
		},
		{
			occupationCode: "3135",
			occupationDescription: "ميكانيكي مشغولات معدنية",
		},
		{
			occupationCode: "462",
			occupationDescription: "ميكانيكي مضخات",
		},
		{
			occupationCode: "3242",
			occupationDescription: "ميكانيكي مضخات حقن ديزل",
		},
		{
			occupationCode: "468",
			occupationDescription: "ميكانيكي معدات",
		},
		{
			occupationCode: "3270",
			occupationDescription: "ميكانيكي مفاتيح سكك الحديد",
		},
		{
			occupationCode: "3161",
			occupationDescription: "ميكانيكي مكيف مركبات",
		},
		{
			occupationCode: "3160",
			occupationDescription: "ميكانيكي مكيفات منزلية",
		},
		{
			occupationCode: "3129",
			occupationDescription: "ميكانيكي نصب ماكينة وتركيبها",
		},
		{
			occupationCode: "3311",
			occupationDescription: "ميكانيكي هيدروليك",
		},
		{
			occupationCode: null,
			occupationDescription: "نائب الرئيس",
		},
		{
			occupationCode: "890",
			occupationDescription: "نائب الرئيس",
		},
		{
			occupationCode: "703",
			occupationDescription: "نائب قنصل",
		},
		{
			occupationCode: "702",
			occupationDescription: "نائب قنصل عام",
		},
		{
			occupationCode: "721",
			occupationDescription: "نائب ملحق عسكري",
		},
		{
			occupationCode: "281",
			occupationDescription: "ناسخ آلة",
		},
		{
			occupationCode: "2460",
			occupationDescription: "ناسخ رسوم الجاكارد",
		},
		{
			occupationCode: "280",
			occupationDescription: "ناسخ طبي",
		},
		{
			occupationCode: "1446",
			occupationDescription: "ناقد أدبي",
		},
		{
			occupationCode: "1490",
			occupationDescription: "ناقد فنون تشكيلية",
		},
		{
			occupationCode: "1507",
			occupationDescription: "ناقد فني",
		},
		{
			occupationCode: "1500",
			occupationDescription: "ناقد موسيقي",
		},
		{
			occupationCode: "2574",
			occupationDescription: "ناقل الصور الشمسية",
		},
		{
			occupationCode: "536",
			occupationDescription: "نجار",
		},
		{
			occupationCode: "711501",
			occupationDescription: "نجار",
		},
		{
			occupationCode: "3430",
			occupationDescription: "نجار أثاث خيزراني",
		},
		{
			occupationCode: "3427",
			occupationDescription: "نجار أثاث عام",
		},
		{
			occupationCode: "3448",
			occupationDescription: "نجار أساسات خشبية مؤقتة للسفن",
		},
		{
			occupationCode: "3446",
			occupationDescription: "نجار باب وشباك",
		},
		{
			occupationCode: "3449",
			occupationDescription: "نجار تركيبات خشبية للسفن",
		},
		{
			occupationCode: "3475",
			occupationDescription: "نجار جدران وأرضيات",
		},
		{
			occupationCode: "3445",
			occupationDescription: "نجار جمالونات قرميد",
		},
		{
			occupationCode: "3474",
			occupationDescription: "نجار ديكور",
		},
		{
			occupationCode: "3473",
			occupationDescription: "نجار ديكور عام",
		},
		{
			occupationCode: "3450",
			occupationDescription: "نجار سفينة",
		},
		{
			occupationCode: "711504",
			occupationDescription: "نجار سفينة",
		},
		{
			occupationCode: "3451",
			occupationDescription: "نجار طائرة",
		},
		{
			occupationCode: "3452",
			occupationDescription: "نجار طاولة بنك",
		},
		{
			occupationCode: "3440",
			occupationDescription: "نجار قوارب",
		},
		{
			occupationCode: "3491",
			occupationDescription: "نجار قوالب خرسانيه",
		},
		{
			occupationCode: "3441",
			occupationDescription: "نجار كعوب أحذية",
		},
		{
			occupationCode: null,
			occupationDescription: "نجار مباني",
		},
		{
			occupationCode: "538",
			occupationDescription: "نجار مباني",
		},
		{
			occupationCode: "3442",
			occupationDescription: "نجار مباني عام",
		},
		{
			occupationCode: "3439",
			occupationDescription: "نجار مركبات",
		},
		{
			occupationCode: "537",
			occupationDescription: "نجار موبيليا",
		},
		{
			occupationCode: "3431",
			occupationDescription: "نجارحفر",
		},
		{
			occupationCode: "3432",
			occupationDescription: "نجارصدفيات",
		},
		{
			occupationCode: "3433",
			occupationDescription: "نجارقشرة",
		},
		{
			occupationCode: "236",
			occupationDescription: "نحات",
		},
		{
			occupationCode: "265102",
			occupationDescription: "نحات",
		},
		{
			occupationCode: "438",
			occupationDescription: "نحات حجارة",
		},
		{
			occupationCode: "3112",
			occupationDescription: "نحاس أواني منزلية",
		},
		{
			occupationCode: "3111",
			occupationDescription: "نحاس عام",
		},
		{
			occupationCode: "362",
			occupationDescription: "نحال",
		},
		{
			occupationCode: "612301",
			occupationDescription: "نحال",
		},
		{
			occupationCode: "2479",
			occupationDescription: "نساج قش وسعف",
		},
		{
			occupationCode: "2449",
			occupationDescription: "نشاء منسوجات",
		},
		{
			occupationCode: "2749",
			occupationDescription: "نفاخ زجاج",
		},
		{
			occupationCode: "3484",
			occupationDescription: "نقاش حجر",
		},
		{
			occupationCode: "2790",
			occupationDescription: "نقاش خزف",
		},
		{
			occupationCode: "514",
			occupationDescription: "نقاش زجاج",
		},
		{
			occupationCode: "1489",
			occupationDescription: "نقاش وحفار فني",
		},
		{
			occupationCode: "2288",
			occupationDescription: "هجان",
		},
		{
			occupationCode: "2598",
			occupationDescription: "واضع تصاميم على الاحجار",
		},
		{
			occupationCode: "1904",
			occupationDescription: "وزان",
		},
		{
			occupationCode: "111101",
			occupationDescription: "وزير",
		},
		{
			occupationCode: "705",
			occupationDescription: "وزير مفوض (أ)",
		},
		{
			occupationCode: "706",
			occupationDescription: "وزير مفوض (ب)",
		},
		{
			occupationCode: "2004",
			occupationDescription: "وسيط بيع وتأجير عقارات",
		},
		{
			occupationCode: "2003",
			occupationDescription: "وسيط تأمين أخطار الشحن",
		},
		{
			occupationCode: "2002",
			occupationDescription: "وسيط تأمين عام",
		},
		{
			occupationCode: "332102",
			occupationDescription: "وسيط تأمين عام",
		},
		{
			occupationCode: "2005",
			occupationDescription: "وسيط تأمين عقارات",
		},
		{
			occupationCode: "2006",
			occupationDescription: "وسيط تأمين مركبات",
		},
		{
			occupationCode: "2007",
			occupationDescription: "وسيط تأمين مصانع",
		},
		{
			occupationCode: "2011",
			occupationDescription: "وسيط تخليص جمركي",
		},
		{
			occupationCode: "2008",
			occupationDescription: "وسيط شحن بحري",
		},
		{
			occupationCode: "2009",
			occupationDescription: "وسيط شحن بري",
		},
		{
			occupationCode: "2010",
			occupationDescription: "وسيط شحن جوي",
		},
		{
			occupationCode: "3275",
			occupationDescription: "وقاد بالسفن",
		},
		{
			occupationCode: "3294",
			occupationDescription: "وقاد مرجل بخاري",
		},
		{
			occupationCode: "1968",
			occupationDescription: "وكيل بضائع السكك الحديدية",
		},
		{
			occupationCode: "1987",
			occupationDescription: "وكيل بيع منتجات",
		},
		{
			occupationCode: "1983",
			occupationDescription: "وكيل تجاري",
		},
		{
			occupationCode: "1990",
			occupationDescription: "وكيل دعاية وأعلان",
		},
		{
			occupationCode: "1984",
			occupationDescription: "وكيل سفر",
		},
		{
			occupationCode: "1985",
			occupationDescription: "وكيل سياحي",
		},
		{
			occupationCode: "630",
			occupationDescription: "وكيل وزارة",
		},
	],
	occupationList: [
		{
			occupationCode: "1548",
			occupationDescription: " or ",
		},
		{
			occupationCode: "2667",
			occupationDescription: "(Acid) oil wells Operator",
		},
		{
			occupationCode: "619",
			occupationDescription: "(Brother s)Nephew Muharem",
		},
		{
			occupationCode: "610",
			occupationDescription: "(Daughter) Grandson",
		},
		{
			occupationCode: "618",
			occupationDescription: "(Sister s) nephew Muharem",
		},
		{
			occupationCode: "1656",
			occupationDescription: "A C Draftsman",
		},
		{
			occupationCode: "1667",
			occupationDescription: "A C Installation Technician",
		},
		{
			occupationCode: "1668",
			occupationDescription: "A C Maintenance Technician",
		},
		{
			occupationCode: "2094",
			occupationDescription: "A C Supplies Seller",
		},
		{
			occupationCode: "52",
			occupationDescription: "A/C Engineer",
		},
		{
			occupationCode: "3380",
			occupationDescription: "AC Electrician",
		},
		{
			occupationCode: "1047",
			occupationDescription: "AC Engineer",
		},
		{
			occupationCode: "3142",
			occupationDescription: "AC Operator",
		},
		{
			occupationCode: "3161",
			occupationDescription: "AC Vehicle mechanic",
		},
		{
			occupationCode: "1799",
			occupationDescription: "ANATOMY TECHNINIAN",
		},
		{
			occupationCode: "1318",
			occupationDescription: "ART THERAPIST",
		},
		{
			occupationCode: "2935",
			occupationDescription: "Abrasion machine Worker",
		},
		{
			occupationCode: "1559",
			occupationDescription: "Accident surveyor",
		},
		{
			occupationCode: "284",
			occupationDescription: "Account Clerk",
		},
		{
			occupationCode: "208",
			occupationDescription: "Accountant",
		},
		{
			occupationCode: "707",
			occupationDescription: "Acting",
		},
		{
			occupationCode: "708",
			occupationDescription: "Acting Assignee",
		},
		{
			occupationCode: "240",
			occupationDescription: "Actor",
		},
		{
			occupationCode: "951",
			occupationDescription: "Actuarial statistician",
		},
		{
			occupationCode: "723",
			occupationDescription: "Administrative Attach",
		},
		{
			occupationCode: "265",
			occupationDescription: "Administrative Clerk",
		},
		{
			occupationCode: "275",
			occupationDescription: "Administrative Officer",
		},
		{
			occupationCode: "1474",
			occupationDescription: "Ads Editor",
		},
		{
			occupationCode: "1990",
			occupationDescription: "Advertisement Agent",
		},
		{
			occupationCode: "318",
			occupationDescription: "Advertisement Representative",
		},
		{
			occupationCode: "263",
			occupationDescription: "Advertisement designer",
		},
		{
			occupationCode: "47",
			occupationDescription: "Advertising Technician",
		},
		{
			occupationCode: "261",
			occupationDescription: "Adviser",
		},
		{
			occupationCode: "709",
			occupationDescription: "Advisor / A",
		},
		{
			occupationCode: "710",
			occupationDescription: "Advisor / B",
		},
		{
			occupationCode: "1007",
			occupationDescription: "Aerial Surveying Engineer",
		},
		{
			occupationCode: "1628",
			occupationDescription: "Aerial lines Electrician",
		},
		{
			occupationCode: "375",
			occupationDescription: "Aerial photography technician",
		},
		{
			occupationCode: "1065",
			occupationDescription: "Aeroplane landing Gear Engineer",
		},
		{
			occupationCode: "1135",
			occupationDescription: "Agricultural Aviator",
		},
		{
			occupationCode: "77",
			occupationDescription: "Agricultural Engineer",
		},
		{
			occupationCode: "1055",
			occupationDescription: "Agricultural Machinery Engineer",
		},
		{
			occupationCode: "2258",
			occupationDescription: "Agricultural Products Marketing Driver",
		},
		{
			occupationCode: "116",
			occupationDescription: "Agricultural Technician",
		},
		{
			occupationCode: "3314",
			occupationDescription: "Agricultural Tractor Mechanic",
		},
		{
			occupationCode: "1410",
			occupationDescription: "Agricultural Vocational Teacher",
		},
		{
			occupationCode: "644",
			occupationDescription: "Agricultural and Irrigation Affairs Director",
		},
		{
			occupationCode: "2253",
			occupationDescription: "Agricultural equipment Driver",
		},
		{
			occupationCode: "3362",
			occupationDescription: "Agricultural equipment Electrician",
		},
		{
			occupationCode: "2112",
			occupationDescription: "Agricultural equipment Seller",
		},
		{
			occupationCode: "2116",
			occupationDescription: "Agricultural fertilizers Seller",
		},
		{
			occupationCode: "1112",
			occupationDescription: "Agricultural guidance Specialist",
		},
		{
			occupationCode: "3044",
			occupationDescription: "Agricultural machine assembly Mechanic",
		},
		{
			occupationCode: "3313",
			occupationDescription: "Agricultural machinery Mechanic  or  general",
		},
		{
			occupationCode: "3579",
			occupationDescription: "Agricultural machinery assembling worker",
		},
		{
			occupationCode: "361",
			occupationDescription: "Agricultural machinery operator",
		},
		{
			occupationCode: "455",
			occupationDescription: "Agricultural machines Technician",
		},
		{
			occupationCode: "1113",
			occupationDescription: "Agricultural pest Specialist",
		},
		{
			occupationCode: "115",
			occupationDescription: "Agricultural science Specialist",
		},
		{
			occupationCode: "349",
			occupationDescription: "Agricultural supervisor",
		},
		{
			occupationCode: "2118",
			occupationDescription: "Agricultural tools and machinery Seller",
		},
		{
			occupationCode: "350",
			occupationDescription: "Agricultural workers",
		},
		{
			occupationCode: "3292",
			occupationDescription: "Air Compressor operator",
		},
		{
			occupationCode: "3160",
			occupationDescription: "Air Conditioner Mechanic",
		},
		{
			occupationCode: "3158",
			occupationDescription: "Air Conditioning Mechanic",
		},
		{
			occupationCode: "2161",
			occupationDescription: "Air Host",
		},
		{
			occupationCode: "301",
			occupationDescription: "Air Overseer",
		},
		{
			occupationCode: "104",
			occupationDescription: "Air Pilot",
		},
		{
			occupationCode: "1924",
			occupationDescription: "Air Shipping services Supervisor",
		},
		{
			occupationCode: "2010",
			occupationDescription: "Air cargo Broker",
		},
		{
			occupationCode: "3162",
			occupationDescription: "Air conditioning Assistant mechanic",
		},
		{
			occupationCode: "3167",
			occupationDescription: "Air conditioning device assistant Mechanics",
		},
		{
			occupationCode: "3086",
			occupationDescription: "Air pressure Riveter",
		},
		{
			occupationCode: "1967",
			occupationDescription: "Air traffic control",
		},
		{
			occupationCode: "3451",
			occupationDescription: "Aircraft Carpenter",
		},
		{
			occupationCode: "67",
			occupationDescription: "Aircraft Chassis Engineer",
		},
		{
			occupationCode: "486",
			occupationDescription: "Aircraft Electrician",
		},
		{
			occupationCode: "904",
			occupationDescription: "Aircraft Fire Fighting specialist",
		},
		{
			occupationCode: "1922",
			occupationDescription: "Aircraft Radio Operator",
		},
		{
			occupationCode: "1040",
			occupationDescription: "Aircraft Radio and Radar Engineer",
		},
		{
			occupationCode: "1071",
			occupationDescription: "Aircraft Supply Specialist Supply",
		},
		{
			occupationCode: "3253",
			occupationDescription: "Aircraft Tinner",
		},
		{
			occupationCode: "1070",
			occupationDescription: "Aircraft and artillery Gearbox Engineer",
		},
		{
			occupationCode: "3036",
			occupationDescription: "Aircraft engine filing mechanic",
		},
		{
			occupationCode: "3280",
			occupationDescription: "Aircraft engine mechanic",
		},
		{
			occupationCode: "469",
			occupationDescription: "Aircraft engines technician",
		},
		{
			occupationCode: "3286",
			occupationDescription: "Aircraft maintenance Mechanic",
		},
		{
			occupationCode: "1053",
			occupationDescription: "Aircraft maintenance engineer",
		},
		{
			occupationCode: "36",
			occupationDescription: "Aircraft maintenance technician",
		},
		{
			occupationCode: "1069",
			occupationDescription: "Aircraft thrust Propeller Engineer",
		},
		{
			occupationCode: "784",
			occupationDescription: "Airlines station Manager",
		},
		{
			occupationCode: "1742",
			occupationDescription: "Airplane landing Overseer",
		},
		{
			occupationCode: "1741",
			occupationDescription: "Airplane take off Overseer",
		},
		{
			occupationCode: "664",
			occupationDescription: "Airport director",
		},
		{
			occupationCode: "999",
			occupationDescription: "Airports Engineer",
		},
		{
			occupationCode: "1158",
			occupationDescription: "Allergist",
		},
		{
			occupationCode: "1194",
			occupationDescription: "Allergy Consultant",
		},
		{
			occupationCode: "507",
			occupationDescription: "Aluminium Technician",
		},
		{
			occupationCode: "2644",
			occupationDescription: "Aluminium furnace operator",
		},
		{
			occupationCode: "35",
			occupationDescription: "Ammunition Technician",
		},
		{
			occupationCode: "127",
			occupationDescription: "Anaesthesia Technician",
		},
		{
			occupationCode: "173",
			occupationDescription: "Anaesthesiology Consultant",
		},
		{
			occupationCode: "1168",
			occupationDescription: "Anaesthetist",
		},
		{
			occupationCode: "1177",
			occupationDescription: "Anatomist",
		},
		{
			occupationCode: "1213",
			occupationDescription: "Anatomy consultant",
		},
		{
			occupationCode: "164",
			occupationDescription: "Anesthesiologist",
		},
		{
			occupationCode: "2273",
			occupationDescription: "Animal Breeding Worker",
		},
		{
			occupationCode: "733",
			occupationDescription: "Animal Ranch Manager",
		},
		{
			occupationCode: "1259",
			occupationDescription: "Animal breeding Specialist",
		},
		{
			occupationCode: "3197",
			occupationDescription: "Animal cart driver",
		},
		{
			occupationCode: "1118",
			occupationDescription: "Animal wealth Specialist",
		},
		{
			occupationCode: "1485",
			occupationDescription: "Animation Caricaturist",
		},
		{
			occupationCode: "3389",
			occupationDescription: "Antenna Telephone network Installer",
		},
		{
			occupationCode: "1329",
			occupationDescription: "Anthropology Specialist",
		},
		{
			occupationCode: "1455",
			occupationDescription: "Antiquity Restoration Specialist",
		},
		{
			occupationCode: "1454",
			occupationDescription: "Antiquity Searching Specialist",
		},
		{
			occupationCode: "735",
			occupationDescription: "Apiary manager",
		},
		{
			occupationCode: "954",
			occupationDescription: "Applied Mathematician",
		},
		{
			occupationCode: "950",
			occupationDescription: "Applied statistician",
		},
		{
			occupationCode: "933",
			occupationDescription: "Aquatic Specialist",
		},
		{
			occupationCode: "1008",
			occupationDescription: "Aquatic Surveying Engineer",
		},
		{
			occupationCode: "2518",
			occupationDescription: "Arab clothes Cutter and Tailor",
		},
		{
			occupationCode: "2132",
			occupationDescription: "Arab food Cook",
		},
		{
			occupationCode: "2157",
			occupationDescription: "Arabian coffee maker",
		},
		{
			occupationCode: "2931",
			occupationDescription: "Arabic bellows Blacksmith",
		},
		{
			occupationCode: "1814",
			occupationDescription: "Arabic language Teacher",
		},
		{
			occupationCode: "3076",
			occupationDescription: "Arc welder",
		},
		{
			occupationCode: "22",
			occupationDescription: "Architect",
		},
		{
			occupationCode: "3502",
			occupationDescription: "Architect worker",
		},
		{
			occupationCode: "1596",
			occupationDescription: "Architectural models Maker",
		},
		{
			occupationCode: "256",
			occupationDescription: "Archive Officer",
		},
		{
			occupationCode: "1459",
			occupationDescription: "Archivist",
		},
		{
			occupationCode: "1617",
			occupationDescription: "Ariel and digital survey equipment operator",
		},
		{
			occupationCode: "37",
			occupationDescription: "Armament systems technician",
		},
		{
			occupationCode: "220",
			occupationDescription: "Art Teacher",
		},
		{
			occupationCode: "97",
			occupationDescription: "Art cars",
		},
		{
			occupationCode: "199",
			occupationDescription: "Artificial Limbs Technician",
		},
		{
			occupationCode: "2062",
			occupationDescription: "Artificial flower seller",
		},
		{
			occupationCode: "2063",
			occupationDescription: "Artificial flowers Maker",
		},
		{
			occupationCode: "2054",
			occupationDescription: "Artificial jewellery seller",
		},
		{
			occupationCode: "1507",
			occupationDescription: "Artistic critic",
		},
		{
			occupationCode: "2625",
			occupationDescription: "Asbestos products making Worker",
		},
		{
			occupationCode: "3552",
			occupationDescription: "Asphalt heater operator",
		},
		{
			occupationCode: "3551",
			occupationDescription: "Asphalt mixer operator",
		},
		{
			occupationCode: "3512",
			occupationDescription: "Asphalt roofing worker",
		},
		{
			occupationCode: "3211",
			occupationDescription: "Asphalting Machine Driver",
		},
		{
			occupationCode: "3033",
			occupationDescription: "Assembly filing Mechanic",
		},
		{
			occupationCode: "2167",
			occupationDescription: "Assist flight attendant",
		},
		{
			occupationCode: "1883",
			occupationDescription: "Assistant Administrative",
		},
		{
			occupationCode: "724",
			occupationDescription: "Assistant Administrative Attach",
		},
		{
			occupationCode: "441",
			occupationDescription: "Assistant Blacksmith",
		},
		{
			occupationCode: "1475",
			occupationDescription: "Assistant Chief Editor",
		},
		{
			occupationCode: "327",
			occupationDescription: "Assistant Chief cook",
		},
		{
			occupationCode: "3056",
			occupationDescription: "Assistant Construction Blacksmith",
		},
		{
			occupationCode: "3062",
			occupationDescription: "Assistant Construction Installation Worker",
		},
		{
			occupationCode: "704",
			occupationDescription: "Assistant Consul",
		},
		{
			occupationCode: "717",
			occupationDescription: "Assistant Diplomatic Attach",
		},
		{
			occupationCode: "785",
			occupationDescription: "Assistant Director of Airlines Station",
		},
		{
			occupationCode: "3077",
			occupationDescription: "Assistant Electric Welder",
		},
		{
			occupationCode: "2257",
			occupationDescription: "Assistant Farmer",
		},
		{
			occupationCode: "3022",
			occupationDescription: "Assistant Metal Painter",
		},
		{
			occupationCode: "3008",
			occupationDescription: "Assistant Metal furniture Blacksmith",
		},
		{
			occupationCode: "2999",
			occupationDescription: "Assistant Milling Worker",
		},
		{
			occupationCode: "191",
			occupationDescription: "Assistant Nurse",
		},
		{
			occupationCode: "186",
			occupationDescription: "Assistant Pharmacist",
		},
		{
			occupationCode: "147",
			occupationDescription: "Assistant Physician",
		},
		{
			occupationCode: "2973",
			occupationDescription: "Assistant Plumber",
		},
		{
			occupationCode: "2990",
			occupationDescription: "Assistant Turner",
		},
		{
			occupationCode: "3466",
			occupationDescription: "Assistant Upholsterer",
		},
		{
			occupationCode: "332",
			occupationDescription: "Assistant Waiter",
		},
		{
			occupationCode: "193",
			occupationDescription: "Assistant accoucheur (midwife)",
		},
		{
			occupationCode: "3316",
			occupationDescription: "Assistant agricultural machinery mechanic",
		},
		{
			occupationCode: "780",
			occupationDescription: "Assistant catering site Manager",
		},
		{
			occupationCode: "328",
			occupationDescription: "Assistant cook",
		},
		{
			occupationCode: "167",
			occupationDescription: "Assistant dentist",
		},
		{
			occupationCode: "3328",
			occupationDescription: "Assistant electrical maintenance stations",
		},
		{
			occupationCode: "2997",
			occupationDescription: "Assistant filing Worker",
		},
		{
			occupationCode: "3140",
			occupationDescription: "Assistant maintenance mechanic",
		},
		{
			occupationCode: "3015",
			occupationDescription: "Assistant metal plates Blacksmith",
		},
		{
			occupationCode: "720",
			occupationDescription: "Assistant military Attach",
		},
		{
			occupationCode: "3255",
			occupationDescription: "Assistant paint vehicles",
		},
		{
			occupationCode: "3511",
			occupationDescription: "Assistant painter",
		},
		{
			occupationCode: "1995",
			occupationDescription: "Assistant seller",
		},
		{
			occupationCode: "3507",
			occupationDescription: "Assistant tiller",
		},
		{
			occupationCode: "169",
			occupationDescription: "Assistant vet",
		},
		{
			occupationCode: "3079",
			occupationDescription: "Assistant welding oxygen",
		},
		{
			occupationCode: "1063",
			occupationDescription: "Assisting Power Units Engineer",
		},
		{
			occupationCode: "1613",
			occupationDescription: "Associate surveyor",
		},
		{
			occupationCode: "19",
			occupationDescription: "Astrologist",
		},
		{
			occupationCode: "1524",
			occupationDescription: "Athlete expert",
		},
		{
			occupationCode: "247",
			occupationDescription: "Athletic Coach",
		},
		{
			occupationCode: "1513",
			occupationDescription: "Athletic Referee",
		},
		{
			occupationCode: "716",
			occupationDescription: "Attach",
		},
		{
			occupationCode: "2025",
			occupationDescription: "Attar",
		},
		{
			occupationCode: "1442",
			occupationDescription: "Attorney General",
		},
		{
			occupationCode: "2001",
			occupationDescription: "Auctioneer",
		},
		{
			occupationCode: "1838",
			occupationDescription: "Audio Technician",
		},
		{
			occupationCode: "3424",
			occupationDescription: "Audio equipment operation Worker",
		},
		{
			occupationCode: "1415",
			occupationDescription: "Audio or visual Education specialist",
		},
		{
			occupationCode: "209",
			occupationDescription: "Auditor",
		},
		{
			occupationCode: "228",
			occupationDescription: "Author",
		},
		{
			occupationCode: "2991",
			occupationDescription: "Automatic Lathe Operator",
		},
		{
			occupationCode: "2583",
			occupationDescription: "Automatic Printing clich Workers",
		},
		{
			occupationCode: "3085",
			occupationDescription: "Automatic Riveter",
		},
		{
			occupationCode: "2843",
			occupationDescription: "Automatic bread oven Overseer",
		},
		{
			occupationCode: "2482",
			occupationDescription: "Automatic cloth Weaving Worker",
		},
		{
			occupationCode: "3091",
			occupationDescription: "Automatic cutting Worker",
		},
		{
			occupationCode: "2928",
			occupationDescription: "Automatic hammer Operator",
		},
		{
			occupationCode: "2457",
			occupationDescription: "Automatic loom preparation Mechanic",
		},
		{
			occupationCode: "3002",
			occupationDescription: "Automatic metal machine Worker",
		},
		{
			occupationCode: "3058",
			occupationDescription: "Automatic metal saw operator",
		},
		{
			occupationCode: "2486",
			occupationDescription: "Automatic network preparation Worker",
		},
		{
			occupationCode: "2841",
			occupationDescription: "Automatic oven kneading Worker",
		},
		{
			occupationCode: "2358",
			occupationDescription: "Automatic paper box manufacturing machine Worker",
		},
		{
			occupationCode: "2489",
			occupationDescription: "Automatic plait Preparation worker",
		},
		{
			occupationCode: "3009",
			occupationDescription: "Automatic tin Scissors Operator",
		},
		{
			occupationCode: "3010",
			occupationDescription: "Automatic tin folding operator",
		},
		{
			occupationCode: "2466",
			occupationDescription: "Automating Loom operator",
		},
		{
			occupationCode: "142",
			occupationDescription: "Autopsy Specialist",
		},
		{
			occupationCode: "1098",
			occupationDescription: "Aviation Engineer",
		},
		{
			occupationCode: "1676",
			occupationDescription: "Aviation Engineering Technician",
		},
		{
			occupationCode: "106",
			occupationDescription: "Aviation Instructor",
		},
		{
			occupationCode: "312",
			occupationDescription: "Aviation Officer",
		},
		{
			occupationCode: "103",
			occupationDescription: "Aviator",
		},
		{
			occupationCode: "105",
			occupationDescription: "Aviator Engineer",
		},
		{
			occupationCode: "597",
			occupationDescription: "Awaiting Citizenship",
		},
		{
			occupationCode: "1294",
			occupationDescription: "BIOMEDICAL SPECIALIST",
		},
		{
			occupationCode: "1124",
			occupationDescription: "BIOSECURITY OFFICER",
		},
		{
			occupationCode: "737",
			occupationDescription: "BROODSTOCK BREEDING MANAGER",
		},
		{
			occupationCode: "1535",
			occupationDescription: "BUSINESS VALUER",
		},
		{
			occupationCode: "946",
			occupationDescription: "Bacteriologist",
		},
		{
			occupationCode: "2409",
			occupationDescription: "Bag Repairing Worker",
		},
		{
			occupationCode: "2038",
			occupationDescription: "Bag Seller",
		},
		{
			occupationCode: "1956",
			occupationDescription: "Baggage service Officer",
		},
		{
			occupationCode: "409",
			occupationDescription: "Baker",
		},
		{
			occupationCode: "25",
			occupationDescription: "Balance technician",
		},
		{
			occupationCode: "3430",
			occupationDescription: "Bamboo furniture Carpenter",
		},
		{
			occupationCode: "2320",
			occupationDescription: "Band Saw operator",
		},
		{
			occupationCode: "1926",
			occupationDescription: "Bank clerk",
		},
		{
			occupationCode: "771",
			occupationDescription: "Bank manager",
		},
		{
			occupationCode: "800",
			occupationDescription: "Banking manager",
		},
		{
			occupationCode: "418",
			occupationDescription: "Barbecue Master",
		},
		{
			occupationCode: "343",
			occupationDescription: "Barber",
		},
		{
			occupationCode: "2124",
			occupationDescription: "Barber male",
		},
		{
			occupationCode: "2662",
			occupationDescription: "Bars casting Machine operator",
		},
		{
			occupationCode: "249",
			occupationDescription: "Basketball Coach",
		},
		{
			occupationCode: "2818",
			occupationDescription: "Baskets making Worker",
		},
		{
			occupationCode: "2526",
			occupationDescription: "Basting Worker",
		},
		{
			occupationCode: "433",
			occupationDescription: "Beadsman",
		},
		{
			occupationCode: "406",
			occupationDescription: "Beans and Falafel Master",
		},
		{
			occupationCode: "344",
			occupationDescription: "Beauty Specialist",
		},
		{
			occupationCode: "2302",
			occupationDescription: "Bee Breeder",
		},
		{
			occupationCode: "1121",
			occupationDescription: "Bee Specialist",
		},
		{
			occupationCode: "1735",
			occupationDescription: "Bee breeding Technician",
		},
		{
			occupationCode: "362",
			occupationDescription: "Beekeeper",
		},
		{
			occupationCode: "423",
			occupationDescription: "Beshet Tailor",
		},
		{
			occupationCode: "2901",
			occupationDescription: "Bestrema making Worker",
		},
		{
			occupationCode: "3258",
			occupationDescription: "Bicycle mechanic",
		},
		{
			occupationCode: "464",
			occupationDescription: "Bicycle repair technician",
		},
		{
			occupationCode: "3578",
			occupationDescription: "Bicycles assembling worker",
		},
		{
			occupationCode: "2102",
			occupationDescription: "Bicycles seller",
		},
		{
			occupationCode: "2552",
			occupationDescription: "Binding machine operator",
		},
		{
			occupationCode: "905",
			occupationDescription: "Biochemistry Sciences Instructor",
		},
		{
			occupationCode: "936",
			occupationDescription: "Biochemistry Specialist",
		},
		{
			occupationCode: "1578",
			occupationDescription: "Biological Laboratory Technician",
		},
		{
			occupationCode: "938",
			occupationDescription: "Biologist",
		},
		{
			occupationCode: "113",
			occupationDescription: "Biology Researcher",
		},
		{
			occupationCode: "1395",
			occupationDescription: "Biology Teacher",
		},
		{
			occupationCode: "120",
			occupationDescription: "Biology Technician",
		},
		{
			occupationCode: "937",
			occupationDescription: "Biophysics Specialist",
		},
		{
			occupationCode: "2822",
			occupationDescription: "Bird Preparation and Embalming Worker",
		},
		{
			occupationCode: "2845",
			occupationDescription: "Biscuit Maker",
		},
		{
			occupationCode: "439",
			occupationDescription: "Blacksmith",
		},
		{
			occupationCode: "2472",
			occupationDescription: "Blanket Loom Operator",
		},
		{
			occupationCode: "1426",
			occupationDescription: "Blind Teacher",
		},
		{
			occupationCode: "1796",
			occupationDescription: "Blood Bank Laboratory Technician",
		},
		{
			occupationCode: "1751",
			occupationDescription: "Blood transfusion Nurse",
		},
		{
			occupationCode: "2816",
			occupationDescription: "Blowing instrument making Worker",
		},
		{
			occupationCode: "3105",
			occupationDescription: "Blue painting Worker",
		},
		{
			occupationCode: "3440",
			occupationDescription: "Boat Carpenter",
		},
		{
			occupationCode: "3199",
			occupationDescription: "Boat Sailor",
		},
		{
			occupationCode: "675",
			occupationDescription: "Boatswain",
		},
		{
			occupationCode: "3172",
			occupationDescription: "Boiler Maintenance mechanic",
		},
		{
			occupationCode: "2954",
			occupationDescription: "Boiler plate manufacturing Worker",
		},
		{
			occupationCode: "2556",
			occupationDescription: "Book Cutting machine operator",
		},
		{
			occupationCode: "1464",
			occupationDescription: "Book and Publication Indexer",
		},
		{
			occupationCode: "2558",
			occupationDescription: "Book tailor",
		},
		{
			occupationCode: "1928",
			occupationDescription: "Bookkeeper",
		},
		{
			occupationCode: "1878",
			occupationDescription: "Bookkeeping Clerk",
		},
		{
			occupationCode: "1980",
			occupationDescription: "Bookkeeping Machine Operator",
		},
		{
			occupationCode: "2365",
			occupationDescription: "Books Nailing Machine operator",
		},
		{
			occupationCode: "1460",
			occupationDescription: "Books Reviser",
		},
		{
			occupationCode: "2628",
			occupationDescription: "Boring Machine operator",
		},
		{
			occupationCode: "2937",
			occupationDescription: "Boring machine Worker",
		},
		{
			occupationCode: "3065",
			occupationDescription: "Boring machine preparation worker",
		},
		{
			occupationCode: "942",
			occupationDescription: "Botanist",
		},
		{
			occupationCode: "3239",
			occupationDescription: "Brake Mechanic",
		},
		{
			occupationCode: "1064",
			occupationDescription: "Brake components treatment Engineer",
		},
		{
			occupationCode: "2021",
			occupationDescription: "Bread and Pastry seller",
		},
		{
			occupationCode: "2846",
			occupationDescription: "Bread kneading and baking Worker",
		},
		{
			occupationCode: "2865",
			occupationDescription: "Bread yeast drying Worker",
		},
		{
			occupationCode: "2867",
			occupationDescription: "Bread yeast filtration Operator",
		},
		{
			occupationCode: "2866",
			occupationDescription: "Bread yeast separation Operator",
		},
		{
			occupationCode: "2607",
			occupationDescription: "Brick Roasting furnace Operator",
		},
		{
			occupationCode: "2796",
			occupationDescription: "Brick and tile hand casting Worker",
		},
		{
			occupationCode: "2615",
			occupationDescription: "Brick and tiles Furnace operator",
		},
		{
			occupationCode: "3489",
			occupationDescription: "Brick builder",
		},
		{
			occupationCode: "998",
			occupationDescription: "Bridges Engineer",
		},
		{
			occupationCode: "243",
			occupationDescription: "Broadcaster",
		},
		{
			occupationCode: "405",
			occupationDescription: "Broasted chicken Master",
		},
		{
			occupationCode: "427",
			occupationDescription: "Brocader",
		},
		{
			occupationCode: "2820",
			occupationDescription: "Broom hand making Worker",
		},
		{
			occupationCode: "572",
			occupationDescription: "Brother",
		},
		{
			occupationCode: "608",
			occupationDescription: "Brother Muharem",
		},
		{
			occupationCode: "3460",
			occupationDescription: "Brush painter",
		},
		{
			occupationCode: "1537",
			occupationDescription: "Budget organizer",
		},
		{
			occupationCode: "413",
			occupationDescription: "Buffett worker",
		},
		{
			occupationCode: "532",
			occupationDescription: "Builder",
		},
		{
			occupationCode: "1597",
			occupationDescription: "Building Construction Draftsman",
		},
		{
			occupationCode: "485",
			occupationDescription: "Building Electrician",
		},
		{
			occupationCode: "2229",
			occupationDescription: "Building Guard",
		},
		{
			occupationCode: "2096",
			occupationDescription: "Building Mechanisms Seller",
		},
		{
			occupationCode: "2670",
			occupationDescription: "Building and drilling equipment Overseer",
		},
		{
			occupationCode: "3454",
			occupationDescription: "Building demolishing worker",
		},
		{
			occupationCode: "1601",
			occupationDescription: "Buildings Surveyor",
		},
		{
			occupationCode: "1599",
			occupationDescription: "Buildings Technician",
		},
		{
			occupationCode: "3444",
			occupationDescription: "Buildings carpenter Assistant",
		},
		{
			occupationCode: "2089",
			occupationDescription: "Buildings materials Seller",
		},
		{
			occupationCode: "3206",
			occupationDescription: "Bulldozer driver",
		},
		{
			occupationCode: "3190",
			occupationDescription: "Bus driver",
		},
		{
			occupationCode: "1416",
			occupationDescription: "Business Administration Teacher",
		},
		{
			occupationCode: "402",
			occupationDescription: "Butcher",
		},
		{
			occupationCode: "2895",
			occupationDescription: "Butchery Butcher",
		},
		{
			occupationCode: "2913",
			occupationDescription: "Butter maker",
		},
		{
			occupationCode: "2527",
			occupationDescription: "Buttonhole Worker",
		},
		{
			occupationCode: "973",
			occupationDescription: "CENTER DATA ADMINISTRATOR",
		},
		{
			occupationCode: "788",
			occupationDescription: "CHIEF OPERATING OFFICER",
		},
		{
			occupationCode: "1276",
			occupationDescription:
				"CT or MRI or PET consultant/ CT or MRI or PET CONSULTANT",
		},
		{
			occupationCode: "1800",
			occupationDescription: "CUPPER",
		},
		{
			occupationCode: "1914",
			occupationDescription: "Cable Clerk",
		},
		{
			occupationCode: "1920",
			occupationDescription: "Cable Operator",
		},
		{
			occupationCode: "490",
			occupationDescription: "Cable Welder",
		},
		{
			occupationCode: "495",
			occupationDescription: "Cable technician",
		},
		{
			occupationCode: "1981",
			occupationDescription: "Calcutawuniyar Operator",
		},
		{
			occupationCode: "233",
			occupationDescription: "Calligrapher",
		},
		{
			occupationCode: "2276",
			occupationDescription: "Camel Breeder",
		},
		{
			occupationCode: "2288",
			occupationDescription: "Camel Rider",
		},
		{
			occupationCode: "3568",
			occupationDescription: "Cameras assembling worker",
		},
		{
			occupationCode: "2225",
			occupationDescription: "Can Packing Machine operator",
		},
		{
			occupationCode: "2140",
			occupationDescription: "Candy maker",
		},
		{
			occupationCode: "2805",
			occupationDescription: "Capsule filling Machine operator",
		},
		{
			occupationCode: "2806",
			occupationDescription: "Capsule polishing Machine operator",
		},
		{
			occupationCode: "3365",
			occupationDescription: "Car Assistant Electrician",
		},
		{
			occupationCode: "1828",
			occupationDescription: "Car Driving Instructor",
		},
		{
			occupationCode: "1690",
			occupationDescription: "Car Ornamentation",
		},
		{
			occupationCode: "1963",
			occupationDescription: "Car Rental Officer",
		},
		{
			occupationCode: "1960",
			occupationDescription: "Car Traffic Controller",
		},
		{
			occupationCode: "3263",
			occupationDescription: "Car lubrication Worker",
		},
		{
			occupationCode: "467",
			occupationDescription: "Car mechanic",
		},
		{
			occupationCode: "2360",
			occupationDescription: "Cardboard Cutting Press Operation Worker",
		},
		{
			occupationCode: "2359",
			occupationDescription: "Cardboard Lining Machine Worker",
		},
		{
			occupationCode: "2361",
			occupationDescription: "Cardboard Press machine Worker",
		},
		{
			occupationCode: "129",
			occupationDescription: "Cardiac Catheter Technician",
		},
		{
			occupationCode: "1228",
			occupationDescription: "Cardiac surgeon",
		},
		{
			occupationCode: "2414",
			occupationDescription: "Carding Machine operator",
		},
		{
			occupationCode: "160",
			occupationDescription: "Cardiologist",
		},
		{
			occupationCode: "176",
			occupationDescription: "Cardiology Consultant",
		},
		{
			occupationCode: "3221",
			occupationDescription: "Cargo Lifting vehicle operator",
		},
		{
			occupationCode: "1484",
			occupationDescription: "Caricaturist",
		},
		{
			occupationCode: "536",
			occupationDescription: "Carpenter",
		},
		{
			occupationCode: "3439",
			occupationDescription: "Carpenter of vehicles",
		},
		{
			occupationCode: "2090",
			occupationDescription: "Carpentry Supplies seller",
		},
		{
			occupationCode: "3562",
			occupationDescription: "Carpentry machines assembling worker",
		},
		{
			occupationCode: "472",
			occupationDescription: "Carpentry technician",
		},
		{
			occupationCode: "2470",
			occupationDescription: "Carpet Loom Operator",
		},
		{
			occupationCode: "2030",
			occupationDescription: "Carpet seller",
		},
		{
			occupationCode: "3478",
			occupationDescription: "Carpets and Rugs installer",
		},
		{
			occupationCode: "487",
			occupationDescription: "Cars Electrician",
		},
		{
			occupationCode: "530",
			occupationDescription: "Cars Painter",
		},
		{
			occupationCode: "430",
			occupationDescription: "Cars Upholsterer",
		},
		{
			occupationCode: "504",
			occupationDescription: "Cars tin man",
		},
		{
			occupationCode: "82",
			occupationDescription: "Cartographer",
		},
		{
			occupationCode: "1489",
			occupationDescription: "Carver and Engraver",
		},
		{
			occupationCode: "3123",
			occupationDescription: "Carving Worker",
		},
		{
			occupationCode: "1045",
			occupationDescription: "Casting Engineer",
		},
		{
			occupationCode: "1662",
			occupationDescription: "Casting Technician",
		},
		{
			occupationCode: "2986",
			occupationDescription: "Casting press shaping Worker",
		},
		{
			occupationCode: "2563",
			occupationDescription: "Casting printing plates Maker",
		},
		{
			occupationCode: "379",
			occupationDescription: "Casting worker",
		},
		{
			occupationCode: "2130",
			occupationDescription: "Catering services Supervisor",
		},
		{
			occupationCode: "2450",
			occupationDescription: "Catheter Worker",
		},
		{
			occupationCode: "1101",
			occupationDescription: "Cathode protection Engineer",
		},
		{
			occupationCode: "2275",
			occupationDescription: "Cattle Breeder",
		},
		{
			occupationCode: "2894",
			occupationDescription: "Cattle Butcher",
		},
		{
			occupationCode: "2026",
			occupationDescription: "Cattle Seller",
		},
		{
			occupationCode: "2283",
			occupationDescription: "Cattle milker",
		},
		{
			occupationCode: "352",
			occupationDescription: "Cattleman",
		},
		{
			occupationCode: "2604",
			occupationDescription: "Cement Brick Automatic Press Operator",
		},
		{
			occupationCode: "2603",
			occupationDescription: "Cement Brick Hand Press Operator",
		},
		{
			occupationCode: "2602",
			occupationDescription: "Cement Brick mixture preparation Worker",
		},
		{
			occupationCode: "2608",
			occupationDescription: "Cement Tile unit Operator",
		},
		{
			occupationCode: "2601",
			occupationDescription: "Cement industry Furnace operator",
		},
		{
			occupationCode: "2620",
			occupationDescription: "Cement pipes Casting Machine operator",
		},
		{
			occupationCode: "2614",
			occupationDescription: "Cement production Overseer",
		},
		{
			occupationCode: "3523",
			occupationDescription: "Cement smoothing worker",
		},
		{
			occupationCode: "2609",
			occupationDescription: "Cement tiles Hand Press Operator",
		},
		{
			occupationCode: "46",
			occupationDescription: "Censorship technician",
		},
		{
			occupationCode: "3159",
			occupationDescription: "Central AC Mechanic",
		},
		{
			occupationCode: "3163",
			occupationDescription: "Central Air conditioning operator",
		},
		{
			occupationCode: "1923",
			occupationDescription: "Central Manager",
		},
		{
			occupationCode: "3398",
			occupationDescription: "Central antenna Installer",
		},
		{
			occupationCode: "3173",
			occupationDescription: "Central heating systems operator",
		},
		{
			occupationCode: "2790",
			occupationDescription: "Ceramic Carver",
		},
		{
			occupationCode: "2787",
			occupationDescription: "Ceramic Extrusion machine operator",
		},
		{
			occupationCode: "2621",
			occupationDescription: "Ceramic Pipes Casting Machine operator",
		},
		{
			occupationCode: "2788",
			occupationDescription: "Ceramic burning Furnace Operator",
		},
		{
			occupationCode: "2785",
			occupationDescription: "Ceramic molding Potter",
		},
		{
			occupationCode: "2786",
			occupationDescription: "Ceramic press operator",
		},
		{
			occupationCode: "2789",
			occupationDescription: "Ceramic product models Maker",
		},
		{
			occupationCode: "2783",
			occupationDescription: "Ceramic raw material grinding worker",
		},
		{
			occupationCode: "2612",
			occupationDescription: "Ceramic tiles Press Operator",
		},
		{
			occupationCode: "2610",
			occupationDescription: "Ceramic tiles mixture Preparation Worker",
		},
		{
			occupationCode: "2784",
			occupationDescription: "Ceramic wheel operator",
		},
		{
			occupationCode: "510",
			occupationDescription: "Ceramic worker",
		},
		{
			occupationCode: "2791",
			occupationDescription: "Ceramics Painting Spray worker",
		},
		{
			occupationCode: "2792",
			occupationDescription: "Ceramics Painting Worker",
		},
		{
			occupationCode: "2245",
			occupationDescription: "Cereal Farmer",
		},
		{
			occupationCode: "2825",
			occupationDescription: "Cereal Grinder",
		},
		{
			occupationCode: "1721",
			occupationDescription: "Cereal cultivation Technician",
		},
		{
			occupationCode: "2827",
			occupationDescription: "Cereal grating machine Operator",
		},
		{
			occupationCode: "2828",
			occupationDescription: "Cereal mill Operator",
		},
		{
			occupationCode: "2826",
			occupationDescription: "Cereal sifting Operator",
		},
		{
			occupationCode: "631",
			occupationDescription: "Chairman of Board",
		},
		{
			occupationCode: "731",
			occupationDescription: "Chairman of service",
		},
		{
			occupationCode: "2286",
			occupationDescription: "Cheeses Maker",
		},
		{
			occupationCode: "329",
			occupationDescription: "Chef",
		},
		{
			occupationCode: "2710",
			occupationDescription: "Chemical Bleaching Operator",
		},
		{
			occupationCode: "99",
			occupationDescription: "Chemical Engineering technician",
		},
		{
			occupationCode: "20",
			occupationDescription: "Chemical Technician",
		},
		{
			occupationCode: "2697",
			occupationDescription: "Chemical crushing operation worker",
		},
		{
			occupationCode: "69",
			occupationDescription: "Chemical engineer",
		},
		{
			occupationCode: "1303",
			occupationDescription: "Chemical medicines Specialist",
		},
		{
			occupationCode: "2702",
			occupationDescription: "Chemical treatment drying Worker",
		},
		{
			occupationCode: "392",
			occupationDescription: "Chemical treatment worker",
		},
		{
			occupationCode: "9",
			occupationDescription: "Chemist",
		},
		{
			occupationCode: "1697",
			occupationDescription: "Chemist Technician",
		},
		{
			occupationCode: "1560",
			occupationDescription: "Chemistry Laboratory Technician",
		},
		{
			occupationCode: "903",
			occupationDescription: "Chemistry Specialist",
		},
		{
			occupationCode: "1392",
			occupationDescription: "Chemistry Teacher",
		},
		{
			occupationCode: "2851",
			occupationDescription: "Chewing gum Maker",
		},
		{
			occupationCode: "2136",
			occupationDescription: "Chicken Broiler",
		},
		{
			occupationCode: "888",
			occupationDescription: "Chief",
		},
		{
			occupationCode: "1465",
			occupationDescription: "Chief Editor",
		},
		{
			occupationCode: "674",
			occupationDescription: "Chief Engineer",
		},
		{
			occupationCode: "891",
			occupationDescription: "Chief Executive of SABIC Project",
		},
		{
			occupationCode: "1131",
			occupationDescription: "Chief Marine Officers",
		},
		{
			occupationCode: "189",
			occupationDescription: "Chief Nurse",
		},
		{
			occupationCode: "2151",
			occupationDescription: "Chief cook",
		},
		{
			occupationCode: "2033",
			occupationDescription: "Children Clothes Seller",
		},
		{
			occupationCode: "2047",
			occupationDescription: "Children Games Seller",
		},
		{
			occupationCode: "3520",
			occupationDescription: "Chimneys builder",
		},
		{
			occupationCode: "2182",
			occupationDescription: "Chimneys cleaning Worker",
		},
		{
			occupationCode: "1783",
			occupationDescription: "Chinese acupuncture Technician",
		},
		{
			occupationCode: "1288",
			occupationDescription: "Chinese needles Specialist",
		},
		{
			occupationCode: "2848",
			occupationDescription: "Chocolate Maker",
		},
		{
			occupationCode: "3426",
			occupationDescription: "Cinema operation worker",
		},
		{
			occupationCode: "1508",
			occupationDescription: "Cinematographer",
		},
		{
			occupationCode: "3585",
			occupationDescription: "Circuit breaker assembly worker",
		},
		{
			occupationCode: "627",
			occupationDescription: "Citizen's widow",
		},
		{
			occupationCode: "2260",
			occupationDescription: "Citrus Farmer",
		},
		{
			occupationCode: "1726",
			occupationDescription: "Citrus cultivation Technician",
		},
		{
			occupationCode: "991",
			occupationDescription: "City Planning Engineer",
		},
		{
			occupationCode: "45",
			occupationDescription: "Civil Engineer",
		},
		{
			occupationCode: "84",
			occupationDescription: "Civil Engineering Technician",
		},
		{
			occupationCode: "1608",
			occupationDescription: "Civil engineering Draftsman",
		},
		{
			occupationCode: "1865",
			occupationDescription: "Civil status Clerk",
		},
		{
			occupationCode: "2793",
			occupationDescription: "Clay and pottery molding Worker",
		},
		{
			occupationCode: "2178",
			occupationDescription: "Cleaning hotel room Worker",
		},
		{
			occupationCode: "339",
			occupationDescription: "Cleanliness supervisor",
		},
		{
			occupationCode: "340",
			occupationDescription: "Cleanliness worker",
		},
		{
			occupationCode: "1699",
			occupationDescription: "Cleansing industry Technician",
		},
		{
			occupationCode: "274",
			occupationDescription: "Clerical work Supervisor",
		},
		{
			occupationCode: "929",
			occupationDescription: "Climate conditions Overseer",
		},
		{
			occupationCode: "678",
			occupationDescription: "Clinic manager",
		},
		{
			occupationCode: "2507",
			occupationDescription: "Clothing Models Maker",
		},
		{
			occupationCode: "2529",
			occupationDescription: "Clothing Patching up Worker",
		},
		{
			occupationCode: "2173",
			occupationDescription: "Clothing and linens Sorter",
		},
		{
			occupationCode: "693",
			occupationDescription: "Club manager",
		},
		{
			occupationCode: "248",
			occupationDescription: "Coach",
		},
		{
			occupationCode: "2272",
			occupationDescription: "Coal Production furnace operator",
		},
		{
			occupationCode: "2123",
			occupationDescription: "Coal and wood seller",
		},
		{
			occupationCode: "2502",
			occupationDescription: "Coat Cutter Tailor",
		},
		{
			occupationCode: "3093",
			occupationDescription: "Coating Worker",
		},
		{
			occupationCode: "3094",
			occupationDescription: "Coating machine operator",
		},
		{
			occupationCode: "1977",
			occupationDescription: "Coding Officer",
		},
		{
			occupationCode: "2155",
			occupationDescription: "Coffee Boy",
		},
		{
			occupationCode: "2833",
			occupationDescription: "Coffee Roasting and grinding Worker",
		},
		{
			occupationCode: "2158",
			occupationDescription: "Coffee and tea maker",
		},
		{
			occupationCode: "1946",
			occupationDescription: "Coin Counter",
		},
		{
			occupationCode: "1962",
			occupationDescription: "Collector",
		},
		{
			occupationCode: "1187",
			occupationDescription: "Colorectal Consultant",
		},
		{
			occupationCode: "1151",
			occupationDescription: "Colorectal surgeon",
		},
		{
			occupationCode: "2546",
			occupationDescription: "Colour printing machine operator",
		},
		{
			occupationCode: "3035",
			occupationDescription: "Combustion engine filing mechanic",
		},
		{
			occupationCode: "215",
			occupationDescription: "Commerce Teacher",
		},
		{
			occupationCode: "314",
			occupationDescription: "Commercial Manager",
		},
		{
			occupationCode: "1411",
			occupationDescription: "Commercial Vocational Teacher",
		},
		{
			occupationCode: "1847",
			occupationDescription: "Commercial advertising Cameraman",
		},
		{
			occupationCode: "1844",
			occupationDescription: "Commercial advertising artist",
		},
		{
			occupationCode: "1132",
			occupationDescription: "Commercial pilot",
		},
		{
			occupationCode: "1994",
			occupationDescription: "Commodity Service Representative",
		},
		{
			occupationCode: "3404",
			occupationDescription:
				"Communication devices maintenance electronic Technician",
		},
		{
			occupationCode: "1970",
			occupationDescription: "Communication service Supervisor",
		},
		{
			occupationCode: "62",
			occupationDescription: "Communications Engineer",
		},
		{
			occupationCode: "270",
			occupationDescription: "Communications Manager",
		},
		{
			occupationCode: "92",
			occupationDescription: "Communications Technician",
		},
		{
			occupationCode: "3397",
			occupationDescription: "Communications antenna Installer",
		},
		{
			occupationCode: "887",
			occupationDescription: "Company Chairman",
		},
		{
			occupationCode: "2553",
			occupationDescription: "Compilation binding machine operator",
		},
		{
			occupationCode: "1909",
			occupationDescription: "Complaint Clerk",
		},
		{
			occupationCode: "239",
			occupationDescription: "Composer",
		},
		{
			occupationCode: "2536",
			occupationDescription: "Compositor",
		},
		{
			occupationCode: "2332",
			occupationDescription: "Compressed Wood Manufacturing Worker",
		},
		{
			occupationCode: "962",
			occupationDescription: "Computer Instructor",
		},
		{
			occupationCode: "3416",
			occupationDescription: "Computer Maintenance electrician",
		},
		{
			occupationCode: "1591",
			occupationDescription: "Computer Operator",
		},
		{
			occupationCode: "958",
			occupationDescription: "Computer Programmer",
		},
		{
			occupationCode: "2080",
			occupationDescription: "Computer Salesman",
		},
		{
			occupationCode: "1403",
			occupationDescription: "Computer Teacher",
		},
		{
			occupationCode: "481",
			occupationDescription: "Computer Technician",
		},
		{
			occupationCode: "75",
			occupationDescription: "Computer engineer",
		},
		{
			occupationCode: "959",
			occupationDescription: "Computer network Supervisor",
		},
		{
			occupationCode: "290",
			occupationDescription: "Computer supervisor",
		},
		{
			occupationCode: "3594",
			occupationDescription: "Computers assembling worker",
		},
		{
			occupationCode: "3497",
			occupationDescription: "Concrete Mixer Operator",
		},
		{
			occupationCode: "3486",
			occupationDescription: "Concrete assistant builder",
		},
		{
			occupationCode: "3485",
			occupationDescription: "Concrete builder",
		},
		{
			occupationCode: "3495",
			occupationDescription: "Concrete mixture Overseer",
		},
		{
			occupationCode: "3491",
			occupationDescription: "Concrete mold Carpenter",
		},
		{
			occupationCode: "3490",
			occupationDescription: "Concrete mold Supervisor",
		},
		{
			occupationCode: "2624",
			occupationDescription: "Concrete products making Worker",
		},
		{
			occupationCode: "3498",
			occupationDescription: "Concrete pump operator",
		},
		{
			occupationCode: "3522",
			occupationDescription: "Concrete reinforcing worker",
		},
		{
			occupationCode: "534",
			occupationDescription: "Concrete worker",
		},
		{
			occupationCode: "334",
			occupationDescription: "Confectioner",
		},
		{
			occupationCode: "400",
			occupationDescription: "Confectionery Master",
		},
		{
			occupationCode: "2852",
			occupationDescription: "Confectionery Packaging Worker",
		},
		{
			occupationCode: "410",
			occupationDescription: "Confectionery worker",
		},
		{
			occupationCode: "3053",
			occupationDescription: "Construction Blacksmith",
		},
		{
			occupationCode: "3060",
			occupationDescription: "Construction Installation Worker",
		},
		{
			occupationCode: "3055",
			occupationDescription: "Construction building worker",
		},
		{
			occupationCode: "3051",
			occupationDescription: "Construction preparation Worker",
		},
		{
			occupationCode: "2091",
			occupationDescription: "Construction supplies seller",
		},
		{
			occupationCode: "700",
			occupationDescription: "Consul",
		},
		{
			occupationCode: "701",
			occupationDescription: "Consul general",
		},
		{
			occupationCode: "184",
			occupationDescription: "Consultant",
		},
		{
			occupationCode: "1238",
			occupationDescription: "Consultant Cardiac Surgeon",
		},
		{
			occupationCode: "1298",
			occupationDescription: "Consultant Patient nutrition",
		},
		{
			occupationCode: "1305",
			occupationDescription: "Consultant Pharmaceuticals",
		},
		{
			occupationCode: "139",
			occupationDescription: "Consultant Physician",
		},
		{
			occupationCode: "1285",
			occupationDescription: "Consultant Psychotherapist",
		},
		{
			occupationCode: "1249",
			occupationDescription: "Consultant dentist",
		},
		{
			occupationCode: "1275",
			occupationDescription: "Consultant medical imaging",
		},
		{
			occupationCode: "1191",
			occupationDescription: "Consultant vascular surgeon",
		},
		{
			occupationCode: "2707",
			occupationDescription: "Continuous distillery Operator",
		},
		{
			occupationCode: "1541",
			occupationDescription: "Contracts Specialist",
		},
		{
			occupationCode: "1030",
			occupationDescription: "Control and Monitoring Engineer",
		},
		{
			occupationCode: "3412",
			occupationDescription:
				"Control devices maintenance electronic Technician",
		},
		{
			occupationCode: "2678",
			occupationDescription: "Control panel Overseer",
		},
		{
			occupationCode: "330",
			occupationDescription: "Cook",
		},
		{
			occupationCode: "2726",
			occupationDescription: "Cooling and drying Rubber Machine operator",
		},
		{
			occupationCode: "488",
			occupationDescription: "Cooling devices Electrician",
		},
		{
			occupationCode: "2056",
			occupationDescription: "Copier salesman",
		},
		{
			occupationCode: "1886",
			occupationDescription: "Copiers Operator",
		},
		{
			occupationCode: "501",
			occupationDescription: "Copper Welder",
		},
		{
			occupationCode: "2049",
			occupationDescription: "Copper antiques seller",
		},
		{
			occupationCode: "2950",
			occupationDescription: "Copper works molding worker",
		},
		{
			occupationCode: "3111",
			occupationDescription: "Coppersmith",
		},
		{
			occupationCode: "2201",
			occupationDescription: "Corpses Embalmer",
		},
		{
			occupationCode: "1882",
			occupationDescription: "Correspondence Writer",
		},
		{
			occupationCode: "230",
			occupationDescription: "Correspondent",
		},
		{
			occupationCode: "1843",
			occupationDescription: "Cosmetic Technician",
		},
		{
			occupationCode: "2711",
			occupationDescription: "Cosmetic materials and toothpaste Preparator",
		},
		{
			occupationCode: "2746",
			occupationDescription: "Cosmetics Mixtures preparation Worker",
		},
		{
			occupationCode: "2059",
			occupationDescription: "Cosmetics Seller",
		},
		{
			occupationCode: "1855",
			occupationDescription: "Cost accounts Technician",
		},
		{
			occupationCode: "1553",
			occupationDescription: "Costs Accountant",
		},
		{
			occupationCode: "1942",
			occupationDescription: "Costs Clerk",
		},
		{
			occupationCode: "2247",
			occupationDescription: "Cotton Farmer",
		},
		{
			occupationCode: "1884",
			occupationDescription: "Court clerk",
		},
		{
			occupationCode: "253",
			occupationDescription: "Crafts Instructor",
		},
		{
			occupationCode: "3247",
			occupationDescription: "Crank Whetter",
		},
		{
			occupationCode: "2912",
			occupationDescription: "Cream maker",
		},
		{
			occupationCode: "1530",
			occupationDescription: "Credit Analyst",
		},
		{
			occupationCode: "801",
			occupationDescription: "Credit Manager",
		},
		{
			occupationCode: "2669",
			occupationDescription: "Crude oil refinement Worker",
		},
		{
			occupationCode: "3219",
			occupationDescription: "Crusher Driver",
		},
		{
			occupationCode: "384",
			occupationDescription: "Crushing Plant worker",
		},
		{
			occupationCode: "2698",
			occupationDescription: "Crushing and grinding machine Worker",
		},
		{
			occupationCode: "2637",
			occupationDescription: "Crushing plant Operator",
		},
		{
			occupationCode: "2309",
			occupationDescription: "Crustaceans Breeder",
		},
		{
			occupationCode: "718",
			occupationDescription: "Cultural Attach",
		},
		{
			occupationCode: "1482",
			occupationDescription: "Cultural Supervisor",
		},
		{
			occupationCode: "643",
			occupationDescription: "Culture and Information Affairs Director",
		},
		{
			occupationCode: "1404",
			occupationDescription: "Curriculum development Specialist",
		},
		{
			occupationCode: "1934",
			occupationDescription: "Customs Clerk",
		},
		{
			occupationCode: "2291",
			occupationDescription: "Customs Dogman",
		},
		{
			occupationCode: "1421",
			occupationDescription: "Customs Trainer",
		},
		{
			occupationCode: "2011",
			occupationDescription: "Customs clearance Broker",
		},
		{
			occupationCode: "1935",
			occupationDescription: "Customs clearance Clerk",
		},
		{
			occupationCode: "2940",
			occupationDescription: "Cutting Tool Sharpening Worker",
		},
		{
			occupationCode: "2994",
			occupationDescription: "Cutting Tool whetting Worker",
		},
		{
			occupationCode: "3031",
			occupationDescription: "Cutting machine operator",
		},
		{
			occupationCode: "975",
			occupationDescription: "DATA CENTER ADMINISTRATOR",
		},
		{
			occupationCode: "988",
			occupationDescription: "DIGITAL MEDIA DESIGNER",
		},
		{
			occupationCode: "792",
			occupationDescription: "DIRECTOR OF NETWORKING MANAGEMENT",
		},
		{
			occupationCode: "736",
			occupationDescription: "Dairy Product Manger",
		},
		{
			occupationCode: "357",
			occupationDescription: "Dairy Technician",
		},
		{
			occupationCode: "2285",
			occupationDescription: "Dairy maker",
		},
		{
			occupationCode: "2918",
			occupationDescription: "Dairy pasteurization Worker",
		},
		{
			occupationCode: "2909",
			occupationDescription: "Dairy products Maker",
		},
		{
			occupationCode: "2911",
			occupationDescription: "Dairy products Sterilizer",
		},
		{
			occupationCode: "408",
			occupationDescription: "Dairy products worker",
		},
		{
			occupationCode: "1002",
			occupationDescription: "Dams Engineer",
		},
		{
			occupationCode: "291",
			occupationDescription: "Data entry Operator",
		},
		{
			occupationCode: "960",
			occupationDescription: "Databank Systems Programmer",
		},
		{
			occupationCode: "289",
			occupationDescription: "Database supervisor",
		},
		{
			occupationCode: "2878",
			occupationDescription: "Dates Cook",
		},
		{
			occupationCode: "2880",
			occupationDescription: "Dates fumigation Worker",
		},
		{
			occupationCode: "2879",
			occupationDescription: "Dates or stone separation machine operator",
		},
		{
			occupationCode: "2882",
			occupationDescription: "Dates press Operator",
		},
		{
			occupationCode: "1427",
			occupationDescription: "Deaf and Dumb Teacher",
		},
		{
			occupationCode: "1868",
			occupationDescription: "Death Registration Clerk",
		},
		{
			occupationCode: "1939",
			occupationDescription: "Debt Collector",
		},
		{
			occupationCode: "3474",
			occupationDescription: "Decoration Carpenter",
		},
		{
			occupationCode: "72",
			occupationDescription: "Decoration Engineer",
		},
		{
			occupationCode: "234",
			occupationDescription: "Decoration Teacher",
		},
		{
			occupationCode: "454",
			occupationDescription: "Decoration technician",
		},
		{
			occupationCode: "2953",
			occupationDescription: "Decorative works molding Worker",
		},
		{
			occupationCode: "1811",
			occupationDescription: "Decrepit care Technician",
		},
		{
			occupationCode: "2946",
			occupationDescription: "Decrepit outfit manufacturing Worker",
		},
		{
			occupationCode: "170",
			occupationDescription: "Dental consultant",
		},
		{
			occupationCode: "1787",
			occupationDescription: "Dental hygienist",
		},
		{
			occupationCode: "1784",
			occupationDescription: "Dental technician",
		},
		{
			occupationCode: "1785",
			occupationDescription: "Dental treatment Technician",
		},
		{
			occupationCode: "166",
			occupationDescription: "Dentist",
		},
		{
			occupationCode: "1247",
			occupationDescription: "Dentist / public health",
		},
		{
			occupationCode: "1245",
			occupationDescription: "Dentist general",
		},
		{
			occupationCode: "1246",
			occupationDescription: "Dentist specialist",
		},
		{
			occupationCode: "2712",
			occupationDescription: "Denture making Worker",
		},
		{
			occupationCode: "702",
			occupationDescription: "Deputy Consul General",
		},
		{
			occupationCode: "721",
			occupationDescription: "Deputy military Attach",
		},
		{
			occupationCode: "149",
			occupationDescription: "Dermatologist",
		},
		{
			occupationCode: "1195",
			occupationDescription: "Dermatology Consultant",
		},
		{
			occupationCode: "2369",
			occupationDescription: "Dermis Cleaner",
		},
		{
			occupationCode: "373",
			occupationDescription: "Derrick man",
		},
		{
			occupationCode: "3186",
			occupationDescription: "Desalination plant Control room operator",
		},
		{
			occupationCode: "3185",
			occupationDescription: "Desalination plant Heat operator",
		},
		{
			occupationCode: "3187",
			occupationDescription: "Desalination plant Pumping station operator",
		},
		{
			occupationCode: "3188",
			occupationDescription: "Desalination plant lime Worker",
		},
		{
			occupationCode: "1388",
			occupationDescription: "Designer, Educational Programmes",
		},
		{
			occupationCode: "2690",
			occupationDescription: "Desulfurization treatment operator",
		},
		{
			occupationCode: "2212",
			occupationDescription: "Detective",
		},
		{
			occupationCode: "378",
			occupationDescription: "Developing Technician",
		},
		{
			occupationCode: "1093",
			occupationDescription: "Developing and Specification Engineer",
		},
		{
			occupationCode: "3236",
			occupationDescription: "Diesel Engine Mechanic",
		},
		{
			occupationCode: "3225",
			occupationDescription: "Diesel engines Operator",
		},
		{
			occupationCode: "1017",
			occupationDescription: "Digital Aerial Survey Specialist",
		},
		{
			occupationCode: "1011",
			occupationDescription: "Digital Aerial surveying Supervisor (First)",
		},
		{
			occupationCode: "1016",
			occupationDescription: "Digital Cartography Specialist",
		},
		{
			occupationCode: "1614",
			occupationDescription: "Digital Chart Cartographer",
		},
		{
			occupationCode: "1010",
			occupationDescription: "Digital Charting Specialist",
		},
		{
			occupationCode: "638",
			occupationDescription: "Diplomatic Ambassador",
		},
		{
			occupationCode: "876",
			occupationDescription: "Director Operations Planning",
		},
		{
			occupationCode: "806",
			occupationDescription: "Director of Accounts and Budget Manager",
		},
		{
			occupationCode: "802",
			occupationDescription: "Director of Administration",
		},
		{
			occupationCode: "852",
			occupationDescription: "Director of Aluminium Planning and Investment",
		},
		{
			occupationCode: "849",
			occupationDescription: "Director of Aluminium operation and marketing",
		},
		{
			occupationCode: "824",
			occupationDescription: "Director of Annual plans Administration",
		},
		{
			occupationCode: "808",
			occupationDescription: "Director of Antiquities",
		},
		{
			occupationCode: "699",
			occupationDescription: "Director of CHAMBER OF COMMERCE",
		},
		{
			occupationCode: "830",
			occupationDescription: "Director of Cash Operations Management",
		},
		{
			occupationCode: "811",
			occupationDescription: "Director of Cash investment Department",
		},
		{
			occupationCode: "745",
			occupationDescription: "Director of Chemicals and Fertilizers Documents",
		},
		{
			occupationCode: "815",
			occupationDescription: "Director of Collection and credit Department",
		},
		{
			occupationCode: "846",
			occupationDescription: "Director of Customer Services Department",
		},
		{
			occupationCode: "649",
			occupationDescription: "Director of Economic and Commercial Affairs",
		},
		{
			occupationCode: "669",
			occupationDescription: "Director of Electricity",
		},
		{
			occupationCode: "866",
			occupationDescription: "Director of Europe and America Area shipping",
		},
		{
			occupationCode: "755",
			occupationDescription: "Director of Fertilizer techniques Section",
		},
		{
			occupationCode: "798",
			occupationDescription: "Director of Filming",
		},
		{
			occupationCode: "817",
			occupationDescription: "Director of Financial Planning and Coordination",
		},
		{
			occupationCode: "821",
			occupationDescription: "Director of Financial reports",
		},
		{
			occupationCode: "822",
			occupationDescription: "Director of Financing",
		},
		{
			occupationCode: "764",
			occupationDescription: "Director of Gas fields exploration",
		},
		{
			occupationCode: "750",
			occupationDescription: "Director of Gas operation and investment",
		},
		{
			occupationCode: "751",
			occupationDescription: "Director of Gas work Development",
		},
		{
			occupationCode: "859",
			occupationDescription: "Director of General Administration for Auditing",
		},
		{
			occupationCode: "677",
			occupationDescription: "Director of Hospital",
		},
		{
			occupationCode: "763",
			occupationDescription: "Director of Housing and materials",
		},
		{
			occupationCode: "847",
			occupationDescription: "Director of Industrial Security Administration",
		},
		{
			occupationCode: "687",
			occupationDescription: "Director of Information",
		},
		{
			occupationCode: "854",
			occupationDescription: "Director of Information Technical Services",
		},
		{
			occupationCode: "848",
			occupationDescription: "Director of Information Technology Applications",
		},
		{
			occupationCode: "843",
			occupationDescription: "Director of Information Technology Support",
		},
		{
			occupationCode: "869",
			occupationDescription: "Director of Information and Market Research",
		},
		{
			occupationCode: "831",
			occupationDescription: "Director of Internal Audit Department",
		},
		{
			occupationCode: "814",
			occupationDescription: "Director of International Trade Department",
		},
		{
			occupationCode: "657",
			occupationDescription: "Director of Investment",
		},
		{
			occupationCode: "880",
			occupationDescription: "Director of Job Evaluation system Management",
		},
		{
			occupationCode: "820",
			occupationDescription: "Director of Job development",
		},
		{
			occupationCode: "857",
			occupationDescription: "Director of Legal Affairs Department",
		},
		{
			occupationCode: "885",
			occupationDescription: "Director of License Department",
		},
		{
			occupationCode: "742",
			occupationDescription: "Director of Maintenance",
		},
		{
			occupationCode: "810",
			occupationDescription: "Director of Management Systems Department",
		},
		{
			occupationCode: "834",
			occupationDescription: "Director of Manpower Planning Department",
		},
		{
			occupationCode: "758",
			occupationDescription: "Director of Manufacturing Laboratory Section",
		},
		{
			occupationCode: "861",
			occupationDescription: "Director of Monetary public administration",
		},
		{
			occupationCode: "858",
			occupationDescription: "Director of New opportunities Administration",
		},
		{
			occupationCode: "863",
			occupationDescription:
				"Director of Office Management of Managing Director",
		},
		{
			occupationCode: "874",
			occupationDescription: "Director of Operation Planning",
		},
		{
			occupationCode: "753",
			occupationDescription: "Director of P. V. C. Section",
		},
		{
			occupationCode: "803",
			occupationDescription: "Director of Personnel Relations",
		},
		{
			occupationCode: "759",
			occupationDescription:
				"Director of Physical properties Laboratory Section",
		},
		{
			occupationCode: "754",
			occupationDescription: "Director of Pilot plants Section",
		},
		{
			occupationCode: "872",
			occupationDescription:
				"Director of Planning and operation Analysis and Research",
		},
		{
			occupationCode: "665",
			occupationDescription: "Director of Post Office",
		},
		{
			occupationCode: "694",
			occupationDescription: "Director of Printing and Publication",
		},
		{
			occupationCode: "862",
			occupationDescription: "Director of Product Accounting Administration",
		},
		{
			occupationCode: "688",
			occupationDescription: "Director of Radio",
		},
		{
			occupationCode: "833",
			occupationDescription: "Director of Raw Materials Department",
		},
		{
			occupationCode: "813",
			occupationDescription: "Director of Regulations Administration",
		},
		{
			occupationCode: "805",
			occupationDescription: "Director of Research and Development",
		},
		{
			occupationCode: "653",
			occupationDescription: "Director of Research and Studies",
		},
		{
			occupationCode: "844",
			occupationDescription: "Director of Risk Management",
		},
		{
			occupationCode: "760",
			occupationDescription: "Director of Security and Safety",
		},
		{
			occupationCode: "812",
			occupationDescription: "Director of Shares",
		},
		{
			occupationCode: "697",
			occupationDescription: "Director of Society",
		},
		{
			occupationCode: "747",
			occupationDescription: "Director of Solid material handling",
		},
		{
			occupationCode: "867",
			occupationDescription: "Director of South or East Asia Area shipping",
		},
		{
			occupationCode: "864",
			occupationDescription: "Director of Strategic Planning",
		},
		{
			occupationCode: "816",
			occupationDescription: "Director of Strategic Planning Department",
		},
		{
			occupationCode: "873",
			occupationDescription: "Director of Strategic Planning and Investment",
		},
		{
			occupationCode: "823",
			occupationDescription: "Director of Support Services",
		},
		{
			occupationCode: "689",
			occupationDescription: "Director of Television",
		},
		{
			occupationCode: "856",
			occupationDescription: "Director of Trade Policies Department",
		},
		{
			occupationCode: "686",
			occupationDescription: "Director of Training Centre",
		},
		{
			occupationCode: "818",
			occupationDescription: "Director of Training and Special Programmes",
		},
		{
			occupationCode: "878",
			occupationDescription: "Director of Urea Process Planning",
		},
		{
			occupationCode: "749",
			occupationDescription: "Director of Works and investment",
		},
		{
			occupationCode: "853",
			occupationDescription: "Director of Works and support information",
		},
		{
			occupationCode: "646",
			occupationDescription: "Director of Youth and Sport Welfare Affairs",
		},
		{
			occupationCode: "826",
			occupationDescription: "Director of Zakat and taxes Department",
		},
		{
			occupationCode: "762",
			occupationDescription: "Director of administrative services development",
		},
		{
			occupationCode: "825",
			occupationDescription: "Director of advertising Department",
		},
		{
			occupationCode: "804",
			occupationDescription: "Director of advertising and public relations",
		},
		{
			occupationCode: "672",
			occupationDescription: "Director of air transport",
		},
		{
			occupationCode: "819",
			occupationDescription: "Director of cash flow Department",
		},
		{
			occupationCode: "772",
			occupationDescription: "Director of client services",
		},
		{
			occupationCode: "829",
			occupationDescription: "Director of contracts and tenders Department",
		},
		{
			occupationCode: "886",
			occupationDescription: "Director of customers technical support",
		},
		{
			occupationCode: "851",
			occupationDescription: "Director of documentary credits",
		},
		{
			occupationCode: "835",
			occupationDescription: "Director of employees compensation Department",
		},
		{
			occupationCode: "796",
			occupationDescription: "Director of film production",
		},
		{
			occupationCode: "650",
			occupationDescription: "Director of financial and accounting",
		},
		{
			occupationCode: "761",
			occupationDescription: "Director of financial and loans planning",
		},
		{
			occupationCode: "658",
			occupationDescription: "Director of follow or up",
		},
		{
			occupationCode: "676",
			occupationDescription: "Director of industrial city",
		},
		{
			occupationCode: "685",
			occupationDescription: "Director of industrial training workshops",
		},
		{
			occupationCode: "882",
			occupationDescription: "Director of internal market development",
		},
		{
			occupationCode: "881",
			occupationDescription:
				"Director of international cooperation coordination",
		},
		{
			occupationCode: "746",
			occupationDescription: "Director of liquid material handling",
		},
		{
			occupationCode: "828",
			occupationDescription:
				"Director of maintenance and communications Department",
		},
		{
			occupationCode: "671",
			occupationDescription: "Director of maritime transportation",
		},
		{
			occupationCode: "836",
			occupationDescription: "Director of offices Services Management",
		},
		{
			occupationCode: "875",
			occupationDescription: "Director of operation Planning and technique",
		},
		{
			occupationCode: "877",
			occupationDescription: "Director of operations planning and technique",
		},
		{
			occupationCode: "842",
			occupationDescription: "Director of personnel payments Department",
		},
		{
			occupationCode: "855",
			occupationDescription: "Director of plans and operation Management",
		},
		{
			occupationCode: "879",
			occupationDescription: "Director of plastic products Manufacturing",
		},
		{
			occupationCode: "752",
			occupationDescription: "Director of polyester Section",
		},
		{
			occupationCode: "744",
			occupationDescription: "Director of polymer Documents Department",
		},
		{
			occupationCode: "757",
			occupationDescription: "Director of polyolefin catalyst",
		},
		{
			occupationCode: "756",
			occupationDescription: "Director of polyolefin techniques",
		},
		{
			occupationCode: "797",
			occupationDescription: "Director of radio and TV Production",
		},
		{
			occupationCode: "860",
			occupationDescription: "Director of raw materials and utilities",
		},
		{
			occupationCode: "884",
			occupationDescription: "Director of regional offices",
		},
		{
			occupationCode: "670",
			occupationDescription: "Director of road transportation",
		},
		{
			occupationCode: "868",
			occupationDescription: "Director of sales and customer services",
		},
		{
			occupationCode: "837",
			occupationDescription:
				"Director of shipping and distribution Department of the Middle",
		},
		{
			occupationCode: "839",
			occupationDescription:
				"Director of shipping and distribution Department of the West",
		},
		{
			occupationCode: "838",
			occupationDescription: "Director of shipping and distribution of gas",
		},
		{
			occupationCode: "827",
			occupationDescription: "Director of ships Department",
		},
		{
			occupationCode: "698",
			occupationDescription: "Director of social care Home",
		},
		{
			occupationCode: "841",
			occupationDescription: "Director of supplier payments Department",
		},
		{
			occupationCode: "883",
			occupationDescription:
				"Director of technical services and technical coordinator",
		},
		{
			occupationCode: "667",
			occupationDescription: "Director of telecommunications and wireless",
		},
		{
			occupationCode: "682",
			occupationDescription: "Director of the Institute",
		},
		{
			occupationCode: "648",
			occupationDescription: "Director of the municipality and village",
		},
		{
			occupationCode: "795",
			occupationDescription: "Director of theatre production",
		},
		{
			occupationCode: "871",
			occupationDescription: "Director of trade Analysis and research",
		},
		{
			occupationCode: "870",
			occupationDescription: "Director of trade Information and research",
		},
		{
			occupationCode: "680",
			occupationDescription: "Director of veterinary hospital",
		},
		{
			occupationCode: "668",
			occupationDescription: "Director of water and Sewerage",
		},
		{
			occupationCode: "647",
			occupationDescription: "Director of works and public utilities",
		},
		{
			occupationCode: "1323",
			occupationDescription: "Disabled care Specialist",
		},
		{
			occupationCode: "1810",
			occupationDescription: "Disabled care Technician",
		},
		{
			occupationCode: "948",
			occupationDescription: "Disease Botanist",
		},
		{
			occupationCode: "947",
			occupationDescription: "Disease Zoologist",
		},
		{
			occupationCode: "2706",
			occupationDescription: "Distillery Operator",
		},
		{
			occupationCode: "387",
			occupationDescription: "Distillery work",
		},
		{
			occupationCode: "3587",
			occupationDescription: "Distribution panels assembling worker",
		},
		{
			occupationCode: "109",
			occupationDescription: "Diver",
		},
		{
			occupationCode: "2221",
			occupationDescription: "Dockworker",
		},
		{
			occupationCode: "1891",
			occupationDescription: "Document Endorsement Clerk",
		},
		{
			occupationCode: "3446",
			occupationDescription: "Door and window carpenter",
		},
		{
			occupationCode: "347",
			occupationDescription: "Doorkeeper",
		},
		{
			occupationCode: "2799",
			occupationDescription: "Dough / clay mixing Worker",
		},
		{
			occupationCode: "2842",
			occupationDescription: "Dough Cutting Machine Operator",
		},
		{
			occupationCode: "2795",
			occupationDescription: "Dough hand casting Worker",
		},
		{
			occupationCode: "2348",
			occupationDescription: "Dough smoothing machine operator",
		},
		{
			occupationCode: "79",
			occupationDescription: "Drawer",
		},
		{
			occupationCode: "2205",
			occupationDescription: "Dressing Nurse",
		},
		{
			occupationCode: "2674",
			occupationDescription: "Drilling Derrick Overseer",
		},
		{
			occupationCode: "2675",
			occupationDescription: "Drilling equipment Operation Overseer",
		},
		{
			occupationCode: "3045",
			occupationDescription: "Drilling equipment filing mechanic",
		},
		{
			occupationCode: "2664",
			occupationDescription: "Drilling operator",
		},
		{
			occupationCode: "2663",
			occupationDescription: "Drilling platform Preparator",
		},
		{
			occupationCode: "560",
			occupationDescription: "Driver",
		},
		{
			occupationCode: "2542",
			occupationDescription: "Drum printing machine Operator",
		},
		{
			occupationCode: "2171",
			occupationDescription: "Dry cleaning worker",
		},
		{
			occupationCode: "2175",
			occupationDescription: "Dry or cleaning Worker",
		},
		{
			occupationCode: "2326",
			occupationDescription: "Drying Oven wood Operator",
		},
		{
			occupationCode: "2985",
			occupationDescription: "Dust furnace operator",
		},
		{
			occupationCode: "482",
			occupationDescription: "Dynamo Winding Technician",
		},
		{
			occupationCode: "1291",
			occupationDescription: "ECG SPECIALIST",
		},
		{
			occupationCode: "126",
			occupationDescription: "EKG Technician",
		},
		{
			occupationCode: "977",
			occupationDescription: "ELECTRONIC TRANSFORMATION SPECIALIST",
		},
		{
			occupationCode: "171",
			occupationDescription: "ENT Consultant",
		},
		{
			occupationCode: "965",
			occupationDescription: "ENTERPRISE ARCHITECT",
		},
		{
			occupationCode: "1532",
			occupationDescription: "EXPERT LABOR FORCE",
		},
		{
			occupationCode: "1423",
			occupationDescription: "EXPERT PRODUCTION LINES",
		},
		{
			occupationCode: "1424",
			occupationDescription: "EXPERT TAILORING",
		},
		{
			occupationCode: "930",
			occupationDescription: "Earthquakes Overseer",
		},
		{
			occupationCode: "1528",
			occupationDescription: "Economic analyst",
		},
		{
			occupationCode: "1527",
			occupationDescription: "Economics Specialist",
		},
		{
			occupationCode: "206",
			occupationDescription: "Economist",
		},
		{
			occupationCode: "231",
			occupationDescription: "Editor",
		},
		{
			occupationCode: "639",
			occupationDescription: "Education Affairs Director",
		},
		{
			occupationCode: "1833",
			occupationDescription: "Educational Aids Draftsman",
		},
		{
			occupationCode: "1832",
			occupationDescription: "Educational Aids Technician",
		},
		{
			occupationCode: "725",
			occupationDescription: "Educational Attach",
		},
		{
			occupationCode: "224",
			occupationDescription: "Educational Conductor",
		},
		{
			occupationCode: "1835",
			occupationDescription: "Educational Models Draftsman",
		},
		{
			occupationCode: "1834",
			occupationDescription: "Educational Models Technician",
		},
		{
			occupationCode: "2295",
			occupationDescription: "Egg Chicken Breeder",
		},
		{
			occupationCode: "2298",
			occupationDescription: "Eggs Collection and sorting Worker",
		},
		{
			occupationCode: "1623",
			occupationDescription: "Electric Designs Draftsman",
		},
		{
			occupationCode: "477",
			occupationDescription: "Electric Machinery Electrician",
		},
		{
			occupationCode: "3387",
			occupationDescription: "Electric furnace operation Supervisor",
		},
		{
			occupationCode: "549",
			occupationDescription: "Electric generator operation Technician",
		},
		{
			occupationCode: "2110",
			occupationDescription: "Electric machines Salesman",
		},
		{
			occupationCode: "3583",
			occupationDescription: "Electric motors assembling worker",
		},
		{
			occupationCode: "475",
			occupationDescription: "Electric motors technician",
		},
		{
			occupationCode: "1023",
			occupationDescription: "Electric power Engineer",
		},
		{
			occupationCode: "2491",
			occupationDescription: "Electric sewing machine operator",
		},
		{
			occupationCode: "3306",
			occupationDescription: "Electric turbine operator",
		},
		{
			occupationCode: "1634",
			occupationDescription: "Electrical Engineering Electrician",
		},
		{
			occupationCode: "86",
			occupationDescription: "Electrical Engineering Technician",
		},
		{
			occupationCode: "2069",
			occupationDescription: "Electrical Musical instruments seller",
		},
		{
			occupationCode: "499",
			occupationDescription: "Electrical Welder",
		},
		{
			occupationCode: "443",
			occupationDescription: "Electrical and mechanical Specialist",
		},
		{
			occupationCode: "88",
			occupationDescription: "Electrical appliance Technician",
		},
		{
			occupationCode: "3095",
			occupationDescription: "Electrical coating worker",
		},
		{
			occupationCode: "3381",
			occupationDescription: "Electrical device preparation worker",
		},
		{
			occupationCode: "50",
			occupationDescription: "Electrical engineer",
		},
		{
			occupationCode: "2043",
			occupationDescription: "Electrical equipment Seller",
		},
		{
			occupationCode: "3590",
			occupationDescription: "Electrical equipment assembling worker",
		},
		{
			occupationCode: "3379",
			occupationDescription: "Electrical equipment examination worker",
		},
		{
			occupationCode: "2092",
			occupationDescription: "Electrical laying out supplies Seller",
		},
		{
			occupationCode: "3584",
			occupationDescription: "Electrical transformer assembling worker",
		},
		{
			occupationCode: "3083",
			occupationDescription: "Electrical welding machine operator",
		},
		{
			occupationCode: "94",
			occupationDescription: "Electrician",
		},
		{
			occupationCode: "1621",
			occupationDescription: "Electrician Draftsman",
		},
		{
			occupationCode: "3345",
			occupationDescription: "Electrician Maintenance of accurate",
		},
		{
			occupationCode: "1948",
			occupationDescription: "Electricity meter Reader",
		},
		{
			occupationCode: "915",
			occupationDescription: "Electromagnetic Physicist",
		},
		{
			occupationCode: "1643",
			occupationDescription: "Electronic Draftsman",
		},
		{
			occupationCode: "3597",
			occupationDescription: "Electronic devices assembling worker",
		},
		{
			occupationCode: "1033",
			occupationDescription: "Electronic engineer",
		},
		{
			occupationCode: "87",
			occupationDescription: "Electronic engineering technician",
		},
		{
			occupationCode: "3420",
			occupationDescription: "Electronic equipment preparation Worker",
		},
		{
			occupationCode: "3394",
			occupationDescription: "Electronic exchanges Installer",
		},
		{
			occupationCode: "3396",
			occupationDescription: "Electronic exchanges Operator",
		},
		{
			occupationCode: "1039",
			occupationDescription: "Electronic maintenance engineer",
		},
		{
			occupationCode: "1570",
			occupationDescription: "Electronics Laboratory",
		},
		{
			occupationCode: "369",
			occupationDescription: "Electronics Production supervisor",
		},
		{
			occupationCode: "479",
			occupationDescription: "Electronics Technician",
		},
		{
			occupationCode: "51",
			occupationDescription: "Electronics engineer",
		},
		{
			occupationCode: "16",
			occupationDescription: "Electronics physicist",
		},
		{
			occupationCode: "2566",
			occupationDescription: "Electroplating Worker",
		},
		{
			occupationCode: "2211",
			occupationDescription: "Elevator",
		},
		{
			occupationCode: "3360",
			occupationDescription: "Elevator Assistant Electrician",
		},
		{
			occupationCode: "3359",
			occupationDescription: "Elevator Electrician",
		},
		{
			occupationCode: "478",
			occupationDescription: "Elevator Technician",
		},
		{
			occupationCode: "428",
			occupationDescription: "Embroiderer",
		},
		{
			occupationCode: "2524",
			occupationDescription: "Embroidery machine operator",
		},
		{
			occupationCode: "2523",
			occupationDescription: "Embroidery worker",
		},
		{
			occupationCode: "144",
			occupationDescription: "Emergency Physician",
		},
		{
			occupationCode: "1222",
			occupationDescription: "Emergency Resident Physician",
		},
		{
			occupationCode: "1153",
			occupationDescription: "Endocrinologist",
		},
		{
			occupationCode: "1189",
			occupationDescription: "Endocrinology Consultant",
		},
		{
			occupationCode: "1252",
			occupationDescription: "Endodontist",
		},
		{
			occupationCode: "1166",
			occupationDescription: "Endoscopist",
		},
		{
			occupationCode: "1202",
			occupationDescription: "Endoscopy Consultant",
		},
		{
			occupationCode: "3248",
			occupationDescription: "Engine Head Whetter",
		},
		{
			occupationCode: "3246",
			occupationDescription: "Engine Turner",
		},
		{
			occupationCode: "450",
			occupationDescription: "Engine worker",
		},
		{
			occupationCode: "53",
			occupationDescription: "Engineer",
		},
		{
			occupationCode: "68",
			occupationDescription: "Engineer cars",
		},
		{
			occupationCode: "465",
			occupationDescription: "Engines Mechanic",
		},
		{
			occupationCode: "1060",
			occupationDescription: "Engines Mechanical Engineer",
		},
		{
			occupationCode: "2545",
			occupationDescription: "Engraved printing machine operator",
		},
		{
			occupationCode: "3431",
			occupationDescription: "Engraving Carpenter",
		},
		{
			occupationCode: "2568",
			occupationDescription: "Engraving Machine Operator",
		},
		{
			occupationCode: "945",
			occupationDescription: "Entomologist",
		},
		{
			occupationCode: "1107",
			occupationDescription: "Environment ENGINEER",
		},
		{
			occupationCode: "1062",
			occupationDescription: "Environmental Control Systems Chief technician",
		},
		{
			occupationCode: "354",
			occupationDescription: "Equestrian",
		},
		{
			occupationCode: "3126",
			occupationDescription: "Equipment Installation Assistant Mechanic",
		},
		{
			occupationCode: "3125",
			occupationDescription: "Equipment Installation Mechanic",
		},
		{
			occupationCode: "3128",
			occupationDescription: "Equipment Maintenance Mechanic",
		},
		{
			occupationCode: "468",
			occupationDescription: "Equipment Mechanic",
		},
		{
			occupationCode: "446",
			occupationDescription: "Equipment Worker",
		},
		{
			occupationCode: "3419",
			occupationDescription: "Equipment installation electrician",
		},
		{
			occupationCode: "496",
			occupationDescription: "Equipment operation worker",
		},
		{
			occupationCode: "547",
			occupationDescription: "Equipment operator",
		},
		{
			occupationCode: "449",
			occupationDescription: "Equipment technician",
		},
		{
			occupationCode: "1944",
			occupationDescription: "Establishment Cashier",
		},
		{
			occupationCode: "2012",
			occupationDescription: "Estimator",
		},
		{
			occupationCode: "2497",
			occupationDescription: "European clothing Cutter",
		},
		{
			occupationCode: "2709",
			occupationDescription: "Evaporation apparatus Operation",
		},
		{
			occupationCode: "3099",
			occupationDescription: "Examination Worker",
		},
		{
			occupationCode: "44",
			occupationDescription: "Examination technician",
		},
		{
			occupationCode: "3208",
			occupationDescription: "Excavator Operator",
		},
		{
			occupationCode: "1919",
			occupationDescription: "Exchange operator",
		},
		{
			occupationCode: "30",
			occupationDescription: "Exchanges Technician",
		},
		{
			occupationCode: "3402",
			occupationDescription:
				"Exchanges maintenance electronic Technician or General",
		},
		{
			occupationCode: "809",
			occupationDescription: "Executive Director",
		},
		{
			occupationCode: "1861",
			occupationDescription: "Executive secretary",
		},
		{
			occupationCode: "3245",
			occupationDescription: "Exhaust set Mechanic",
		},
		{
			occupationCode: "1837",
			occupationDescription: "Exhibition Guide",
		},
		{
			occupationCode: "2215",
			occupationDescription: "Expediter",
		},
		{
			occupationCode: "1312",
			occupationDescription: "Experimental Psychiatric Specialist",
		},
		{
			occupationCode: "276",
			occupationDescription: "Expert",
		},
		{
			occupationCode: "1082",
			occupationDescription: "Explosion Engineer",
		},
		{
			occupationCode: "1706",
			occupationDescription: "Explosion Technician",
		},
		{
			occupationCode: "2630",
			occupationDescription: "Explosion Worker",
		},
		{
			occupationCode: "39",
			occupationDescription: "Explosives Technician",
		},
		{
			occupationCode: "2975",
			occupationDescription: "Extrusion casting machine operator",
		},
		{
			occupationCode: "1231",
			occupationDescription: "Eye surgeon",
		},
		{
			occupationCode: "2139",
			occupationDescription: "FALAFEL maker",
		},
		{
			occupationCode: "395",
			occupationDescription: "Fabric worker",
		},
		{
			occupationCode: "396",
			occupationDescription: "Fabrics Dyeing Worker",
		},
		{
			occupationCode: "2031",
			occupationDescription: "Fabrics Seller",
		},
		{
			occupationCode: "337",
			occupationDescription: "Facilities",
		},
		{
			occupationCode: "2007",
			occupationDescription: "Factory Insurance broker",
		},
		{
			occupationCode: "739",
			occupationDescription: "Factory Manager",
		},
		{
			occupationCode: "390",
			occupationDescription: "Factory Overseer",
		},
		{
			occupationCode: "1710",
			occupationDescription: "Factory layout Draftsman",
		},
		{
			occupationCode: "2255",
			occupationDescription: "Farm Supervisor",
		},
		{
			occupationCode: "732",
			occupationDescription: "Farm manager",
		},
		{
			occupationCode: "351",
			occupationDescription: "Farmer",
		},
		{
			occupationCode: "425",
			occupationDescription: "Fashion designer",
		},
		{
			occupationCode: "777",
			occupationDescription: "Fast food Manager",
		},
		{
			occupationCode: "571",
			occupationDescription: "Father",
		},
		{
			occupationCode: "611",
			occupationDescription: "Father Muharem",
		},
		{
			occupationCode: "2910",
			occupationDescription: "Fats Sorting machine operator",
		},
		{
			occupationCode: "1932",
			occupationDescription: "Fees Account Clerk",
		},
		{
			occupationCode: "3098",
			occupationDescription: "Fermentation Worker",
		},
		{
			occupationCode: "1143",
			occupationDescription: "Ferryboat Master",
		},
		{
			occupationCode: "2250",
			occupationDescription: "Fertilization Worker",
		},
		{
			occupationCode: "1076",
			occupationDescription: "Fertilizer Industry Engineer",
		},
		{
			occupationCode: "2435",
			occupationDescription: "Fibre Pulling Worker",
		},
		{
			occupationCode: "391",
			occupationDescription: "Fibre production Worker",
		},
		{
			occupationCode: "2779",
			occupationDescription: "Fibrous Glassmaking Worker",
		},
		{
			occupationCode: "2244",
			occupationDescription: "Field crop farmer",
		},
		{
			occupationCode: "1110",
			occupationDescription: "Field crops specialist",
		},
		{
			occupationCode: "1881",
			occupationDescription: "Files Writer",
		},
		{
			occupationCode: "3046",
			occupationDescription: "Filing Supervisor",
		},
		{
			occupationCode: "445",
			occupationDescription: "Filing worker",
		},
		{
			occupationCode: "2569",
			occupationDescription: "Film Developer",
		},
		{
			occupationCode: "1502",
			occupationDescription: "Film Production Specialist",
		},
		{
			occupationCode: "242",
			occupationDescription: "Film producer",
		},
		{
			occupationCode: "277",
			occupationDescription: "Financial Analyst",
		},
		{
			occupationCode: "1943",
			occupationDescription: "Financial Clerk",
		},
		{
			occupationCode: "1539",
			occupationDescription: "Financial observer",
		},
		{
			occupationCode: "1860",
			occupationDescription: "Financial securities Teller",
		},
		{
			occupationCode: "1637",
			occupationDescription: "Fire Alarm Device Technician",
		},
		{
			occupationCode: "345",
			occupationDescription: "Fire or Fighter",
		},
		{
			occupationCode: "2204",
			occupationDescription: "Fire or Fighting Man",
		},
		{
			occupationCode: "1714",
			occupationDescription: "Fire or Fighting Technician",
		},
		{
			occupationCode: "902",
			occupationDescription: "Fire prevention Specialist",
		},
		{
			occupationCode: "1748",
			occupationDescription: "First Aid Nurse  or  Emergency",
		},
		{
			occupationCode: "711",
			occupationDescription: "First Secretary / A",
		},
		{
			occupationCode: "712",
			occupationDescription: "First Secretary / B",
		},
		{
			occupationCode: "2207",
			occupationDescription: "First or Aid Man",
		},
		{
			occupationCode: "2135",
			occupationDescription: "Fish Broiler/Fryer",
		},
		{
			occupationCode: "2908",
			occupationDescription: "Fish Conservation and freezing worker",
		},
		{
			occupationCode: "2905",
			occupationDescription: "Fish Cook",
		},
		{
			occupationCode: "2306",
			occupationDescription: "Fish Fodder",
		},
		{
			occupationCode: "2907",
			occupationDescription: "Fish Remnants Manufacturing worker",
		},
		{
			occupationCode: "2019",
			occupationDescription: "Fish Seller",
		},
		{
			occupationCode: "1122",
			occupationDescription: "Fish Specialist",
		},
		{
			occupationCode: "2304",
			occupationDescription: "Fish breeder",
		},
		{
			occupationCode: "2906",
			occupationDescription: "Fish canning Worker",
		},
		{
			occupationCode: "2903",
			occupationDescription: "Fish canning and conservation Worker",
		},
		{
			occupationCode: "2904",
			occupationDescription: "Fish cutting and cleaning Worker",
		},
		{
			occupationCode: "941",
			occupationDescription: "Fisheries specialist",
		},
		{
			occupationCode: "365",
			occupationDescription: "Fisherman",
		},
		{
			occupationCode: "1512",
			occupationDescription: "Fitness coach",
		},
		{
			occupationCode: "2547",
			occupationDescription: "Flat Printing machine operator",
		},
		{
			occupationCode: "1973",
			occupationDescription: "Flight operations officer",
		},
		{
			occupationCode: "2142",
			occupationDescription: "Foal (beans) Medames maker",
		},
		{
			occupationCode: "2282",
			occupationDescription: "Fodder Worker",
		},
		{
			occupationCode: "2119",
			occupationDescription: "Fodder seller",
		},
		{
			occupationCode: "2425",
			occupationDescription: "Folding Worker",
		},
		{
			occupationCode: "3030",
			occupationDescription: "Folding machine operator",
		},
		{
			occupationCode: "1579",
			occupationDescription: "Food Animal Research Technician",
		},
		{
			occupationCode: "897",
			occupationDescription: "Food Chemist",
		},
		{
			occupationCode: "1077",
			occupationDescription: "Food Industry Engineer",
		},
		{
			occupationCode: "1563",
			occupationDescription: "Food Laboratory Technician",
		},
		{
			occupationCode: "2147",
			occupationDescription: "Food Main Server",
		},
		{
			occupationCode: "2148",
			occupationDescription: "Food Server",
		},
		{
			occupationCode: "2150",
			occupationDescription: "Food Supervisor",
		},
		{
			occupationCode: "2873",
			occupationDescription: "Foodstuffs Sterilizer",
		},
		{
			occupationCode: "2875",
			occupationDescription: "Foodstuffs drying Worker",
		},
		{
			occupationCode: "2874",
			occupationDescription: "Foodstuffs freezing Worker",
		},
		{
			occupationCode: "245",
			occupationDescription: "Football Coach",
		},
		{
			occupationCode: "1851",
			occupationDescription: "Foreign currencies Transactor",
		},
		{
			occupationCode: "2133",
			occupationDescription: "Foreign food Cook",
		},
		{
			occupationCode: "1815",
			occupationDescription: "Foreign language Teacher",
		},
		{
			occupationCode: "1207",
			occupationDescription: "Forensic Medicine Consultant",
		},
		{
			occupationCode: "2269",
			occupationDescription: "Forest Farmer",
		},
		{
			occupationCode: "2208",
			occupationDescription: "Forest Fire or Fighting man",
		},
		{
			occupationCode: "2271",
			occupationDescription: "Forest Overseer",
		},
		{
			occupationCode: "1730",
			occupationDescription: "Forests and rangelands Technician",
		},
		{
			occupationCode: "3212",
			occupationDescription: "Forklift driver",
		},
		{
			occupationCode: "3499",
			occupationDescription: "Foundations driller",
		},
		{
			occupationCode: "3537",
			occupationDescription: "Foundations pile driver",
		},
		{
			occupationCode: "2156",
			occupationDescription: "Fruit juice maker",
		},
		{
			occupationCode: "2121",
			occupationDescription: "Fuel Seller",
		},
		{
			occupationCode: "3224",
			occupationDescription: "Fuel tender Driver",
		},
		{
			occupationCode: "2327",
			occupationDescription: "Fumigation Worker",
		},
		{
			occupationCode: "2287",
			occupationDescription: "Fur Animal Breeding Worker",
		},
		{
			occupationCode: "2653",
			occupationDescription: "Furnace operation Overseer",
		},
		{
			occupationCode: "3429",
			occupationDescription: "Furniture carpenter Assistant",
		},
		{
			occupationCode: "790",
			occupationDescription: "GROUND HANDLING MANAGER",
		},
		{
			occupationCode: "2265",
			occupationDescription: "Garden or Nursery Worker",
		},
		{
			occupationCode: "360",
			occupationDescription: "Gardener",
		},
		{
			occupationCode: "1116",
			occupationDescription: "Gardens Specialist",
		},
		{
			occupationCode: "1728",
			occupationDescription: "Gardens Technician",
		},
		{
			occupationCode: "3155",
			occupationDescription: "Gas furnaces maintenance mechanic",
		},
		{
			occupationCode: "1949",
			occupationDescription: "Gas meter Reader",
		},
		{
			occupationCode: "3180",
			occupationDescription: "Gas network laying out Mechanic",
		},
		{
			occupationCode: "2980",
			occupationDescription: "Gas pipes installation Worker",
		},
		{
			occupationCode: "2122",
			occupationDescription: "Gas seller",
		},
		{
			occupationCode: "414",
			occupationDescription: "Gas station worker",
		},
		{
			occupationCode: "3296",
			occupationDescription: "Gas turbine mechanic",
		},
		{
			occupationCode: "3237",
			occupationDescription: "Gasoline engine Mechanic",
		},
		{
			occupationCode: "150",
			occupationDescription: "Gastroenterologist",
		},
		{
			occupationCode: "1574",
			occupationDescription: "Gastronomist",
		},
		{
			occupationCode: "2432",
			occupationDescription: "Gathering fibre",
		},
		{
			occupationCode: "3117",
			occupationDescription: "Gemstone installation Worker",
		},
		{
			occupationCode: "1853",
			occupationDescription: "General Account Technician",
		},
		{
			occupationCode: "1552",
			occupationDescription: "General Accountant",
		},
		{
			occupationCode: "1875",
			occupationDescription: "General Administrative clerk",
		},
		{
			occupationCode: "3372",
			occupationDescription: "General Aircraft Electrician",
		},
		{
			occupationCode: "927",
			occupationDescription: "General Astronomer",
		},
		{
			occupationCode: "2840",
			occupationDescription: "General Baker",
		},
		{
			occupationCode: "2551",
			occupationDescription: "General Bookbinder",
		},
		{
			occupationCode: "3442",
			occupationDescription: "General Building carpenter",
		},
		{
			occupationCode: "2893",
			occupationDescription: "General Butcher",
		},
		{
			occupationCode: "2847",
			occupationDescription: "General Candy Maker",
		},
		{
			occupationCode: "3363",
			occupationDescription: "General Car Electrician",
		},
		{
			occupationCode: "3170",
			occupationDescription: "General Central heating Mechanic",
		},
		{
			occupationCode: "3171",
			occupationDescription: "General Central heating assistant mechanic",
		},
		{
			occupationCode: "892",
			occupationDescription: "General Chemist",
		},
		{
			occupationCode: "2180",
			occupationDescription: "General Cleaner",
		},
		{
			occupationCode: "3059",
			occupationDescription: "General Construction Installation Worker",
		},
		{
			occupationCode: "366",
			occupationDescription: "General Controller",
		},
		{
			occupationCode: "2131",
			occupationDescription: "General Cook",
		},
		{
			occupationCode: "3473",
			occupationDescription: "General Decoration Carpenter",
		},
		{
			occupationCode: "1607",
			occupationDescription: "General Draftsman",
		},
		{
			occupationCode: "562",
			occupationDescription: "General Driver",
		},
		{
			occupationCode: "3074",
			occupationDescription: "General Electric Welder",
		},
		{
			occupationCode: "3374",
			occupationDescription: "General Electrician",
		},
		{
			occupationCode: "2495",
			occupationDescription: "General Fashion Cutter",
		},
		{
			occupationCode: "921",
			occupationDescription: "General Geologist",
		},
		{
			occupationCode: "3358",
			occupationDescription: "General Household appliances Electrician",
		},
		{
			occupationCode: "1910",
			occupationDescription: "General Information Clerk",
		},
		{
			occupationCode: "2168",
			occupationDescription: "General Ironer",
		},
		{
			occupationCode: "1057",
			occupationDescription: "General Mechanical Engineer",
		},
		{
			occupationCode: "1184",
			occupationDescription: "General Medicine Consultant",
		},
		{
			occupationCode: "1214",
			occupationDescription: "General Medicine Instructor",
		},
		{
			occupationCode: "1148",
			occupationDescription: "General Medicine specialist",
		},
		{
			occupationCode: "2627",
			occupationDescription: "General Mining Worker",
		},
		{
			occupationCode: "1747",
			occupationDescription: "General Nurse",
		},
		{
			occupationCode: "1295",
			occupationDescription: "General Nutrition Specialist",
		},
		{
			occupationCode: "3455",
			occupationDescription: "General Painter",
		},
		{
			occupationCode: "2120",
			occupationDescription: "General Petroleum products Seller",
		},
		{
			occupationCode: "1299",
			occupationDescription: "General Pharmaceuticals Specialist",
		},
		{
			occupationCode: "2586",
			occupationDescription: "General Photographic Engraver",
		},
		{
			occupationCode: "910",
			occupationDescription: "General Physicist",
		},
		{
			occupationCode: "2971",
			occupationDescription: "General Plumber",
		},
		{
			occupationCode: "2782",
			occupationDescription: "General Potter",
		},
		{
			occupationCode: "2294",
			occupationDescription: "General Poultry breeder",
		},
		{
			occupationCode: "136",
			occupationDescription: "General Practitioner",
		},
		{
			occupationCode: "3557",
			occupationDescription: "General Railway Installer",
		},
		{
			occupationCode: "2164",
			occupationDescription: "General Residence Supervisor",
		},
		{
			occupationCode: "3369",
			occupationDescription: "General Ship Electrician",
		},
		{
			occupationCode: "2389",
			occupationDescription: "General Shoe Maker",
		},
		{
			occupationCode: "2385",
			occupationDescription: "General Shoe maker and Tailor",
		},
		{
			occupationCode: "1325",
			occupationDescription: "General Social Researcher",
		},
		{
			occupationCode: "949",
			occupationDescription: "General Statistician",
		},
		{
			occupationCode: "138",
			occupationDescription: "General Surgeon",
		},
		{
			occupationCode: "1006",
			occupationDescription: "General Surveyor Engineer",
		},
		{
			occupationCode: "956",
			occupationDescription: "General Systems Analyst",
		},
		{
			occupationCode: "2496",
			occupationDescription: "General Tailor",
		},
		{
			occupationCode: "3388",
			occupationDescription: "General Telephone network Installer",
		},
		{
			occupationCode: "3366",
			occupationDescription: "General Train Electrician",
		},
		{
			occupationCode: "2988",
			occupationDescription: "General Turner",
		},
		{
			occupationCode: "1885",
			occupationDescription: "General Typist",
		},
		{
			occupationCode: "3463",
			occupationDescription: "General Upholsterer",
		},
		{
			occupationCode: "1255",
			occupationDescription: "General Veterinarian",
		},
		{
			occupationCode: "3073",
			occupationDescription: "General Welder",
		},
		{
			occupationCode: "3481",
			occupationDescription: "General builder",
		},
		{
			occupationCode: "3427",
			occupationDescription: "General carpenter",
		},
		{
			occupationCode: "3164",
			occupationDescription: "General cooling mechanic",
		},
		{
			occupationCode: "2562",
			occupationDescription: "General depiction Engraver",
		},
		{
			occupationCode: "3393",
			occupationDescription: "General electronic exchanges Installer",
		},
		{
			occupationCode: "3395",
			occupationDescription: "General electronic exchanges Operator",
		},
		{
			occupationCode: "3124",
			occupationDescription: "General equipment Installation Mechanic",
		},
		{
			occupationCode: "2995",
			occupationDescription: "General filing Worker",
		},
		{
			occupationCode: "2871",
			occupationDescription: "General fruits and vegetables Cook",
		},
		{
			occupationCode: "3154",
			occupationDescription: "General furnaces Maintenance mechanic",
		},
		{
			occupationCode: "3414",
			occupationDescription: "General industrial electronic Technician",
		},
		{
			occupationCode: "3127",
			occupationDescription: "General maintenance Mechanic",
		},
		{
			occupationCode: "266",
			occupationDescription: "General manager",
		},
		{
			occupationCode: "3005",
			occupationDescription: "General metal furniture Blacksmith",
		},
		{
			occupationCode: "3013",
			occupationDescription: "General metal plates Blacksmith",
		},
		{
			occupationCode: "3019",
			occupationDescription: "General pipeline filing worker",
		},
		{
			occupationCode: "3080",
			occupationDescription: "General pipes Welder",
		},
		{
			occupationCode: "2979",
			occupationDescription: "General pipes installation Worker",
		},
		{
			occupationCode: "2535",
			occupationDescription: "General printing Worker",
		},
		{
			occupationCode: "1235",
			occupationDescription: "General surgery Consultant",
		},
		{
			occupationCode: "2453",
			occupationDescription: "General textiles Treatment Worker",
		},
		{
			occupationCode: "2992",
			occupationDescription: "General whetting Worker",
		},
		{
			occupationCode: "2863",
			occupationDescription: "General yeast Maker",
		},
		{
			occupationCode: "931",
			occupationDescription: "General zoology Specialist",
		},
		{
			occupationCode: "3382",
			occupationDescription: "Generator Operator",
		},
		{
			occupationCode: "1639",
			occupationDescription: "Generator and Motor Electrician",
		},
		{
			occupationCode: "3582",
			occupationDescription: "Generators assembling worker",
		},
		{
			occupationCode: "1013",
			occupationDescription: "Geodetic Expert",
		},
		{
			occupationCode: "1332",
			occupationDescription: "Geographer",
		},
		{
			occupationCode: "1012",
			occupationDescription: "Geographic Information systems Expert",
		},
		{
			occupationCode: "1573",
			occupationDescription: "Geological Surveyor",
		},
		{
			occupationCode: "1078",
			occupationDescription: "Geological engineer",
		},
		{
			occupationCode: "18",
			occupationDescription: "Geologist",
		},
		{
			occupationCode: "1572",
			occupationDescription: "Geologist Laboratory Technician",
		},
		{
			occupationCode: "1571",
			occupationDescription: "Geologist Technician",
		},
		{
			occupationCode: "922",
			occupationDescription: "Geologist physicist",
		},
		{
			occupationCode: "1394",
			occupationDescription: "Geology Teacher",
		},
		{
			occupationCode: "1584",
			occupationDescription: "Germs Laboratory Technician",
		},
		{
			occupationCode: "2046",
			occupationDescription: "Gifts and antiques Seller",
		},
		{
			occupationCode: "2410",
			occupationDescription: "Ginning machine operator",
		},
		{
			occupationCode: "2749",
			occupationDescription: "Glass Blower",
		},
		{
			occupationCode: "2754",
			occupationDescription: "Glass Casting Worker",
		},
		{
			occupationCode: "2752",
			occupationDescription: "Glass Cutting machine operator",
		},
		{
			occupationCode: "2769",
			occupationDescription: "Glass Fixing Operation worker",
		},
		{
			occupationCode: "2774",
			occupationDescription: "Glass Hardening worker",
		},
		{
			occupationCode: "2747",
			occupationDescription: "Glass Mixtures Preparation Worker",
		},
		{
			occupationCode: "515",
			occupationDescription: "Glass Painter",
		},
		{
			occupationCode: "2755",
			occupationDescription: "Glass Polisher",
		},
		{
			occupationCode: "2750",
			occupationDescription: "Glass Press Operator",
		},
		{
			occupationCode: "2763",
			occupationDescription: "Glass Pulling Machine operator",
		},
		{
			occupationCode: "1096",
			occupationDescription: "Glass and Ceramics Technician",
		},
		{
			occupationCode: "76",
			occupationDescription: "Glass and ceramic technician",
		},
		{
			occupationCode: "2772",
			occupationDescription: "Glass blowing machine Worker",
		},
		{
			occupationCode: "514",
			occupationDescription: "Glass carver",
		},
		{
			occupationCode: "2777",
			occupationDescription: "Glass coating Material making Worker",
		},
		{
			occupationCode: "2781",
			occupationDescription: "Glass cutting worker",
		},
		{
			occupationCode: "2775",
			occupationDescription: "Glass engraving Worker",
		},
		{
			occupationCode: "3471",
			occupationDescription: "Glass installer",
		},
		{
			occupationCode: "2748",
			occupationDescription: "Glass melting furnace operator",
		},
		{
			occupationCode: "2766",
			occupationDescription: "Glass or blowing machine operator",
		},
		{
			occupationCode: "2780",
			occupationDescription: "Glass painting worker",
		},
		{
			occupationCode: "2765",
			occupationDescription: "Glass plasticizing Furnace operator",
		},
		{
			occupationCode: "2751",
			occupationDescription: "Glass plate molding unit operator",
		},
		{
			occupationCode: "2776",
			occupationDescription: "Glass sand or blasting carving worker",
		},
		{
			occupationCode: "513",
			occupationDescription: "Glass technician",
		},
		{
			occupationCode: "2759",
			occupationDescription: "Glass tubes molding Worker",
		},
		{
			occupationCode: "2753",
			occupationDescription: "Glass whetting machine operator",
		},
		{
			occupationCode: "2761",
			occupationDescription: "Glass wool Manufacture Worker",
		},
		{
			occupationCode: "509",
			occupationDescription: "Glass worker",
		},
		{
			occupationCode: "1764",
			occupationDescription: "Glasses Technician",
		},
		{
			occupationCode: "2057",
			occupationDescription: "Glasses seller",
		},
		{
			occupationCode: "722",
			occupationDescription: "Global Attach",
		},
		{
			occupationCode: "2325",
			occupationDescription: "Gluing Mixer operator",
		},
		{
			occupationCode: "3118",
			occupationDescription: "Gold an silver Goldsmith",
		},
		{
			occupationCode: "3114",
			occupationDescription: "Gold jewellery Goldsmith",
		},
		{
			occupationCode: "2052",
			occupationDescription: "Gold jewellery seller",
		},
		{
			occupationCode: "505",
			occupationDescription: "Goldsmith",
		},
		{
			occupationCode: "1902",
			occupationDescription: "Goods Receipt Clerk",
		},
		{
			occupationCode: "1650",
			occupationDescription: "Governing System Technician",
		},
		{
			occupationCode: "12",
			occupationDescription: "Government Employed ",
		},
		{
			occupationCode: "1",
			occupationDescription: "Governmental Sector",
		},
		{
			occupationCode: "660",
			occupationDescription: "Governor of Province",
		},
		{
			occupationCode: "3218",
			occupationDescription: "Grader Driver",
		},
		{
			occupationCode: "398",
			occupationDescription: "Grain Mill Worker",
		},
		{
			occupationCode: "625",
			occupationDescription: "Grandfather Muharem",
		},
		{
			occupationCode: "613",
			occupationDescription: "Grandson",
		},
		{
			occupationCode: "620",
			occupationDescription: "Grandson Muharem",
		},
		{
			occupationCode: "2261",
			occupationDescription: "Grape Farmer",
		},
		{
			occupationCode: "2202",
			occupationDescription: "Gravedigger",
		},
		{
			occupationCode: "2248",
			occupationDescription: "Greenhouse Farmer",
		},
		{
			occupationCode: "1111",
			occupationDescription: "Greenhouse Specialist",
		},
		{
			occupationCode: "385",
			occupationDescription: "Grinder worker",
		},
		{
			occupationCode: "2016",
			occupationDescription: "Grocer",
		},
		{
			occupationCode: "2009",
			occupationDescription: "Ground Freight Broker",
		},
		{
			occupationCode: "2160",
			occupationDescription: "Ground Host",
		},
		{
			occupationCode: "1925",
			occupationDescription: "Ground Radio station operator",
		},
		{
			occupationCode: "1629",
			occupationDescription: "Ground cables Electrician",
		},
		{
			occupationCode: "2267",
			occupationDescription: "Grounds Care Worker",
		},
		{
			occupationCode: "346",
			occupationDescription: "Guard",
		},
		{
			occupationCode: "3532",
			occupationDescription: "Gypsum molding worker",
		},
		{
			occupationCode: "3531",
			occupationDescription: "Gypsum painter",
		},
		{
			occupationCode: "541",
			occupationDescription: "Gypsum worker",
		},
		{
			occupationCode: "2310",
			occupationDescription: "HARVEST OFFICER",
		},
		{
			occupationCode: "1776",
			occupationDescription: "HEALTH EPIDEMIC SERVICE SUPERVISOR",
		},
		{
			occupationCode: "974",
			occupationDescription: "HELP DESK OFFICER",
		},
		{
			occupationCode: "955",
			occupationDescription: "HELP DESK OPERATOR",
		},
		{
			occupationCode: "2159",
			occupationDescription: "HOSPITALITY WORKER",
		},
		{
			occupationCode: "1156",
			occupationDescription: "Haematologist",
		},
		{
			occupationCode: "1192",
			occupationDescription: "Haematology Consultant",
		},
		{
			occupationCode: "2125",
			occupationDescription: "Hairdresser",
		},
		{
			occupationCode: "3215",
			occupationDescription: "Hammer operator",
		},
		{
			occupationCode: "2404",
			occupationDescription: "Hand Bag Maker",
		},
		{
			occupationCode: "2554",
			occupationDescription: "Hand Bookbinder",
		},
		{
			occupationCode: "2559",
			occupationDescription: "Hand Books Decorator",
		},
		{
			occupationCode: "2170",
			occupationDescription: "Hand Ironer",
		},
		{
			occupationCode: "2567",
			occupationDescription: "Hand Metal printing Plate Engraver",
		},
		{
			occupationCode: "2224",
			occupationDescription: "Hand Packing Worker",
		},
		{
			occupationCode: "3084",
			occupationDescription: "Hand Riveter",
		},
		{
			occupationCode: "2480",
			occupationDescription: "Hand Tricot worker",
		},
		{
			occupationCode: "2484",
			occupationDescription: "Hand carpet weaving Worker",
		},
		{
			occupationCode: "2490",
			occupationDescription: "Hand knitter",
		},
		{
			occupationCode: "3028",
			occupationDescription: "Hand metal shaping Worker",
		},
		{
			occupationCode: "2819",
			occupationDescription: "Hand or brush Worker",
		},
		{
			occupationCode: "2530",
			occupationDescription: "Hand or embroidery Worker",
		},
		{
			occupationCode: "2512",
			occupationDescription: "Hand or sewing leather Worker",
		},
		{
			occupationCode: "2519",
			occupationDescription: "Hand umbrella Worker",
		},
		{
			occupationCode: "244",
			occupationDescription: "Handball Coach",
		},
		{
			occupationCode: "506",
			occupationDescription: "Hanger Technician",
		},
		{
			occupationCode: "2420",
			occupationDescription: "Hank Rolling Machine operator wrapped",
		},
		{
			occupationCode: "3315",
			occupationDescription: "Harvester Mechanic",
		},
		{
			occupationCode: "661",
			occupationDescription: "Head of Municipality or village Community",
		},
		{
			occupationCode: "2522",
			occupationDescription: "Headcord (Eqal)Cutter",
		},
		{
			occupationCode: "640",
			occupationDescription: "Health Affairs Director",
		},
		{
			occupationCode: "1771",
			occupationDescription: "Health Assistant",
		},
		{
			occupationCode: "726",
			occupationDescription: "Health Attach",
		},
		{
			occupationCode: "1586",
			occupationDescription: "Health Guide",
		},
		{
			occupationCode: "1756",
			occupationDescription: "Health care Technician",
		},
		{
			occupationCode: "1566",
			occupationDescription: "Heat Laboratory Technician",
		},
		{
			occupationCode: "3592",
			occupationDescription: "Heaters assembling worker",
		},
		{
			occupationCode: "3169",
			occupationDescription: "Heating Mechanic",
		},
		{
			occupationCode: "2095",
			occupationDescription: "Heating supplies Seller",
		},
		{
			occupationCode: "3307",
			occupationDescription: "Heavy machinery Mechanical  or  general",
		},
		{
			occupationCode: "3310",
			occupationDescription: "Heavy machinery assistant Mechanic",
		},
		{
			occupationCode: "3309",
			occupationDescription: "Heavy wheel machinery Mechanic",
		},
		{
			occupationCode: "1133",
			occupationDescription: "Helicopter Azimuth Aviator",
		},
		{
			occupationCode: "2050",
			occupationDescription: "Heritage Products Seller",
		},
		{
			occupationCode: "89",
			occupationDescription: "High Voltage Technician",
		},
		{
			occupationCode: "2643",
			occupationDescription: "High furnace operator",
		},
		{
			occupationCode: "1274",
			occupationDescription: "Histopathology Lab Consultant",
		},
		{
			occupationCode: "1261",
			occupationDescription: "Histopathology lab Specialist",
		},
		{
			occupationCode: "1331",
			occupationDescription: "Historian",
		},
		{
			occupationCode: "2936",
			occupationDescription: "Hollowing machine Worker",
		},
		{
			occupationCode: "3166",
			occupationDescription: "Home cooling devices Mechanic",
		},
		{
			occupationCode: "2279",
			occupationDescription: "Horse Breeder",
		},
		{
			occupationCode: "1734",
			occupationDescription: "Horse Breeding Technician",
		},
		{
			occupationCode: "2280",
			occupationDescription: "Horse Stableman",
		},
		{
			occupationCode: "356",
			occupationDescription: "Horseman",
		},
		{
			occupationCode: "355",
			occupationDescription: "Horseshoer",
		},
		{
			occupationCode: "1115",
			occupationDescription: "Horticulture Specialist",
		},
		{
			occupationCode: "1725",
			occupationDescription: "Horticulture Technician",
		},
		{
			occupationCode: "2259",
			occupationDescription: "Horticulture farmer",
		},
		{
			occupationCode: "359",
			occupationDescription: "Horticulture worker",
		},
		{
			occupationCode: "2179",
			occupationDescription: "Hospital Cleaner",
		},
		{
			occupationCode: "320",
			occupationDescription: "Host",
		},
		{
			occupationCode: "775",
			occupationDescription: "Hosting House Manager",
		},
		{
			occupationCode: "2656",
			occupationDescription: "Hot Rolling Worker",
		},
		{
			occupationCode: "3101",
			occupationDescription: "Hot dipping painting Worker",
		},
		{
			occupationCode: "2185",
			occupationDescription: "Hotel Service Supervisor",
		},
		{
			occupationCode: "1412",
			occupationDescription: "Hotel Vocational Teacher",
		},
		{
			occupationCode: "323",
			occupationDescription: "Hotel manager",
		},
		{
			occupationCode: "776",
			occupationDescription: "Hotel owner",
		},
		{
			occupationCode: "1907",
			occupationDescription: "Hotel reception Clerk",
		},
		{
			occupationCode: "2236",
			occupationDescription: "House Coffee or Boy",
		},
		{
			occupationCode: "2233",
			occupationDescription: "House Cook",
		},
		{
			occupationCode: "2235",
			occupationDescription: "House Farmer",
		},
		{
			occupationCode: "2228",
			occupationDescription: "House Guard",
		},
		{
			occupationCode: "2239",
			occupationDescription: "House Nurse",
		},
		{
			occupationCode: "2232",
			occupationDescription: "House Tailor",
		},
		{
			occupationCode: "2238",
			occupationDescription: "House Usher",
		},
		{
			occupationCode: "1402",
			occupationDescription: "House economics Teacher",
		},
		{
			occupationCode: "3352",
			occupationDescription: "House laying out Electrician",
		},
		{
			occupationCode: "3157",
			occupationDescription: "House stove repair Mechanic",
		},
		{
			occupationCode: "2237",
			occupationDescription: "House waiter",
		},
		{
			occupationCode: "326",
			occupationDescription: "House worker",
		},
		{
			occupationCode: "2042",
			occupationDescription: "Household Stuff Seller",
		},
		{
			occupationCode: "3357",
			occupationDescription: "Household appliances Electrician",
		},
		{
			occupationCode: "2041",
			occupationDescription: "Household appliances Seller",
		},
		{
			occupationCode: "2234",
			occupationDescription: "Housekeeper",
		},
		{
			occupationCode: "336",
			occupationDescription: "Housemaid",
		},
		{
			occupationCode: "576",
			occupationDescription: "Housewife",
		},
		{
			occupationCode: "2317",
			occupationDescription: "Hunting Dogs Instructor",
		},
		{
			occupationCode: "2316",
			occupationDescription: "Hunting Hawks Instructor",
		},
		{
			occupationCode: "3026",
			occupationDescription: "Hunting rifle Repair worker",
		},
		{
			occupationCode: "569",
			occupationDescription: "Husband",
		},
		{
			occupationCode: "609",
			occupationDescription: "Husband Muharem",
		},
		{
			occupationCode: "1581",
			occupationDescription: "Hybridization Researcher",
		},
		{
			occupationCode: "932",
			occupationDescription: "Hybridization Specialist",
		},
		{
			occupationCode: "3312",
			occupationDescription: "Hydraulic Assistant Mechanic",
		},
		{
			occupationCode: "3311",
			occupationDescription: "Hydraulic Mechanic",
		},
		{
			occupationCode: "1049",
			occupationDescription: "Hydraulic engineer",
		},
		{
			occupationCode: "984",
			occupationDescription: "INFORMATION SECURITY SPECIALIST",
		},
		{
			occupationCode: "983",
			occupationDescription: "INTERNET ADMINISTRATOR",
		},
		{
			occupationCode: "2921",
			occupationDescription: "Ice Maker",
		},
		{
			occupationCode: "2853",
			occupationDescription: "Ice or cream machine maker",
		},
		{
			occupationCode: "2916",
			occupationDescription: "Iced beverages Maker",
		},
		{
			occupationCode: "1876",
			occupationDescription: "Incoming and outgoing Clerk",
		},
		{
			occupationCode: "2301",
			occupationDescription: "Incubation Workshop worker",
		},
		{
			occupationCode: "645",
			occupationDescription: "Industrial Affairs Director",
		},
		{
			occupationCode: "1711",
			occupationDescription: "Industrial Equipment Installation Technician",
		},
		{
			occupationCode: "1089",
			occupationDescription: "Industrial Equipment Installation engineer",
		},
		{
			occupationCode: "3153",
			occupationDescription: "Industrial Establishment Mechanic",
		},
		{
			occupationCode: "254",
			occupationDescription: "Industrial Instructor",
		},
		{
			occupationCode: "1059",
			occupationDescription: "Industrial Machinery and machines Engineer",
		},
		{
			occupationCode: "1315",
			occupationDescription: "Industrial Psychiatry Specialist",
		},
		{
			occupationCode: "1409",
			occupationDescription: "Industrial Vocational Teacher",
		},
		{
			occupationCode: "74",
			occupationDescription: "Industrial engineer",
		},
		{
			occupationCode: "2108",
			occupationDescription: "Industrial equipment Salesman",
		},
		{
			occupationCode: "2109",
			occupationDescription: "Industrial machines Salesman",
		},
		{
			occupationCode: "2508",
			occupationDescription: "Industrial sewing machine operator",
		},
		{
			occupationCode: "2111",
			occupationDescription: "Industrial tools Seller",
		},
		{
			occupationCode: "1289",
			occupationDescription: "Infection Control Specialist",
		},
		{
			occupationCode: "1472",
			occupationDescription: "Information Programme Organizer",
		},
		{
			occupationCode: "2313",
			occupationDescription: "Inland waters Fisherman",
		},
		{
			occupationCode: "1302",
			occupationDescription: "Insecticides Specialist",
		},
		{
			occupationCode: "1583",
			occupationDescription: "Insects Laboratory Technician",
		},
		{
			occupationCode: "1966",
			occupationDescription: "Inspector road transport services",
		},
		{
			occupationCode: "2982",
			occupationDescription: "Installation Worker",
		},
		{
			occupationCode: "3032",
			occupationDescription: "Installation filing Mechanic",
		},
		{
			occupationCode: "2817",
			occupationDescription: "Instrument rhythming adjustment worker",
		},
		{
			occupationCode: "48",
			occupationDescription: "Insulation Installation technician",
		},
		{
			occupationCode: "2002",
			occupationDescription: "Insurance Broker",
		},
		{
			occupationCode: "309",
			occupationDescription: "Insurance Clerk",
		},
		{
			occupationCode: "207",
			occupationDescription: "Insurance Officer",
		},
		{
			occupationCode: "264",
			occupationDescription: "Insurance Specialist",
		},
		{
			occupationCode: "799",
			occupationDescription: "Insurance Works manager",
		},
		{
			occupationCode: "1558",
			occupationDescription: "Insurance expert",
		},
		{
			occupationCode: "2708",
			occupationDescription: "Interaction device operator",
		},
		{
			occupationCode: "1105",
			occupationDescription: "Internal Audit programme Head",
		},
		{
			occupationCode: "1544",
			occupationDescription: "Internal Auditor",
		},
		{
			occupationCode: "992",
			occupationDescription: "Internal design engineer",
		},
		{
			occupationCode: "156",
			occupationDescription: "Internist",
		},
		{
			occupationCode: "1449",
			occupationDescription: "Interpreter",
		},
		{
			occupationCode: "2733",
			occupationDescription: "Intrusion molding machine Worker",
		},
		{
			occupationCode: "2331",
			occupationDescription: "Inverted Wood Manufacturing worker",
		},
		{
			occupationCode: "770",
			occupationDescription: "Investor",
		},
		{
			occupationCode: "2655",
			occupationDescription: "Iron Metal Conversion Furnace Worker",
		},
		{
			occupationCode: "2649",
			occupationDescription: "Iron extraction Overseer",
		},
		{
			occupationCode: "535",
			occupationDescription: "Iron worker",
		},
		{
			occupationCode: "1003",
			occupationDescription: "Irrigation Engineer",
		},
		{
			occupationCode: "2117",
			occupationDescription: "Irrigation supplies Seller",
		},
		{
			occupationCode: "3139",
			occupationDescription: "Item handling equipment Mechanic",
		},
		{
			occupationCode: "966",
			occupationDescription: "JUNIOR BUSINESS ANALYST",
		},
		{
			occupationCode: "967",
			occupationDescription: "JUNIOR CONTRACT MANAGER",
		},
		{
			occupationCode: "968",
			occupationDescription: "JUNIOR DATABASE ADMINISTRATOR",
		},
		{
			occupationCode: "981",
			occupationDescription: "JUNIOR INFORMATION MANAGER",
		},
		{
			occupationCode: "970",
			occupationDescription: "JUNIOR INFRASTRUCTURE ADMINISTRATOR",
		},
		{
			occupationCode: "972",
			occupationDescription: "JUNIOR NETWORK ADMINISTRATOR",
		},
		{
			occupationCode: "982",
			occupationDescription: "JUNIOR REPORT ADMINISTRATOR",
		},
		{
			occupationCode: "986",
			occupationDescription: "JUNIOR SECURITY ADMINISTRATOR",
		},
		{
			occupationCode: "980",
			occupationDescription: "JUNIOR SOFTWARE DEVELOPER",
		},
		{
			occupationCode: "969",
			occupationDescription: "JUNIOR SYSTEM MANAGER",
		},
		{
			occupationCode: "976",
			occupationDescription: "JUNIOR TECHNICAL SUPPORT",
		},
		{
			occupationCode: "2460",
			occupationDescription: "Jacquard Drawings Transcriber",
		},
		{
			occupationCode: "2483",
			occupationDescription: "Jacquard Loom Weaving Worker",
		},
		{
			occupationCode: "2467",
			occupationDescription: "Jacquard Loom operator",
		},
		{
			occupationCode: "2462",
			occupationDescription: "Jacquard cards preparation Worker",
		},
		{
			occupationCode: "2458",
			occupationDescription: "Jacquard loom preparation Mechanic",
		},
		{
			occupationCode: "2461",
			occupationDescription: "Jacquard paper punching Worker",
		},
		{
			occupationCode: "2876",
			occupationDescription: "Jam maker",
		},
		{
			occupationCode: "1677",
			occupationDescription: "Jet Maintenance Technician",
		},
		{
			occupationCode: "3116",
			occupationDescription: "Jeweller",
		},
		{
			occupationCode: "2051",
			occupationDescription: "Jewellery seller",
		},
		{
			occupationCode: "3122",
			occupationDescription: "Jewels fixing Worker",
		},
		{
			occupationCode: "695",
			occupationDescription: "Journal Administration Manager",
		},
		{
			occupationCode: "1468",
			occupationDescription: "Journalism Director",
		},
		{
			occupationCode: "1440",
			occupationDescription: "Judge",
		},
		{
			occupationCode: "1872",
			occupationDescription: "Judgement Notifier",
		},
		{
			occupationCode: "651",
			occupationDescription: "Judicial Affairs Director",
		},
		{
			occupationCode: "401",
			occupationDescription: "Juice Master",
		},
		{
			occupationCode: "3505",
			occupationDescription: "Junior Assistant Worker",
		},
		{
			occupationCode: "1322",
			occupationDescription: "Juvenile Care Specialist",
		},
		{
			occupationCode: "1808",
			occupationDescription: "Juvenile care Technician",
		},
		{
			occupationCode: "448",
			occupationDescription: "Keys Specialist",
		},
		{
			occupationCode: "2500",
			occupationDescription: "Kid clothes children",
		},
		{
			occupationCode: "2129",
			occupationDescription: "Kiln Baker",
		},
		{
			occupationCode: "222",
			occupationDescription: "Kindergarten Teacher",
		},
		{
			occupationCode: "2152",
			occupationDescription: "Kitchen worker",
		},
		{
			occupationCode: "333",
			occupationDescription: "Kneader",
		},
		{
			occupationCode: "124",
			occupationDescription: "Lab Technician",
		},
		{
			occupationCode: "679",
			occupationDescription: "Laboratory Director",
		},
		{
			occupationCode: "1830",
			occupationDescription: "Laboratory Equipment Technician",
		},
		{
			occupationCode: "1306",
			occupationDescription: "Laboratory Science Instructor",
		},
		{
			occupationCode: "117",
			occupationDescription: "Laboratory Technician",
		},
		{
			occupationCode: "1075",
			occupationDescription: "Laboratory Technician Instructor",
		},
		{
			occupationCode: "2078",
			occupationDescription: "Laboratory equipment Salesman",
		},
		{
			occupationCode: "642",
			occupationDescription: "Labour Affairs Director",
		},
		{
			occupationCode: "2318",
			occupationDescription: "Land Hunter",
		},
		{
			occupationCode: "3390",
			occupationDescription: "Land Telephone network Installer",
		},
		{
			occupationCode: "1890",
			occupationDescription: "Land and Real Estate Registration clerk",
		},
		{
			occupationCode: "1998",
			occupationDescription: "Land broker",
		},
		{
			occupationCode: "1603",
			occupationDescription: "Land surveyor",
		},
		{
			occupationCode: "1450",
			occupationDescription: "Language Specialist",
		},
		{
			occupationCode: "217",
			occupationDescription: "Language Teacher",
		},
		{
			occupationCode: "1397",
			occupationDescription: "Languages Teacher",
		},
		{
			occupationCode: "42",
			occupationDescription: "Laser Systems Technician",
		},
		{
			occupationCode: "444",
			occupationDescription: "Lathe worker",
		},
		{
			occupationCode: "3003",
			occupationDescription: "Lathe works Production Supervisor",
		},
		{
			occupationCode: "434",
			occupationDescription: "Lather",
		},
		{
			occupationCode: "2176",
			occupationDescription: "Laundry Director",
		},
		{
			occupationCode: "341",
			occupationDescription: "Laundryman",
		},
		{
			occupationCode: "210",
			occupationDescription: "Lawyer",
		},
		{
			occupationCode: "1027",
			occupationDescription: "Laying out Engineer",
		},
		{
			occupationCode: "2366",
			occupationDescription: "Leather Cleaner and Dryer",
		},
		{
			occupationCode: "2515",
			occupationDescription: "Leather Clothing Cutting worker",
		},
		{
			occupationCode: "2367",
			occupationDescription: "Leather Hand Barber",
		},
		{
			occupationCode: "2380",
			occupationDescription: "Leather Meat remover",
		},
		{
			occupationCode: "2370",
			occupationDescription: "Leather Ripping Machine operator",
		},
		{
			occupationCode: "2376",
			occupationDescription: "Leather Tanner",
		},
		{
			occupationCode: "2036",
			occupationDescription: "Leather clothing seller",
		},
		{
			occupationCode: "2517",
			occupationDescription: "Leather glove Cutting Worker",
		},
		{
			occupationCode: "2406",
			occupationDescription: "Leather product Cutter",
		},
		{
			occupationCode: "2403",
			occupationDescription: "Leather products maker",
		},
		{
			occupationCode: "2384",
			occupationDescription: "Leather pulling Worker",
		},
		{
			occupationCode: "2383",
			occupationDescription: "Leather welding machine operator",
		},
		{
			occupationCode: "225",
			occupationDescription: "Lecturer",
		},
		{
			occupationCode: "1437",
			occupationDescription: "Legal Adviser of General Systems",
		},
		{
			occupationCode: "211",
			occupationDescription: "Legal Advisor",
		},
		{
			occupationCode: "1874",
			occupationDescription: "Legal Affairs Legal",
		},
		{
			occupationCode: "1873",
			occupationDescription: "Legal Clerk",
		},
		{
			occupationCode: "1438",
			occupationDescription: "Legal adviser of Special Systems",
		},
		{
			occupationCode: "1441",
			occupationDescription: "Legitimate Judge",
		},
		{
			occupationCode: "2537",
			occupationDescription: "Letter Casting Machine Operator",
		},
		{
			occupationCode: "255",
			occupationDescription: "Librarian",
		},
		{
			occupationCode: "257",
			occupationDescription: "Libraries Research",
		},
		{
			occupationCode: "1892",
			occupationDescription: "Library clerk",
		},
		{
			occupationCode: "692",
			occupationDescription: "Library director",
		},
		{
			occupationCode: "2572",
			occupationDescription: "Light Engraving photographer",
		},
		{
			occupationCode: "3234",
			occupationDescription: "Light Vehicle Mechanic",
		},
		{
			occupationCode: "3229",
			occupationDescription: "Lighthouse worker",
		},
		{
			occupationCode: "1839",
			occupationDescription: "Lighting technician",
		},
		{
			occupationCode: "2538",
			occupationDescription: "Lines Casting Machine operator",
		},
		{
			occupationCode: "2800",
			occupationDescription: "Liquid dough making Worker",
		},
		{
			occupationCode: "1445",
			occupationDescription: "Literary Writer",
		},
		{
			occupationCode: "1446",
			occupationDescription: "Literary critic",
		},
		{
			occupationCode: "935",
			occupationDescription: "Live cells Specialist",
		},
		{
			occupationCode: "2274",
			occupationDescription: "Livestock Breeder",
		},
		{
			occupationCode: "1256",
			occupationDescription: "Livestock veterinarian",
		},
		{
			occupationCode: "3207",
			occupationDescription: "Loader Driver",
		},
		{
			occupationCode: "3027",
			occupationDescription: "Lock Blacksmith",
		},
		{
			occupationCode: "2436",
			occupationDescription: "Loom preparation Worker",
		},
		{
			occupationCode: "1534",
			occupationDescription: "MACHINERY AND EQUIPMENT VALUER",
		},
		{
			occupationCode: "1425",
			occupationDescription: "MAKEUP & HAIR ARTIST",
		},
		{
			occupationCode: "786",
			occupationDescription: "MANAGE CREWING",
		},
		{
			occupationCode: "793",
			occupationDescription: "MANAGER AIRLINES NETWORKING",
		},
		{
			occupationCode: "791",
			occupationDescription: "MANAGER CARGO",
		},
		{
			occupationCode: "789",
			occupationDescription: "MANAGER FLIGHT DISPATCH",
		},
		{
			occupationCode: "787",
			occupationDescription: "MANAGER FLIGHT SAFETY DOCUMENTATION",
		},
		{
			occupationCode: "1292",
			occupationDescription: "MEDICAL PHYSICIST",
		},
		{
			occupationCode: "1293",
			occupationDescription: "MEDICAL SCIENCE SPECIALIST",
		},
		{
			occupationCode: "637",
			occupationDescription: "MEMBER OF THE BOARD OF DIRECTORS",
		},
		{
			occupationCode: "2838",
			occupationDescription: "Macaroni Cutting Machine Operator",
		},
		{
			occupationCode: "2835",
			occupationDescription: "Macaroni Kneader",
		},
		{
			occupationCode: "2839",
			occupationDescription: "Macaroni Packaging Worker",
		},
		{
			occupationCode: "2837",
			occupationDescription: "Macaroni drying oven Operator",
		},
		{
			occupationCode: "2834",
			occupationDescription: "Macaroni maker",
		},
		{
			occupationCode: "2836",
			occupationDescription: "Macaroni molding machine operator",
		},
		{
			occupationCode: "3129",
			occupationDescription: "Machine installation Mechanic",
		},
		{
			occupationCode: "2379",
			occupationDescription: "Machine leather Burnishing operator",
		},
		{
			occupationCode: "2944",
			occupationDescription: "Machine operation Worker",
		},
		{
			occupationCode: "3231",
			occupationDescription: "Machine operator fixed",
		},
		{
			occupationCode: "2861",
			occupationDescription: "Machine operator forming sugar",
		},
		{
			occupationCode: "2511",
			occupationDescription: "Machine or hand Sewing Worker",
		},
		{
			occupationCode: "3102",
			occupationDescription: "Machine painting Worker",
		},
		{
			occupationCode: "2943",
			occupationDescription: "Machine preparation Worker",
		},
		{
			occupationCode: "2933",
			occupationDescription: "Machine working",
		},
		{
			occupationCode: "3355",
			occupationDescription: "Machinery Electrician",
		},
		{
			occupationCode: "65",
			occupationDescription: "Machinery Engineer",
		},
		{
			occupationCode: "1632",
			occupationDescription: "Machinery Maintenance Electrician",
		},
		{
			occupationCode: "3034",
			occupationDescription: "Machinery manufacturing Supervisor",
		},
		{
			occupationCode: "544",
			occupationDescription: "Machinery operator",
		},
		{
			occupationCode: "466",
			occupationDescription: "Machines Mechanic",
		},
		{
			occupationCode: "470",
			occupationDescription: "Machines technician",
		},
		{
			occupationCode: "2199",
			occupationDescription: "Madina Visitor Guide",
		},
		{
			occupationCode: "305",
			occupationDescription: "Mail Courier",
		},
		{
			occupationCode: "489",
			occupationDescription: "Maintenance Electrician",
		},
		{
			occupationCode: "54",
			occupationDescription: "Maintenance Engineer",
		},
		{
			occupationCode: "298",
			occupationDescription: "Maintenance Supervisor",
		},
		{
			occupationCode: "473",
			occupationDescription: "Maintenance Technician",
		},
		{
			occupationCode: "3403",
			occupationDescription: "Maintenance of electronic exchanges",
		},
		{
			occupationCode: "901",
			occupationDescription: "Makeup Specialist",
		},
		{
			occupationCode: "338",
			occupationDescription: "Male Nanny",
		},
		{
			occupationCode: "1546",
			occupationDescription: "Management Adviser",
		},
		{
			occupationCode: "794",
			occupationDescription: "Manager of Business Services",
		},
		{
			occupationCode: "743",
			occupationDescription: "Manager of Operation reports",
		},
		{
			occupationCode: "273",
			occupationDescription: "Managing Director",
		},
		{
			occupationCode: "696",
			occupationDescription: "Managing Editor",
		},
		{
			occupationCode: "2465",
			occupationDescription: "Manual Loom operator",
		},
		{
			occupationCode: "3090",
			occupationDescription: "Manual cutting Worker",
		},
		{
			occupationCode: "1090",
			occupationDescription: "Manufacturing Engineer",
		},
		{
			occupationCode: "2730",
			occupationDescription: "Manufacturing fibre Machine operator",
		},
		{
			occupationCode: "3541",
			occupationDescription: "Marble floorer",
		},
		{
			occupationCode: "451",
			occupationDescription: "Marine Engines technician",
		},
		{
			occupationCode: "939",
			occupationDescription: "Marine Environment Specialist",
		},
		{
			occupationCode: "1061",
			occupationDescription: "Marine Equipment Specialist",
		},
		{
			occupationCode: "1744",
			occupationDescription: "Marine Overseer",
		},
		{
			occupationCode: "110",
			occupationDescription: "Marine Pilot",
		},
		{
			occupationCode: "1144",
			occupationDescription: "Marine Services Supervisor",
		},
		{
			occupationCode: "1406",
			occupationDescription: "Marine Supply System Instructor",
		},
		{
			occupationCode: "1638",
			occupationDescription: "Marine Technician Supervisor",
		},
		{
			occupationCode: "1463",
			occupationDescription: "Marine Tourist Guide",
		},
		{
			occupationCode: "1405",
			occupationDescription: "Marine disciplines Instructor",
		},
		{
			occupationCode: "3037",
			occupationDescription: "Marine engine filing mechanic",
		},
		{
			occupationCode: "920",
			occupationDescription: "Marine physics Specialist",
		},
		{
			occupationCode: "940",
			occupationDescription: "Marine pollution Specialist",
		},
		{
			occupationCode: "112",
			occupationDescription: "Marine supervisor",
		},
		{
			occupationCode: "267",
			occupationDescription: "Marketing Manager",
		},
		{
			occupationCode: "1529",
			occupationDescription: "Marketing Specialist",
		},
		{
			occupationCode: "3519",
			occupationDescription: "Marquette stone carving worker",
		},
		{
			occupationCode: "1871",
			occupationDescription: "Marriage Official",
		},
		{
			occupationCode: "1779",
			occupationDescription: "Massage Technician",
		},
		{
			occupationCode: "196",
			occupationDescription: "Masseur",
		},
		{
			occupationCode: "107",
			occupationDescription: "Master",
		},
		{
			occupationCode: "1095",
			occupationDescription: "Material Engineer",
		},
		{
			occupationCode: "1941",
			occupationDescription: "Material planning Clerk",
		},
		{
			occupationCode: "1031",
			occupationDescription: "Materials Follow or up Supervisor",
		},
		{
			occupationCode: "1092",
			occupationDescription: "Materials handling Engineer",
		},
		{
			occupationCode: "1281",
			occupationDescription: "Maternal and Childhood Nursing Consultant",
		},
		{
			occupationCode: "1268",
			occupationDescription: "Maternal and childhood nursing Specialist",
		},
		{
			occupationCode: "214",
			occupationDescription: "Math Teacher",
		},
		{
			occupationCode: "952",
			occupationDescription: "Mathematician",
		},
		{
			occupationCode: "2154",
			occupationDescription: "Meals patient distribution Worker",
		},
		{
			occupationCode: "1389",
			occupationDescription: "Measurement and evaluation Specialist",
		},
		{
			occupationCode: "3145",
			occupationDescription: "Measuring device Mechanic",
		},
		{
			occupationCode: "3591",
			occupationDescription: "Measuring devices assembling worker",
		},
		{
			occupationCode: "2134",
			occupationDescription: "Meat Broiler/Fryer",
		},
		{
			occupationCode: "2296",
			occupationDescription: "Meat Chicken Breeder",
		},
		{
			occupationCode: "2899",
			occupationDescription: "Meat Cutter",
		},
		{
			occupationCode: "2900",
			occupationDescription: "Meat products maker",
		},
		{
			occupationCode: "474",
			occupationDescription: "Mechanic",
		},
		{
			occupationCode: "1622",
			occupationDescription: "Mechanic Draftsman",
		},
		{
			occupationCode: "95",
			occupationDescription: "Mechanical Engineering Technician",
		},
		{
			occupationCode: "1044",
			occupationDescription: "Mechanical Production Engineer",
		},
		{
			occupationCode: "1669",
			occupationDescription: "Mechanical and engines engineering technician",
		},
		{
			occupationCode: "64",
			occupationDescription: "Mechanical engineer",
		},
		{
			occupationCode: "3262",
			occupationDescription: "Mechanical product examination Worker",
		},
		{
			occupationCode: "1565",
			occupationDescription: "Mechanics Laboratory Technician",
		},
		{
			occupationCode: "14",
			occupationDescription: "Mechanics Physicist",
		},
		{
			occupationCode: "1897",
			occupationDescription: "Medical Coding Technician",
		},
		{
			occupationCode: "1260",
			occupationDescription: "Medical Lab Specialist",
		},
		{
			occupationCode: "1769",
			occupationDescription: "Medical Overseer",
		},
		{
			occupationCode: "1263",
			occupationDescription: "Medical Photography specialist",
		},
		{
			occupationCode: "1419",
			occupationDescription: "Medical Records lecturer",
		},
		{
			occupationCode: "145",
			occupationDescription: "Medical Secretary",
		},
		{
			occupationCode: "2391",
			occupationDescription: "Medical Shoe Maker",
		},
		{
			occupationCode: "280",
			occupationDescription: "Medical Typist",
		},
		{
			occupationCode: "1896",
			occupationDescription: "Medical administrative coordinator",
		},
		{
			occupationCode: "2427",
			occupationDescription: "Medical cotton Maker",
		},
		{
			occupationCode: "2082",
			occupationDescription: "Medical devices Salesman",
		},
		{
			occupationCode: "1037",
			occupationDescription: "Medical equipment Engineer",
		},
		{
			occupationCode: "2081",
			occupationDescription: "Medical equipment Salesman",
		},
		{
			occupationCode: "1647",
			occupationDescription: "Medical equipment Technician",
		},
		{
			occupationCode: "3595",
			occupationDescription: "Medical equipment assembling worker",
		},
		{
			occupationCode: "3417",
			occupationDescription:
				"Medical equipment maintenance electronic Technician",
		},
		{
			occupationCode: "1755",
			occupationDescription: "Medical glass Technician",
		},
		{
			occupationCode: "1284",
			occupationDescription: "Medical glasses Consultant",
		},
		{
			occupationCode: "1262",
			occupationDescription: "Medical imaging Specialist",
		},
		{
			occupationCode: "1273",
			occupationDescription: "Medical lab consultant",
		},
		{
			occupationCode: "1795",
			occupationDescription: "Medical laboratory technician",
		},
		{
			occupationCode: "128",
			occupationDescription: "Medical records Technician",
		},
		{
			occupationCode: "1181",
			occupationDescription: "Medical research Scientist",
		},
		{
			occupationCode: "1182",
			occupationDescription: "Medical research Technician",
		},
		{
			occupationCode: "218",
			occupationDescription: "Medical science Teachers",
		},
		{
			occupationCode: "122",
			occupationDescription: "Medical sciences Technician",
		},
		{
			occupationCode: "119",
			occupationDescription: "Medical technician",
		},
		{
			occupationCode: "1802",
			occupationDescription: "Medicine marketing Technician",
		},
		{
			occupationCode: "114",
			occupationDescription: "Medicines Composer",
		},
		{
			occupationCode: "1171",
			occupationDescription: "Medico or legal physician",
		},
		{
			occupationCode: "1862",
			occupationDescription: "Meeting Reporter",
		},
		{
			occupationCode: "2642",
			occupationDescription: "Melting Furnace Preparator",
		},
		{
			occupationCode: "2498",
			occupationDescription: "Men clothing Cutter",
		},
		{
			occupationCode: "421",
			occupationDescription: "Men s clothes tailor",
		},
		{
			occupationCode: "2034",
			occupationDescription: "Men s cloths seller",
		},
		{
			occupationCode: "1431",
			occupationDescription: "Mental Obstruction Specialist",
		},
		{
			occupationCode: "1428",
			occupationDescription: "Mental retarded Student Teacher",
		},
		{
			occupationCode: "325",
			occupationDescription: "Merchant",
		},
		{
			occupationCode: "2565",
			occupationDescription: "Metal Acidifying Engraver",
		},
		{
			occupationCode: "381",
			occupationDescription: "Metal Cleaning worker",
		},
		{
			occupationCode: "3054",
			occupationDescription: "Metal Construction Blacksmith",
		},
		{
			occupationCode: "2939",
			occupationDescription: "Metal Cutting Tool Sharpening Worker",
		},
		{
			occupationCode: "2585",
			occupationDescription: "Metal Engraving worker",
		},
		{
			occupationCode: "377",
			occupationDescription: "Metal Galvanization worker",
		},
		{
			occupationCode: "3021",
			occupationDescription: "Metal Painter",
		},
		{
			occupationCode: "3029",
			occupationDescription: "Metal Press shaping Worker",
		},
		{
			occupationCode: "502",
			occupationDescription: "Metal Welder",
		},
		{
			occupationCode: "3135",
			occupationDescription: "Metal artefacts Mechanic",
		},
		{
			occupationCode: "2984",
			occupationDescription: "Metal casting worker",
		},
		{
			occupationCode: "3107",
			occupationDescription: "Metal cleanness worker",
		},
		{
			occupationCode: "996",
			occupationDescription: "Metal construction engineer",
		},
		{
			occupationCode: "2633",
			occupationDescription: "Metal cutting machine Worker",
		},
		{
			occupationCode: "2652",
			occupationDescription: "Metal deposition equipment Overseer",
		},
		{
			occupationCode: "3049",
			occupationDescription: "Metal doors Blacksmith",
		},
		{
			occupationCode: "374",
			occupationDescription: "Metal furnace Technician",
		},
		{
			occupationCode: "3006",
			occupationDescription: "Metal furniture Blacksmith",
		},
		{
			occupationCode: "2044",
			occupationDescription: "Metal furniture seller",
		},
		{
			occupationCode: "3096",
			occupationDescription: "Metal inundating coating worker",
		},
		{
			occupationCode: "503",
			occupationDescription: "Metal lamination worker",
		},
		{
			occupationCode: "2976",
			occupationDescription: "Metal melting furnace Operator",
		},
		{
			occupationCode: "2987",
			occupationDescription: "Metal melting furnace operation Supervisor",
		},
		{
			occupationCode: "3024",
			occupationDescription: "Metal models manufacturing worker",
		},
		{
			occupationCode: "2947",
			occupationDescription: "Metal molding press Operator",
		},
		{
			occupationCode: "2923",
			occupationDescription: "Metal partition rolling Operator",
		},
		{
			occupationCode: "2924",
			occupationDescription: "Metal pipe rolling Operator",
		},
		{
			occupationCode: "2588",
			occupationDescription: "Metal plate Touch up Worker",
		},
		{
			occupationCode: "2922",
			occupationDescription: "Metal plate rolling Operator",
		},
		{
			occupationCode: "3014",
			occupationDescription: "Metal plates Blacksmith",
		},
		{
			occupationCode: "2938",
			occupationDescription: "Metal polish machine Worker",
		},
		{
			occupationCode: "372",
			occupationDescription: "Metal processing Worker",
		},
		{
			occupationCode: "3025",
			occupationDescription: "Metal shaping worker",
		},
		{
			occupationCode: "3103",
			occupationDescription: "Metal spray painting device Worker",
		},
		{
			occupationCode: "3097",
			occupationDescription: "Metal spraying coating worker",
		},
		{
			occupationCode: "2955",
			occupationDescription: "Metal structure assembly Worker",
		},
		{
			occupationCode: "3039",
			occupationDescription: "Metal tool filing mechanic",
		},
		{
			occupationCode: "2926",
			occupationDescription: "Metal wire Pulling Machine operator",
		},
		{
			occupationCode: "380",
			occupationDescription: "Metal withdrawing workers",
		},
		{
			occupationCode: "3108",
			occupationDescription: "Metal worker cleaning spray",
		},
		{
			occupationCode: "2949",
			occupationDescription: "Metal works molding worker",
		},
		{
			occupationCode: "508",
			occupationDescription: "Metal wrapping Technician",
		},
		{
			occupationCode: "70",
			occupationDescription: "Metals Engineer",
		},
		{
			occupationCode: "2930",
			occupationDescription: "Metals Heating furnace operator",
		},
		{
			occupationCode: "2650",
			occupationDescription: "Metals Rolling Overseer",
		},
		{
			occupationCode: "2086",
			occupationDescription: "Metals Seller",
		},
		{
			occupationCode: "2651",
			occupationDescription: "Metals foundry Overseer",
		},
		{
			occupationCode: "1576",
			occupationDescription: "Meteorologist",
		},
		{
			occupationCode: "1633",
			occupationDescription: "Micro Devices Electrician",
		},
		{
			occupationCode: "1029",
			occupationDescription: "Micro Devices Engineer",
		},
		{
			occupationCode: "2079",
			occupationDescription: "Micro Devices Salesman",
		},
		{
			occupationCode: "1592",
			occupationDescription: "Micro Photography Technician",
		},
		{
			occupationCode: "459",
			occupationDescription: "Micro devices technician",
		},
		{
			occupationCode: "3143",
			occupationDescription: "Micro or device Mechanic",
		},
		{
			occupationCode: "3569",
			occupationDescription: "Microscopes assembling worker",
		},
		{
			occupationCode: "58",
			occupationDescription: "Microwave Engineer",
		},
		{
			occupationCode: "1750",
			occupationDescription: "Midwife",
		},
		{
			occupationCode: "1068",
			occupationDescription: "Military Aircraft Calibration Engineer",
		},
		{
			occupationCode: "719",
			occupationDescription: "Military Attach",
		},
		{
			occupationCode: "2520",
			occupationDescription: "Military Clothing tailor",
		},
		{
			occupationCode: "13",
			occupationDescription: "Military Employed",
		},
		{
			occupationCode: "2506",
			occupationDescription: "Military Headwear maker",
		},
		{
			occupationCode: "422",
			occupationDescription: "Military suits tailor",
		},
		{
			occupationCode: "2915",
			occupationDescription: "Milk Maker",
		},
		{
			occupationCode: "2017",
			occupationDescription: "Milk seller",
		},
		{
			occupationCode: "2998",
			occupationDescription: "Milling Worker",
		},
		{
			occupationCode: "2934",
			occupationDescription: "Milling machine Worker",
		},
		{
			occupationCode: "2636",
			occupationDescription: "Mine Signal Worker",
		},
		{
			occupationCode: "1610",
			occupationDescription: "Mine Surveyor",
		},
		{
			occupationCode: "3227",
			occupationDescription: "Mine cart operator",
		},
		{
			occupationCode: "3217",
			occupationDescription: "Mine locomotive driver",
		},
		{
			occupationCode: "371",
			occupationDescription: "Mine worker",
		},
		{
			occupationCode: "1083",
			occupationDescription: "Mineral Extraction Engineer",
		},
		{
			occupationCode: "925",
			occupationDescription: "Mining Geologist",
		},
		{
			occupationCode: "1703",
			occupationDescription: "Mining Technician",
		},
		{
			occupationCode: "71",
			occupationDescription: "Mining engineer",
		},
		{
			occupationCode: "3134",
			occupationDescription: "Mining machine Mechanic",
		},
		{
			occupationCode: "2692",
			occupationDescription: "Mining machine operator",
		},
		{
			occupationCode: "3040",
			occupationDescription: "Mining machinery filing mechanic",
		},
		{
			occupationCode: "705",
			occupationDescription: "Minister Plenipotentiary (A)",
		},
		{
			occupationCode: "706",
			occupationDescription: "Minister Plenipotentiary (B)",
		},
		{
			occupationCode: "2762",
			occupationDescription: "Mirrors polishing and painting Worker",
		},
		{
			occupationCode: "557",
			occupationDescription: "Mixer operator",
		},
		{
			occupationCode: "491",
			occupationDescription: "Mobile technician",
		},
		{
			occupationCode: "2966",
			occupationDescription: "Model Maker",
		},
		{
			occupationCode: "2877",
			occupationDescription: "Molasses maker",
		},
		{
			occupationCode: "2974",
			occupationDescription: "Mold Casting machine operator",
		},
		{
			occupationCode: "1663",
			occupationDescription: "Mold Technician",
		},
		{
			occupationCode: "304",
			occupationDescription: "Money Collector",
		},
		{
			occupationCode: "2577",
			occupationDescription: "Mono type printing machine mono type",
		},
		{
			occupationCode: "2611",
			occupationDescription: "Mosaic shaping Worker",
		},
		{
			occupationCode: "2194",
			occupationDescription: "Mosque Imam",
		},
		{
			occupationCode: "1435",
			occupationDescription: "Mosque imam and Preacher",
		},
		{
			occupationCode: "2196",
			occupationDescription: "Mosque worker",
		},
		{
			occupationCode: "3356",
			occupationDescription: "Motor winding Electrician",
		},
		{
			occupationCode: "3261",
			occupationDescription: "Motorcycle Repairer",
		},
		{
			occupationCode: "3194",
			occupationDescription: "Motorcycle driver",
		},
		{
			occupationCode: "3257",
			occupationDescription: "Motorcycle mechanic",
		},
		{
			occupationCode: "3577",
			occupationDescription: "Motorcycles assembling worker",
		},
		{
			occupationCode: "2101",
			occupationDescription: "Motorcycles seller",
		},
		{
			occupationCode: "2195",
			occupationDescription: "Muezzin",
		},
		{
			occupationCode: "1433",
			occupationDescription: "Mufti",
		},
		{
			occupationCode: "2321",
			occupationDescription: "Multi Band Saw operator",
		},
		{
			occupationCode: "691",
			occupationDescription: "Museum Director",
		},
		{
			occupationCode: "1836",
			occupationDescription: "Museum Guide",
		},
		{
			occupationCode: "1456",
			occupationDescription: "Museum custodian",
		},
		{
			occupationCode: "1494",
			occupationDescription: "Music Composer",
		},
		{
			occupationCode: "1498",
			occupationDescription: "Music Maestro",
		},
		{
			occupationCode: "1495",
			occupationDescription: "Music Setter",
		},
		{
			occupationCode: "1500",
			occupationDescription: "Music critic",
		},
		{
			occupationCode: "3151",
			occupationDescription: "Musical Instrument mechanic",
		},
		{
			occupationCode: "2068",
			occupationDescription: "Musical instruments Seller",
		},
		{
			occupationCode: "237",
			occupationDescription: "Musician",
		},
		{
			occupationCode: "2197",
			occupationDescription: "Muttawif",
		},
		{
			occupationCode: "1232",
			occupationDescription: "NET surgeon",
		},
		{
			occupationCode: "971",
			occupationDescription: "NETWORK ENGINEER",
		},
		{
			occupationCode: "31",
			occupationDescription: "NULL",
		},
		{
			occupationCode: "2927",
			occupationDescription: "Nails making Machine operator",
		},
		{
			occupationCode: "1812",
			occupationDescription: "Nanny",
		},
		{
			occupationCode: "1869",
			occupationDescription: "Nationality Clerk",
		},
		{
			occupationCode: "2061",
			occupationDescription: "Natural Flower seller",
		},
		{
			occupationCode: "1300",
			occupationDescription: "Natural Medicine Specialist",
		},
		{
			occupationCode: "1708",
			occupationDescription: "Natural minerals Technician",
		},
		{
			occupationCode: "2455",
			occupationDescription: "Natural silk weighting Worker",
		},
		{
			occupationCode: "66",
			occupationDescription: "Navigation engineer",
		},
		{
			occupationCode: "38",
			occupationDescription: "Navigation systems technician",
		},
		{
			occupationCode: "1772",
			occupationDescription: "Nephritic Wash Technician",
		},
		{
			occupationCode: "1215",
			occupationDescription: "Nephrology Physician",
		},
		{
			occupationCode: "59",
			occupationDescription: "Network Planning Engineer",
		},
		{
			occupationCode: "29",
			occupationDescription: "Networks technician",
		},
		{
			occupationCode: "1230",
			occupationDescription: "Neuro or surgeon",
		},
		{
			occupationCode: "1240",
			occupationDescription: "Neuro or surgery Consultant",
		},
		{
			occupationCode: "158",
			occupationDescription: "Neurologist",
		},
		{
			occupationCode: "180",
			occupationDescription: "Neurology Consultant",
		},
		{
			occupationCode: "131",
			occupationDescription: "Neurology System Technician",
		},
		{
			occupationCode: "133",
			occupationDescription: "Neurology physicist Technician",
		},
		{
			occupationCode: "1867",
			occupationDescription: "New or born Registration Clerk",
		},
		{
			occupationCode: "2103",
			occupationDescription: "New spare parts Seller",
		},
		{
			occupationCode: "2099",
			occupationDescription: "New vehicles Salesman",
		},
		{
			occupationCode: "1470",
			occupationDescription: "News Censor",
		},
		{
			occupationCode: "2066",
			occupationDescription: "Newspapers Seller",
		},
		{
			occupationCode: "2065",
			occupationDescription: "Newspapers and periodicals Seller",
		},
		{
			occupationCode: "2067",
			occupationDescription: "Newspapers and publications Seller",
		},
		{
			occupationCode: "2516",
			occupationDescription: "Non Leather glove Cutting Worker",
		},
		{
			occupationCode: "575",
			occupationDescription: "Non or commissioned officer",
		},
		{
			occupationCode: "1066",
			occupationDescription: "Non or destructive testing Chief inspector",
		},
		{
			occupationCode: "894",
			occupationDescription: "Non organic Chemist",
		},
		{
			occupationCode: "2223",
			occupationDescription: "Normal worker",
		},
		{
			occupationCode: "1444",
			occupationDescription: "Notary",
		},
		{
			occupationCode: "148",
			occupationDescription: "Nuclear Medicine Specialist",
		},
		{
			occupationCode: "1056",
			occupationDescription: "Nuclear Power Engineer",
		},
		{
			occupationCode: "1206",
			occupationDescription: "Nuclear medicine consultant",
		},
		{
			occupationCode: "1170",
			occupationDescription: "Nuclear medicine physician",
		},
		{
			occupationCode: "917",
			occupationDescription: "Nuclear physicist",
		},
		{
			occupationCode: "190",
			occupationDescription: "Nurse",
		},
		{
			occupationCode: "2188",
			occupationDescription: "Nursemaid",
		},
		{
			occupationCode: "2263",
			occupationDescription: "Nurseries Farmer",
		},
		{
			occupationCode: "212",
			occupationDescription: "Nursing Instructor",
		},
		{
			occupationCode: "1413",
			occupationDescription: "Nursing Vocational Teacher",
		},
		{
			occupationCode: "1279",
			occupationDescription: "Nursing consultant",
		},
		{
			occupationCode: "1266",
			occupationDescription: "Nursing specialist",
		},
		{
			occupationCode: "1297",
			occupationDescription: "Nutrition Consultant",
		},
		{
			occupationCode: "187",
			occupationDescription: "Nutrition Specialist",
		},
		{
			occupationCode: "1768",
			occupationDescription: "Nutrition Technician",
		},
		{
			occupationCode: "595",
			occupationDescription: "OFFICER PHYSICIAN",
		},
		{
			occupationCode: "738",
			occupationDescription: "OFFSHORE FARM MANAGER",
		},
		{
			occupationCode: "174",
			occupationDescription: "Obe or gynecology Consultant",
		},
		{
			occupationCode: "928",
			occupationDescription: "Observation Astronomer",
		},
		{
			occupationCode: "1161",
			occupationDescription: "Obstetric Gynaecologist",
		},
		{
			occupationCode: "1749",
			occupationDescription: "Obstetric/gynaecological Nurse",
		},
		{
			occupationCode: "151",
			occupationDescription: "Obstetrician or Gynaecologist",
		},
		{
			occupationCode: "1210",
			occupationDescription: "Occupational Diseases Consultant",
		},
		{
			occupationCode: "1713",
			occupationDescription: "Occupational Health Technician",
		},
		{
			occupationCode: "1174",
			occupationDescription: "Occupational Physician",
		},
		{
			occupationCode: "1712",
			occupationDescription: "Occupational security and safety Technician",
		},
		{
			occupationCode: "1531",
			occupationDescription: "Offers planner",
		},
		{
			occupationCode: "2074",
			occupationDescription: "Office equipment Seller",
		},
		{
			occupationCode: "3152",
			occupationDescription: "Office outfit Mechanic",
		},
		{
			occupationCode: "574",
			occupationDescription: "Officer",
		},
		{
			occupationCode: "2541",
			occupationDescription: "Offset Movie preparation Worker",
		},
		{
			occupationCode: "2544",
			occupationDescription: "Offset printing machine operator",
		},
		{
			occupationCode: "416",
			occupationDescription: "Oil Changing worker",
		},
		{
			occupationCode: "1491",
			occupationDescription: "Oil Painting Painter",
		},
		{
			occupationCode: "2744",
			occupationDescription: "Oil Perfume Manufacturing worker",
		},
		{
			occupationCode: "415",
			occupationDescription: "Oil Presses Technician",
		},
		{
			occupationCode: "1698",
			occupationDescription: "Oil Refining chemist Technician",
		},
		{
			occupationCode: "2677",
			occupationDescription: "Oil and gas wells treatment Supervisor",
		},
		{
			occupationCode: "2683",
			occupationDescription: "Oil distillation equipment Operator",
		},
		{
			occupationCode: "2679",
			occupationDescription: "Oil distillation equipment Supervisor",
		},
		{
			occupationCode: "3156",
			occupationDescription: "Oil furnace Maintenance mechanic",
		},
		{
			occupationCode: "2886",
			occupationDescription: "Oil initial substance preparation Worker",
		},
		{
			occupationCode: "2682",
			occupationDescription: "Oil interaction equipment Operator",
		},
		{
			occupationCode: "3179",
			occupationDescription: "Oil network laying out Mechanic",
		},
		{
			occupationCode: "388",
			occupationDescription: "Oil refinery Overseer",
		},
		{
			occupationCode: "389",
			occupationDescription: "Oil refinery workers",
		},
		{
			occupationCode: "1142",
			occupationDescription: "Oil tanker captain",
		},
		{
			occupationCode: "2691",
			occupationDescription: "Oil treatment Overseer",
		},
		{
			occupationCode: "2680",
			occupationDescription: "Oil treatment equipment Operator",
		},
		{
			occupationCode: "2671",
			occupationDescription: "Oilfields Overseer",
		},
		{
			occupationCode: "740",
			occupationDescription: "Operation Manager",
		},
		{
			occupationCode: "33",
			occupationDescription: "Operations Technician",
		},
		{
			occupationCode: "3168",
			occupationDescription: "Operator of a central cooling devices",
		},
		{
			occupationCode: "152",
			occupationDescription: "Ophthalmologist",
		},
		{
			occupationCode: "179",
			occupationDescription: "Ophthalmology Consultant",
		},
		{
			occupationCode: "2770",
			occupationDescription: "Optical glass Cutting Worker",
		},
		{
			occupationCode: "1271",
			occupationDescription: "Optician",
		},
		{
			occupationCode: "194",
			occupationDescription: "Optician Specialist",
		},
		{
			occupationCode: "3147",
			occupationDescription: "Optics Maintenance Mechanic",
		},
		{
			occupationCode: "480",
			occupationDescription: "Optics Technician",
		},
		{
			occupationCode: "1501",
			occupationDescription: "Orchestra Maestro",
		},
		{
			occupationCode: "2640",
			occupationDescription: "Ore Cleaning and separation machine Operator",
		},
		{
			occupationCode: "8",
			occupationDescription: "Organic Chemistry chemist",
		},
		{
			occupationCode: "1543",
			occupationDescription: "Organization Expert",
		},
		{
			occupationCode: "1542",
			occupationDescription: "Organization Researcher",
		},
		{
			occupationCode: "2849",
			occupationDescription: "Oriental confectionery maker",
		},
		{
			occupationCode: "2297",
			occupationDescription: "Ornament birds Breeder",
		},
		{
			occupationCode: "1739",
			occupationDescription: "Ornament fish breeding Technician",
		},
		{
			occupationCode: "1251",
			occupationDescription: "Orthodontist",
		},
		{
			occupationCode: "1781",
			occupationDescription: "Orthopaedic Physical Therapy Technician",
		},
		{
			occupationCode: "460",
			occupationDescription: "Orthopaedic equipment technician",
		},
		{
			occupationCode: "1203",
			occupationDescription: "Orthopaedics Consultant",
		},
		{
			occupationCode: "135",
			occupationDescription: "Orthopaedist",
		},
		{
			occupationCode: "163",
			occupationDescription: "Orthopedician",
		},
		{
			occupationCode: "2",
			occupationDescription: "Other",
		},
		{
			occupationCode: "1719",
			occupationDescription: "Other Engineering Technician",
		},
		{
			occupationCode: "1178",
			occupationDescription: "Other Physician",
		},
		{
			occupationCode: "919",
			occupationDescription: "Other Physicists",
		},
		{
			occupationCode: "2713",
			occupationDescription: "Other chemical treatment Workers",
		},
		{
			occupationCode: "26",
			occupationDescription: "Others",
		},
		{
			occupationCode: "153",
			occupationDescription: "Otolaryngologist",
		},
		{
			occupationCode: "2128",
			occupationDescription: "Oven Baker",
		},
		{
			occupationCode: "3574",
			occupationDescription: "Oven and gas heater assembling worker",
		},
		{
			occupationCode: "3400",
			occupationDescription: "Overhead movie projector operator",
		},
		{
			occupationCode: "295",
			occupationDescription: "Overseer",
		},
		{
			occupationCode: "3078",
			occupationDescription: "Oxygen Welder",
		},
		{
			occupationCode: "2307",
			occupationDescription: "Oyster and crustaceans Breeder",
		},
		{
			occupationCode: "2308",
			occupationDescription: "Oysters Breeder",
		},
		{
			occupationCode: "2315",
			occupationDescription: "Oysters Diver",
		},
		{
			occupationCode: "1738",
			occupationDescription: "Oysters aquaculture Technical",
		},
		{
			occupationCode: "1123",
			occupationDescription: "Oysters breeding Specialist",
		},
		{
			occupationCode: "2243",
			occupationDescription: "PERSONAL ASSISTANT",
		},
		{
			occupationCode: "1386",
			occupationDescription: "POST or DOCTORAL FELLOWS",
		},
		{
			occupationCode: "978",
			occupationDescription: "PROJECT MANAGEMENT OFFICE SPECIALIST",
		},
		{
			occupationCode: "2126",
			occupationDescription: "PRUNING AND MANICURE NAIL",
		},
		{
			occupationCode: "2222",
			occupationDescription: "Packaging Worker",
		},
		{
			occupationCode: "155",
			occupationDescription: "Paediatrician",
		},
		{
			occupationCode: "172",
			occupationDescription: "Paediatrician Consultant",
		},
		{
			occupationCode: "2540",
			occupationDescription: "Page Arranger",
		},
		{
			occupationCode: "2539",
			occupationDescription: "Page Preparator",
		},
		{
			occupationCode: "900",
			occupationDescription: "Paint Chemist",
		},
		{
			occupationCode: "1701",
			occupationDescription: "Paint Industries Technician",
		},
		{
			occupationCode: "527",
			occupationDescription: "Painter",
		},
		{
			occupationCode: "1487",
			occupationDescription: "Painting Repairer",
		},
		{
			occupationCode: "2088",
			occupationDescription: "Paints seller",
		},
		{
			occupationCode: "2262",
			occupationDescription: "Palm Farmer",
		},
		{
			occupationCode: "1727",
			occupationDescription: "Palm cultivation Technician",
		},
		{
			occupationCode: "2821",
			occupationDescription: "Palm frond furniture making Worker",
		},
		{
			occupationCode: "2351",
			occupationDescription: "Paper Burnishing Machine Operator",
		},
		{
			occupationCode: "2363",
			occupationDescription: "Paper Dough Kneading machine Worker",
		},
		{
			occupationCode: "2557",
			occupationDescription: "Paper Folding machine operator",
		},
		{
			occupationCode: "1945",
			occupationDescription: "Paper Money Counter",
		},
		{
			occupationCode: "2555",
			occupationDescription: "Paper Scissor Worker",
		},
		{
			occupationCode: "2356",
			occupationDescription: "Paper envelop maker",
		},
		{
			occupationCode: "2344",
			occupationDescription: "Paper kneader operator",
		},
		{
			occupationCode: "2350",
			occupationDescription: "Paper or drying machine operator",
		},
		{
			occupationCode: "2353",
			occupationDescription: "Paper or making machine operator",
		},
		{
			occupationCode: "2346",
			occupationDescription: "Paper pulp Cleaning machine operator",
		},
		{
			occupationCode: "2767",
			occupationDescription: "Paper sanding manufacturing Worker",
		},
		{
			occupationCode: "41",
			occupationDescription: "Parachute Technician",
		},
		{
			occupationCode: "2685",
			occupationDescription: "Paraffin oil separation Tower operator",
		},
		{
			occupationCode: "1955",
			occupationDescription: "Passenger service Officer",
		},
		{
			occupationCode: "2844",
			occupationDescription: "Pasta and cookie maker",
		},
		{
			occupationCode: "2141",
			occupationDescription: "Pasta maker",
		},
		{
			occupationCode: "2745",
			occupationDescription:
				"Paste and Cosmetic materials Manufacturing worker",
		},
		{
			occupationCode: "404",
			occupationDescription: "Pasty Master",
		},
		{
			occupationCode: "1100",
			occupationDescription: "Patent Specialist",
		},
		{
			occupationCode: "944",
			occupationDescription: "Pathologist",
		},
		{
			occupationCode: "1296",
			occupationDescription: "Patient nutrition Specialist",
		},
		{
			occupationCode: "1908",
			occupationDescription: "Patients receiving clerk",
		},
		{
			occupationCode: "3205",
			occupationDescription: "Pavement machinery Driver",
		},
		{
			occupationCode: "1253",
			occupationDescription: "Pedodontist",
		},
		{
			occupationCode: "2336",
			occupationDescription: "Pencil Maker",
		},
		{
			occupationCode: "2060",
			occupationDescription: "Perfume seller",
		},
		{
			occupationCode: "727",
			occupationDescription: "Permanent delegate",
		},
		{
			occupationCode: "1540",
			occupationDescription: "Personal Affairs Specialist",
		},
		{
			occupationCode: "1866",
			occupationDescription: "Personal Evidence Clerk",
		},
		{
			occupationCode: "2192",
			occupationDescription: "Personal care worker",
		},
		{
			occupationCode: "615",
			occupationDescription: "Personal visit",
		},
		{
			occupationCode: "1893",
			occupationDescription: "Personnel Affairs Clerk",
		},
		{
			occupationCode: "634",
			occupationDescription: "Personnel Affairs Manager",
		},
		{
			occupationCode: "24",
			occupationDescription: "Pest Control Technician",
		},
		{
			occupationCode: "23",
			occupationDescription: "Pesticides Technician",
		},
		{
			occupationCode: "2249",
			occupationDescription: "Pesticides Worker",
		},
		{
			occupationCode: "2115",
			occupationDescription: "Pesticides seller",
		},
		{
			occupationCode: "2305",
			occupationDescription: "Pet Fish breeder",
		},
		{
			occupationCode: "73",
			occupationDescription: "Petroleum Engineer",
		},
		{
			occupationCode: "923",
			occupationDescription: "Petroleum Geologist",
		},
		{
			occupationCode: "554",
			occupationDescription: "Petroleum refinery worker",
		},
		{
			occupationCode: "1707",
			occupationDescription: "Petroleum well performance record Technician",
		},
		{
			occupationCode: "1801",
			occupationDescription: "Pharmaceutical Industry Technician",
		},
		{
			occupationCode: "185",
			occupationDescription: "Pharmacist",
		},
		{
			occupationCode: "1309",
			occupationDescription: "Pharmacy Instructor",
		},
		{
			occupationCode: "1804",
			occupationDescription: "Pharmacy technician Instructor",
		},
		{
			occupationCode: "2574",
			occupationDescription: "Photograph Copiest",
		},
		{
			occupationCode: "2571",
			occupationDescription: "Photograph Enlarging Operator",
		},
		{
			occupationCode: "2570",
			occupationDescription: "Photograph Printer",
		},
		{
			occupationCode: "2573",
			occupationDescription: "Photograph Printing Developer",
		},
		{
			occupationCode: "1611",
			occupationDescription: "Photograph Surveyor",
		},
		{
			occupationCode: "2579",
			occupationDescription: "Photograph casting Preparation Worker",
		},
		{
			occupationCode: "2589",
			occupationDescription: "Photographic Developing Worker",
		},
		{
			occupationCode: "2587",
			occupationDescription: "Photographic Engraver",
		},
		{
			occupationCode: "1509",
			occupationDescription: "Photography specialist",
		},
		{
			occupationCode: "1401",
			occupationDescription: "Physical Education Teacher",
		},
		{
			occupationCode: "1211",
			occupationDescription: "Physical Medicine Consultant",
		},
		{
			occupationCode: "1175",
			occupationDescription: "Physical Medicine Physician",
		},
		{
			occupationCode: "1780",
			occupationDescription: "Physical treatment Technician",
		},
		{
			occupationCode: "137",
			occupationDescription: "Physician",
		},
		{
			occupationCode: "896",
			occupationDescription: "Physicist Chemist",
		},
		{
			occupationCode: "1564",
			occupationDescription: "Physics Laboratory Technician",
		},
		{
			occupationCode: "213",
			occupationDescription: "Physics Teacher",
		},
		{
			occupationCode: "21",
			occupationDescription: "Physics technician",
		},
		{
			occupationCode: "195",
			occupationDescription: "Physio or Therapist",
		},
		{
			occupationCode: "934",
			occupationDescription: "Physiologist",
		},
		{
			occupationCode: "407",
			occupationDescription: "Pickles Master",
		},
		{
			occupationCode: "2870",
			occupationDescription: "Pickles maker",
		},
		{
			occupationCode: "2619",
			occupationDescription: "Pillar Machine Operator",
		},
		{
			occupationCode: "2925",
			occupationDescription: "Pipe Extrusion machine operator",
		},
		{
			occupationCode: "498",
			occupationDescription: "Pipe Installation Worker",
		},
		{
			occupationCode: "3071",
			occupationDescription: "Pipe pulling machine Worker",
		},
		{
			occupationCode: "2668",
			occupationDescription: "Pipeline Pumps operator",
		},
		{
			occupationCode: "3020",
			occupationDescription: "Pipeline filing worker",
		},
		{
			occupationCode: "3542",
			occupationDescription: "Pipelining laying out worker",
		},
		{
			occupationCode: "294",
			occupationDescription: "Pipes Overseer",
		},
		{
			occupationCode: "3081",
			occupationDescription: "Pipes Welder",
		},
		{
			occupationCode: "1737",
			occupationDescription: "Pisciculture Technician",
		},
		{
			occupationCode: "655",
			occupationDescription: "Planning Affairs Director",
		},
		{
			occupationCode: "3321",
			occupationDescription: "Plant Assistant Electrician",
		},
		{
			occupationCode: "548",
			occupationDescription: "Plant Electrician",
		},
		{
			occupationCode: "3320",
			occupationDescription: "Plant Installation Electrician",
		},
		{
			occupationCode: "1088",
			occupationDescription: "Plant Planning Engineer",
		},
		{
			occupationCode: "27",
			occupationDescription: "Plant Technician",
		},
		{
			occupationCode: "943",
			occupationDescription: "Plant hybridization Specialist",
		},
		{
			occupationCode: "545",
			occupationDescription: "Plant operator",
		},
		{
			occupationCode: "1580",
			occupationDescription: "Plant samples Technician",
		},
		{
			occupationCode: "1244",
			occupationDescription: "Plastic Surgery Consultant",
		},
		{
			occupationCode: "2734",
			occupationDescription: "Plastic Thinng worker",
		},
		{
			occupationCode: "2719",
			occupationDescription: "Plastic bags production line worker",
		},
		{
			occupationCode: "3480",
			occupationDescription: "Plastic flooring installer",
		},
		{
			occupationCode: "2741",
			occupationDescription: "Plastic production Industry Overseer",
		},
		{
			occupationCode: "1234",
			occupationDescription: "Plastic surgeon",
		},
		{
			occupationCode: "2715",
			occupationDescription: "Plastics Mixture preparator",
		},
		{
			occupationCode: "2725",
			occupationDescription: "Plastics Products Polishing Machine operator",
		},
		{
			occupationCode: "463",
			occupationDescription: "Plastics Technician",
		},
		{
			occupationCode: "2716",
			occupationDescription: "Plastics injection machine operator",
		},
		{
			occupationCode: "3121",
			occupationDescription: "Plate Maker",
		},
		{
			occupationCode: "246",
			occupationDescription: "Player",
		},
		{
			occupationCode: "497",
			occupationDescription: "Plumber",
		},
		{
			occupationCode: "2339",
			occupationDescription: "Plywood Press Worker",
		},
		{
			occupationCode: "2338",
			occupationDescription: "Plywood machine manufacturing Worker",
		},
		{
			occupationCode: "1447",
			occupationDescription: "Poet",
		},
		{
			occupationCode: "3109",
			occupationDescription: "Polish Worker",
		},
		{
			occupationCode: "2945",
			occupationDescription: "Polishing machine operation Worker",
		},
		{
			occupationCode: "1526",
			occupationDescription: "Political analyst",
		},
		{
			occupationCode: "1525",
			occupationDescription: "Politics Specialist",
		},
		{
			occupationCode: "2220",
			occupationDescription: "Porter",
		},
		{
			occupationCode: "1145",
			occupationDescription: "Ports Operation Expert",
		},
		{
			occupationCode: "1916",
			occupationDescription: "Post Clerk",
		},
		{
			occupationCode: "1917",
			occupationDescription: "Post Sorter",
		},
		{
			occupationCode: "1414",
			occupationDescription: "Post Vocational Teacher",
		},
		{
			occupationCode: "1918",
			occupationDescription: "Postman",
		},
		{
			occupationCode: "3112",
			occupationDescription: "Pot Coppersmith",
		},
		{
			occupationCode: "2896",
			occupationDescription: "Poultry Butcher",
		},
		{
			occupationCode: "2300",
			occupationDescription: "Poultry Fodder Worker",
		},
		{
			occupationCode: "1732",
			occupationDescription: "Poultry breeding Technician",
		},
		{
			occupationCode: "2299",
			occupationDescription: "Poultry incubation workers",
		},
		{
			occupationCode: "358",
			occupationDescription: "Poultry man",
		},
		{
			occupationCode: "2020",
			occupationDescription: "Poultry seller",
		},
		{
			occupationCode: "1257",
			occupationDescription: "Poultry veterinarian",
		},
		{
			occupationCode: "2687",
			occupationDescription: "Power charger operator",
		},
		{
			occupationCode: "3383",
			occupationDescription: "Power station operator",
		},
		{
			occupationCode: "1310",
			occupationDescription: "Preiodontist",
		},
		{
			occupationCode: "681",
			occupationDescription: "President of University",
		},
		{
			occupationCode: "1467",
			occupationDescription: "Press Editor",
		},
		{
			occupationCode: "1466",
			occupationDescription: "Press Writer",
		},
		{
			occupationCode: "1471",
			occupationDescription: "Press correspondent",
		},
		{
			occupationCode: "3063",
			occupationDescription: "Press operation Worker",
		},
		{
			occupationCode: "1842",
			occupationDescription: "Press photographer",
		},
		{
			occupationCode: "2970",
			occupationDescription: "Press shaping works",
		},
		{
			occupationCode: "386",
			occupationDescription: "Press worker",
		},
		{
			occupationCode: "2330",
			occupationDescription: "Pressed Wood Manufacturing worker",
		},
		{
			occupationCode: "1032",
			occupationDescription: "Prevention Engineer",
		},
		{
			occupationCode: "659",
			occupationDescription: "Prince of Province",
		},
		{
			occupationCode: "683",
			occupationDescription: "Principal of School",
		},
		{
			occupationCode: "453",
			occupationDescription: "Printer technician",
		},
		{
			occupationCode: "2076",
			occupationDescription: "Printers Salesman",
		},
		{
			occupationCode: "1888",
			occupationDescription: "Printing Designer",
		},
		{
			occupationCode: "83",
			occupationDescription: "Printing Technician",
		},
		{
			occupationCode: "1979",
			occupationDescription: "Printing and photography Operator",
		},
		{
			occupationCode: "2576",
			occupationDescription: "Printing machine Worker",
		},
		{
			occupationCode: "3041",
			occupationDescription: "Printing machine assembly mechanic",
		},
		{
			occupationCode: "2548",
			occupationDescription: "Printing montage Worker",
		},
		{
			occupationCode: "3133",
			occupationDescription: "Printing press Maintenance mechanic",
		},
		{
			occupationCode: "2550",
			occupationDescription: "Printing toner Technician",
		},
		{
			occupationCode: "4",
			occupationDescription: "Private Business",
		},
		{
			occupationCode: "11",
			occupationDescription: "Private Employed ",
		},
		{
			occupationCode: "2213",
			occupationDescription: "Private Escort",
		},
		{
			occupationCode: "2240",
			occupationDescription: "Private Physiotherapist",
		},
		{
			occupationCode: "3",
			occupationDescription: "Private Sector",
		},
		{
			occupationCode: "2241",
			occupationDescription: "Private Speech and Hearing Specialist",
		},
		{
			occupationCode: "2165",
			occupationDescription: "Private residence Supervisor",
		},
		{
			occupationCode: "850",
			occupationDescription: "Private sector Relations Manager",
		},
		{
			occupationCode: "768",
			occupationDescription: "Procurement Manager",
		},
		{
			occupationCode: "1987",
			occupationDescription: "Product Selling Agent",
		},
		{
			occupationCode: "1930",
			occupationDescription: "Production Clerk",
		},
		{
			occupationCode: "63",
			occupationDescription: "Production Engineer",
		},
		{
			occupationCode: "102",
			occupationDescription: "Production Engineering Technician",
		},
		{
			occupationCode: "271",
			occupationDescription: "Production Manager",
		},
		{
			occupationCode: "367",
			occupationDescription: "Production Supervisor",
		},
		{
			occupationCode: "118",
			occupationDescription: "Production technician",
		},
		{
			occupationCode: "91",
			occupationDescription: "Professional management contracts",
		},
		{
			occupationCode: "1352",
			occupationDescription: "Professor, Agronomy",
		},
		{
			occupationCode: "1354",
			occupationDescription: "Professor, Air Navigation",
		},
		{
			occupationCode: "1338",
			occupationDescription: "Professor, Animal",
		},
		{
			occupationCode: "1364",
			occupationDescription: "Professor, Anthropology",
		},
		{
			occupationCode: "1372",
			occupationDescription: "Professor, Archaeology",
		},
		{
			occupationCode: "1344",
			occupationDescription: "Professor, Architecture",
		},
		{
			occupationCode: "1374",
			occupationDescription: "Professor, Art composition",
		},
		{
			occupationCode: "1376",
			occupationDescription: "Professor, Art representative",
		},
		{
			occupationCode: "1336",
			occupationDescription: "Professor, Astronomy",
		},
		{
			occupationCode: "1339",
			occupationDescription: "Professor, Botany",
		},
		{
			occupationCode: "1349",
			occupationDescription: "Professor, Chemical engineering",
		},
		{
			occupationCode: "1333",
			occupationDescription: "Professor, Chemistry",
		},
		{
			occupationCode: "1345",
			occupationDescription: "Professor, Civil Engineering",
		},
		{
			occupationCode: "1384",
			occupationDescription: "Professor, Computer Engineering",
		},
		{
			occupationCode: "1357",
			occupationDescription: "Professor, Dentistry",
		},
		{
			occupationCode: "1335",
			occupationDescription: "Professor, Earth layers",
		},
		{
			occupationCode: "1379",
			occupationDescription: "Professor, Economics",
		},
		{
			occupationCode: "1367",
			occupationDescription: "Professor, Education",
		},
		{
			occupationCode: "1346",
			occupationDescription: "Professor, Electrical Engineering",
		},
		{
			occupationCode: "1347",
			occupationDescription: "Professor, Electronic Engineering",
		},
		{
			occupationCode: "1370",
			occupationDescription: "Professor, Ethics",
		},
		{
			occupationCode: "1366",
			occupationDescription: "Professor, Geography",
		},
		{
			occupationCode: "1365",
			occupationDescription: "Professor, History",
		},
		{
			occupationCode: "1353",
			occupationDescription: "Professor, Horticulture and Forests",
		},
		{
			occupationCode: "1350",
			occupationDescription: "Professor, Industrial Engineering",
		},
		{
			occupationCode: "1343",
			occupationDescription: "Professor, Information Systems",
		},
		{
			occupationCode: "1369",
			occupationDescription: "Professor, Law",
		},
		{
			occupationCode: "1342",
			occupationDescription: "Professor, Mathematics",
		},
		{
			occupationCode: "1348",
			occupationDescription: "Professor, Mechanical Engineering",
		},
		{
			occupationCode: "1359",
			occupationDescription: "Professor, Medical Assistance Sciences",
		},
		{
			occupationCode: "1355",
			occupationDescription: "Professor, Medicine",
		},
		{
			occupationCode: "1337",
			occupationDescription: "Professor, Meteorology",
		},
		{
			occupationCode: "1375",
			occupationDescription: "Professor, Music",
		},
		{
			occupationCode: "1340",
			occupationDescription: "Professor, Pathology",
		},
		{
			occupationCode: "1360",
			occupationDescription: "Professor, Pharmacology",
		},
		{
			occupationCode: "1361",
			occupationDescription: "Professor, Pharmacy",
		},
		{
			occupationCode: "1377",
			occupationDescription: "Professor, Physical Education",
		},
		{
			occupationCode: "1334",
			occupationDescription: "Professor, Physics",
		},
		{
			occupationCode: "1378",
			occupationDescription: "Professor, Politics",
		},
		{
			occupationCode: "1362",
			occupationDescription: "Professor, Psychology",
		},
		{
			occupationCode: "1368",
			occupationDescription: "Professor, Religious Science",
		},
		{
			occupationCode: "1351",
			occupationDescription: "Professor, Sanitary Engineering and Environment",
		},
		{
			occupationCode: "1363",
			occupationDescription: "Professor, Sociology",
		},
		{
			occupationCode: "1341",
			occupationDescription: "Professor, Statistics",
		},
		{
			occupationCode: "1356",
			occupationDescription: "Professor, Surgery",
		},
		{
			occupationCode: "1358",
			occupationDescription: "Professor, Veterinary Medicine",
		},
		{
			occupationCode: "1380",
			occupationDescription: "Professor, finance",
		},
		{
			occupationCode: "1371",
			occupationDescription: "Professor, languages",
		},
		{
			occupationCode: "1373",
			occupationDescription: "Professor, libraries",
		},
		{
			occupationCode: "3000",
			occupationDescription: "Programmed operation machine Operator",
		},
		{
			occupationCode: "205",
			occupationDescription: "Programmer",
		},
		{
			occupationCode: "292",
			occupationDescription: "Programmes Coordinator",
		},
		{
			occupationCode: "656",
			occupationDescription: "Project Director",
		},
		{
			occupationCode: "268",
			occupationDescription: "Project Manager",
		},
		{
			occupationCode: "55",
			occupationDescription: "Project engineer",
		},
		{
			occupationCode: "1477",
			occupationDescription: "Propaganda Editor",
		},
		{
			occupationCode: "1254",
			occupationDescription: "Prosthodontist",
		},
		{
			occupationCode: "3413",
			occupationDescription:
				"Protection devices maintenance electronic Technician",
		},
		{
			occupationCode: "181",
			occupationDescription: "Psychiatric Consultant",
		},
		{
			occupationCode: "159",
			occupationDescription: "Psychiatrist",
		},
		{
			occupationCode: "1311",
			occupationDescription: "Psychiatry Specialist",
		},
		{
			occupationCode: "1317",
			occupationDescription: "Psychological Researcher",
		},
		{
			occupationCode: "1316",
			occupationDescription: "Psychological tests Specialist",
		},
		{
			occupationCode: "1185",
			occupationDescription: "Public Health consultant",
		},
		{
			occupationCode: "635",
			occupationDescription: "Public Relations Manager",
		},
		{
			occupationCode: "3192",
			occupationDescription: "Public Vehicle Driver",
		},
		{
			occupationCode: "1250",
			occupationDescription: "Public health Dental Consultant",
		},
		{
			occupationCode: "1269",
			occupationDescription: "Public health Nursing specialist",
		},
		{
			occupationCode: "1149",
			occupationDescription: "Public health Physician",
		},
		{
			occupationCode: "1282",
			occupationDescription: "Public health nursing Consultant",
		},
		{
			occupationCode: "1911",
			occupationDescription: "Public relations Clerk",
		},
		{
			occupationCode: "232",
			occupationDescription: "Public relations officer",
		},
		{
			occupationCode: "300",
			occupationDescription: "Public services supervisor",
		},
		{
			occupationCode: "2693",
			occupationDescription: "Pulling Equipment operation Worker",
		},
		{
			occupationCode: "2415",
			occupationDescription: "Pulling Machine operator",
		},
		{
			occupationCode: "3120",
			occupationDescription: "Pulling and flattened Worker",
		},
		{
			occupationCode: "154",
			occupationDescription: "Pulmonologist",
		},
		{
			occupationCode: "182",
			occupationDescription: "Pulmonology Consultant",
		},
		{
			occupationCode: "3305",
			occupationDescription: "Pumping machine operator",
		},
		{
			occupationCode: "462",
			occupationDescription: "Pumps Mechanic",
		},
		{
			occupationCode: "546",
			occupationDescription: "Pumps Operator",
		},
		{
			occupationCode: "283",
			occupationDescription: "Punching Worker",
		},
		{
			occupationCode: "1982",
			occupationDescription: "Punching machine operator",
		},
		{
			occupationCode: "317",
			occupationDescription: "Purchases man",
		},
		{
			occupationCode: "293",
			occupationDescription: "Qualitative Coordinator",
		},
		{
			occupationCode: "134",
			occupationDescription: "Qualitative Technician",
		},
		{
			occupationCode: "1015",
			occupationDescription: "Quality / Cartography test Specialist (First)",
		},
		{
			occupationCode: "2824",
			occupationDescription: "Quality Examiner",
		},
		{
			occupationCode: "1104",
			occupationDescription: "Quality Systems Coordinator",
		},
		{
			occupationCode: "1094",
			occupationDescription: "Quality control engineer",
		},
		{
			occupationCode: "1103",
			occupationDescription: "Quality system Chief Auditor",
		},
		{
			occupationCode: "1102",
			occupationDescription: "Quality system internal Auditor",
		},
		{
			occupationCode: "85",
			occupationDescription: "Quantity surveyor",
		},
		{
			occupationCode: "2631",
			occupationDescription: "Quarrier",
		},
		{
			occupationCode: "1086",
			occupationDescription: "Quarry Engineer",
		},
		{
			occupationCode: "2634",
			occupationDescription: "Quarry Supervisor",
		},
		{
			occupationCode: "2635",
			occupationDescription: "Quarry Worker",
		},
		{
			occupationCode: "3241",
			occupationDescription: "Quick service Mechanic",
		},
		{
			occupationCode: "1533",
			occupationDescription: "REAL ESTATE VALUER/APPRAISER",
		},
		{
			occupationCode: "2278",
			occupationDescription: "Rabbit Breeder",
		},
		{
			occupationCode: "1330",
			occupationDescription: "Races and breeds Specialist",
		},
		{
			occupationCode: "1644",
			occupationDescription: "Radio Broadcast Technician",
		},
		{
			occupationCode: "32",
			occupationDescription: "Radio Technician",
		},
		{
			occupationCode: "483",
			occupationDescription: "Radio and Television technician",
		},
		{
			occupationCode: "1473",
			occupationDescription: "Radio and television broadcaster",
		},
		{
			occupationCode: "1479",
			occupationDescription: "Radio and television correspondent",
		},
		{
			occupationCode: "1034",
			occupationDescription: "Radio and television engineer",
		},
		{
			occupationCode: "3602",
			occupationDescription: "Radio assembling worker",
		},
		{
			occupationCode: "3409",
			occupationDescription: "Radio maintenance electronic Technician",
		},
		{
			occupationCode: "1792",
			occupationDescription: "Radiological Photography Technician",
		},
		{
			occupationCode: "162",
			occupationDescription: "Radiologist",
		},
		{
			occupationCode: "1201",
			occupationDescription: "Radiology Consultant",
		},
		{
			occupationCode: "1766",
			occupationDescription: "Radiology Instructor",
		},
		{
			occupationCode: "1286",
			occupationDescription: "Radiology specialist Instructor",
		},
		{
			occupationCode: "197",
			occupationDescription: "Radiology technician",
		},
		{
			occupationCode: "1180",
			occupationDescription: "Radionuclide Production consultant",
		},
		{
			occupationCode: "1264",
			occupationDescription: "Radiotherapist",
		},
		{
			occupationCode: "1277",
			occupationDescription: "Radiotherapy Consultant",
		},
		{
			occupationCode: "132",
			occupationDescription: "Radiotherapy Technician",
		},
		{
			occupationCode: "3559",
			occupationDescription: "Railway Assistant Installer",
		},
		{
			occupationCode: "1001",
			occupationDescription: "Railway Engineer",
		},
		{
			occupationCode: "3558",
			occupationDescription: "Railway Installer",
		},
		{
			occupationCode: "3560",
			occupationDescription: "Railway beams Installer",
		},
		{
			occupationCode: "662",
			occupationDescription: "Railway station Director",
		},
		{
			occupationCode: "2382",
			occupationDescription: "Raw Leather Matcher",
		},
		{
			occupationCode: "2647",
			occupationDescription: "Raw Materials Roasting Furnace operator",
		},
		{
			occupationCode: "2641",
			occupationDescription: "Raw Materials purification Machine operator",
		},
		{
			occupationCode: "2639",
			occupationDescription: "Raw materials Grinder",
		},
		{
			occupationCode: "2648",
			occupationDescription: "Raw materials Packaging Worker",
		},
		{
			occupationCode: "1383",
			occupationDescription: "Reader",
		},
		{
			occupationCode: "2622",
			occupationDescription: "Ready Made Concrete manufacturing worker",
		},
		{
			occupationCode: "2514",
			occupationDescription: "Ready made Clothing Cutting worker",
		},
		{
			occupationCode: "2501",
			occupationDescription: "Ready made Suit tailor",
		},
		{
			occupationCode: "2032",
			occupationDescription: "Ready or made Clothes seller",
		},
		{
			occupationCode: "2005",
			occupationDescription: "Real estate Insurance Broker",
		},
		{
			occupationCode: "3410",
			occupationDescription: "Receivers maintenance Worker",
		},
		{
			occupationCode: "1906",
			occupationDescription: "Reception Clerk",
		},
		{
			occupationCode: "310",
			occupationDescription: "Receptionist",
		},
		{
			occupationCode: "2193",
			occupationDescription: "Reciter",
		},
		{
			occupationCode: "1898",
			occupationDescription: "Recruitment Clerk",
		},
		{
			occupationCode: "2689",
			occupationDescription: "Refinery Operator",
		},
		{
			occupationCode: "2684",
			occupationDescription: "Refinery control panel Overseer",
		},
		{
			occupationCode: "2681",
			occupationDescription: "Refinery pump Operator",
		},
		{
			occupationCode: "56",
			occupationDescription: "Refrigeration Engineer",
		},
		{
			occupationCode: "456",
			occupationDescription: "Refrigeration Technician",
		},
		{
			occupationCode: "98",
			occupationDescription: "Refrigeration and A/C Technician",
		},
		{
			occupationCode: "845",
			occupationDescription: "Regional plastic sales manager",
		},
		{
			occupationCode: "442",
			occupationDescription: "Reinforcement Blacksmith",
		},
		{
			occupationCode: "2623",
			occupationDescription: "Reinforcing Steel pulling machine Operator",
		},
		{
			occupationCode: "652",
			occupationDescription: "Religious Affairs Director",
		},
		{
			occupationCode: "1398",
			occupationDescription: "Religious Education Teacher",
		},
		{
			occupationCode: "226",
			occupationDescription: "Religious Instructor",
		},
		{
			occupationCode: "3378",
			occupationDescription: "Repair Electrician",
		},
		{
			occupationCode: "316",
			occupationDescription: "Representative",
		},
		{
			occupationCode: "2206",
			occupationDescription: "Rescuer",
		},
		{
			occupationCode: "1073",
			occupationDescription: "Research and Development Engineer",
		},
		{
			occupationCode: "258",
			occupationDescription: "Researcher",
		},
		{
			occupationCode: "17",
			occupationDescription: "Researcher physicist",
		},
		{
			occupationCode: "311",
			occupationDescription: "Reservation Officer",
		},
		{
			occupationCode: "2230",
			occupationDescription: "Rest House Guard",
		},
		{
			occupationCode: "774",
			occupationDescription: "Restaurant and Cafe Manager",
		},
		{
			occupationCode: "412",
			occupationDescription: "Restaurant worker",
		},
		{
			occupationCode: "769",
			occupationDescription: "Retail trade Manager",
		},
		{
			occupationCode: "1993",
			occupationDescription: "Retail trade Supervisor",
		},
		{
			occupationCode: "7",
			occupationDescription: "Retired",
		},
		{
			occupationCode: "2469",
			occupationDescription: "Ribbon Loom Operator",
		},
		{
			occupationCode: "2829",
			occupationDescription: "Rice Husking worker",
		},
		{
			occupationCode: "2830",
			occupationDescription: "Rice milling Worker",
		},
		{
			occupationCode: "447",
			occupationDescription: "Rifles Repairer",
		},
		{
			occupationCode: "1598",
			occupationDescription: "Road Construction Draftsman",
		},
		{
			occupationCode: "997",
			occupationDescription: "Road Engineer",
		},
		{
			occupationCode: "1051",
			occupationDescription: "Road Machinery Engineer",
		},
		{
			occupationCode: "1602",
			occupationDescription: "Road Surveyor",
		},
		{
			occupationCode: "1600",
			occupationDescription: "Road Technician",
		},
		{
			occupationCode: "3204",
			occupationDescription: "Road machinery Driver",
		},
		{
			occupationCode: "1672",
			occupationDescription: "Road machinery maintenance Technician",
		},
		{
			occupationCode: "556",
			occupationDescription: "Road paving Worker",
		},
		{
			occupationCode: "3210",
			occupationDescription: "Road roller Driver",
		},
		{
			occupationCode: "1969",
			occupationDescription: "Road transportation service Supervisor",
		},
		{
			occupationCode: "2097",
			occupationDescription: "Roads Mechanisms Seller",
		},
		{
			occupationCode: "2701",
			occupationDescription: "Roasting Worker",
		},
		{
			occupationCode: "540",
			occupationDescription: "Rolling Worker",
		},
		{
			occupationCode: "2417",
			occupationDescription: "Rolling out machine operator",
		},
		{
			occupationCode: "3526",
			occupationDescription: "Roof asphalting worker",
		},
		{
			occupationCode: "3525",
			occupationDescription: "Roof covering worker",
		},
		{
			occupationCode: "2189",
			occupationDescription: "Room Worker",
		},
		{
			occupationCode: "2177",
			occupationDescription: "Room service Supervisor",
		},
		{
			occupationCode: "299",
			occupationDescription: "Rooms supervisor",
		},
		{
			occupationCode: "2676",
			occupationDescription: "Rope excavator operation Forman",
		},
		{
			occupationCode: "2419",
			occupationDescription: "Rope or making machine operator",
		},
		{
			occupationCode: "2543",
			occupationDescription: "Rotary printing machine operator",
		},
		{
			occupationCode: "2421",
			occupationDescription: "Rotating brominated threads worker",
		},
		{
			occupationCode: "3556",
			occupationDescription: "Route Maintenance worker",
		},
		{
			occupationCode: "3549",
			occupationDescription: "Routes Paver",
		},
		{
			occupationCode: "2724",
			occupationDescription: "Rubber Lamination Machine operator",
		},
		{
			occupationCode: "2731",
			occupationDescription: "Rubber Products Collection Worker",
		},
		{
			occupationCode: "2727",
			occupationDescription: "Rubber fabric clothing Machine operator",
		},
		{
			occupationCode: "2739",
			occupationDescription: "Rubber production Overseer",
		},
		{
			occupationCode: "2471",
			occupationDescription: "Rug Loom Operator",
		},
		{
			occupationCode: "1422",
			occupationDescription: "SALES MARKETING EXPERT",
		},
		{
			occupationCode: "596",
			occupationDescription: "SECONDED OFFICER",
		},
		{
			occupationCode: "985",
			occupationDescription: "SECURITY SPECIALIST",
		},
		{
			occupationCode: "987",
			occupationDescription: "SOFTWARE ENGINEERING SPECIALIST",
		},
		{
			occupationCode: "964",
			occupationDescription: "STRATEGY AND PLANNING SPECIALIST",
		},
		{
			occupationCode: "1594",
			occupationDescription: "SUPPORT TECHNICIAN",
		},
		{
			occupationCode: "963",
			occupationDescription: "SYSTEMS ARCHIVING SPECIALIST IST",
		},
		{
			occupationCode: "2408",
			occupationDescription: "Saddler",
		},
		{
			occupationCode: "1091",
			occupationDescription: "Safety and Occupational Health Engineer",
		},
		{
			occupationCode: "108",
			occupationDescription: "Sailor",
		},
		{
			occupationCode: "2144",
			occupationDescription: "Salad Maker",
		},
		{
			occupationCode: "1929",
			occupationDescription: "Salary Clerk",
		},
		{
			occupationCode: "272",
			occupationDescription: "Sales Manager",
		},
		{
			occupationCode: "315",
			occupationDescription: "Sales supervisor",
		},
		{
			occupationCode: "319",
			occupationDescription: "Salesman",
		},
		{
			occupationCode: "2920",
			occupationDescription: "Salt Manufacturing Workers",
		},
		{
			occupationCode: "2632",
			occupationDescription: "Samples Catcher",
		},
		{
			occupationCode: "2605",
			occupationDescription: "Sand Brick Automatic Press Operator",
		},
		{
			occupationCode: "2606",
			occupationDescription: "Sand Brick drying Furnace Operator",
		},
		{
			occupationCode: "2967",
			occupationDescription: "Sand mold Maker",
		},
		{
			occupationCode: "2969",
			occupationDescription: "Sand mold shaping Worker",
		},
		{
			occupationCode: "2390",
			occupationDescription: "Sandal Maker",
		},
		{
			occupationCode: "2778",
			occupationDescription: "Sanding components mixing Worker",
		},
		{
			occupationCode: "2329",
			occupationDescription: "Sanding machine operator",
		},
		{
			occupationCode: "335",
			occupationDescription: "Sandwich maker",
		},
		{
			occupationCode: "2968",
			occupationDescription: "Sandy molding maker",
		},
		{
			occupationCode: "1106",
			occupationDescription: "Sanitary Engineer",
		},
		{
			occupationCode: "1665",
			occupationDescription: "Sanitary Laying out Installation Technician",
		},
		{
			occupationCode: "1666",
			occupationDescription: "Sanitary Laying out Maintenance Technician",
		},
		{
			occupationCode: "2093",
			occupationDescription: "Sanitary Laying out Supplies Seller",
		},
		{
			occupationCode: "121",
			occupationDescription: "Sanitary Supervisor",
		},
		{
			occupationCode: "3176",
			occupationDescription: "Sanitary laying out Assistant Mechanic",
		},
		{
			occupationCode: "1655",
			occupationDescription: "Sanitary laying out Draftsman",
		},
		{
			occupationCode: "3177",
			occupationDescription: "Sanitary laying out Installer",
		},
		{
			occupationCode: "3175",
			occupationDescription: "Sanitary laying out Mechanic",
		},
		{
			occupationCode: "2941",
			occupationDescription: "Saw repair and sharpening Worker",
		},
		{
			occupationCode: "3435",
			occupationDescription: "Sawing Machine operator",
		},
		{
			occupationCode: "3447",
			occupationDescription: "Scaffold Installation Worker",
		},
		{
			occupationCode: "1506",
			occupationDescription: "Scenarist",
		},
		{
			occupationCode: "1831",
			occupationDescription: "Science Laboratory Technician",
		},
		{
			occupationCode: "1818",
			occupationDescription: "Science Teacher",
		},
		{
			occupationCode: "2077",
			occupationDescription: "Scientific instruments Salesman",
		},
		{
			occupationCode: "906",
			occupationDescription: "Scientist or expert",
		},
		{
			occupationCode: "3064",
			occupationDescription: "Scraping machine operation worker",
		},
		{
			occupationCode: "3513",
			occupationDescription: "Screening and classifying stones worker",
		},
		{
			occupationCode: "236",
			occupationDescription: "Sculptor",
		},
		{
			occupationCode: "1486",
			occupationDescription: "Sculpture Specialist",
		},
		{
			occupationCode: "2312",
			occupationDescription: "Sea Fisherman",
		},
		{
			occupationCode: "2008",
			occupationDescription: "Sea Freight Broker",
		},
		{
			occupationCode: "2561",
			occupationDescription: "Seal Making Worker",
		},
		{
			occupationCode: "2564",
			occupationDescription: "Seals Engraver",
		},
		{
			occupationCode: "663",
			occupationDescription: "Seaport director",
		},
		{
			occupationCode: "1000",
			occupationDescription: "Seaports Engineer",
		},
		{
			occupationCode: "552",
			occupationDescription: "Seaports Worker",
		},
		{
			occupationCode: "713",
			occupationDescription: "Second secretary / A",
		},
		{
			occupationCode: "714",
			occupationDescription: "Second secretary / B",
		},
		{
			occupationCode: "278",
			occupationDescription: "Secretary",
		},
		{
			occupationCode: "1880",
			occupationDescription: "Secretary and Shorthand",
		},
		{
			occupationCode: "889",
			occupationDescription: "Sector Head",
		},
		{
			occupationCode: "2000",
			occupationDescription: "Securities Broker",
		},
		{
			occupationCode: "1850",
			occupationDescription: "Securities Technician",
		},
		{
			occupationCode: "566",
			occupationDescription: "Security man",
		},
		{
			occupationCode: "2114",
			occupationDescription: "Seedlings Seller",
		},
		{
			occupationCode: "2113",
			occupationDescription: "Seeds and fertilizer Seller",
		},
		{
			occupationCode: "10",
			occupationDescription: "Self Employed",
		},
		{
			occupationCode: "322",
			occupationDescription: "Seller",
		},
		{
			occupationCode: "2004",
			occupationDescription: "Selling and renting Broker",
		},
		{
			occupationCode: "2705",
			occupationDescription: "Separation machine Worker",
		},
		{
			occupationCode: "1717",
			occupationDescription: "Sewage Treatment station Technician",
		},
		{
			occupationCode: "3178",
			occupationDescription: "Sewage cleaning Worker",
		},
		{
			occupationCode: "1716",
			occupationDescription: "Sewage network technician",
		},
		{
			occupationCode: "2513",
			occupationDescription: "Sewing machine Operator",
		},
		{
			occupationCode: "3565",
			occupationDescription: "Sewing machines assembling worker",
		},
		{
			occupationCode: "2638",
			occupationDescription: "Shaker Operator",
		},
		{
			occupationCode: "3061",
			occupationDescription: "Shaping Worker",
		},
		{
			occupationCode: "1940",
			occupationDescription: "Shares and securities Clerk",
		},
		{
			occupationCode: "2137",
			occupationDescription: "Shawarmah Broiler",
		},
		{
			occupationCode: "403",
			occupationDescription: "Shawerma Master",
		},
		{
			occupationCode: "2277",
			occupationDescription: "Sheep Breeder",
		},
		{
			occupationCode: "188",
			occupationDescription: "Shift Supervisor",
		},
		{
			occupationCode: "3371",
			occupationDescription: "Ship Assistant Electrician",
		},
		{
			occupationCode: "3450",
			occupationDescription: "Ship Carpenter",
		},
		{
			occupationCode: "3370",
			occupationDescription: "Ship Electrician",
		},
		{
			occupationCode: "3226",
			occupationDescription: "Ship Engine operator",
		},
		{
			occupationCode: "111",
			occupationDescription: "Ship Engineer",
		},
		{
			occupationCode: "2162",
			occupationDescription: "Ship Host",
		},
		{
			occupationCode: "3271",
			occupationDescription: "Ship Mechanic or general",
		},
		{
			occupationCode: "2217",
			occupationDescription: "Ship Mooring Man",
		},
		{
			occupationCode: "1128",
			occupationDescription: "Ship Pilot",
		},
		{
			occupationCode: "1921",
			occupationDescription: "Ship Radio Operator",
		},
		{
			occupationCode: "3272",
			occupationDescription: "Ship engine Mechanic",
		},
		{
			occupationCode: "3278",
			occupationDescription: "Ship operation Worker",
		},
		{
			occupationCode: "3459",
			occupationDescription: "Ship painter",
		},
		{
			occupationCode: "1140",
			occupationDescription: "Ship passenger Captain",
		},
		{
			occupationCode: "2981",
			occupationDescription: "Ship pipes installation Worker",
		},
		{
			occupationCode: "3273",
			occupationDescription: "Ship propulsion Mechanic",
		},
		{
			occupationCode: "1745",
			occupationDescription: "Ship traffic Overseer",
		},
		{
			occupationCode: "2003",
			occupationDescription: "Shipping Risk Insurance Broker",
		},
		{
			occupationCode: "1054",
			occupationDescription: "Ships Maintenance Engineer",
		},
		{
			occupationCode: "1678",
			occupationDescription: "Ships engines Maintenance Technician",
		},
		{
			occupationCode: "2396",
			occupationDescription: "Shoe Burnisher",
		},
		{
			occupationCode: "2397",
			occupationDescription: "Shoe Face Finishing Worker",
		},
		{
			occupationCode: "2395",
			occupationDescription: "Shoe Hand Tailor",
		},
		{
			occupationCode: "2387",
			occupationDescription: "Shoe Manual Cutter",
		},
		{
			occupationCode: "2393",
			occupationDescription: "Shoe Tree Maker",
		},
		{
			occupationCode: "2388",
			occupationDescription: "Shoe clicker Machine Operator",
		},
		{
			occupationCode: "432",
			occupationDescription: "Shoe fixer",
		},
		{
			occupationCode: "2386",
			occupationDescription: "Shoe models maker",
		},
		{
			occupationCode: "2037",
			occupationDescription: "Shoe seller",
		},
		{
			occupationCode: "2184",
			occupationDescription: "Shoeblack",
		},
		{
			occupationCode: "2394",
			occupationDescription: "Shoes Tailor",
		},
		{
			occupationCode: "279",
			occupationDescription: "Shorthand",
		},
		{
			occupationCode: "1894",
			occupationDescription: "Shorthand and Typist",
		},
		{
			occupationCode: "1457",
			occupationDescription: "Show Designer",
		},
		{
			occupationCode: "3570",
			occupationDescription: "Show equipment assembling worker",
		},
		{
			occupationCode: "1270",
			occupationDescription: "Sigh checking Specialist",
		},
		{
			occupationCode: "3555",
			occupationDescription: "Sign Painter",
		},
		{
			occupationCode: "3202",
			occupationDescription: "Signal worker",
		},
		{
			occupationCode: "1615",
			occupationDescription: "Signed art digital aerial survey",
		},
		{
			occupationCode: "2444",
			occupationDescription: "Silk gum Remover",
		},
		{
			occupationCode: "2303",
			occupationDescription: "Silkworm breeder",
		},
		{
			occupationCode: "3115",
			occupationDescription: "Silver jewellery Silversmith",
		},
		{
			occupationCode: "2053",
			occupationDescription: "Silver jewellery seller",
		},
		{
			occupationCode: "238",
			occupationDescription: "Singer",
		},
		{
			occupationCode: "990",
			occupationDescription: "Site Engineer",
		},
		{
			occupationCode: "1129",
			occupationDescription: "Skilled sailor",
		},
		{
			occupationCode: "2898",
			occupationDescription: "Slaughtered Poultry Bowels Cleaning Worker",
		},
		{
			occupationCode: "2897",
			occupationDescription: "Slaughtered cattle Bowels Cleaning Worker",
		},
		{
			occupationCode: "3196",
			occupationDescription: "Small Truck driver",
		},
		{
			occupationCode: "3322",
			occupationDescription: "Small plant Electro or Mechanic",
		},
		{
			occupationCode: "376",
			occupationDescription: "Smelter Worker",
		},
		{
			occupationCode: "2929",
			occupationDescription: "Smithery Press Operator",
		},
		{
			occupationCode: "2743",
			occupationDescription: "Soap Packing Machine operator",
		},
		{
			occupationCode: "1321",
			occupationDescription: "Social Care Specialist",
		},
		{
			occupationCode: "1933",
			occupationDescription: "Social Insurance Fees",
		},
		{
			occupationCode: "1314",
			occupationDescription: "Social Psychiatry Specialist",
		},
		{
			occupationCode: "260",
			occupationDescription: "Social Supervisor",
		},
		{
			occupationCode: "1817",
			occupationDescription: "Social Teacher",
		},
		{
			occupationCode: "1326",
			occupationDescription: "Social and demographic Instructor",
		},
		{
			occupationCode: "259",
			occupationDescription: "Social officer",
		},
		{
			occupationCode: "1805",
			occupationDescription: "Social search Technician",
		},
		{
			occupationCode: "1320",
			occupationDescription: "Social service Specialist",
		},
		{
			occupationCode: "1806",
			occupationDescription: "Social service Technician",
		},
		{
			occupationCode: "2023",
			occupationDescription: "Soft drinks seller",
		},
		{
			occupationCode: "1005",
			occupationDescription: "Soil Engineer",
		},
		{
			occupationCode: "1605",
			occupationDescription: "Soil Mechanics Laboratory Technician",
		},
		{
			occupationCode: "1114",
			occupationDescription: "Soil science specialist",
		},
		{
			occupationCode: "3092",
			occupationDescription: "Soldering Welder",
		},
		{
			occupationCode: "2398",
			occupationDescription: "Sole Cutter",
		},
		{
			occupationCode: "2400",
			occupationDescription: "Sole Installer",
		},
		{
			occupationCode: "2399",
			occupationDescription: "Sole preparation worker",
		},
		{
			occupationCode: "570",
			occupationDescription: "Son",
		},
		{
			occupationCode: "617",
			occupationDescription: "Son Muharem",
		},
		{
			occupationCode: "914",
			occupationDescription: "Sound Physicist",
		},
		{
			occupationCode: "223",
			occupationDescription: "Special Education Teacher",
		},
		{
			occupationCode: "1429",
			occupationDescription: "Special Educational Specialist",
		},
		{
			occupationCode: "2231",
			occupationDescription: "Special Teacher",
		},
		{
			occupationCode: "165",
			occupationDescription: "Specialist",
		},
		{
			occupationCode: "140",
			occupationDescription: "Specialist First Physician",
		},
		{
			occupationCode: "201",
			occupationDescription: "Specialist Mathematics",
		},
		{
			occupationCode: "1436",
			occupationDescription: "Specialist Reader (Reciter)",
		},
		{
			occupationCode: "146",
			occupationDescription: "Specialist Second Physician",
		},
		{
			occupationCode: "200",
			occupationDescription: "Specialist Statistics",
		},
		{
			occupationCode: "1757",
			occupationDescription: "Specialized Nurse",
		},
		{
			occupationCode: "2832",
			occupationDescription: "Spices Grinder",
		},
		{
			occupationCode: "2429",
			occupationDescription: "Spin yarn treatment Worker",
		},
		{
			occupationCode: "1753",
			occupationDescription: "Spinal series Orthopaedic Technician",
		},
		{
			occupationCode: "2424",
			occupationDescription: "Spinner",
		},
		{
			occupationCode: "3130",
			occupationDescription: "Spinning machines Maintenance mechanic",
		},
		{
			occupationCode: "3563",
			occupationDescription: "Spinning machines assembling worker",
		},
		{
			occupationCode: "393",
			occupationDescription: "Spinning worker",
		},
		{
			occupationCode: "2072",
			occupationDescription: "Sports clothing seller",
		},
		{
			occupationCode: "1514",
			occupationDescription: "Sports commentator",
		},
		{
			occupationCode: "2073",
			occupationDescription: "Sports equipment Seller",
		},
		{
			occupationCode: "1172",
			occupationDescription: "Sports medicine Physician",
		},
		{
			occupationCode: "1208",
			occupationDescription: "Sports medicine consultant",
		},
		{
			occupationCode: "3461",
			occupationDescription: "Spray painter (except construction)",
		},
		{
			occupationCode: "3068",
			occupationDescription: "Spraying machine preparation Worker",
		},
		{
			occupationCode: "3260",
			occupationDescription: "Spring Blacksmith",
		},
		{
			occupationCode: "1382",
			occupationDescription: "Staff Member",
		},
		{
			occupationCode: "2657",
			occupationDescription: "Stainless Steel Rolling worker",
		},
		{
			occupationCode: "550",
			occupationDescription: "Stationary machines operator",
		},
		{
			occupationCode: "2075",
			occupationDescription: "Stationery seller",
		},
		{
			occupationCode: "1976",
			occupationDescription: "Statistical Clerk",
		},
		{
			occupationCode: "1590",
			occupationDescription: "Statistical surveyor",
		},
		{
			occupationCode: "953",
			occupationDescription: "Statistician",
		},
		{
			occupationCode: "654",
			occupationDescription: "Statistics Affairs Director",
		},
		{
			occupationCode: "3291",
			occupationDescription: "Steam Turbine operator",
		},
		{
			occupationCode: "3294",
			occupationDescription: "Steam boiler Stoker",
		},
		{
			occupationCode: "3293",
			occupationDescription: "Steam generator operator",
		},
		{
			occupationCode: "3288",
			occupationDescription: "Steam turbine Mechanic",
		},
		{
			occupationCode: "3287",
			occupationDescription: "Steam turbine Mechanic  or general",
		},
		{
			occupationCode: "3290",
			occupationDescription: "Steam turbine Operation Supervisor",
		},
		{
			occupationCode: "3289",
			occupationDescription: "Steam turbine assistant Mechanic",
		},
		{
			occupationCode: "2645",
			occupationDescription: "Steel Furnace operator",
		},
		{
			occupationCode: "3050",
			occupationDescription: "Steel doors Blacksmith",
		},
		{
			occupationCode: "2956",
			occupationDescription: "Steel plate molding Worker",
		},
		{
			occupationCode: "3238",
			occupationDescription: "Steering gear Mechanic",
		},
		{
			occupationCode: "2323",
			occupationDescription: "Stem Peeling machine Operator",
		},
		{
			occupationCode: "2580",
			occupationDescription: "Stereotype model Worker",
		},
		{
			occupationCode: "130",
			occupationDescription: "Sterilization Technician",
		},
		{
			occupationCode: "1957",
			occupationDescription: "Stevedoring Clerk",
		},
		{
			occupationCode: "553",
			occupationDescription: "Stevedoring Worker",
		},
		{
			occupationCode: "1905",
			occupationDescription: "Stock controller",
		},
		{
			occupationCode: "2596",
			occupationDescription: "Stone Boring Worker",
		},
		{
			occupationCode: "2599",
			occupationDescription: "Stone Characters Engraver",
		},
		{
			occupationCode: "2597",
			occupationDescription: "Stone Classifying Worker",
		},
		{
			occupationCode: "2590",
			occupationDescription: "Stone Cutting and Polishing Worker",
		},
		{
			occupationCode: "2591",
			occupationDescription: "Stone Cutting and Sawing Worker",
		},
		{
			occupationCode: "2646",
			occupationDescription: "Stone Furnace operator",
		},
		{
			occupationCode: "2595",
			occupationDescription: "Stone Hand Polishing Worker",
		},
		{
			occupationCode: "2594",
			occupationDescription: "Stone Lathe operator",
		},
		{
			occupationCode: "2592",
			occupationDescription: "Stone and marble Polishing Machine operator",
		},
		{
			occupationCode: "3484",
			occupationDescription: "Stone carver",
		},
		{
			occupationCode: "2598",
			occupationDescription: "Stone designs Engraver",
		},
		{
			occupationCode: "3517",
			occupationDescription: "Stones carving worker",
		},
		{
			occupationCode: "3533",
			occupationDescription: "Stones cutting Machine operator",
		},
		{
			occupationCode: "3514",
			occupationDescription: "Stones design Transfer Worker",
		},
		{
			occupationCode: "437",
			occupationDescription: "Stones worker",
		},
		{
			occupationCode: "1901",
			occupationDescription: "Store Keeper",
		},
		{
			occupationCode: "782",
			occupationDescription: "Store Manager",
		},
		{
			occupationCode: "1903",
			occupationDescription: "Storeman",
		},
		{
			occupationCode: "1451",
			occupationDescription: "Story Narrator",
		},
		{
			occupationCode: "2815",
			occupationDescription: "Stringed instrument making Worker",
		},
		{
			occupationCode: "90",
			occupationDescription: "Strong electrical technician",
		},
		{
			occupationCode: "435",
			occupationDescription: "Structures worker",
		},
		{
			occupationCode: "5",
			occupationDescription: "Student",
		},
		{
			occupationCode: "1327",
			occupationDescription: "Student Leader",
		},
		{
			occupationCode: "1846",
			occupationDescription: "Studio Cameraman",
		},
		{
			occupationCode: "3423",
			occupationDescription: "Studio operation worker",
		},
		{
			occupationCode: "3392",
			occupationDescription: "Subscriber lines Installer",
		},
		{
			occupationCode: "1630",
			occupationDescription: "Subscribers services Electrician",
		},
		{
			occupationCode: "2862",
			occupationDescription: "Sugar Packaging Worker",
		},
		{
			occupationCode: "2857",
			occupationDescription: "Sugar carbonization Machine Operator",
		},
		{
			occupationCode: "2858",
			occupationDescription: "Sugar crystallization Machine Operator",
		},
		{
			occupationCode: "2860",
			occupationDescription: "Sugar drying Operator",
		},
		{
			occupationCode: "2854",
			occupationDescription: "Sugar manufacturing Worker",
		},
		{
			occupationCode: "2859",
			occupationDescription: "Sugar separation Machine Operator",
		},
		{
			occupationCode: "2855",
			occupationDescription: "Sugarcane press worker",
		},
		{
			occupationCode: "2014",
			occupationDescription: "Supplies Material Seller",
		},
		{
			occupationCode: "3543",
			occupationDescription: "Surface Cleaning worker",
		},
		{
			occupationCode: "141",
			occupationDescription: "Surgeon Specialist",
		},
		{
			occupationCode: "1280",
			occupationDescription: "Surgery Nursing Consultant",
		},
		{
			occupationCode: "2083",
			occupationDescription: "Surgery Tools Salesman",
		},
		{
			occupationCode: "3596",
			occupationDescription: "Surveillance devices assembling worker",
		},
		{
			occupationCode: "2058",
			occupationDescription: "Survey Equipment Salesman",
		},
		{
			occupationCode: "1009",
			occupationDescription: "Surveying Adjustment Networks Engineer",
		},
		{
			occupationCode: "3436",
			occupationDescription: "Surveying Machine operator",
		},
		{
			occupationCode: "1014",
			occupationDescription: "Surveyor Engineer (First)",
		},
		{
			occupationCode: "1616",
			occupationDescription: "Surveyor and Field Verifier",
		},
		{
			occupationCode: "2022",
			occupationDescription: "Sweets seller",
		},
		{
			occupationCode: "251",
			occupationDescription: "Swimming Coach",
		},
		{
			occupationCode: "1688",
			occupationDescription: "Swimming Pool Maintenance Technician",
		},
		{
			occupationCode: "2209",
			occupationDescription: "Swimming Rescure",
		},
		{
			occupationCode: "3203",
			occupationDescription: "Switchman",
		},
		{
			occupationCode: "2773",
			occupationDescription: "Synthetic fibre manufacturing Overseer",
		},
		{
			occupationCode: "2626",
			occupationDescription: "Synthetic stone Manufacture Worker",
		},
		{
			occupationCode: "3544",
			occupationDescription: "Synthetic stones manufacturing worker",
		},
		{
			occupationCode: "43",
			occupationDescription: "System technician",
		},
		{
			occupationCode: "203",
			occupationDescription: "Systems Analyst",
		},
		{
			occupationCode: "1648",
			occupationDescription: "T V Maintenance Technician",
		},
		{
			occupationCode: "1645",
			occupationDescription: "TV Broadcast Technician",
		},
		{
			occupationCode: "3399",
			occupationDescription: "TV antenna Installer",
		},
		{
			occupationCode: "1510",
			occupationDescription: "TV cameraman",
		},
		{
			occupationCode: "3408",
			occupationDescription: "TV maintenance electronic Technician",
		},
		{
			occupationCode: "2040",
			occupationDescription: "Tablecloths and blankets Seller",
		},
		{
			occupationCode: "2807",
			occupationDescription: "Tablet Coating Unit Operator",
		},
		{
			occupationCode: "2809",
			occupationDescription: "Tablet packaging machine operator",
		},
		{
			occupationCode: "2808",
			occupationDescription: "Tablet player control device",
		},
		{
			occupationCode: "2804",
			occupationDescription: "Tablet press Operator",
		},
		{
			occupationCode: "2478",
			occupationDescription: "Tabriz Worker",
		},
		{
			occupationCode: "2890",
			occupationDescription: "Tahina Maker",
		},
		{
			occupationCode: "2070",
			occupationDescription: "Tapes Seller",
		},
		{
			occupationCode: "3195",
			occupationDescription: "Taxi driver",
		},
		{
			occupationCode: "2919",
			occupationDescription: "Tea Blender",
		},
		{
			occupationCode: "411",
			occupationDescription: "Tea Boy",
		},
		{
			occupationCode: "221",
			occupationDescription: "Teacher",
		},
		{
			occupationCode: "1390",
			occupationDescription: "Teaching aids Specialist",
		},
		{
			occupationCode: "1452",
			occupationDescription: "Technical Catalogue Manual Writer",
		},
		{
			occupationCode: "748",
			occupationDescription: "Technical Operation Manager",
		},
		{
			occupationCode: "1986",
			occupationDescription: "Technical Service Advisor",
		},
		{
			occupationCode: "558",
			occupationDescription: "Technical Worker",
		},
		{
			occupationCode: "96",
			occupationDescription: "Technician engines",
		},
		{
			occupationCode: "93",
			occupationDescription: "Telecom Engineering Technician",
		},
		{
			occupationCode: "666",
			occupationDescription: "Telephone Director",
		},
		{
			occupationCode: "493",
			occupationDescription: "Telephone Technician",
		},
		{
			occupationCode: "3411",
			occupationDescription: "Telephone and telegraph maintenance Worker",
		},
		{
			occupationCode: "3604",
			occupationDescription: "Telephone and teletype production Overseer",
		},
		{
			occupationCode: "3600",
			occupationDescription: "Telephone assembling worker",
		},
		{
			occupationCode: "1913",
			occupationDescription: "Telephone calls Clerk",
		},
		{
			occupationCode: "3406",
			occupationDescription: "Telephone maintenance electronic Technician",
		},
		{
			occupationCode: "3391",
			occupationDescription: "Telephone network Assistant Installer",
		},
		{
			occupationCode: "3405",
			occupationDescription: "Teletype maintenance electronic Technician",
		},
		{
			occupationCode: "282",
			occupationDescription: "Teletypist",
		},
		{
			occupationCode: "1503",
			occupationDescription: "Television and Radio Director",
		},
		{
			occupationCode: "3407",
			occupationDescription:
				"Television and radio maintenance electronic Technician",
		},
		{
			occupationCode: "1915",
			occupationDescription: "Telex Clerk",
		},
		{
			occupationCode: "286",
			occupationDescription: "Teller",
		},
		{
			occupationCode: "252",
			occupationDescription: "Tennis coach",
		},
		{
			occupationCode: "431",
			occupationDescription: "Tents tailor",
		},
		{
			occupationCode: "3432",
			occupationDescription: "Testaceous works Carpenter",
		},
		{
			occupationCode: "2533",
			occupationDescription: "Textile Printing Worker",
		},
		{
			occupationCode: "2401",
			occupationDescription: "Textile Shoe maker",
		},
		{
			occupationCode: "2487",
			occupationDescription: "Textile Tricot Worker",
		},
		{
			occupationCode: "2942",
			occupationDescription: "Textile combing machine sharpening Worker",
		},
		{
			occupationCode: "2476",
			occupationDescription: "Textile defect repair Worker",
		},
		{
			occupationCode: "3042",
			occupationDescription: "Textile filing mechanic",
		},
		{
			occupationCode: "3564",
			occupationDescription: "Textile machines assembling worker",
		},
		{
			occupationCode: "2029",
			occupationDescription: "Textiles and leather Seller",
		},
		{
			occupationCode: "1478",
			occupationDescription: "Theatre Costume supervisor",
		},
		{
			occupationCode: "690",
			occupationDescription: "Theatre Director",
		},
		{
			occupationCode: "3376",
			occupationDescription: "Theatre and Studio Electrician",
		},
		{
			occupationCode: "241",
			occupationDescription: "Theatre producer",
		},
		{
			occupationCode: "912",
			occupationDescription: "Therma Physicist",
		},
		{
			occupationCode: "1664",
			occupationDescription: "Thermal Parameter Technician",
		},
		{
			occupationCode: "15",
			occupationDescription: "Thermal Physicist",
		},
		{
			occupationCode: "542",
			occupationDescription: "Thermal insulation Worker",
		},
		{
			occupationCode: "2978",
			occupationDescription: "Thermal treatment laboratory Assistant Technical",
		},
		{
			occupationCode: "2948",
			occupationDescription: "Thin Metal plate molding Worker",
		},
		{
			occupationCode: "715",
			occupationDescription: "Third secretary",
		},
		{
			occupationCode: "2437",
			occupationDescription: "Threads Dye Worker",
		},
		{
			occupationCode: "1961",
			occupationDescription: "Ticket Inspector",
		},
		{
			occupationCode: "1954",
			occupationDescription: "Ticket Officer",
		},
		{
			occupationCode: "303",
			occupationDescription: "Tickets Collector",
		},
		{
			occupationCode: "2617",
			occupationDescription: "Tile Cutter Operator",
		},
		{
			occupationCode: "2618",
			occupationDescription: "Tile Furnace Operator",
		},
		{
			occupationCode: "2616",
			occupationDescription: "Tile Press Operator",
		},
		{
			occupationCode: "3488",
			occupationDescription: "Tile assistant builder",
		},
		{
			occupationCode: "3487",
			occupationDescription: "Tile builder",
		},
		{
			occupationCode: "512",
			occupationDescription: "Tile worker",
		},
		{
			occupationCode: "533",
			occupationDescription: "Tiler",
		},
		{
			occupationCode: "2613",
			occupationDescription: "Tiles Polisher Operator",
		},
		{
			occupationCode: "2335",
			occupationDescription: "Timber Sorter",
		},
		{
			occupationCode: "2087",
			occupationDescription: "Timber seller",
		},
		{
			occupationCode: "1099",
			occupationDescription: "Time and movement study Engineer",
		},
		{
			occupationCode: "3088",
			occupationDescription: "Tin Welder",
		},
		{
			occupationCode: "3011",
			occupationDescription: "Tin reel Operator",
		},
		{
			occupationCode: "3018",
			occupationDescription: "Tin shaping Lathe operator",
		},
		{
			occupationCode: "2951",
			occupationDescription: "Tin works molding worker",
		},
		{
			occupationCode: "3017",
			occupationDescription: "Tinsmith",
		},
		{
			occupationCode: "3047",
			occupationDescription: "Tool Supervisor",
		},
		{
			occupationCode: "3001",
			occupationDescription: "Tool and mold Maker",
		},
		{
			occupationCode: "3023",
			occupationDescription: "Tools maker",
		},
		{
			occupationCode: "807",
			occupationDescription: "Tour Agency Manager",
		},
		{
			occupationCode: "1985",
			occupationDescription: "Tourist Agent",
		},
		{
			occupationCode: "348",
			occupationDescription: "Tourist Guide",
		},
		{
			occupationCode: "1912",
			occupationDescription: "Tourist Service Clerk",
		},
		{
			occupationCode: "1950",
			occupationDescription: "Tourist booking Officer",
		},
		{
			occupationCode: "3214",
			occupationDescription: "Tower Crane Operator",
		},
		{
			occupationCode: "1304",
			occupationDescription: "Toxicologist",
		},
		{
			occupationCode: "1879",
			occupationDescription: "Tracking Writer",
		},
		{
			occupationCode: "3235",
			occupationDescription: "Tractor Mechanic",
		},
		{
			occupationCode: "1983",
			occupationDescription: "Trading Agent",
		},
		{
			occupationCode: "1004",
			occupationDescription: "Traffic Engineer",
		},
		{
			occupationCode: "1136",
			occupationDescription: "Trail Aviator",
		},
		{
			occupationCode: "3368",
			occupationDescription: "Train Assistant Electrician",
		},
		{
			occupationCode: "3201",
			occupationDescription: "Train Assistant driver",
		},
		{
			occupationCode: "3228",
			occupationDescription: "Train Brakeman",
		},
		{
			occupationCode: "3367",
			occupationDescription: "Train Electrician",
		},
		{
			occupationCode: "3200",
			occupationDescription: "Train driver",
		},
		{
			occupationCode: "3266",
			occupationDescription: "Train engine Mechanic",
		},
		{
			occupationCode: "1965",
			occupationDescription: "Train traffic warden",
		},
		{
			occupationCode: "614",
			occupationDescription: "Trainee",
		},
		{
			occupationCode: "1418",
			occupationDescription: "Training Adviser",
		},
		{
			occupationCode: "269",
			occupationDescription: "Training Manager",
		},
		{
			occupationCode: "1417",
			occupationDescription: "Training specialist",
		},
		{
			occupationCode: "1052",
			occupationDescription: "Trains Maintenance Engineer",
		},
		{
			occupationCode: "3348",
			occupationDescription: "Transformer equipping and installation worker",
		},
		{
			occupationCode: "1958",
			occupationDescription: "Transit service Officer",
		},
		{
			occupationCode: "262",
			occupationDescription: "Transtawuniyar",
		},
		{
			occupationCode: "1025",
			occupationDescription: "Transmission Engineer",
		},
		{
			occupationCode: "1024",
			occupationDescription: "Transmission and distribution Engineer",
		},
		{
			occupationCode: "3422",
			occupationDescription: "Transmitter operation Worker",
		},
		{
			occupationCode: "1964",
			occupationDescription: "Transport service Inspector",
		},
		{
			occupationCode: "781",
			occupationDescription: "Transportation Manager",
		},
		{
			occupationCode: "2405",
			occupationDescription: "Travel luggage Maker",
		},
		{
			occupationCode: "2024",
			occupationDescription: "Travelling seller",
		},
		{
			occupationCode: "2322",
			occupationDescription: "Tray saw operator",
		},
		{
			occupationCode: "285",
			occupationDescription: "Treasurer",
		},
		{
			occupationCode: "1887",
			occupationDescription: "Trial Writer / Verifier",
		},
		{
			occupationCode: "612",
			occupationDescription: "Tribe s Sheikh",
		},
		{
			occupationCode: "353",
			occupationDescription: "Tribes Members",
		},
		{
			occupationCode: "2475",
			occupationDescription: "Tricot machine operator",
		},
		{
			occupationCode: "2459",
			occupationDescription: "Tricot machine preparation Worker",
		},
		{
			occupationCode: "394",
			occupationDescription: "Tricot worker",
		},
		{
			occupationCode: "3113",
			occupationDescription: "Trinketry and jewellery Goldsmith",
		},
		{
			occupationCode: "2027",
			occupationDescription: "Trip supplies Seller",
		},
		{
			occupationCode: "1212",
			occupationDescription: "Tropical Medicine Consultant",
		},
		{
			occupationCode: "1176",
			occupationDescription: "Tropical Physician",
		},
		{
			occupationCode: "561",
			occupationDescription: "Truck Driver",
		},
		{
			occupationCode: "2629",
			occupationDescription: "Tunnel Pillars Installer",
		},
		{
			occupationCode: "3581",
			occupationDescription: "Turbine engines assembling worker",
		},
		{
			occupationCode: "3038",
			occupationDescription: "Turbine filing mechanic",
		},
		{
			occupationCode: "2416",
			occupationDescription: "Twisting Machine operator",
		},
		{
			occupationCode: "520",
			occupationDescription: "Typesetting worker",
		},
		{
			occupationCode: "281",
			occupationDescription: "Typist",
		},
		{
			occupationCode: "2737",
			occupationDescription: "Tyres Coarsening Machine operator",
		},
		{
			occupationCode: "2728",
			occupationDescription: "Tyres Examiner",
		},
		{
			occupationCode: "2722",
			occupationDescription: "Tyres clothing Operator",
		},
		{
			occupationCode: "2729",
			occupationDescription: "Tyres molding Worker",
		},
		{
			occupationCode: "624",
			occupationDescription: "Uncle",
		},
		{
			occupationCode: "623",
			occupationDescription: "Uncle Muharem",
		},
		{
			occupationCode: "630",
			occupationDescription: "Undersecretary",
		},
		{
			occupationCode: "2203",
			occupationDescription: "Undertaker",
		},
		{
			occupationCode: "6",
			occupationDescription: "Unemployed",
		},
		{
			occupationCode: "1381",
			occupationDescription: "University Professor",
		},
		{
			occupationCode: "157",
			occupationDescription: "Urologist",
		},
		{
			occupationCode: "175",
			occupationDescription: "Urology Consultant",
		},
		{
			occupationCode: "1227",
			occupationDescription: "Urology surgeon",
		},
		{
			occupationCode: "2104",
			occupationDescription: "Used spare parts Seller",
		},
		{
			occupationCode: "2738",
			occupationDescription: "Used tires packaging Worker",
		},
		{
			occupationCode: "321",
			occupationDescription: "Usher",
		},
		{
			occupationCode: "3104",
			occupationDescription: "Utensils Polisher",
		},
		{
			occupationCode: "832",
			occupationDescription: "Utilities Department Manager",
		},
		{
			occupationCode: "1545",
			occupationDescription: "Utility services supervisor",
		},
		{
			occupationCode: "1536",
			occupationDescription: "VEHICLES DAMAGE VALUER",
		},
		{
			occupationCode: "1155",
			occupationDescription: "Vascular surgeon",
		},
		{
			occupationCode: "1239",
			occupationDescription: "Vascular surgery Consultant",
		},
		{
			occupationCode: "2246",
			occupationDescription: "Vegetable Farmer",
		},
		{
			occupationCode: "2015",
			occupationDescription: "Vegetable and fruit seller",
		},
		{
			occupationCode: "1722",
			occupationDescription: "Vegetable cultivation Technician",
		},
		{
			occupationCode: "2885",
			occupationDescription: "Vegetable oil Manufacturing worker",
		},
		{
			occupationCode: "2888",
			occupationDescription: "Vegetable oil filtration Operator",
		},
		{
			occupationCode: "2889",
			occupationDescription: "Vegetable oil hydrogenation Operator",
		},
		{
			occupationCode: "2887",
			occupationDescription: "Vegetable oil press Operator",
		},
		{
			occupationCode: "2891",
			occupationDescription: "Vegetable oil remnants press Worker",
		},
		{
			occupationCode: "2881",
			occupationDescription: "Vegetables Packaging Worker",
		},
		{
			occupationCode: "2872",
			occupationDescription: "Vegetables and Fruits preparation Worker",
		},
		{
			occupationCode: "3252",
			occupationDescription: "Vehicle Assistant Tinner",
		},
		{
			occupationCode: "3254",
			occupationDescription: "Vehicle Painter",
		},
		{
			occupationCode: "3251",
			occupationDescription: "Vehicle Tinner",
		},
		{
			occupationCode: "3087",
			occupationDescription: "Vehicle Welder",
		},
		{
			occupationCode: "3250",
			occupationDescription: "Vehicle chassis Blacksmith",
		},
		{
			occupationCode: "2006",
			occupationDescription: "Vehicle insurance broker",
		},
		{
			occupationCode: "2106",
			occupationDescription: "Vehicle spare parts Storeman",
		},
		{
			occupationCode: "1050",
			occupationDescription: "Vehicles Engineer",
		},
		{
			occupationCode: "471",
			occupationDescription: "Vehicles Technician",
		},
		{
			occupationCode: "3576",
			occupationDescription: "Vehicles assembling worker",
		},
		{
			occupationCode: "2473",
			occupationDescription: "Velvet Loom Operator",
		},
		{
			occupationCode: "2334",
			occupationDescription: "Veneer Processing Machine Operator",
		},
		{
			occupationCode: "2333",
			occupationDescription: "Veneer Wood Manufacturing worker",
		},
		{
			occupationCode: "161",
			occupationDescription: "Venereologist",
		},
		{
			occupationCode: "183",
			occupationDescription: "Venereology Consultant",
		},
		{
			occupationCode: "3449",
			occupationDescription: "Vessel wooden fittings carpenter",
		},
		{
			occupationCode: "168",
			occupationDescription: "Vet",
		},
		{
			occupationCode: "2084",
			occupationDescription: "Veterinary medicine Equipment Salesman",
		},
		{
			occupationCode: "1789",
			occupationDescription: "Veterinary medicine technician",
		},
		{
			occupationCode: "1790",
			occupationDescription: "Veterinary nurse",
		},
		{
			occupationCode: "2665",
			occupationDescription: "Vibrating Excavator operator",
		},
		{
			occupationCode: "890",
			occupationDescription: "Vice President",
		},
		{
			occupationCode: "703",
			occupationDescription: "Vice or Consul",
		},
		{
			occupationCode: "2071",
			occupationDescription: "Video Seller",
		},
		{
			occupationCode: "2869",
			occupationDescription: "Vinegar maker",
		},
		{
			occupationCode: "1283",
			occupationDescription: "Vision checking Consultant",
		},
		{
			occupationCode: "1462",
			occupationDescription: "Visitors Guide",
		},
		{
			occupationCode: "1823",
			occupationDescription: "Vocational / Agricultural Instructor",
		},
		{
			occupationCode: "1824",
			occupationDescription: "Vocational / Commerce Instructor",
		},
		{
			occupationCode: "1826",
			occupationDescription: "Vocational / Nursing Instructor",
		},
		{
			occupationCode: "1827",
			occupationDescription: "Vocational / Post Instructor",
		},
		{
			occupationCode: "1825",
			occupationDescription: "Vocational / hotel Instructor",
		},
		{
			occupationCode: "1822",
			occupationDescription: "Vocational / industrial Instructor",
		},
		{
			occupationCode: "1407",
			occupationDescription: "Vocational Analyst",
		},
		{
			occupationCode: "219",
			occupationDescription: "Vocational Teacher",
		},
		{
			occupationCode: "1782",
			occupationDescription: "Vocational rehabilitation Technician",
		},
		{
			occupationCode: "1568",
			occupationDescription: "Voice Laboratory Technician",
		},
		{
			occupationCode: "250",
			occupationDescription: "Volleyball Trainer",
		},
		{
			occupationCode: "1493",
			occupationDescription: "WEDDING PLATFORM DESIGNER",
		},
		{
			occupationCode: "331",
			occupationDescription: "Waiter",
		},
		{
			occupationCode: "3479",
			occupationDescription: "Wallpaper installer",
		},
		{
			occupationCode: "3475",
			occupationDescription: "Walls and Floors Carpenter",
		},
		{
			occupationCode: "307",
			occupationDescription: "Warehouseman",
		},
		{
			occupationCode: "2174",
			occupationDescription: "Washing and ironing Worker",
		},
		{
			occupationCode: "3138",
			occupationDescription: "Washing and ironing machines Mechanic",
		},
		{
			occupationCode: "3573",
			occupationDescription: "Washing machines assembling worker",
		},
		{
			occupationCode: "2814",
			occupationDescription: "Waste burning Worker",
		},
		{
			occupationCode: "2813",
			occupationDescription: "Waste treatment Operator",
		},
		{
			occupationCode: "458",
			occupationDescription: "Watch fixer",
		},
		{
			occupationCode: "2055",
			occupationDescription: "Watch seller",
		},
		{
			occupationCode: "924",
			occupationDescription: "Water Geologist",
		},
		{
			occupationCode: "3182",
			occupationDescription: "Water desalination machine operator",
		},
		{
			occupationCode: "3183",
			occupationDescription: "Water desalination plant operator",
		},
		{
			occupationCode: "926",
			occupationDescription: "Water expert",
		},
		{
			occupationCode: "1947",
			occupationDescription: "Water meter Reader",
		},
		{
			occupationCode: "2696",
			occupationDescription: "Water purification Control panel Overseer",
		},
		{
			occupationCode: "3222",
			occupationDescription: "Water tender Driver",
		},
		{
			occupationCode: "2673",
			occupationDescription: "Water wells Drilling Overseer",
		},
		{
			occupationCode: "1724",
			occupationDescription: "Watering Technician",
		},
		{
			occupationCode: "1793",
			occupationDescription: "Wave photography Technician",
		},
		{
			occupationCode: "2823",
			occupationDescription: "Wax maker",
		},
		{
			occupationCode: "2932",
			occupationDescription: "Weapons Blacksmith",
		},
		{
			occupationCode: "49",
			occupationDescription: "Weapons Specialist",
		},
		{
			occupationCode: "34",
			occupationDescription: "Weapons Technician",
		},
		{
			occupationCode: "1904",
			occupationDescription: "Weight worker",
		},
		{
			occupationCode: "500",
			occupationDescription: "Welder",
		},
		{
			occupationCode: "1661",
			occupationDescription: "Welding Examiner",
		},
		{
			occupationCode: "1657",
			occupationDescription: "Welding and tin Draftsman",
		},
		{
			occupationCode: "1046",
			occupationDescription: "Welding engineer",
		},
		{
			occupationCode: "1660",
			occupationDescription: "Welding technician",
		},
		{
			occupationCode: "1081",
			occupationDescription: "Well Digging Engineer",
		},
		{
			occupationCode: "368",
			occupationDescription: "Well drilling supervisor",
		},
		{
			occupationCode: "2850",
			occupationDescription: "Western confectionery maker",
		},
		{
			occupationCode: "2740",
			occupationDescription: "Wheels Inflating Worker",
		},
		{
			occupationCode: "2797",
			occupationDescription: "Whetting wheel molding Worker",
		},
		{
			occupationCode: "3230",
			occupationDescription: "Widow of a working locomotive Goods",
		},
		{
			occupationCode: "3220",
			occupationDescription: "Winch operator",
		},
		{
			occupationCode: "3589",
			occupationDescription: "Wire hand or winding worker",
		},
		{
			occupationCode: "3588",
			occupationDescription: "Wire machine or winding worker",
		},
		{
			occupationCode: "3401",
			occupationDescription: "Wireless mast Worker",
		},
		{
			occupationCode: "492",
			occupationDescription: "Wireless operation Technician",
		},
		{
			occupationCode: "2499",
			occupationDescription: "Women clothing Cutter",
		},
		{
			occupationCode: "419",
			occupationDescription: "Women s clothing tailor",
		},
		{
			occupationCode: "2035",
			occupationDescription: "Women s cloths seller",
		},
		{
			occupationCode: "3216",
			occupationDescription: "Wood Carrier Driver",
		},
		{
			occupationCode: "2340",
			occupationDescription: "Wood Cutting machine Worker",
		},
		{
			occupationCode: "2342",
			occupationDescription: "Wood Engraver",
		},
		{
			occupationCode: "2324",
			occupationDescription: "Wood Grinding machine operator",
		},
		{
			occupationCode: "2341",
			occupationDescription: "Wood Sawing Worker",
		},
		{
			occupationCode: "3434",
			occupationDescription: "Wood Turner",
		},
		{
			occupationCode: "3458",
			occupationDescription: "Wood assistant painter",
		},
		{
			occupationCode: "3043",
			occupationDescription: "Wood filing mechanic",
		},
		{
			occupationCode: "2343",
			occupationDescription: "Wood pulp mill operator",
		},
		{
			occupationCode: "2328",
			occupationDescription: "Wood treatment Worker",
		},
		{
			occupationCode: "382",
			occupationDescription: "Wood worker",
		},
		{
			occupationCode: "2270",
			occupationDescription: "Woodcutter",
		},
		{
			occupationCode: "3457",
			occupationDescription: "Wooden doors painter",
		},
		{
			occupationCode: "3456",
			occupationDescription: "Wooden furniture painter",
		},
		{
			occupationCode: "3453",
			occupationDescription: "Wooden platform installation worker",
		},
		{
			occupationCode: "2281",
			occupationDescription: "Wool Cutter",
		},
		{
			occupationCode: "2446",
			occupationDescription: "Wool textiles Treatment Worker",
		},
		{
			occupationCode: "1900",
			occupationDescription: "Working Hours Clerk",
		},
		{
			occupationCode: "436",
			occupationDescription: "Workshop worker",
		},
		{
			occupationCode: "3198",
			occupationDescription: "Yacht Captain",
		},
		{
			occupationCode: "2868",
			occupationDescription: "Yeast Packaging Worker etc.",
		},
		{
			occupationCode: "2864",
			occupationDescription: "Yeast fermentation Field Operator",
		},
		{
			occupationCode: "2917",
			occupationDescription: "Yogurt maker",
		},
		{
			occupationCode: "1809",
			occupationDescription: "Youth care Technician",
		},
		{
			occupationCode: "2198",
			occupationDescription: "Zmzmi (Zamzam Water Dispenser)",
		},
		{
			occupationCode: "192",
			occupationDescription: "accoucheur (midwife)",
		},
		{
			occupationCode: "2660",
			occupationDescription: "adjusting equipment operation Worker",
		},
		{
			occupationCode: "563",
			occupationDescription: "agricultural Driver",
		},
		{
			occupationCode: "1673",
			occupationDescription: "agricultural machinery Technical maintenance",
		},
		{
			occupationCode: "3332",
			occupationDescription: "air network Assistant electrician",
		},
		{
			occupationCode: "3330",
			occupationDescription: "air network Electrician",
		},
		{
			occupationCode: "3283",
			occupationDescription: "aircraft Service Mechanic",
		},
		{
			occupationCode: "3285",
			occupationDescription: "aircraft chassis Mechanic",
		},
		{
			occupationCode: "457",
			occupationDescription: "aircraft hulls Technician",
		},
		{
			occupationCode: "3279",
			occupationDescription: "aircraft turbo engine Mechanic",
		},
		{
			occupationCode: "80",
			occupationDescription: "architectural draftsman",
		},
		{
			occupationCode: "3476",
			occupationDescription: "artificial ceiling installer",
		},
		{
			occupationCode: "3550",
			occupationDescription: "asphalt mixture Overseer",
		},
		{
			occupationCode: "1575",
			occupationDescription: "astronomical Cartographer",
		},
		{
			occupationCode: "918",
			occupationDescription: "astronomy Physicist",
		},
		{
			occupationCode: "2485",
			occupationDescription: "automatic carpet Weaving Worker",
		},
		{
			occupationCode: "543",
			occupationDescription: "automotive glass Specialist",
		},
		{
			occupationCode: "1308",
			occupationDescription: "bacteria and drugs Specialist",
		},
		{
			occupationCode: "2355",
			occupationDescription: "bag making Machine operator",
		},
		{
			occupationCode: "2856",
			occupationDescription: "beet milling and press machine Operator",
		},
		{
			occupationCode: "3540",
			occupationDescription: "belt carrier operator",
		},
		{
			occupationCode: "524",
			occupationDescription: "binding worker",
		},
		{
			occupationCode: "3538",
			occupationDescription: "bitumen spreading Machine operator",
		},
		{
			occupationCode: "3274",
			occupationDescription: "boat Mechanic",
		},
		{
			occupationCode: "2560",
			occupationDescription: "book decoration Machine operator",
		},
		{
			occupationCode: "2064",
			occupationDescription: "books Seller",
		},
		{
			occupationCode: "3445",
			occupationDescription: "brick shed Carpenter",
		},
		{
			occupationCode: "1035",
			occupationDescription: "broadcast Engineer",
		},
		{
			occupationCode: "538",
			occupationDescription: "building Carpenter",
		},
		{
			occupationCode: "528",
			occupationDescription: "building Painter",
		},
		{
			occupationCode: "1972",
			occupationDescription: "bus Collector",
		},
		{
			occupationCode: "3233",
			occupationDescription: "bus and truck Mechanic",
		},
		{
			occupationCode: "1671",
			occupationDescription: "buses and trucks Technical maintenance",
		},
		{
			occupationCode: "616",
			occupationDescription: "business Visit",
		},
		{
			occupationCode: "2528",
			occupationDescription: "buttons Installation Worker",
		},
		{
			occupationCode: "3335",
			occupationDescription: "cable welding Assistant electrician",
		},
		{
			occupationCode: "1689",
			occupationDescription: "car examination Technician",
		},
		{
			occupationCode: "3244",
			occupationDescription: "car radiator Technician",
		},
		{
			occupationCode: "1141",
			occupationDescription: "cargo ship Captain",
		},
		{
			occupationCode: "2181",
			occupationDescription: "carpet cleaning Worker",
		},
		{
			occupationCode: "3141",
			occupationDescription: "carrier belt Welder",
		},
		{
			occupationCode: "779",
			occupationDescription: "catering site Manager",
		},
		{
			occupationCode: "370",
			occupationDescription: "catering supervisor",
		},
		{
			occupationCode: "1687",
			occupationDescription: "cation prevention Technician",
		},
		{
			occupationCode: "531",
			occupationDescription: "cement and gypsum products Worker",
		},
		{
			occupationCode: "3496",
			occupationDescription: "central concrete mixer operator",
		},
		{
			occupationCode: "3165",
			occupationDescription: "central cooling Equipment Mechanic",
		},
		{
			occupationCode: "2798",
			occupationDescription: "ceramics immersing Worker",
		},
		{
			occupationCode: "3535",
			occupationDescription: "channel drilling machine operation worker",
		},
		{
			occupationCode: "2146",
			occupationDescription: "chef on board",
		},
		{
			occupationCode: "568",
			occupationDescription: "citizen Wife",
		},
		{
			occupationCode: "2468",
			occupationDescription: "cloth fabric Worker",
		},
		{
			occupationCode: "426",
			occupationDescription: "clothes Cutter",
		},
		{
			occupationCode: "2172",
			occupationDescription: "clothes washing Machine Operator",
		},
		{
			occupationCode: "2456",
			occupationDescription: "clothing Dyeing Worker",
		},
		{
			occupationCode: "2661",
			occupationDescription: "cold Rolling metal worker",
		},
		{
			occupationCode: "2413",
			occupationDescription: "combing Machine operator",
		},
		{
			occupationCode: "57",
			occupationDescription: "communication Engineer",
		},
		{
			occupationCode: "494",
			occupationDescription: "communication equipment Technician",
		},
		{
			occupationCode: "1593",
			occupationDescription: "computer networks Technician",
		},
		{
			occupationCode: "288",
			occupationDescription: "computer operation technician",
		},
		{
			occupationCode: "3492",
			occupationDescription: "concrete metal mold installer",
		},
		{
			occupationCode: "3539",
			occupationDescription: "concrete mixing unit Operator",
		},
		{
			occupationCode: "3501",
			occupationDescription: "concrete structures installer",
		},
		{
			occupationCode: "324",
			occupationDescription: "conductor",
		},
		{
			occupationCode: "2098",
			occupationDescription: "construction Mechanisms Seller",
		},
		{
			occupationCode: "1606",
			occupationDescription: "construction materials Laboratory Technician",
		},
		{
			occupationCode: "2085",
			occupationDescription: "construction materials Seller",
		},
		{
			occupationCode: "3361",
			occupationDescription: "control device Maintenance Electrician",
		},
		{
			occupationCode: "476",
			occupationDescription: "control devices Electrician",
		},
		{
			occupationCode: "3350",
			occupationDescription: "control switches equipping worker",
		},
		{
			occupationCode: "3329",
			occupationDescription: "control switches maintenance Electrician",
		},
		{
			occupationCode: "2700",
			occupationDescription: "cooking machine Worker",
		},
		{
			occupationCode: "551",
			occupationDescription: "cooling device operator",
		},
		{
			occupationCode: "3572",
			occupationDescription: "cooling equipment assembling worker",
		},
		{
			occupationCode: "555",
			occupationDescription: "crane operator",
		},
		{
			occupationCode: "1561",
			occupationDescription: "crude oil Laboratory Technician",
		},
		{
			occupationCode: "3467",
			occupationDescription: "curtains Upholsterer",
		},
		{
			occupationCode: "3477",
			occupationDescription: "curtains installer",
		},
		{
			occupationCode: "2200",
			occupationDescription: "dead Washer",
		},
		{
			occupationCode: "526",
			occupationDescription: "developing and printing worker",
		},
		{
			occupationCode: "1026",
			occupationDescription: "distribution Engineer",
		},
		{
			occupationCode: "3334",
			occupationDescription: "distribution cable Electrician",
		},
		{
			occupationCode: "3331",
			occupationDescription: "distribution network Electrician",
		},
		{
			occupationCode: "2347",
			occupationDescription: "dough crumbling Machine operator",
		},
		{
			occupationCode: "2801",
			occupationDescription: "dough hand press Worker",
		},
		{
			occupationCode: "2794",
			occupationDescription: "dough sifting Worker",
		},
		{
			occupationCode: "81",
			occupationDescription: "draftsman",
		},
		{
			occupationCode: "308",
			occupationDescription: "drawing Technician",
		},
		{
			occupationCode: "3500",
			occupationDescription: "driller compressor operator",
		},
		{
			occupationCode: "3534",
			occupationDescription: "drilling machine operation worker",
		},
		{
			occupationCode: "2443",
			occupationDescription: "dyes Preparator",
		},
		{
			occupationCode: "3385",
			occupationDescription: "electrical connection Supervisor",
		},
		{
			occupationCode: "3384",
			occupationDescription: "electrical load distribution Operator",
		},
		{
			occupationCode: "3100",
			occupationDescription: "electrical metal painting Worker",
		},
		{
			occupationCode: "3586",
			occupationDescription: "electrical switches assembling worker",
		},
		{
			occupationCode: "3386",
			occupationDescription: "electricity industry Production Supervisor",
		},
		{
			occupationCode: "3344",
			occupationDescription: "electricity meter Electrician",
		},
		{
			occupationCode: "1569",
			occupationDescription: "electromagnetic Laboratory Technician",
		},
		{
			occupationCode: "3603",
			occupationDescription: "electronic Production and repair Overseer",
		},
		{
			occupationCode: "3598",
			occupationDescription: "electronic exchanges assembling worker",
		},
		{
			occupationCode: "3249",
			occupationDescription: "engine cylinder Turner",
		},
		{
			occupationCode: "559",
			occupationDescription: "equipment Driver",
		},
		{
			occupationCode: "2477",
			occupationDescription: "fabrics Examiner",
		},
		{
			occupationCode: "2412",
			occupationDescription: "fibre Cleaning machine operator",
		},
		{
			occupationCode: "2433",
			occupationDescription: "fibre combing worker",
		},
		{
			occupationCode: "2430",
			occupationDescription: "fibre sorting and classifying worker",
		},
		{
			occupationCode: "2423",
			occupationDescription: "fibres Sorter",
		},
		{
			occupationCode: "1720",
			occupationDescription: "field crops",
		},
		{
			occupationCode: "2704",
			occupationDescription: "filtration Drum operation Worker",
		},
		{
			occupationCode: "2703",
			occupationDescription: "filtration press operation Worker",
		},
		{
			occupationCode: "2494",
			occupationDescription: "fishing net hand weaving worker",
		},
		{
			occupationCode: "2493",
			occupationDescription: "fishing net machine weaving worker",
		},
		{
			occupationCode: "1700",
			occupationDescription: "food industries Technician",
		},
		{
			occupationCode: "1117",
			occupationDescription: "forests and pastureland Specialist",
		},
		{
			occupationCode: "537",
			occupationDescription: "furniture Carpenter",
		},
		{
			occupationCode: "529",
			occupationDescription: "furniture Painter",
		},
		{
			occupationCode: "429",
			occupationDescription: "furniture Upholsterer",
		},
		{
			occupationCode: "424",
			occupationDescription: "furniture tailor",
		},
		{
			occupationCode: "3297",
			occupationDescription: "gas compressor operator",
		},
		{
			occupationCode: "3298",
			occupationDescription: "gas turbine Assistant Mechanic",
		},
		{
			occupationCode: "3299",
			occupationDescription: "gas turbine operator",
		},
		{
			occupationCode: "1683",
			occupationDescription: "gas turbines Technician",
		},
		{
			occupationCode: "1609",
			occupationDescription: "general Surveyor",
		},
		{
			occupationCode: "2764",
			occupationDescription: "glass composition furnace operator",
		},
		{
			occupationCode: "2768",
			occupationDescription: "glass equipment blowing Worker",
		},
		{
			occupationCode: "2771",
			occupationDescription: "glass tube tucking Worker",
		},
		{
			occupationCode: "3333",
			occupationDescription: "ground cable Electrician",
		},
		{
			occupationCode: "2481",
			occupationDescription: "hand or embroidered Textile Preparation Worker",
		},
		{
			occupationCode: "1675",
			occupationDescription: "helicopter Maintenance Technician",
		},
		{
			occupationCode: "3347",
			occupationDescription: "high voltage electricity lines Electrician",
		},
		{
			occupationCode: "3575",
			occupationDescription: "household appliances manufacturing Overseer",
		},
		{
			occupationCode: "1680",
			occupationDescription: "hydraulic fluids Technician",
		},
		{
			occupationCode: "3353",
			occupationDescription: "industrial laying out Electrician",
		},
		{
			occupationCode: "636",
			occupationDescription: "industrial relations Manager",
		},
		{
			occupationCode: "2812",
			occupationDescription: "injection production unit Operator",
		},
		{
			occupationCode: "177",
			occupationDescription: "internal medicine Consultant",
		},
		{
			occupationCode: "3318",
			occupationDescription: "irrigation and sprinkling Assistant Mechanic",
		},
		{
			occupationCode: "3317",
			occupationDescription: "irrigation and sprinkling equipment Mechanic",
		},
		{
			occupationCode: "229",
			occupationDescription: "journalist",
		},
		{
			occupationCode: "2883",
			occupationDescription: "juice Manufacturing worker",
		},
		{
			occupationCode: "399",
			occupationDescription: "juice Worker",
		},
		{
			occupationCode: "2884",
			occupationDescription: "juice drinks preparator",
		},
		{
			occupationCode: "2426",
			occupationDescription: "jute yarn smoothing Machine operator",
		},
		{
			occupationCode: "2226",
			occupationDescription: "labeling Worker",
		},
		{
			occupationCode: "143",
			occupationDescription: "laboratory Specialist",
		},
		{
			occupationCode: "297",
			occupationDescription: "labour Forman",
		},
		{
			occupationCode: "1674",
			occupationDescription: "lathe engines Technician",
		},
		{
			occupationCode: "342",
			occupationDescription: "launder",
		},
		{
			occupationCode: "1631",
			occupationDescription: "laying out Electrician",
		},
		{
			occupationCode: "3351",
			occupationDescription: "laying out Electrician  or  general",
		},
		{
			occupationCode: "3354",
			occupationDescription: "laying out assistance Electrician",
		},
		{
			occupationCode: "1430",
			occupationDescription: "learning Difficulties Specialist",
		},
		{
			occupationCode: "2374",
			occupationDescription: "leather Acidifying Worker",
		},
		{
			occupationCode: "2378",
			occupationDescription: "leather Drying oven Operator",
		},
		{
			occupationCode: "2375",
			occupationDescription: "leather Preparation Worker",
		},
		{
			occupationCode: "2407",
			occupationDescription: "leather Tailing Worker",
		},
		{
			occupationCode: "2377",
			occupationDescription: "leather dyeing Worker",
		},
		{
			occupationCode: "2368",
			occupationDescription: "leather machine Barber",
		},
		{
			occupationCode: "2371",
			occupationDescription: "leather pulling and ironing machine operator",
		},
		{
			occupationCode: "2402",
			occupationDescription: "leather shoe Repairer",
		},
		{
			occupationCode: "2757",
			occupationDescription: "lenses Polisher",
		},
		{
			occupationCode: "2758",
			occupationDescription: "lenses molding Worker",
		},
		{
			occupationCode: "2756",
			occupationDescription: "lenses whetting Worker",
		},
		{
			occupationCode: "913",
			occupationDescription: "light Physicist",
		},
		{
			occupationCode: "1567",
			occupationDescription: "light and optics Laboratory Technician",
		},
		{
			occupationCode: "1670",
			occupationDescription: "light vehicles Maintenance Technician",
		},
		{
			occupationCode: "2372",
			occupationDescription: "lime Machine remover",
		},
		{
			occupationCode: "296",
			occupationDescription: "lines Overseer",
		},
		{
			occupationCode: "2584",
			occupationDescription: "lithograph Copying Worker",
		},
		{
			occupationCode: "2549",
			occupationDescription: "lithography machine Worker",
		},
		{
			occupationCode: "2581",
			occupationDescription: "lithography stone engraving Worker",
		},
		{
			occupationCode: "1119",
			occupationDescription: "livestock Specialist",
		},
		{
			occupationCode: "1731",
			occupationDescription: "livestock breeding Technician",
		},
		{
			occupationCode: "3209",
			occupationDescription: "loading machinery Operator",
		},
		{
			occupationCode: "1679",
			occupationDescription: "locomotives Maintenance Technician",
		},
		{
			occupationCode: "3425",
			occupationDescription: "loudspeaker operation worker",
		},
		{
			occupationCode: "3276",
			occupationDescription: "lubrication ship Worker",
		},
		{
			occupationCode: "3110",
			occupationDescription: "manual inundation Painter",
		},
		{
			occupationCode: "3069",
			occupationDescription: "manual wire pulling Worker",
		},
		{
			occupationCode: "2337",
			occupationDescription: "matches Manufacturing worker",
		},
		{
			occupationCode: "3469",
			occupationDescription: "mattress manufacturing worker",
		},
		{
			occupationCode: "3346",
			occupationDescription: "measuring device Electrician",
		},
		{
			occupationCode: "3070",
			occupationDescription: "mechanical wire pulling Worker",
		},
		{
			occupationCode: "2810",
			occupationDescription: "medicines production unit Operator",
		},
		{
			occupationCode: "2977",
			occupationDescription: "melting furnace Assistant Operator",
		},
		{
			occupationCode: "3106",
			occupationDescription: "metal cleansing worker",
		},
		{
			occupationCode: "100",
			occupationDescription: "metals Technician",
		},
		{
			occupationCode: "3567",
			occupationDescription: "micro machines assembling worker",
		},
		{
			occupationCode: "587",
			occupationDescription: "military Instructor",
		},
		{
			occupationCode: "588",
			occupationDescription: "military equipment Instructor",
		},
		{
			occupationCode: "1702",
			occupationDescription: "mines Technician",
		},
		{
			occupationCode: "2699",
			occupationDescription: "mixing and blending machine worker",
		},
		{
			occupationCode: "2445",
			occupationDescription: "moisturizing Machine Operator",
		},
		{
			occupationCode: "3325",
			occupationDescription: "monitoring and control panel Electrician",
		},
		{
			occupationCode: "3509",
			occupationDescription: "mosaics installer",
		},
		{
			occupationCode: "2718",
			occupationDescription: "mould press operator",
		},
		{
			occupationCode: "525",
			occupationDescription: "neon Technician",
		},
		{
			occupationCode: "2658",
			occupationDescription: "non or ferrous metals Rolling worker",
		},
		{
			occupationCode: "1137",
			occupationDescription: "non or transportation general Aviator",
		},
		{
			occupationCode: "3148",
			occupationDescription: "office machines maintenance Mechanic",
		},
		{
			occupationCode: "2686",
			occupationDescription: "oil Mixing worker",
		},
		{
			occupationCode: "1704",
			occupationDescription: "oil Technician",
		},
		{
			occupationCode: "2666",
			occupationDescription: "oil and gas wells lining Worker",
		},
		{
			occupationCode: "1074",
			occupationDescription: "oil industry Engineer",
		},
		{
			occupationCode: "2811",
			occupationDescription: "ointments production unit Operator",
		},
		{
			occupationCode: "3561",
			occupationDescription: "operation Machines assembling worker",
		},
		{
			occupationCode: "202",
			occupationDescription: "operations Analyst",
		},
		{
			occupationCode: "1729",
			occupationDescription: "ornament Plant Technician",
		},
		{
			occupationCode: "1733",
			occupationDescription: "ornamental bird breeding Technician",
		},
		{
			occupationCode: "3530",
			occupationDescription: "ornamental painter",
		},
		{
			occupationCode: "461",
			occupationDescription: "orthodontic technician",
		},
		{
			occupationCode: "3472",
			occupationDescription: "painting frames installer",
		},
		{
			occupationCode: "2381",
			occupationDescription: "painting leather unit Operator",
		},
		{
			occupationCode: "2048",
			occupationDescription: "paintings Seller",
		},
		{
			occupationCode: "3349",
			occupationDescription: "panel installation and maintenance Electrician",
		},
		{
			occupationCode: "2345",
			occupationDescription: "paper Cutting caldron operator",
		},
		{
			occupationCode: "2364",
			occupationDescription: "paper Folding worker",
		},
		{
			occupationCode: "2352",
			occupationDescription: "paper Painting machine operator",
		},
		{
			occupationCode: "2354",
			occupationDescription: "paper box making Machine operator",
		},
		{
			occupationCode: "518",
			occupationDescription: "paper industry worker",
		},
		{
			occupationCode: "2357",
			occupationDescription: "paper or making machine worker",
		},
		{
			occupationCode: "2362",
			occupationDescription: "paper production industry Supervisor",
		},
		{
			occupationCode: "383",
			occupationDescription: "paper worker",
		},
		{
			occupationCode: "3536",
			occupationDescription: "paving roads Machine operator",
		},
		{
			occupationCode: "3150",
			occupationDescription: "photocopiers maintenance mechanic",
		},
		{
			occupationCode: "28",
			occupationDescription: "photographer",
		},
		{
			occupationCode: "1265",
			occupationDescription: "physiotherapist",
		},
		{
			occupationCode: "2451",
			occupationDescription: "pile burning Worker",
		},
		{
			occupationCode: "3554",
			occupationDescription: "pillars Installer",
		},
		{
			occupationCode: "227",
			occupationDescription: "pilot",
		},
		{
			occupationCode: "364",
			occupationDescription: "pisciculture man",
		},
		{
			occupationCode: "3327",
			occupationDescription: "plant maintenance Electrician",
		},
		{
			occupationCode: "3326",
			occupationDescription: "plant maintenance Electrician  or  general",
		},
		{
			occupationCode: "3324",
			occupationDescription: "plant operation Electrician",
		},
		{
			occupationCode: "3323",
			occupationDescription: "plant operation Electrician  or  general",
		},
		{
			occupationCode: "1483",
			occupationDescription: "plastic arts Painter",
		},
		{
			occupationCode: "1490",
			occupationDescription: "plastic arts critic",
		},
		{
			occupationCode: "2732",
			occupationDescription: "plastic injection machine worker",
		},
		{
			occupationCode: "2721",
			occupationDescription: "plastic molding machine worker",
		},
		{
			occupationCode: "2735",
			occupationDescription: "plastic products Assembling Worker",
		},
		{
			occupationCode: "2736",
			occupationDescription: "plastic products Installation Worker",
		},
		{
			occupationCode: "516",
			occupationDescription: "plastic products Technician",
		},
		{
			occupationCode: "2392",
			occupationDescription: "plastic shoes Maker",
		},
		{
			occupationCode: "2717",
			occupationDescription: "plastics Extrusion machine operator",
		},
		{
			occupationCode: "440",
			occupationDescription: "plates Blacksmith",
		},
		{
			occupationCode: "3012",
			occupationDescription: "plates shaping Lathe operator",
		},
		{
			occupationCode: "3067",
			occupationDescription: "polishing machine preparation Worker",
		},
		{
			occupationCode: "2505",
			occupationDescription: "popular clothes tailor",
		},
		{
			occupationCode: "302",
			occupationDescription: "postal services supervisor",
		},
		{
			occupationCode: "2802",
			occupationDescription: "pottery decoration Worker",
		},
		{
			occupationCode: "734",
			occupationDescription: "poultry Ranch Manage",
		},
		{
			occupationCode: "417",
			occupationDescription: "poultry Slaughtering worker",
		},
		{
			occupationCode: "1120",
			occupationDescription: "poultry Specialist",
		},
		{
			occupationCode: "2803",
			occupationDescription: "powder Preparation Unit operator",
		},
		{
			occupationCode: "1625",
			occupationDescription: "power plants Technician",
		},
		{
			occupationCode: "1624",
			occupationDescription: "power plants and installation Technician",
		},
		{
			occupationCode: "3119",
			occupationDescription: "precious metal ornamentation Goldsmith",
		},
		{
			occupationCode: "2578",
			occupationDescription: "preparation Worker",
		},
		{
			occupationCode: "3421",
			occupationDescription: "preparation and installation Worker",
		},
		{
			occupationCode: "3566",
			occupationDescription: "press machines assembling worker",
		},
		{
			occupationCode: "519",
			occupationDescription: "printing worker",
		},
		{
			occupationCode: "1659",
			occupationDescription: "production mechanic Technician",
		},
		{
			occupationCode: "1845",
			occupationDescription: "products Designer",
		},
		{
			occupationCode: "2892",
			occupationDescription: "products and oils Packing Worker",
		},
		{
			occupationCode: "1515",
			occupationDescription: "professional athlete",
		},
		{
			occupationCode: "1523",
			occupationDescription: "professional soccer player",
		},
		{
			occupationCode: "3415",
			occupationDescription:
				"programmed machines maintenance electronic Technician",
		},
		{
			occupationCode: "204",
			occupationDescription: "projects Analyst",
		},
		{
			occupationCode: "1723",
			occupationDescription: "protected cultivation Technician",
		},
		{
			occupationCode: "1272",
			occupationDescription: "psychotherapist",
		},
		{
			occupationCode: "2349",
			occupationDescription: "pulp bleaching Machine operator",
		},
		{
			occupationCode: "3242",
			occupationDescription: "pump and diesel injection Mechanic",
		},
		{
			occupationCode: "3137",
			occupationDescription: "pumps and compressors Maintenance mechanic",
		},
		{
			occupationCode: "3468",
			occupationDescription: "quilt and mattress Upholsterer",
		},
		{
			occupationCode: "1968",
			occupationDescription: "rail cargo Agent",
		},
		{
			occupationCode: "3270",
			occupationDescription: "railway switching Mechanic",
		},
		{
			occupationCode: "3493",
			occupationDescription: "reinforcing building iron blacksmith",
		},
		{
			occupationCode: "3494",
			occupationDescription: "reinforcing iron assistant blacksmith",
		},
		{
			occupationCode: "1556",
			occupationDescription: "reinsurance Specialist",
		},
		{
			occupationCode: "3082",
			occupationDescription: "resistance welding machine operator",
		},
		{
			occupationCode: "125",
			occupationDescription: "respiratory therapy Technician",
		},
		{
			occupationCode: "1557",
			occupationDescription: "risk insurance Specialist",
		},
		{
			occupationCode: "3580",
			occupationDescription: "roads machinery assembly worker",
		},
		{
			occupationCode: "3527",
			occupationDescription: "roof panelling worker",
		},
		{
			occupationCode: "101",
			occupationDescription: "safety equipment Technician",
		},
		{
			occupationCode: "123",
			occupationDescription: "samples Technician",
		},
		{
			occupationCode: "60",
			occupationDescription: "satellite Network Engineer",
		},
		{
			occupationCode: "3132",
			occupationDescription: "sewing machines Maintenance mechanic",
		},
		{
			occupationCode: "2039",
			occupationDescription: "sewing supplies Seller",
		},
		{
			occupationCode: "673",
			occupationDescription: "ship Commander",
		},
		{
			occupationCode: "1058",
			occupationDescription: "ship Construction Engineer",
		},
		{
			occupationCode: "2186",
			occupationDescription: "ship Service Supervisor",
		},
		{
			occupationCode: "3275",
			occupationDescription: "ship Stoker",
		},
		{
			occupationCode: "3277",
			occupationDescription: "ship repair Supervisor",
		},
		{
			occupationCode: "2504",
			occupationDescription: "shirts and Pajamas tailor",
		},
		{
			occupationCode: "3441",
			occupationDescription: "shoe soles Carpenter",
		},
		{
			occupationCode: "40",
			occupationDescription: "shooting technician",
		},
		{
			occupationCode: "1938",
			occupationDescription: "signature Check Clerk",
		},
		{
			occupationCode: "2531",
			occupationDescription: "silk network printing Worker",
		},
		{
			occupationCode: "2742",
			occupationDescription: "soap materials cooking Machine operator",
		},
		{
			occupationCode: "641",
			occupationDescription: "social Affairs Director",
		},
		{
			occupationCode: "1319",
			occupationDescription: "sociologist",
		},
		{
			occupationCode: "216",
			occupationDescription: "sociology Teacher",
		},
		{
			occupationCode: "2492",
			occupationDescription: "socks Sewing machine operator",
		},
		{
			occupationCode: "564",
			occupationDescription: "special Driver",
		},
		{
			occupationCode: "2532",
			occupationDescription: "stamping Worker",
		},
		{
			occupationCode: "2169",
			occupationDescription: "steam clothes Ironer",
		},
		{
			occupationCode: "2983",
			occupationDescription: "steam pipe Plumber",
		},
		{
			occupationCode: "1682",
			occupationDescription: "steam turbines maintenance Technician",
		},
		{
			occupationCode: "1681",
			occupationDescription: "steam turbines operating Technician",
		},
		{
			occupationCode: "2534",
			occupationDescription: "stencils Cutting Worker",
		},
		{
			occupationCode: "573",
			occupationDescription: "stepson",
		},
		{
			occupationCode: "622",
			occupationDescription: "stepson Muharem",
		},
		{
			occupationCode: "1763",
			occupationDescription: "sterilization Materials Technician",
		},
		{
			occupationCode: "2593",
			occupationDescription: "stone Disc Saw operator",
		},
		{
			occupationCode: "3503",
			occupationDescription: "stone Painter",
		},
		{
			occupationCode: "3483",
			occupationDescription: "stone assistant builder",
		},
		{
			occupationCode: "3482",
			occupationDescription: "stone builder",
		},
		{
			occupationCode: "3516",
			occupationDescription: "stone characters engraving worker",
		},
		{
			occupationCode: "3518",
			occupationDescription: "stone coarsen worker",
		},
		{
			occupationCode: "3515",
			occupationDescription: "stones Lathe operation Worker",
		},
		{
			occupationCode: "438",
			occupationDescription: "stones Sculptor",
		},
		{
			occupationCode: "521",
			occupationDescription: "stones carver",
		},
		{
			occupationCode: "2479",
			occupationDescription: "straw and frond Weaver",
		},
		{
			occupationCode: "1889",
			occupationDescription: "student Affairs Registration clerk",
		},
		{
			occupationCode: "3343",
			occupationDescription: "subscriber service Electrician",
		},
		{
			occupationCode: "178",
			occupationDescription: "surgery Consultant",
		},
		{
			occupationCode: "1267",
			occupationDescription: "surgery Nursing specialist",
		},
		{
			occupationCode: "3418",
			occupationDescription:
				"surveillance Equipment maintenance electronic Technician",
		},
		{
			occupationCode: "3571",
			occupationDescription: "survey equipment assembling worker",
		},
		{
			occupationCode: "78",
			occupationDescription: "surveyor",
		},
		{
			occupationCode: "3452",
			occupationDescription: "table Carpenter",
		},
		{
			occupationCode: "420",
			occupationDescription: "tailor",
		},
		{
			occupationCode: "2688",
			occupationDescription: "tankers filling equipment Operator",
		},
		{
			occupationCode: "397",
			occupationDescription: "tanner",
		},
		{
			occupationCode: "2373",
			occupationDescription: "tanning Solution Preparer",
		},
		{
			occupationCode: "61",
			occupationDescription: "telecommunication Engineer",
		},
		{
			occupationCode: "1636",
			occupationDescription: "telecommunications Technician",
		},
		{
			occupationCode: "3599",
			occupationDescription: "teletype assembling worker",
		},
		{
			occupationCode: "3601",
			occupationDescription: "television assembling worker",
		},
		{
			occupationCode: "2441",
			occupationDescription: "textile Dyeing machine operator",
		},
		{
			occupationCode: "2449",
			occupationDescription: "textile Starch worker",
		},
		{
			occupationCode: "2488",
			occupationDescription: "textile finishing Worker",
		},
		{
			occupationCode: "2442",
			occupationDescription: "textile oven drying Operator",
		},
		{
			occupationCode: "2454",
			occupationDescription: "textile terminating Machine operator",
		},
		{
			occupationCode: "2474",
			occupationDescription: "textiles Examiner",
		},
		{
			occupationCode: "2438",
			occupationDescription: "textiles Hand or washer",
		},
		{
			occupationCode: "2452",
			occupationDescription: "textiles Treatment Worker",
		},
		{
			occupationCode: "2439",
			occupationDescription: "textiles bleacher",
		},
		{
			occupationCode: "1313",
			occupationDescription: "therapeutic Psychiatric specialist",
		},
		{
			occupationCode: "3521",
			occupationDescription: "thermal brick builder",
		},
		{
			occupationCode: "2440",
			occupationDescription: "threads Dyeing machine operator",
		},
		{
			occupationCode: "2428",
			occupationDescription: "threads Examiner",
		},
		{
			occupationCode: "2464",
			occupationDescription: "threads wrapping Worker",
		},
		{
			occupationCode: "3508",
			occupationDescription: "tiles polisher",
		},
		{
			occupationCode: "511",
			occupationDescription: "tiles worker",
		},
		{
			occupationCode: "1686",
			occupationDescription: "time and movement study Technician",
		},
		{
			occupationCode: "517",
			occupationDescription: "tire worker",
		},
		{
			occupationCode: "2105",
			occupationDescription: "tires Seller",
		},
		{
			occupationCode: "3308",
			occupationDescription: "tracked machinery Mechanic",
		},
		{
			occupationCode: "3553",
			occupationDescription: "traffic pillars Overseer",
		},
		{
			occupationCode: "3267",
			occupationDescription: "train brake Mechanic",
		},
		{
			occupationCode: "3269",
			occupationDescription: "train valves Mechanic",
		},
		{
			occupationCode: "3268",
			occupationDescription: "train wheel repair Mechanic",
		},
		{
			occupationCode: "2163",
			occupationDescription: "train/bus Host",
		},
		{
			occupationCode: "1829",
			occupationDescription: "trainer of sales of gold and jewelry",
		},
		{
			occupationCode: "1134",
			occupationDescription: "training Aviator",
		},
		{
			occupationCode: "3265",
			occupationDescription: "trains Mechanic",
		},
		{
			occupationCode: "3342",
			occupationDescription: "transfer station assistant Electrician",
		},
		{
			occupationCode: "3337",
			occupationDescription: "transfer station installation Electrician",
		},
		{
			occupationCode: "3341",
			occupationDescription: "transfer station maintenance Electrician",
		},
		{
			occupationCode: "3339",
			occupationDescription: "transfer station operation Electrician",
		},
		{
			occupationCode: "3338",
			occupationDescription:
				"transfer station operation Electrician or general",
		},
		{
			occupationCode: "1627",
			occupationDescription: "transfer stations Technician",
		},
		{
			occupationCode: "1626",
			occupationDescription: "transfer stations and installation Technician",
		},
		{
			occupationCode: "3336",
			occupationDescription:
				"transfer stations installation Electrician or general",
		},
		{
			occupationCode: "3240",
			occupationDescription: "transmission Mechanic",
		},
		{
			occupationCode: "1984",
			occupationDescription: "travel Agent",
		},
		{
			occupationCode: "2264",
			occupationDescription: "tree Clipper",
		},
		{
			occupationCode: "2503",
			occupationDescription: "trousers tailor",
		},
		{
			occupationCode: "3282",
			occupationDescription: "turbine Assistant mechanic",
		},
		{
			occupationCode: "452",
			occupationDescription: "turbines Technician",
		},
		{
			occupationCode: "3281",
			occupationDescription: "turbo engine Mechanic",
		},
		{
			occupationCode: "3149",
			occupationDescription: "typewriters maintenance mechanic",
		},
		{
			occupationCode: "2720",
			occupationDescription: "tyres Press Operator",
		},
		{
			occupationCode: "2723",
			occupationDescription: "tyres making Worker",
		},
		{
			occupationCode: "2100",
			occupationDescription: "used vehicles Salesman",
		},
		{
			occupationCode: "2149",
			occupationDescription: "utensils Cleaner",
		},
		{
			occupationCode: "1301",
			occupationDescription: "vaccines Specialist",
		},
		{
			occupationCode: "3259",
			occupationDescription: "vehicle lubrication Worker",
		},
		{
			occupationCode: "2509",
			occupationDescription: "vehicles Covers tailor",
		},
		{
			occupationCode: "3256",
			occupationDescription: "vehicles Glass Installer",
		},
		{
			occupationCode: "3465",
			occupationDescription: "vehicles Upholsterer",
		},
		{
			occupationCode: "3243",
			occupationDescription: "vehicles tires Repairer",
		},
		{
			occupationCode: "3433",
			occupationDescription: "veneer Carpenter",
		},
		{
			occupationCode: "3174",
			occupationDescription: "ventilation and heating devices Operator",
		},
		{
			occupationCode: "3593",
			occupationDescription: "ventilation equipment assembling worker",
		},
		{
			occupationCode: "3448",
			occupationDescription: "vessel wooden foundation carpenter",
		},
		{
			occupationCode: "1408",
			occupationDescription: "vocational leader",
		},
		{
			occupationCode: "3146",
			occupationDescription: "watchmaker",
		},
		{
			occupationCode: "2694",
			occupationDescription: "water Boiler Operator",
		},
		{
			occupationCode: "1562",
			occupationDescription: "water Laboratory Technician",
		},
		{
			occupationCode: "1718",
			occupationDescription: "water and sewerage Technician",
		},
		{
			occupationCode: "1108",
			occupationDescription: "water desalination Engineer",
		},
		{
			occupationCode: "3184",
			occupationDescription: "water desalination sample Catcher",
		},
		{
			occupationCode: "1715",
			occupationDescription: "water network Technician",
		},
		{
			occupationCode: "899",
			occupationDescription: "water purification Chemist",
		},
		{
			occupationCode: "3181",
			occupationDescription: "water treatment Machine operator",
		},
		{
			occupationCode: "2695",
			occupationDescription: "water treatment plant Operator",
		},
		{
			occupationCode: "3302",
			occupationDescription: "water turbine Assistant Mechanic",
		},
		{
			occupationCode: "3301",
			occupationDescription: "water turbine Mechanic",
		},
		{
			occupationCode: "3303",
			occupationDescription: "water turbine Operation Supervisor",
		},
		{
			occupationCode: "3304",
			occupationDescription: "water turbine Operator",
		},
		{
			occupationCode: "3300",
			occupationDescription: "water turbine mechanic  or  general",
		},
		{
			occupationCode: "363",
			occupationDescription: "watering worker",
		},
		{
			occupationCode: "3131",
			occupationDescription: "weaving machines Maintenance mechanic",
		},
		{
			occupationCode: "1705",
			occupationDescription: "well drilling Technician",
		},
		{
			occupationCode: "2672",
			occupationDescription: "wells test Overseer",
		},
		{
			occupationCode: "3284",
			occupationDescription: "wheel Mechanic",
		},
		{
			occupationCode: "2993",
			occupationDescription: "whetting Worker",
		},
		{
			occupationCode: "1992",
			occupationDescription: "wholesale trade Supervisor",
		},
		{
			occupationCode: "2190",
			occupationDescription: "windows cleaner",
		},
		{
			occupationCode: "2659",
			occupationDescription: "withdrawing Pipes Machine operator",
		},
		{
			occupationCode: "3136",
			occupationDescription: "wood artefacts machine Mechanic",
		},
		{
			occupationCode: "522",
			occupationDescription: "wood carver",
		},
		{
			occupationCode: "3528",
			occupationDescription: "wood coverage worker",
		},
		{
			occupationCode: "3462",
			occupationDescription: "wood emery and painting",
		},
		{
			occupationCode: "2582",
			occupationDescription: "wood or rubber Worker",
		},
		{
			occupationCode: "2045",
			occupationDescription: "wooden furniture Seller",
		},
		{
			occupationCode: "2411",
			occupationDescription: "wool Wash operator",
		},
		{
			occupationCode: "2447",
			occupationDescription: "wool compacting Worker",
		},
		{
			occupationCode: "2431",
			occupationDescription: "wool fibre preparation worker",
		},
		{
			occupationCode: "2448",
			occupationDescription: "wool removing Worker",
		},
		{
			occupationCode: "2434",
			occupationDescription: "wool synthesis mixing Worker",
		},
		{
			occupationCode: "565",
			occupationDescription: "worker",
		},
		{
			occupationCode: "1067",
			occupationDescription: "workshop production Developing Engineer",
		},
		{
			occupationCode: "2227",
			occupationDescription: "wrapping Machine Worker",
		},
		{
			occupationCode: "2418",
			occupationDescription: "يتi Machine operator",
		},
	],
};
